export const LOCALE_COOKIE_NAME = "callo_locale"
export const LOCALE_STORAGE_KEY = "callo_locale"
export const DEFAULT_LOCALE = "fr"

export type LocaleCode =
  | "fr"
  | "en"
  | "es"
  | "pt"
  | "de"
  | "it"
  | "ar"
  | "tr"
  | "nl"
  | "ru"
  | "zh"
  | "ja"
  | "ko"
  | "hi"

export interface LocaleOption {
  code: LocaleCode
  label: string
  nativeLabel: string
  flag: string
  dir?: "ltr" | "rtl"
  hreflang: string
}

export const SUPPORTED_LOCALES: LocaleOption[] = [
  { code: "fr", label: "French", nativeLabel: "Français", flag: "🇫🇷", hreflang: "fr-FR" },
  { code: "en", label: "English", nativeLabel: "English", flag: "🇬🇧", hreflang: "en-US" },
  { code: "es", label: "Spanish", nativeLabel: "Español", flag: "🇪🇸", hreflang: "es-ES" },
  { code: "pt", label: "Portuguese", nativeLabel: "Português", flag: "🇧🇷", hreflang: "pt-BR" },
  { code: "de", label: "German", nativeLabel: "Deutsch", flag: "🇩🇪", hreflang: "de-DE" },
  { code: "it", label: "Italian", nativeLabel: "Italiano", flag: "🇮🇹", hreflang: "it-IT" },
  { code: "ar", label: "Arabic", nativeLabel: "العربية", flag: "🇸🇦", dir: "rtl", hreflang: "ar-SA" },
  { code: "tr", label: "Turkish", nativeLabel: "Türkçe", flag: "🇹🇷", hreflang: "tr-TR" },
  { code: "nl", label: "Dutch", nativeLabel: "Nederlands", flag: "🇳🇱", hreflang: "nl-NL" },
  { code: "ru", label: "Russian", nativeLabel: "Русский", flag: "🇷🇺", hreflang: "ru-RU" },
  { code: "zh", label: "Chinese", nativeLabel: "中文", flag: "🇨🇳", hreflang: "zh-CN" },
  { code: "ja", label: "Japanese", nativeLabel: "日本語", flag: "🇯🇵", hreflang: "ja-JP" },
  { code: "ko", label: "Korean", nativeLabel: "한국어", flag: "🇰🇷", hreflang: "ko-KR" },
  { code: "hi", label: "Hindi", nativeLabel: "हिन्दी", flag: "🇮🇳", hreflang: "hi-IN" },
]

const baseTranslations = {
  reputationTotal: "{count} réactions au total",
reputationExcellent: "Excellent",
reputationCorrect: "Correct",
reputationFaible: "Faible",
  appName: "Callo",
  theme: "Thème",
  themeModeLight: "Mode clair",
  themeModeDark: "Mode sombre",
  language: "Langue",
  changeLanguage: "Changer la langue",
  selectLanguage: "Choisir une langue",
  defaultFrench: "Français par défaut",
  languageSaved: "Langue enregistrée",
  languageHint: "Votre choix reste mémorisé jusqu'à ce que vous le changiez.",
  rootMetaTitle: "Callo — Appel aléatoire gratuit & live",
  rootMetaTitleShort: "Callo — Appel aléatoire & live",
  rootMetaDescription: "Callo propose des appels aléatoires gratuits et des lives. Sans téléchargement.",
  rootMetaDescriptionShort: "Appels aléatoires gratuits et lives. Sans téléchargement.",
  heroBadge: "+10 000 personnes connectées maintenant",
  heroTitle: "L’appel aléatoire gratuit qui connecte le monde",
  heroSubtitle: "Appels aléatoires, lives, messagerie et publications dans une interface moderne.",
  landingTickerRandomVideo: "Appel aléatoire gratuit",
  landingTickerAltOmegle: "Alternative Omegle 2026",
  landingTickerLives: "Lives en direct",
  landingTickerMessaging: "Messagerie instantanée",
  landingTickerFree: "100% gratuit",
  landingTickerUsers: "+50 000 utilisateurs",
  landingTickerNoDownload: "Sans téléchargement",
  landingTickerAlwaysOn: "Disponible 24/7",
  landingHowBadge: "Simple comme bonjour",
  landingHowTitle: "Comment ça",
  landingHowTitleAccent: "marche ?",
  landingHowSubtitle: "Trois étapes pour rencontrer des personnes du monde entier",
  landingHowStep1Title: "Créez votre profil",
  landingHowStep1Desc: "Inscription gratuite en 30 secondes. Choisissez vos langues et centres d’intérêt.",
  landingHowStep2Title: "Lancez un appel",
  landingHowStep2Desc: "Un clic suffit pour être connecté à quelqu’un au hasard par vidéo. Instantané.",
  landingHowStep3Title: "Connectez-vous",
  landingHowStep3Desc: "Ajoutez vos coups de cœur en amis, chattez en privé, partagez des moments.",
  landingFeaturesBadge: "Fonctionnalités",
  landingFeaturesTitle: "Tout ce dont vous avez",
  landingFeaturesTitleAccent: "besoin",
  landingFeaturesSubtitle: "Une plateforme sociale complète de chat vidéo, live streaming et messagerie",
  landingFeatureGlobalTitle: "Portée mondiale",
  landingFeatureGlobalDesc: "Rencontrez des personnes de plus de 18 pays. Filtrez par langue, région ou centres d’intérêt.",
  landingFeatureInstantTitle: "Appels instantanés",
  landingFeatureInstantDesc: "Un clic pour un appel vidéo aléatoire. Notre algorithme vous matche en moins de 3 secondes.",
  landingFeatureLivesTitle: "Lives en direct",
  landingFeatureLivesDesc: "Créez votre propre live ou rejoignez ceux des autres. Spectateurs illimités.",
  landingFeatureMessagingTitle: "Messagerie privée",
  landingFeatureMessagingDesc: "Chattez en temps réel avec vos amis. Envoyez textes, photos et messages vocaux.",
  landingFeatureCommunityTitle: "Communauté active",
  landingFeatureCommunityDesc: "Publications, commentaires, hashtags tendance. Un vrai réseau social intégré.",
  landingFeatureSecurityTitle: "Sécurité renforcée",
  landingFeatureSecurityDesc: "Chiffrement de bout en bout, modération IA, et respect total de votre vie privée.",
  landingTagPopular: "Populaire",
  landingTagNew: "Nouveau",
  landingTestimonialsBadge: "Témoignages",
  landingTestimonialsTitle: "Ils adorent",
  landingTestimonial1Name: "Marie L.",
  landingTestimonial1Text: "J'ai rencontré ma meilleure amie sur Callo ! On se parle tous les jours maintenant. C'est bien mieux qu'Omegle.",
  landingTestimonial2Name: "Jean K.",
  landingTestimonial2Text: "L'appel aléatoire est addictif. J'ai parlé avec des gens du Japon, du Brésil, d'Allemagne... incroyable.",
  landingTestimonial3Name: "Sofia R.",
  landingTestimonial3Text: "Les lives sont super fun ! J'adore l'ambiance et la communauté. Et c'est 100% gratuit, pas de mauvaises surprises.",
  landingCtaTitleLine1: "Prêt à rencontrer",
  landingCtaTitleLine2: "le monde entier ?",
  landingCtaSubtitle: "Rejoignez des milliers de personnes qui utilisent Callo chaque jour pour se connecter, discuter et partager.",
  landingCtaPrimary: "Créer mon compte gratuit",
  landingCtaSecondary: "J'ai déjà un compte",
  landingFooterDesc: "Callo est la meilleure alternative gratuite à Omegle et Chatroulette. Chat vidéo aléatoire, live streaming, messagerie et réseau social — tout en une seule app.",
  landingFooterRegister: "Inscription gratuite",
  landingFooterLogin: "Connexion",
  landingFooterDiscover: "Découvrir",
  landingFooterLive: "Lives en direct",
  landingFooterTerms: "Conditions d'utilisation",
  landingFooterPrivacy: "Politique de confidentialité",
  landingFooterLegal: "Mentions légales",
  landingStatFree: "Gratuit",
  landingStatUsers: "Utilisateurs",
  landingStatCountries: "Pays",
  landingStatAvailable: "Disponible",
  landingCopyright: "© {year} Callo. Chat vidéo aléatoire gratuit — Alternative Omegle & Chatroulette.",
  landingLegalPrefix: "En vous inscrivant, vous acceptez nos",
  landingLegalAnd: "et notre",
  publicNavHome: "Accueil",
  publicNavAbout: "À propos",
  publicNavContact: "Contact",
  publicNavSafety: "Sécurité",
  publicNavPrivacy: "Confidentialité",
  publicNavTerms: "Conditions",
  publicNavLegal: "Mentions légales",
  aboutMetaTitle: "À propos de Callo | Plateforme de chat vidéo social gratuit",
  aboutMetaDescription: "Découvrez Callo, une plateforme sociale gratuite de chat vidéo aléatoire, lives, messagerie et publications, avec des règles de sécurité et de modération claires.",
  aboutStructuredName: "À propos de Callo",
  aboutStructuredDescription: "Callo est une plateforme sociale gratuite de chat vidéo aléatoire, lives, messagerie et publications.",
  aboutBadge: "Plateforme sociale vidéo",
  aboutHeroTitle: "Callo rend les rencontres vidéo plus simples, plus claires et plus responsables.",
  aboutHeroText: "Callo est une plateforme sociale gratuite qui combine chat vidéo aléatoire, lives, messagerie et publications. Le service met l'accent sur l'accessibilité, la modération et la transparence afin de proposer une expérience utile aux visiteurs comme aux moteurs de recherche.",
  aboutSafetyCta: "Voir les règles de sécurité",
  aboutInfoTitle: "Informations publiques",
  aboutInfoSubtitle: "Utile pour visiteurs et vérification AdSense",
  aboutInfoText: "Les pages publiques de Callo expliquent le service, les règles, les contacts et la confidentialité avant toute connexion utilisateur.",
  aboutPillarVideoTitle: "Chat vidéo instantané",
  aboutPillarVideoText: "Des appels vidéo aléatoires accessibles depuis le navigateur, sans installation, pour rencontrer de nouvelles personnes rapidement.",
  aboutPillarSocialTitle: "Échanges sociaux",
  aboutPillarSocialText: "Lives, messagerie et publications permettent de continuer une conversation au-delà du premier appel.",
  aboutPillarTrustTitle: "Cadre de confiance",
  aboutPillarTrustText: "Des règles publiques, des signalements et une modération progressive aident à limiter les abus.",
  aboutCommitmentFree: "Service gratuit et accessible sans téléchargement.",
  aboutCommitmentPublic: "Pages publiques claires pour expliquer le produit, la sécurité et les contacts.",
  aboutCommitmentAds: "Publicité réservée aux espaces compatibles avec les règles de la plateforme.",
  aboutCommitmentLegal: "Informations légales, confidentialité et conditions disponibles depuis chaque page publique.",
  aboutStatFree: "gratuit",
  aboutStatAge: "âge minimum",
  aboutStatAvailable: "accessible",
  aboutWhyTitle: "Pourquoi ces pages existent ?",
  aboutWhyText: "Un site compatible avec la publicité doit être compréhensible, accessible et transparent. Callo présente donc son fonctionnement, ses règles et ses moyens de contact publiquement.",
  contactMetaTitle: "Contact Callo | Support, signalements et données personnelles",
  contactMetaDescription: "Contactez Callo pour le support, les signalements, les questions légales, la confidentialité et les demandes liées aux données personnelles.",
  contactStructuredName: "Contact Callo",
  contactBadge: "Support officiel Callo",
  contactHeroTitle: "Contact, assistance et signalements.",
  contactHeroText: "Cette page centralise les moyens de contact publics de Callo. Elle permet aux utilisateurs, visiteurs, partenaires et services de vérification de comprendre comment joindre l'équipe selon le type de demande.",
  contactBeforeTitle: "Avant d'écrire",
  contactBeforeText: "Une demande précise est plus simple à traiter et aide aussi à documenter les signalements importants.",
  contactSupportTitle: "Support général",
  contactSupportText: "Compte, connexion, appels vidéo, lives, messages, publications ou problème technique.",
  contactSupportCta: "Écrire au support",
  contactReportTitle: "Signalement de contenu",
  contactReportText: "Profil, message, live ou publication qui semble dangereux, abusif, frauduleux ou interdit.",
  contactReportCta: "Envoyer un signalement",
  contactDataTitle: "Données personnelles",
  contactDataText: "Demande d'accès, rectification, suppression de compte ou question sur la confidentialité.",
  contactDataCta: "Exercer mes droits",
  contactChecklistEmail: "Votre adresse email de contact.",
  contactChecklistUsername: "Le pseudo ou l'identifiant concerné, si disponible.",
  contactChecklistType: "Le type de problème rencontré.",
  contactChecklistDescription: "Une description courte et précise de la situation.",
  contactDocsTitle: "Documents utiles",
  contactDocsText: "Pour les questions de confidentialité, de conditions d'utilisation ou de responsabilité éditoriale, consultez les pages légales publiques avant d'envoyer votre demande.",
  safetyMetaTitle: "Sécurité et modération | Règles publiques Callo",
  safetyMetaDescription: "Consultez les règles de sécurité, de modération, de signalement et de conformité publicitaire de Callo.",
  safetyStructuredName: "Sécurité et modération Callo",
  safetyStructuredDescription: "Règles publiques de sécurité, modération, signalement et conformité publicitaire de Callo.",
  safetyBadge: "Sécurité et modération",
  safetyHeroTitle: "Des règles publiques pour protéger les utilisateurs.",
  safetyHeroText: "Callo est une plateforme sociale avec contenu utilisateur. Les règles ci-dessous expliquent les contenus interdits, la modération, les signalements et la manière dont la publicité doit rester compatible avec un environnement responsable.",
  safetyImportantTitle: "Important",
  safetyImportantText: "Les annonces ne doivent pas être placées sur des écrans privés, des pages sans contenu utile ou près de contenus interdits. Les pages publiques informatives sont les espaces les plus adaptés.",
  safetyReportCta: "Signaler un problème",
  safetyBlockReportsTitle: "Signalements accessibles",
  safetyBlockReportsText: "Les utilisateurs peuvent signaler un profil, un message, un live ou une publication qui enfreint les règles.",
  safetyBlockAccountsTitle: "Comptes encadrés",
  safetyBlockAccountsText: "L'inscription demande une adresse email valide et le service est réservé aux personnes âgées d'au moins 16 ans.",
  safetyBlockDataTitle: "Données expliquées",
  safetyBlockDataText: "Les données collectées, la localisation et les cookies sont documentés dans la politique de confidentialité.",
  safetyBlockPublicTitle: "Pages publiques lisibles",
  safetyBlockPublicText: "Les règles et contacts sont consultables sans connexion pour renforcer la transparence du service.",
  safetyForbiddenTitle: "Contenus et comportements interdits",
  safetyForbiddenText: "Ces catégories servent de base aux actions de modération et aident à maintenir un environnement compatible avec les standards publicitaires et communautaires.",
  safetyForbiddenSexual: "Nudité non sollicitée, contenu sexuel explicite ou exploitation de mineurs.",
  safetyForbiddenHarassment: "Harcèlement, menaces, intimidation, discrimination ou usurpation d'identité.",
  safetyForbiddenSpam: "Spam, phishing, arnaque, publicité abusive ou automatisation abusive.",
  safetyForbiddenIllegal: "Contenu illégal, violent, terroriste, haineux ou dangereux.",
  safetyForbiddenPersonalData: "Partage de données personnelles d'autrui sans autorisation.",
  safetyForbiddenBypass: "Tentative de contournement des outils de modération ou de sécurité.",
  safetyProcessTitle: "Traitement des signalements",
  safetyProcessText: "Le processus doit rester lisible pour les utilisateurs et documentable pour les partenaires externes.",
  safetyRulesCta: "Lire les règles complètes",
  safetyStepLabel: "Étape {number}",
  safetyStepReceiveTitle: "Réception du signalement",
  safetyStepReceiveText: "La demande doit contenir le plus d'éléments utiles possible : profil, contenu, date et contexte.",
  safetyStepReviewTitle: "Évaluation",
  safetyStepReviewText: "Le contenu est comparé aux règles de conduite et aux obligations légales applicables.",
  safetyStepActionTitle: "Action",
  safetyStepActionText: "Selon la gravité : avertissement, retrait, suspension, bannissement ou signalement aux autorités.",
  ctaLogin: "Se connecter",
  ctaRegister: "Créer un compte",
  ctaPublish: "Créer une publication",
  ctaBrowse: "Découvrir",
  feature1: "Appels vidéo aléatoires",
  feature2: "Messagerie instantanée",
  feature3: "Lives en direct",
  feature4: "Communauté mondiale",
  authLoginTitle: "Bon retour !",
  authLoginSubtitle: "Connectez-vous pour retrouver votre communauté",
  authRegisterTitle: "Rejoignez Callo",
  authRegisterSubtitle: "Créez votre compte et connectez-vous au monde entier",
  authEmail: "Adresse email",
  authPassword: "Mot de passe",
  authConfirmPassword: "Confirmer le mot de passe",
  authName: "Nom complet",
  authUsername: "Identifiant",
  authDOB: "Date de naissance",
  authDOBDay: "Jour",
  authDOBMonth: "Mois",
  authDOBYear: "Année",
  authLanguages: "Langues parlées",
  authForgotPassword: "Mot de passe oublié ?",
  authLoginLoading: "Connexion en cours...",
  authRegisterLoading: "Création du compte...",
  authNoAccount: "Pas de compte ?",
  authSignUp: "S'inscrire",
  authHaveAccount: "Déjà un compte ?",
  authSignIn: "Se connecter",
  authLoginError: "Erreur lors de la connexion",
  authPasswordMismatch: "Les mots de passe ne correspondent pas",
  authSelectOneLanguage: "Veuillez sélectionner au moins une langue",
  authInvalidUsername: "Identifiant invalide (3-30 caractères, lettres, chiffres et _)",
  authUsernameTaken: "Ce nom d'utilisateur est déjà pris",
  authRegisterError: "Erreur lors de l'inscription",
  authUsernameTakenShort: "Déjà pris",
  authUsernameInvalidShort: "3-30 car., lettres/chiffres/_",
  authUsernameAvailable: "✓ Disponible",
  authMinAgeHint: "Vous devez avoir au moins 16 ans",
  authPasswordMinPlaceholder: "8 caractères min.",
  authNamePlaceholder: "Ex. Alex Martin",
  authUsernamePlaceholder: "alex.martin",
  authPasswordPlaceholder: "Créez un mot de passe fort",
  authConfirmPasswordPlaceholder: "Répétez le mot de passe",
  authDateOfBirthPlaceholder: "jj/mm/aaaa",
  authLegalPrefix: "En vous inscrivant, vous confirmez avoir au moins",
  authLegalAnd: "et acceptez nos",
  authChatMessage1: "Salut ! Tu viens d'où ? 😄",
  authChatMessage2: "Hey! Nice to meet you!",
  authChatMessage3: "On se fait un live ?",
  authChatMessage4: "Callo c'est trop bien 🔥",
  authChatMessage5: "T'es dispo pour un call ?",
  authChatMessage6: "Just joined from Tokyo! 🇯🇵",
  authChatMessage7: "Qui veut rejoindre mon live ?",
  authChatMessage8: "Best video chat ever! 💜",
  authNotif1: "Marie a aimé votre post",
  authNotif2: "+3 nouveaux amis en ligne",
  authNotif3: "Appel vidéo entrant...",
  authNotif4: "Votre live a 52 viewers !",
  authNotif5: "Ahmed a réagi à votre story",
  authNotif6: "12 personnes en ligne près de vous",
  authLoginMetaTitle: "Connexion à votre compte",
  authLoginMetaDescription: "Connectez-vous à Callo pour retrouver vos amis, vos messages privés et vos lives.",
  authLoginMetaOgTitle: "Connexion | Callo",
  authLoginMetaOgDescription: "Accédez à votre compte Callo et reprenez vos conversations en un instant.",
  authRegisterMetaTitle: "Créer un compte gratuit",
  authRegisterMetaDescription: "Inscrivez-vous gratuitement sur Callo, la meilleure alternative à Omegle et Chatroulette. Chat vidéo aléatoire, lives en direct, messagerie privée. Inscription en 1 minute, sans téléchargement.",
  authRegisterMetaOgTitle: "Créer un compte gratuit | Callo",
  authRegisterMetaOgDescription: "Inscrivez-vous gratuitement — chat vidéo aléatoire, lives, messagerie. Alternative Omegle & Chatroulette.",
  authRegisterMetaTwitterDescription: "Inscription gratuite en 1 minute. Chat vidéo aléatoire, alternative Omegle.",
  authForgotPasswordMetaTitle: "Mot de passe oublié",
  authForgotPasswordMetaDescription: "Réinitialisez votre mot de passe Callo. Recevez un code de vérification par email pour créer un nouveau mot de passe sécurisé.",
  authResetCodeMetaTitle: "Vérification du code",
  authResetCodeMetaDescription: "Entrez le code de vérification reçu par email pour réinitialiser votre mot de passe Callo.",
  authResetPasswordMetaTitle: "Nouveau mot de passe",
  authResetPasswordMetaDescription: "Créez un nouveau mot de passe sécurisé pour votre compte Callo.",
  forgotPasswordEmailRequired: "Veuillez entrer votre adresse email",
  forgotPasswordSendError: "Erreur lors de l'envoi",
  forgotPasswordSubtitle: "Entrez votre email et nous vous enverrons un code pour réinitialiser votre mot de passe",
  forgotPasswordSending: "Envoi en cours...",
  forgotPasswordSendCode: "Envoyer le code",
  forgotPasswordRemembered: "Vous vous souvenez ?",
  resetPasswordMinLengthError: "Le mot de passe doit contenir au moins 8 caractères",
  resetPasswordSessionExpired: "Session expirée. Veuillez recommencer la procédure.",
  resetPasswordResetError: "Erreur lors de la réinitialisation",
  resetPasswordSuccessTitle: "Mot de passe modifié !",
  resetPasswordSuccessRedirect: "Redirection vers la connexion…",
  resetPasswordSubtitle: "Choisissez un mot de passe sécurisé pour protéger votre compte",
  resetPasswordNewPasswordLabel: "Nouveau mot de passe",
  resetPasswordRuleMinLength: "8 caractères min",
  resetPasswordRuleUpper: "Une majuscule",
  resetPasswordRuleLower: "Une minuscule",
  resetPasswordRuleNumber: "Un chiffre",
  resetPasswordPasswordsMatch: "Les mots de passe correspondent",
  resetPasswordUpdating: "Modification...",
  resetPasswordSubmit: "Modifier le mot de passe",
  profileUserNotFoundMetaTitle: "Profil introuvable — Callo",
  profileUserMetaTitleSuffix: "— Profil Callo",
  profileUserMetaDescription: "Découvrez le profil de {name} sur Callo — chat vidéo aléatoire gratuit{countryPart}.",
  profileUserMetaCountryPrefix: ", {country}",
  profileUserMetaImageAlt: "{name} — Callo",
  verifySuccessTitle: "Email vérifié avec succès !",
  verifySuccessSubtitle: "Votre compte Callo a été activé. Vous pouvez maintenant vous connecter et commencer à rencontrer des gens du monde entier.",
  verifySuccessRedirect: "Redirection automatique vers la page de connexion dans 5 secondes...",
  verifySuccessLoginNow: "Se connecter maintenant",
  verifyErrorTitle: "Échec de la vérification",
  verifyErrorMissingToken: "Le lien de vérification est incomplet. Veuillez utiliser le lien complet reçu par email.",
  verifyErrorInvalidToken: "Ce lien de vérification est invalide ou a expiré. Veuillez demander un nouveau lien.",
  verifyErrorServer: "Une erreur s'est produite lors de la vérification. Veuillez réessayer plus tard.",
  verifyErrorDefault: "Une erreur s'est produite lors de la vérification de votre email.",
  verifyErrorCreateAccount: "Créer un nouveau compte",
  verifyErrorBackLogin: "Retour à la connexion",
  profileEditTitle: "Modifier mon profil",
  profileEditSubtitle: "Mettez à jour vos informations personnelles",
  profileProfilePhoto: "Photo de profil",
  profileFullName: "Nom complet",
  profileUsername: "Identifiant",
  profileAgeAuto: "Calculé automatiquement à partir de votre date de naissance",
  profileDobFormatHint: "Format jour/mois/année selon votre appareil",
  profileBio: "Bio",
  profileBioPlaceholder: "Parlez-nous de vous...",
  profileCharsCount: "{count}/500 caractères",
  profileLocationAuto: "Détectée automatiquement via la géolocalisation",
  profileAvatarTooLarge: "L'image est trop volumineuse (max 10 MB)",
  profileAvatarUploadError: "Erreur lors de l'upload de l'image",
  profileAvatarUploading: "Téléversement...",
  profileAvatarChange: "Changer la photo",
  profileAvatarRemove: "Supprimer la photo",
  profileCopyLink: "Copier le lien",
  profileShareProfile: "Partager le profil",
  profileBlockUser: "Bloquer cet utilisateur",
  profileReportUser: "Signaler",
  profileTopBadge: "Top",
  profileSeePhoto: "Voir la photo en grand",
  profileEditProfile: "Modifier le profil",
  profileBackToDiscover: "Explorer",
  profileBack: "Retour",
  profilePostsSectionTitle: "Publications",
  profileFilterAll: "Tout",
  profileFilterPhotos: "Photos",
  profileFilterVideos: "Vidéos",
  profileFilterTexts: "Textes",
  profileNoPosts: "Aucune publication",
  profileNoPostsHint: "Les posts apparaîtront ici.",
  profileUsernameUrlHint: "Apparaît dans votre URL de profil",
  verifyEmailTitle: "Vérification de l'email",
  verifyEmailLoading: "Vérification en cours...",
  verifyEmailSuccess: "Email vérifié",
  verifyEmailFailure: "Erreur de vérification",
  verifyEmailMissingToken: "Token de vérification manquant",
  verifyEmailError: "Erreur lors de la vérification",
  verifyEmailSuccessMessage: "Votre email a été vérifié avec succès!",
  verifyEmailGoToAccount: "Accéder à mon compte",
  verifyEmailBackHome: "Retour à l'accueil",
  verifyCodeTitle: "Vérification email",
  verifyCodeSubtitle: "Saisissez le code à 6 chiffres reçu par mail",
  verifyCodeDigit: "Chiffre",
  verifyCodeVerifying: "Vérification…",
  verifyCodeConfirm: "Confirmer",
  verifyCodeResend: "Renvoyer le code",
  verifyCodeResendIn: "Renvoyer dans",
  verifyCodeHint: "Pensez à vérifier vos spams · Code valide 24h",
  verifyCodeMissingEmail: "Email manquant — reconnectez-vous via le lien d'inscription.",
  verifyCodeInvalidFormat: "Entrez un code à 6 chiffres valide.",
  verifyCodeInvalid: "Code invalide. Veuillez réessayer.",
  verifyCodeNetworkError: "Erreur réseau. Vérifiez votre connexion.",
  verifyCodeEnterEmailResend: "Entrez votre email pour renvoyer le code.",
  verifyCodeResendError: "Impossible de renvoyer le code.",
  verifyCodeResendSuccess: "✓ Nouveau code envoyé !",
  verifyCodeNetworkShort: "Erreur réseau.",
  verifyCodeVerifiedTitle: "Compte vérifié",
  verifyCodeRedirectLogin: "Redirection vers la connexion…",
  resetCodeTitle: "Vérification",
  resetCodeSubtitle: "Saisissez le code à 6 chiffres envoyé par email",
  resetCodeSubmit: "Vérifier le code",
  resetCodeHint: "Pensez à vérifier vos spams · Code valide 15 min",
  resetCodeMissingEmail: "Email manquant",
  settingsTitle: "Paramètres",
  settingsSubtitle: "Personnalisez votre expérience Callo",
  settingsNotifications: "Notifications",
  settingsNotificationsDesc: "Recevez les notifications de Callo sur votre appareil",
  settingsPreferences: "Préférences d'appels",
  settingsAccount: "Compte",
  settingsAppLanguageTitle: "Langue de l'application",
  settingsAppLanguageDesc: "Définissez la langue d'affichage globale de Callo.",
  settingsLanguageSaved: "Langue mise à jour",
  settingsDownloadAppTitle: "Télécharger l'application",
  settingsDownloadAppDesc: "Installer Callo sur votre appareil pour un accès plus rapide et des notifications fiables.",
  settingsInstallPromptTitle: "Installer Callo",
  settingsInstallPromptDesc: "Obtenez Callo directement sur votre appareil. Accès rapide, notifications en temps réel, même mode hors ligne.",
  settingsInstallPlatformTitle: "Instructions d'installation",
  settingsInstallIosStep1: "Ouvrez Safari et rendez-vous sur callo.online",
  settingsInstallIosStep2: "Appuyez sur l'icône de partage en bas (carré avec flèche)",
  settingsInstallIosStep3: "Sélectionnez \"Ajouter à l'écran d'accueil\"",
  settingsInstallAndroidStep1: "Ouvrez Chrome et rendez-vous sur callo.online",
  settingsInstallAndroidStep2: "Appuyez sur le menu (3 points) en haut à droite",
  settingsInstallAndroidStep3: "Sélectionnez \"Installer l'application\"",
  settingsInstallDesktopStep1: "Vous verrez une icône d'installation dans la barre d'adresse du navigateur",
  settingsInstallDesktopStep2: "Cliquez sur l'icône et confirmez l'installation",
  settingsInstallBenefitFast: "Accès rapide",
  settingsInstallBenefitFastDesc: "Lancez Callo en un clic depuis votre écran d'accueil",
  settingsInstallBenefitNotifications: "Notifications fiables",
  settingsInstallBenefitNotificationsDesc: "Recevez les alertes même quand le navigateur est fermé",
  settingsInstallButtonInstall: "Installer maintenant",
  settingsInstallButtonClose: "Fermer",
  settingsInstallDeviceMobile: "Mobile",
  settingsInstallDeviceTablet: "Tablette",
  settingsInstallDeviceDesktop: "Bureau",
  settingsInstallBadgeNew: "Nouveau",
  settingsInstallBadgeInstalled: "Installé",
  settingsInstallButtonInstalled: "Installé",
  settingsPushConsentQuestion: "Recevez les notifications de Callo sur votre appareil ?",
  settingsPushConsentExplanation: "Vous choisissez. Si vous continuez, le navigateur vous demandera ensuite l'autorisation.",
  settingsPushConsentLater: "Plus tard",
  settingsPushConsentAllow: "Autoriser",
  settingsInstallSuccess: "Callo a été installé avec succès !",
  settingsInstallAlreadyInstalled: "Callo est déjà installé sur cet appareil.",
  dashboardMetaTitle: "Fil d'actualité",
  dashboardMetaDescription: "Votre fil d'actualité Callo — publications, tendances et activité de vos amis.",
  friendsMetaTitle: "Amis",
  friendsMetaDescription: "Vos amis et demandes d'amis sur Callo.",
  discoverMetaDescription: "Découvrez de nouvelles personnes du monde entier sur Callo.",
  liveMetaTitle: "Lives",
  liveMetaDescription: "Regardez et démarrez des lives en direct sur Callo.",
  messagesMetaTitle: "Messages",
  messagesMetaDescription: "Vos conversations privées sur Callo.",
  notificationsMetaTitle: "Notifications",
  notificationsMetaDescription: "Vos notifications et interactions sur Callo.",
  settingsMetaTitle: "Paramètres",
  settingsMetaDescription: "Gérez vos préférences et paramètres de compte Callo.",
  profileMetaTitle: "Mon profil",
  profileMetaDescription: "Votre profil Callo — informations personnelles et publications.",
  dashboardEmailUnverifiedTitle: "Email non vérifié",
  dashboardEmailUnverifiedDesc: "Veuillez vérifier votre email pour accéder à toutes les fonctionnalités",
  dashboardMoreLanguagesAria: "Langues supplémentaires",
  dashboardSuggestionsForYou: "Suggestions pour vous",
  dashboardSwipeHint: "Glissez ->",
  settingsOtherRegion: "Autre",
  settingsOtherLanguages: "Autres langues",
  settingsRegionEurope: "Europe",
  settingsRegionNorthAmerica: "Amérique du Nord",
  settingsRegionSouthAmerica: "Amérique du Sud",
  settingsRegionAfrica: "Afrique",
  settingsRegionAsia: "Asie",
  settingsRegionOceania: "Océanie",
  settingsLangGroupEuropean: "Langues européennes",
  settingsLangGroupAsian: "Langues asiatiques",
  settingsLangGroupAfrican: "Langues africaines",
  settingsGenericError: "Erreur",
  settingsDeleteTypeConfirm: "Tapez SUPPRIMER pour confirmer",
  settingsDeletePasswordRequired: "Mot de passe requis",
  settingsPreferencesDesc: "Pays, langues, tranche d'âge pour les appels aléatoires",
  settingsFiltersCount: "{count} filtres",
  settingsAccountDesc: "Informations, sécurité et suppression du compte",
  settingsPreferencesSaved: "Préférences enregistrées !",
  settingsPreferencesHelp: "Configurez vos filtres pour les appels aléatoires. Laissez vide pour accepter tout le monde.",
  settingsPushTitle: "Notifications sur cet appareil",
  settingsPushSubtitle: "Recevez les alertes Callo même quand l'application est fermée.",
  settingsPushStatusSupported: "Compatibilité",
  settingsPushStatusEnabled: "Actives",
  settingsPushStatusDisabled: "Désactivées",
  settingsPushPermissionDefault: "Autorisation non demandée",
  settingsPushPermissionGranted: "Autorisation accordée",
  settingsPushPermissionDenied: "Autorisation refusée",
  settingsPushEnable: "Activer les notifications",
  settingsPushDisable: "Désactiver",
  settingsPushSaveError: "Impossible de configurer les notifications",
  settingsPushEnabledSuccess: "Notifications activées sur cet appareil",
  settingsPushDisabledSuccess: "Notifications désactivées sur cet appareil",
  settingsPushUnsupported: "Les notifications push ne sont pas prises en charge dans ce navigateur",
  settingsPushPermissionDeniedError: "Les notifications ont été refusées dans le navigateur",
  settingsPushExplain: "Vous recevrez les messages, demandes d'amis, réactions et lives directement sur l'appareil.",
  settingsPushNeedPermission: "Le navigateur vous demandera une autorisation avant l'activation.",
  settingsPushPromptTitle: "Recevez les notifications",
  settingsPushPromptDescription: "Bonjour {name} ! Autorisez Callo à vous envoyer les alertes importantes directement sur votre appareil.",
  settingsPushPromptBenefit1: "Restez informé en temps réel",
  settingsPushPromptBenefit2: "Messages, demandes d'amis, réactions et lives apparaissent directement sur votre appareil.",
  settingsPushPromptAllow: "Autoriser",
  settingsPushPromptLater: "Plus tard",
  settingsCountriesTitle: "Pays",
  settingsCountriesNoFilter: "Aucun filtre — tous les pays",
  settingsLanguagesTitle: "Langues",
  settingsLanguagesNoFilter: "Aucun filtre — toutes les langues",
  settingsAgeRangeTitle: "Tranche d'âge",
  settingsSaving: "Enregistrement...",
  settingsSavePreferences: "Enregistrer les préférences",
  settingsManageAccount: "Gérer mon compte",
  settingsManageAccountDesc: "Actions rapides : modifier le mot de passe, utilisateurs bloqués ou suppression du compte",
  settingsFilterCountriesTitle: "Filtrer par pays",
  settingsFilterCountriesHelp: "Seuls les pays où des utilisateurs sont inscrits sont affichés. Vous pouvez sélectionner une région entière en un clic.",
  settingsCountriesSelected: "{count} pays sélectionné{plural}",
  settingsDeselectAll: "Tout désélectionner",
  settingsFilterLanguagesTitle: "Filtrer par langues",
  settingsFilterLanguagesHelp: "Seules les langues parlées par des utilisateurs inscrits sont affichées. Vous pouvez sélectionner un groupe entier.",
  settingsLanguagesSelected: "{count} langue{plural} sélectionnée{plural}",
  settingsAgeRangeHelp: "Définissez l'âge minimum et maximum des personnes avec qui vous souhaitez être mis en relation.",
  settingsMinAge: "Âge minimum",
  settingsMaxAge: "Âge maximum",
  settingsAgeRangeSummary: "Vous verrez les personnes entre {min} et {max} {years}",
  settingsAccountInfoTitle: "Informations du compte",
  settingsAccountInfoDesc: "Email, localisation, date d'inscription",
  settingsBlockedTitle: "Utilisateurs bloqués",
  settingsBlockedDesc: "Gérez les personnes que vous avez bloquées",
  settingsBlockedEmpty: "Aucun utilisateur bloqué",
  settingsUnblock: "Débloquer",
  settingsLoading: "Chargement...",
  settingsDeleteTitle: "Supprimer le compte",
  settingsDeleteDesc: "Supprimer définitivement votre compte et toutes vos données",
  settingsLocation: "Localisation",
  settingsNotDetected: "Non détectée",
  settingsGeolocation: "Géolocalisation",
  settingsAllowed: "Autorisée",
  settingsNotAllowed: "Non autorisée",
  settingsMemberSince: "Membre depuis",
  settingsEditProfileHintPrefix: "Pour modifier votre nom, âge, bio ou langues, rendez-vous dans la section",
  settingsEditProfileHintSuffix: "La localisation est mise à jour automatiquement.",
  settingsIrreversibleAction: "Action irréversible",
  settingsDeleteKeyword: "SUPPRIMER",
  settingsDeleteWarningDesc: "La suppression de votre compte entraînera la perte définitive de toutes vos données :",
  settingsDeleteItemProfile: "Profil et photo de profil",
  settingsDeleteItemMessages: "Messages et conversations",
  settingsDeleteItemFriends: "Liste d'amis et demandes",
  settingsDeleteItemPosts: "Publications et commentaires",
  settingsDeleteItemCalls: "Historique d'appels",
  settingsDeleteItemReactions: "Likes, dislikes et réactions",
  settingsCurrentPassword: "Mot de passe actuel",
  settingsEnterPassword: "Entrez votre mot de passe",
  settingsChangePasswordTitle: "Changer le mot de passe",
  settingsChangePasswordDesc: "Mettez à jour votre mot de passe pour renforcer la sécurité de votre compte",
  settingsNewPassword: "Nouveau mot de passe",
  settingsConfirmNewPassword: "Confirmer le nouveau mot de passe",
  settingsPasswordRules: "8 caractères min, une majuscule, une minuscule, un chiffre",
  settingsPasswordChangedSuccess: "Mot de passe mis à jour avec succès",
  settingsPasswordTooShort: "Le mot de passe doit contenir au moins 8 caractères",
  settingsPasswordMismatch: "Les mots de passe ne correspondent pas",
  settingsChangePasswordButton: "Modifier le mot de passe",
  settingsShowPassword: "Afficher les mots de passe",
  settingsHidePassword: "Masquer les mots de passe",
  settingsType: "Tapez",
  settingsToConfirm: "pour confirmer",
  settingsDeleting: "Suppression en cours...",
  settingsDeleteForever: "Supprimer définitivement mon compte",
  legalTermsPageTitle: "Conditions d'utilisation",
  legalTermsMetaDescription: "Conditions générales d'utilisation de Callo. Règles d'utilisation de la plateforme de chat vidéo.",
  legalTermsPill: "Document légal officiel",
  legalTermsHeroIntro: "Ces conditions régissent votre accès à la plateforme.",
  legalTermsFeature_video: "Appels vidéo",
  legalTermsFeature_lives: "Lives",
  legalTermsFeature_messaging: "Messagerie",
  legalTermsFeature_posts: "Publications",
  legalTermsNoticeIntro: "Les présentes CGU régissent l'accès et l'utilisation de la plateforme",
  legalTermsNav_s1: "Objet",
  legalTermsNav_s2: "Conditions d'accès",
  legalTermsNav_s3: "Règles de conduite",
  legalTermsNav_s4: "Modération & sanctions",
  legalTermsNav_s5: "Propriété intellectuelle",
  legalTermsNav_s6: "Responsabilité",
  legalTermsNav_s7: "Gratuité",
  legalTermsNav_s8: "Résiliation",
  legalTermsNav_s9: "Modifications des CGU",
  legalTermsNav_s10: "Droit applicable",
  legalTermsNav_s11: "Contact",
  legalTermsProhib_illegal: "Contenu illégal",
  legalTermsProhib_harassment: "Harcèlement",
  legalTermsProhib_nudity: "Nudité / Sexualité",
  legalTermsProhib_fraud: "Fraude / Spam",
  termsContents: "Sommaire",
  termsUpdated: "Mise à jour",
  termsUpdatedDate: "Janvier 2025",
  termsReadTime: "Lecture ~5 min",
  termsJurisdiction: "Droit français · Paris",
  termsNavLocation: "Localisation",
  termsLawTitle: "Droit applicable et juridiction",
  termsNoticeAccept: "En créant un compte ou en utilisant nos services, vous acceptez ces conditions dans leur intégralité.",
  termsObjectIntro: "Callo est une plateforme de mise en relation sociale proposant :",
  termsAgeTitle: "Âge minimum requis : 16 ans",
  termsAgeText: "En créant un compte, vous certifiez être majeur(e) selon la législation de votre pays. Toute fausse déclaration entraîne la suppression immédiate du compte.",
  termsReportHours: "24 à 48 h",
  termsFeatureVideo: "Appels vidéo aléatoires", termsFeatureVideoDesc: "entre utilisateurs du monde entier", termsFeatureLives: "Diffusions en direct (lives)", termsFeatureLivesDesc: "ouvertes à la communauté", termsFeatureMessaging: "Messagerie instantanée privée", termsFeatureMessagingDesc: "chiffrée et sécurisée", termsFeaturePosts: "Fil d'actualité", termsFeaturePostsDesc: "avec publications et interactions",
  termsAccountCreation: "2.1 · Création de compte", termsAccountSecurity: "2.2 · Sécurité du compte", termsSixteen: "16 ans révolus", termsMinimum: "minimum", termsValidEmail: "Adresse email valide", termsPassword: "Mot de passe min. 8 caractères", termsEmailVerification: "Vérification email requise", termsAcceptance: "Acceptation des CGU & vie privée", termsAccountSecurityText: "Vous êtes responsable de la confidentialité de vos identifiants. Toute activité depuis votre compte est réputée effectuée par vous. En cas de compromission, contactez-nous immédiatement.", termsLocationIntro: "Pour accéder à Callo, vous devez autoriser le partage de votre localisation. Nous collectons uniquement votre", termsCityCountry: "ville et pays", termsLocationRefusal: "Si vous refusez de partager votre localisation, l'accès à la plateforme sera limité.", termsDeleteData: "Pour supprimer votre compte et vos données, accédez aux paramètres de votre profil.", termsPrivacyMore: "Pour plus d'informations, consultez notre", termsExpected: "Attendus", termsRespect: "Respecter les autres utilisateurs", termsCourtesy: "Communiquer avec courtoisie", termsReport: "Signaler les contenus inappropriés", termsResponsible: "Utiliser la plateforme de façon responsable", termsForbidden: "Interdits", termsForbiddenIntro: "Voir les 4 catégories ci-dessous pour la liste complète des actes prohibés sur la plateforme.", termsProhibIllegal: "Contenu illégal", termsProhibHarassment: "Harcèlement", termsProhibNudity: "Nudité / Sexualité", termsProhibFraud: "Fraude / Spam", termsIllegal1: "Pornographie infantile", termsIllegal2: "Contenus pédopornographiques", termsIllegal3: "Terrorisme / apologie de crimes", termsIllegal4: "Trafic de substances illicites", termsHarassment1: "Harcèlement moral ou sexuel", termsHarassment2: "Intimidation / menaces", termsHarassment3: "Discrimination (racisme, sexisme…)", termsHarassment4: "Diffamation / injures", termsNudity1: "Nudité non sollicitée", termsNudity2: "Contenus sexuellement explicites", termsNudity3: "Sollicitations sexuelles", termsNudity4: "Exhibitionnisme", termsFraud1: "Usurpation d'identité", termsFraud2: "Arnaques / phishing", termsFraud3: "Spam / publicité non sollicitée", termsFraud4: "Faux profils / bots", termsReportProcess: "Signalement disponible sur chaque profil et conversation. Traitement sous", termsWarning: "Avertissement", termsWarningDesc: "Premier manquement mineur — notification envoyée", termsSuspension: "Suspension temporaire", termsSuspensionDesc: "Manquement répété ou grave — accès bloqué", termsBan: "Bannissement définitif", termsBanDesc: "Violation majeure ou récidive — compte supprimé", termsAuthorities: "Signalement aux autorités", termsAuthoritiesDesc: "Pour tout contenu manifestement illégal", termsOwnershipText1: "Le nom Callo, le logo, le design et l'ensemble des contenus de la plateforme sont la propriété exclusive de Callo. Toute reproduction sans autorisation écrite est strictement interdite.", termsOwnershipText2: "En publiant du contenu sur Callo, vous conservez vos droits de propriété intellectuelle mais accordez à Callo une licence mondiale, non exclusive et gratuite pour afficher, distribuer et promouvoir ce contenu dans le cadre du service.", termsCalloResponsibility: "6.1 · Responsabilité de Callo", termsCalloResponsibilityText: "Callo agit en tant qu'hébergeur au sens de l'article 6 de la LCEN. Nous retirons promptement tout contenu manifestement illicite signalé.", termsUserResponsibility: "6.2 · Responsabilité de l'utilisateur", termsUserResponsibilityText: "Vous êtes seul responsable de vos interactions et du contenu que vous publiez. Callo ne peut être tenu responsable des dommages résultant de vos échanges.", termsFreeText: "Callo est un service 100% gratuit. Toutes les fonctionnalités — appels vidéo, lives, messagerie, publications — sont accessibles sans abonnement ni paiement. Le service est financé par la publicité.", termsTerminationText1: "Vous pouvez supprimer votre compte à tout moment depuis les paramètres de votre profil. La suppression entraîne l'effacement de vos données personnelles conformément à notre Politique de confidentialité.", termsTerminationText2: "Callo peut également suspendre ou supprimer votre compte en cas de violation des présentes CGU, sans préavis ni indemnité.", termsChangesText: "Nous nous réservons le droit de modifier ces CGU à tout moment. Les modifications importantes vous seront notifiées par email ou via l'application. La poursuite de l'utilisation du service après notification vaut acceptation des nouvelles conditions.", termsLawText: "Les présentes CGU sont soumises au droit français. Tout litige relatif à leur interprétation ou exécution sera soumis aux tribunaux compétents de Paris, France.", termsContactText: "Pour toute question sur ces conditions",
  legalOtherDocsTitle: "Autres documents légaux",
  legalMentionsPageTitle: "Mentions légales",
  legalMentionsMetaDescription: "Mentions légales de Callo conformément à la loi LCEN. Informations sur l'éditeur du site.",
  legalMentionsHeaderSubtitle: "Conformément à l'article 6 de la loi n°2004-575 du 21 juin 2004 (LCEN)",
  legalPrivacyPageTitle: "Politique de confidentialité",
  legalPrivacyMetaDescription: "Politique de confidentialité de Callo. Découvrez comment nous protégeons vos données personnelles conformément au RGPD.",
  legalLastUpdated: "Dernière mise à jour : 10 mars 2025",
  legalSiteName: "Nom du site",
  legalUrl: "URL",
  legalContactLabel: "Contact",
  legalContents: "Sommaire", legalInformation: "Informations", legalUpdated: "Mise à jour", legalUpdatedDate: "Janv. 2025", legalJurisdiction: "Juridiction", legalJurisdictionValue: "Droit français · Paris", legalReadTime: "Lecture ~3 min", legalNotice: "Informations publiques relatives à l'éditeur, la protection des données et la propriété intellectuelle.", legalNavPublisher: "Éditeur", legalNavOwnership: "Propriété", legalNavData: "Données", legalNavCookies: "Cookies", legalNavLiability: "Responsabilité", legalNavLinks: "Liens", legalNavLaw: "Droit applicable", legalNavContact: "Contact", legalSectionPublisher: "Éditeur du site", legalSectionOwnership: "Propriété intellectuelle", legalSectionData: "Protection des données personnelles", legalSectionCookies: "Cookies", legalSectionLiability: "Limitation de responsabilité", legalSectionLinks: "Liens hypertextes", legalSectionLaw: "Droit applicable", legalSectionContact: "Contact", legalOwnershipText1: "L'ensemble du contenu du site Callo (textes, images, logos, icônes, design, code source) est la propriété exclusive de Callo ou de ses partenaires et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.", legalOwnershipText2: "Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site est interdite sans autorisation écrite préalable.", legalDataText: "Conformément au RGPD, vous disposez de droits sur vos données personnelles.", legalSeePrivacy: "Consultez notre", legalForDetails: "pour plus de détails.", legalCookiesText: "Le site utilise des cookies techniques et peut utiliser des cookies de mesure d'audience ou de publicité lorsque ces services sont activés.", legalLiabilityText: "Callo met en œuvre tous les moyens raisonnables pour assurer la qualité des informations publiées, sans toutefois garantir leur exhaustivité.", legalLinksText: "Le site peut contenir des liens externes fournis à titre informatif ; Callo ne contrôle pas ces sites et décline toute responsabilité quant à leur contenu.", legalLawText: "Les présentes mentions sont régies par le droit français. En cas de litige, les tribunaux français sont compétents.", legalContactText: "Pour toute question relative aux mentions légales",
  privacyContents: "Sommaire",
  privacyInformation: "Informations",
  privacyUpdate: "Mise à jour",
  privacyUpdateShort: "Janv. 2025",
  privacyJurisdiction: "Droit français · Paris",
  privacyReadTime: "Lecture ~4 min",
  privacyNotice: "Callo s'engage à protéger votre vie privée — explication des données collectées et de vos droits.",
  privacyNavController: "Responsable", privacyNavData: "Données", privacyNavLocation: "Localisation", privacyNavUse: "Utilisation", privacyNavSecurity: "Sécurité", privacyNavHosting: "Hébergement", privacyNavCookies: "Cookies", privacyNavMinors: "Mineurs", privacyNavContact: "Contact",
  privacySectionController: "Responsable du traitement", privacySectionData: "Données collectées", privacySectionLocation: "Localisation", privacySectionUse: "Utilisation des données", privacySectionSecurity: "Sécurité", privacySectionHosting: "Hébergement des données", privacySectionCookies: "Cookies", privacySectionMinors: "Protection des mineurs", privacySectionContact: "Contact",
  privacyControllerText: "Le responsable du traitement des données personnelles est :", privacyWebsite: "Site web", privacyContactLabel: "Contact", privacyDataIntro: "Lors de l'inscription et de l'utilisation, nous collectons :", privacyAccountData: "Informations de compte (email, pseudo, date de naissance)", privacyProfileData: "Informations de profil (photo, biographie, localisation)", privacyTechnicalData: "Données techniques et de navigation", privacyLocationIntro: "Pour accéder à Callo, vous devez autoriser le partage de votre localisation. Nous collectons uniquement votre", privacyCityCountry: "ville et pays", privacyLocationCollectTitle: "Ce que nous collectons", privacyNoGps: "Aucune adresse précise ou coordonnée GPS n'est enregistrée", privacyLocationUseTitle: "Comment vos données sont utilisées", privacyLocationProfile: "Affichage de votre localisation sur votre profil", privacyLocationImprove: "Amélioration de votre expérience sur la plateforme", privacyDeleteTitle: "Suppression de votre compte", privacyDeleteText: "Vous pouvez supprimer votre compte à tout moment depuis les paramètres de votre profil. Cela supprime toutes vos données, y compris votre localisation.", privacySecurityTitle: "Sécurité", privacyLocationSecurity: "Votre localisation est traitée de manière sécurisée et n'est jamais partagée avec des tiers sans votre consentement.", privacyUseText: "Nous utilisons vos données pour fournir, sécuriser et améliorer le service, ainsi que pour respecter nos obligations légales.", privacySecurityText: "Des mesures techniques et organisationnelles appropriées sont mises en place pour protéger vos données.", privacyHostingText: "Hébergement : serveurs sécurisés.", privacyCookiesText1: "Nous utilisons des cookies techniques nécessaires au fonctionnement du service, ainsi que des outils de mesure d'audience et de publicité lorsqu'ils sont activés en production.", privacyCookiesText2: "Si des annonces Google AdSense sont diffusées, Google et ses partenaires peuvent utiliser des cookies pour personnaliser ou mesurer les annonces, limiter la fraude publicitaire et améliorer la pertinence des contenus sponsorisés.", privacyCookiesText3: "Les pages de connexion, d'inscription, de messagerie privée et les espaces personnels ne sont pas destinés à recevoir des annonces.", privacyMinorsText: "L'utilisation de Callo est réservée aux personnes âgées de", privacyContactText: "Pour exercer vos droits ou poser une question",
  collapseSidebar: "Réduire",
  expandSidebar: "Agrandir",
  backLabel: "Retour",
  yearsLabel: "ans",
  allLabel: "Tous",
  feedLoading: "Chargement...",
  feedEmptyTitle: "Aucune publication",
  feedEmptySubtitle: "Soyez le premier à partager quelque chose !",
  feedUpToDate: "Vous êtes à jour",
  commentReplyLabel: "réponse",
  commentEmptyTitle: "Aucun commentaire pour le moment",
  commentEmptySubtitle: "Soyez le premier à commenter !",
  commentReplyPlaceholder: "Répondre à {name}…",
  commentEditPlaceholder: "Modifier le commentaire…",
  commentWritePlaceholder: "Écrire un commentaire...",
  commentJustNow: "À l'instant",
  commentTimeMinute: "m",
  commentTimeHour: "h",
  commentTimeDay: "j",
  commentLike: "J'aime",
  commentUnlike: "Ne plus aimer",
  commentDislike: "Je n'aime pas",
  commentUndo: "Annuler",
  commentActions: "Actions",
  commentReply: "Répondre",
  commentEdit: "Modifier",
  commentDelete: "Supprimer",
  commentReplySub: "Répondre à ce commentaire",
  commentEditSub: "Modifier votre commentaire",
  commentDeleteSub: "Action irréversible",
  commentDeleteTitle: "Supprimer ce commentaire ?",
  commentDeleteConfirm: "Cette action est irréversible.",
  commentCancel: "Annuler",
  commentSave: "Enregistrer",
  commentSend: "Envoyer",
  commentEditing: "Modification",
  commentEdited: "modifié",
  commentInReplyTo: "en réponse à",
  commentReplyTo: "Répondre à",
  commentYou: "Vous",
  commentHide: "Masquer",
  commentReplyWord: "réponse",
  commentRepliesWord: "réponses",
  commentCommentWord: "commentaire",
  commentCommentsWord: "commentaires",
  commentRepliesCount: "{count} {word}",
  commentMoreReplies: "Voir {count} {word} de plus",
  commentMoreComments: "Voir {count} {word} de plus",
  liveLoading: "Chargement…",
  liveLoadingSession: "Chargement du live...",
  liveRetry: "Réessayer",

  liveBroadcastsLive: "{count} diffusions en direct",
  liveNoBroadcasts: "Aucune diffusion",
  livePublicLives: "Lives publics",
  liveLiveNow: "En direct",
  liveEndedTitle: "Live terminé",
  randomCallEndedTitle: "Appel terminé",
  randomCallThanks: "Merci d'avoir participé à cet appel.",
  randomCallLeave: "Quitter l'appel",
  randomCallNewCall: "Nouvel appel",
  randomCallCameraDisabled: "Caméra désactivée",
  randomCallMicMuted: "Micro coupé",
  liveRedirecting: "Redirection vers la liste des lives...",
  liveConnectingWith: "Connexion avec",
  liveConnectingTo: "Connexion à",
  liveVideoSyncing: "Synchronisation vidéo en cours.",
  liveP2PConnecting: "Connexion P2P en cours",
  liveSessionPreparing: "Session en préparation",
  liveInCall: "EN APPEL",
  liveThanks: "Merci d'avoir utilisé Callo",
  liveSecure: "Sécurisé",
  liveInstant: "Instant",
  liveOpen: "Ouvert",
  livePrivate: "Privé",
  liveFast: "Rapide",
  liveLaunchCall: "Lancer un appel",
  liveNewCall: "Nouvel appel",
  liveNotFoundTitle: "Live introuvable",
  liveNotFoundSubtitle: "Ce live n'existe pas ou a été terminé",
  liveBackToList: "Retour aux lives",
  liveWaitingHost: "En attente de l'hôte...",
  liveMuteMic: "Couper le micro",
  liveEnableMic: "Activer le micro",
  liveDisableCamera: "Couper la caméra",
  liveEnableCamera: "Activer la caméra",
  liveSwitchCamera: "Retourner la caméra",
  liveEndSession: "Terminer le live",
  liveLeave: "Quitter",
  liveStepDown: "Passer en spectateur",
  liveDemote: "Descendre",
  liveViewerMode: "Vous êtes spectateur",
  liveJoin: "Rejoindre",
  liveFull: "Complet",
  liveTrending: "Tendance",
  liveViewers: "Spectateurs",
  liveParticipants: "Participants",
  liveRequests: "Demandes",
  liveInvite: "Inviter",
  liveComments: "Commentaires",
  liveJoinSession: "Rejoignez une session ou lancez la vôtre en quelques secondes.",
  liveMoreLives: "Plus de lives",
  liveCountLabel: "{count} lives",
  liveCreateLive: "Créer un live",
  liveNoLive: "Aucun live en cours",
  liveStartSession: "Soyez le premier à lancer une session et invitez votre communauté en temps réel.",
  liveLaunchLive: "Lancer un live",
  liveRandomCall: "Appel aléatoire",
  randomHeroConnect: "Connecte.",
  randomHeroClick: "Clique.",
  randomHeroSpeak: "Parle.",
  randomActionLabel: "Action",
  randomLaunchNow: "Lancer maintenant",
  randomBlockUserConfirm: "Voulez-vous vraiment bloquer {name} ?",
  liveDialogSubtitle: "8 invités · spectateurs illimités",
  liveTitlePlaceholder: "Titre de votre live...",
  liveQuickSuggestions: "Suggestions rapides",
  liveSwipe: "Glisser",
  liveDescriptionOptional: "Description (optionnelle)",
  liveStarting: "Démarrage...",
  liveStart: "Démarrer le live",
  liveSuggestion1: "Viens me parler !",
  liveSuggestion2: "🎥 Questions live",
  liveSuggestion3: "🔥 Débat ouvert",
  liveSuggestion4: "🚀 On monte ensemble",
  liveSuggestion5: "💬 Rejoins la famille",
  friendsNoFriendYet: "Aucun ami pour le moment",
  friendsNoFriendYetDesc: "Commencez par rencontrer des personnes et ajoutez-les comme amis",
  friendsNoRequestYet: "Aucune demande en attente",
  friendsRequestsDesc: "Les demandes d'amis reçues apparaîtront ici",
  friendsNoSentYet: "Aucune demande envoyée",
  friendsSentDesc: "Les demandes d'amis envoyées apparaîtront ici",
  friendsTabFriends: "Amis",
  friendsTabRequests: "Demandes",
  friendsTabSent: "Envoyées",
  friendsTitleMyFriends: "Mes amis",
  friendsHeaderStats: "{contacts} contacts{onlinePart}",
  friendsOnlineLabel: "en ligne",
  friendsSubtitleManageContacts: "Gérez vos contacts",
  friendsNewCall: "Nouvel appel",
  friendsCallShort: "Appel",
  friendsSendMessage: "Envoyer un message",
  friendsRemoveFriend: "Retirer cet ami",
  friendsAccept: "Accepter",
  friendsReject: "Refuser",
  friendsWaiting: "En attente",
  friendsRemoveConfirm: "Retirer cet ami ?",
  friendsNoResult: "Aucun résultat",
  friendsSearchNoResult: "Aucun ami ne correspond à \"{search}\"",
  friendsStartCall: "Démarrer un appel",
  friendsOnline: "● En ligne",
  friendsStartConversation: "Démarrer une conversation",
  discoverTitle: "Découvrir",
  discoverForYou: "Pour vous",
  discoverNearby: "À proximité",
  discoverOnline: "En ligne",
  discoverPopular: "Populaires",
  discoverViewGrid: "Vue grille",
  discoverViewMap: "Vue carte",
  discoverFilters: "Filtres",
  discoverResetFilters: "Réinitialiser",
  discoverAllCountries: "Tous les pays",
  discoverAllLanguages: "Toutes les langues",
  discoverOnlineOnly: "En ligne uniquement",
  discoverNearbySection: "À proximité",
  discoverShowAll: "Voir tout",
  discoverClearFilters: "Effacer les filtres",
  discoverNoUsers: "Aucun utilisateur trouvé",
  discoverNoUsersDesc: "Essayez de modifier vos filtres ou votre recherche",
  discoverNoLocalizedUsers: "Aucun utilisateur localisé",
  discoverNoLocalizedUsersDesc: "Les utilisateurs apparaîtront ici quand ils partagent leur position",
  discoverFounder: "Fondateur",
  discoverPeopleCount: "{count} personnes",
  discoverSearchPlaceholder: "Nom, pseudo ou bio…",
  discoverGPSRequired: "GPS requis",
  discoverResultsCount: "{count} résultats",
  discoverAdd: "Ajouter",
  discoverRequestSent: "Demande envoyée",
  discoverViewProfile: "Voir le profil",
  discoverSent: "Envoyé ✓",
  notificationsTitle: "Notifications",
  notificationsSubtitle: "Restez informé de vos interactions",
  notificationsSomeone: "Quelqu'un",
  notificationsAnd: "et",
  notificationsOther: "autre",
  notificationsOthers: "autres",
  notificationsToday: "Aujourd'hui",
  notificationsYesterday: "Hier",
  notificationsThisWeek: "Cette semaine",
  notificationsOlder: "Plus ancien",
  notificationsAll: "Toutes",
  notificationsUnread: "Non lues",
  notificationsNoNotifications: "Aucune notification",
  notificationsUpToDate: "Vous êtes à jour !",
  notificationsNoUnread: "Les notifications de vos interactions apparaîtront ici",
  notificationsDelete: "Supprimer",
  notificationsNew: "Nouveau",
  notificationsCallReactionSingle: "{name} a réagi à votre appel",
  notificationsCallReactionMultiple: "{names} ont réagi à vos appels",
  notificationsLikeCommentSingle: "{name} a réagi à votre commentaire",
  notificationsLikePostSingle: "{name} a réagi à votre publication",
  notificationsLikeProfileSingle: "{name} a aimé votre profil",
  notificationsLikeCommentMultiple: "{names} ont réagi à votre commentaire",
  notificationsLikePostMultiple: "{names} ont réagi à votre publication",
  notificationsLikeProfileMultiple: "{names} ont aimé votre profil",
  notificationsDislikeCommentSingle: "{name} a réagi à votre commentaire",
  notificationsDislikePostSingle: "{name} a réagi à votre publication",
  notificationsDislikeProfileSingle: "{name} n'a pas aimé votre profil",
  notificationsDislikeCommentMultiple: "{names} ont réagi à votre commentaire",
  notificationsDislikePostMultiple: "{names} ont réagi à votre publication",
  notificationsDislikeProfileMultiple: "{names} n'ont pas aimé votre profil",
  notificationsFriendRequestSingle: "{name} vous a envoyé une demande d'ami",
  notificationsFriendRejectedSingle: "{name} a refusé votre demande d'ami",
  notificationsFriendAcceptedSingle: "{name} a accepté votre demande d'ami",
  notificationsProfileViewSingle: "{name} a consulté votre profil",
  notificationsProfileViewMultiple: "{names} ont consulté votre profil",
  notificationsMessageReplySingle: "{name} a répondu à votre commentaire",
  notificationsMessageCommentSingle: "{name} a commenté votre publication",
  notificationsMessagePostSingle: "{name} a commenté votre publication",
  notificationsMessageDirectSingle: "{name} vous a envoyé un message",
  notificationsMessageReplyMultiple: "{names} ont répondu à votre commentaire",
  notificationsMessageCommentMultiple: "{names} ont commenté votre publication",
  notificationsMessagePostMultiple: "{names} ont commenté votre publication",
  notificationsMessageDirectMultiple: "{names} vous ont envoyé des messages",
  notificationsLiveInvitationSingle: "{name} vous invite à rejoindre son live",
  notificationsLiveJoinRequestSingle: "{name} demande à rejoindre votre live",
  notificationsLiveStartedSingle: "{name} est en live",
  notificationsGenericSingle: "{name} a interagi avec vous",
  notificationsGenericMultiple: "{names} ont interagi avec vous",
  notificationsCallReactionsTitle: "Réactions à vos appels",
  notificationsReactionsCount: "Réactions : {count}",
  notificationsNoReactionYet: "Aucune réaction pour le moment",
  notificationsProfileVisitorsTitle: "Visiteurs de votre profil",
  notificationsVisitorsCount: "Visites : {count}",
  notificationsNoVisitorsYet: "Aucun visiteur pour le moment",
  notificationsPeople: "personnes",
  chatNoConversation: "Aucune conversation",
  chatAllRead: "Tout lu ✓",
  chatPersonOnline: "Personne en ligne",
  chatOffline: "Hors ligne",
  chatSeenAt: "Vu à",
  chatSeenYesterdayAt: "Vu hier à",
  chatSeenOn: "Vu le",
  chatYourMessage: "Votre message",
  chatMedia: "Média",
  chatEditContent: "Éditer le contenu",
  chatDeleteForEveryone: "Supprime pour tout le monde",
  chatRecording: "Enregistrement…",
  chatFinish: "Terminer",
  chatVoiceReady: "Message vocal prêt",
  chatMicAccessError: "Impossible d'accéder au microphone",
  chatSearchInConversation: "Rechercher dans la conversation…",
  chatStartConversationTitle: "Démarrez la conversation",
  chatSayHello: "Dites bonjour à {name} !",
  chatNewMessages: "Nouveaux messages",
  chatDeletedMessage: "Message supprimé",
  chatEditMessage: "Modifier le message",
  chatMessagePlaceholder: "Message…",
  chatNoMatch: "\"{search}\" introuvable",
  chatNewMessage: "Nouveau message",
  chatChooseContact: "Choisissez un contact et commencez instantanément",
  chatSearchPlaceholder: "Rechercher…",
  chatSearchContact: "Rechercher un contact…",
  chatContacts: "contact{plural}",
  chatNoContactAvailable: "Aucun contact disponible",
  chatNoFriendFound: "Aucun ami trouvé",
  chatFriends: "Amis",
  chatRecents: "Récents",
  chatStartConversation: "Démarrer une conversation",
  chatOpenConversation: "Ouvrir la conversation",
  chatYou: "Vous",
  reactionLiked: "a aimé",
  reactionDisliked: "n'a pas aimé",
  chatUnknown: "Inconnu",
  chatVideo: "Vidéo",
  chatVoiceMessage: "Message vocal",
  chatPhoto: "Photo",
  chatFile: "Fichier",
  chatUnreadFilter: "Non lus",
  chatOnlineFilter: "En ligne",
  chatUnreadCount: "{count} non lu{plural}",
  chatConversationsCount: "{count} conversation{plural}",
  chatEmptyHint: "Appuyez sur + pour envoyer votre premier message",
  chatYesterday: "Hier",
  postVisibilityPublic: "Public",
  postVisibilityFriends: "Amis",
  postVisibilityPrivate: "Privé",
  postComposerPrompt: "Quoi de neuf ? Partagez quelque chose...",
  postNewPublication: "Nouvelle publication",
  postWriteSomething: "Écrivez quelque chose... Utilisez des #hashtags",
  postAddImage: "Ajouter une image",
  postAddVideo: "Ajouter une vidéo",
  postVideosTab: "Vidéos",
  postStep: "Étape",
  postHashtagTip: "Astuce : utilisez des #hashtags",
  postDropMedia: "Déposez vos images/vidéos ou cliquez (max 9)",
  postVisibility: "Visibilité",
  postAllowComments: "Autoriser les commentaires",
  postTrendingTitle: "Tendances",
  postGuestOverlayTitle: "Rejoignez la discussion",
  postGuestOverlayDesc: "Connectez-vous à CALLO pour voir cette publication en entier, interagir avec l'auteur et bien plus encore.",
  postNoTrendingNow: "Aucune tendance pour le moment",
  postCustomTags: "Tags personnalisés",
  postAddTag: "Ajouter un tag",
  postWizardStepContent: "Contenu",
  postWizardStepMedia: "Médias",
  postWizardStepTagsSettings: "Tags & Réglages",
  postWizardStepPreview: "Aperçu",
  postVisibilityPublicDesc: "Visible par tous",
  postVisibilityFriendsDesc: "Vos amis uniquement",
  postVisibilityPrivateDesc: "Vous uniquement",
  postYourPublication: "Votre publication",
  nextLabel: "Suivant",
  sendingLabel: "Envoi...",
  postAdd: "Ajouter",
  postCopyLink: "Copier le lien",
  postExternalShare: "Partage externe",
  postReshare: "Repartager",
  postReport: "Signaler",
  postDeleteConfirm: "Supprimer le post ?",
  postShareError: "Erreur de partage",
  postCommentsEnabled: "Commentaires actifs",
  postCommentsDisabled: "Commentaires désactivés",
  postNoTextContent: "Aucun contenu texte",
  postReactAction: "Réagir",
  postCommentAction: "Commenter",
  postShareAction: "Partager",
  postShowMore: "Afficher la suite",
  postReactionCount: "{count} réaction{plural}",
  postViewsWord: "vue{plural}",
  reactionLike: "J'aime",
  reactionLove: "J'adore",
  reactionHaha: "Haha",
  reactionWow: "Wow",
  reactionSad: "Triste",
  reactionFire: "Feu",
  reactionClap: "Bravo",
  profileVideoCalls: "Appels vidéo",
  profileCallsCompleted: "terminés",
  profileReputation: "Réputation",
  profilePositive: "positive",
  profileLikes: "Likes",
  profileDislikes: "Dislikes",
  profileRecentVisitorsTitle: "Visiteurs récents",
  profileRecentVisitorsSubtitle: "Personnes ayant consulté votre profil",
  profileNoRecentVisitors: "Aucun visiteur récent",
  profileTabPosts: "Publications",
  profileTabVisitors: "Visiteurs",
  profileVisitorsHistoryTitle: "Historique de profil",
  profileVisitorsListTitle: "Liste des visiteurs",
  profileVisitorsTodaySummary: "Visiteurs aujourd'hui",
  profileVisitorsVisitsSummary: "Visites totales",
  postNotFoundMetaTitle: "Publication introuvable — Callo",
  postMetaTitle: "{name} sur Callo",
  postMetaFallbackDescription: "Publication de {name} sur Callo",
  postNotFoundPage: "Publication introuvable",
  navDashboard: "Accueil",
  navLive: "Lives",
  navMessages: "Messages",
  navDiscover: "Découvrir",
  navNotifications: "Notifications",
  navProfile: "Profil",
  navSettings: "Paramètres",
  navLogout: "Déconnexion",
  liveJoinRequest: "Participer",
  liveRequestSending: "Envoi...",
  liveRequestPending: "Attente hôte",
  liveRequestRejected: "Refusé",
  liveRequestRejectedMsg: "Votre demande a été refusée",
  liveInvitationPrompt: "{name} vous invite à monter dans le live",
  liveInvitationAccept: "Accepter",
  liveInvitationReject: "Refuser",
  liveHideComments: "Masquer les commentaires",
  liveShowComments: "Afficher les commentaires",
  liveCameraOff: "Caméra désactivée",
} satisfies Record<string, string>

export type TranslationKey = keyof typeof baseTranslations

type TranslationMap = Record<string, string>

const PUBLIC_PAGE_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  en: {
    publicNavHome: "Home",
    publicNavAbout: "About",
    publicNavContact: "Contact",
    publicNavSafety: "Safety",
    publicNavPrivacy: "Privacy",
    publicNavTerms: "Terms",
    publicNavLegal: "Legal notice",
    aboutMetaTitle: "About Callo | Free social video chat platform",
    aboutMetaDescription: "Discover Callo, a free social platform for random video chat, lives, messaging and posts, with clear safety and moderation rules.",
    aboutStructuredName: "About Callo",
    aboutStructuredDescription: "Callo is a free social platform for random video chat, lives, messaging and posts.",
    aboutBadge: "Social video platform",
    aboutHeroTitle: "Callo makes video meetings simpler, clearer and more responsible.",
    aboutHeroText: "Callo is a free social platform combining random video chat, lives, messaging and posts. The service focuses on accessibility, moderation and transparency to provide a useful experience for visitors and search engines.",
    aboutSafetyCta: "View safety rules",
    aboutInfoTitle: "Public information",
    aboutInfoSubtitle: "Useful for visitors and AdSense review",
    aboutInfoText: "Callo's public pages explain the service, rules, contact options and privacy before any user login.",
    aboutPillarVideoTitle: "Instant video chat",
    aboutPillarVideoText: "Random video calls available from the browser, with no installation, to meet new people quickly.",
    aboutPillarSocialTitle: "Social exchanges",
    aboutPillarSocialText: "Lives, messaging and posts make it possible to continue a conversation beyond the first call.",
    aboutPillarTrustTitle: "Trust framework",
    aboutPillarTrustText: "Public rules, reports and progressive moderation help limit abuse.",
    aboutCommitmentFree: "Free service available without download.",
    aboutCommitmentPublic: "Clear public pages explaining the product, safety and contact options.",
    aboutCommitmentAds: "Ads reserved for areas compatible with platform rules.",
    aboutCommitmentLegal: "Legal information, privacy and terms available from every public page.",
    aboutStatFree: "free",
    aboutStatAge: "minimum age",
    aboutStatAvailable: "available",
    aboutWhyTitle: "Why do these pages exist?",
    aboutWhyText: "A site compatible with advertising must be understandable, accessible and transparent. Callo therefore presents how it works, its rules and its contact options publicly.",
    contactMetaTitle: "Contact Callo | Support, reports and personal data",
    contactMetaDescription: "Contact Callo for support, reports, legal questions, privacy and requests related to personal data.",
    contactStructuredName: "Contact Callo",
    contactBadge: "Official Callo support",
    contactHeroTitle: "Contact, help and reports.",
    contactHeroText: "This page centralizes Callo's public contact options. It helps users, visitors, partners and review services understand how to reach the team depending on the request type.",
    contactBeforeTitle: "Before writing",
    contactBeforeText: "A precise request is easier to process and also helps document important reports.",
    contactSupportTitle: "General support",
    contactSupportText: "Account, login, video calls, lives, messages, posts or technical issue.",
    contactSupportCta: "Write to support",
    contactReportTitle: "Content report",
    contactReportText: "Profile, message, live or post that seems dangerous, abusive, fraudulent or forbidden.",
    contactReportCta: "Send a report",
    contactDataTitle: "Personal data",
    contactDataText: "Access, correction, account deletion request or question about privacy.",
    contactDataCta: "Exercise my rights",
    contactChecklistEmail: "Your contact email address.",
    contactChecklistUsername: "The username or identifier concerned, if available.",
    contactChecklistType: "The type of problem encountered.",
    contactChecklistDescription: "A short and precise description of the situation.",
    contactDocsTitle: "Useful documents",
    contactDocsText: "For privacy, terms of use or editorial responsibility questions, check the public legal pages before sending your request.",
    safetyMetaTitle: "Safety and moderation | Callo public rules",
    safetyMetaDescription: "Read Callo's safety, moderation, reporting and advertising compliance rules.",
    safetyStructuredName: "Callo safety and moderation",
    safetyStructuredDescription: "Public rules for Callo safety, moderation, reporting and advertising compliance.",
    safetyBadge: "Safety and moderation",
    safetyHeroTitle: "Public rules to protect users.",
    safetyHeroText: "Callo is a social platform with user-generated content. The rules below explain forbidden content, moderation, reports and how advertising must remain compatible with a responsible environment.",
    safetyImportantTitle: "Important",
    safetyImportantText: "Ads must not be placed on private screens, pages without useful content, or near forbidden content. Informative public pages are the most appropriate areas.",
    safetyReportCta: "Report a problem",
    safetyBlockReportsTitle: "Accessible reports",
    safetyBlockReportsText: "Users can report a profile, message, live or post that violates the rules.",
    safetyBlockAccountsTitle: "Supervised accounts",
    safetyBlockAccountsText: "Registration requires a valid email address and the service is reserved for people aged at least 16.",
    safetyBlockDataTitle: "Explained data",
    safetyBlockDataText: "Collected data, location and cookies are documented in the privacy policy.",
    safetyBlockPublicTitle: "Readable public pages",
    safetyBlockPublicText: "Rules and contact options are available without login to strengthen service transparency.",
    safetyForbiddenTitle: "Forbidden content and behavior",
    safetyForbiddenText: "These categories guide moderation actions and help maintain an environment compatible with advertising and community standards.",
    safetyForbiddenSexual: "Unsolicited nudity, explicit sexual content or exploitation of minors.",
    safetyForbiddenHarassment: "Harassment, threats, intimidation, discrimination or identity theft.",
    safetyForbiddenSpam: "Spam, phishing, scams, abusive advertising or abusive automation.",
    safetyForbiddenIllegal: "Illegal, violent, terrorist, hateful or dangerous content.",
    safetyForbiddenPersonalData: "Sharing another person's personal data without authorization.",
    safetyForbiddenBypass: "Attempting to bypass moderation or safety tools.",
    safetyProcessTitle: "Report handling",
    safetyProcessText: "The process must remain readable for users and documentable for external partners.",
    safetyRulesCta: "Read the full rules",
    safetyStepLabel: "Step {number}",
    safetyStepReceiveTitle: "Report received",
    safetyStepReceiveText: "The request should contain as many useful details as possible: profile, content, date and context.",
    safetyStepReviewTitle: "Review",
    safetyStepReviewText: "The content is compared with conduct rules and applicable legal obligations.",
    safetyStepActionTitle: "Action",
    safetyStepActionText: "Depending on severity: warning, removal, suspension, ban or report to authorities.",
  },
  es: {
    publicNavHome: "Inicio", publicNavAbout: "Acerca de", publicNavContact: "Contacto", publicNavSafety: "Seguridad", publicNavPrivacy: "Privacidad", publicNavTerms: "Condiciones", publicNavLegal: "Aviso legal",
    aboutBadge: "Plataforma social de video", aboutHeroTitle: "Callo hace que los encuentros por video sean más simples, claros y responsables.", aboutSafetyCta: "Ver reglas de seguridad", aboutInfoTitle: "Información pública", aboutWhyTitle: "¿Por qué existen estas páginas?",
    contactBadge: "Soporte oficial de Callo", contactHeroTitle: "Contacto, ayuda y reportes.", contactBeforeTitle: "Antes de escribir", contactSupportTitle: "Soporte general", contactReportTitle: "Reporte de contenido", contactDataTitle: "Datos personales", contactDocsTitle: "Documentos útiles",
    safetyBadge: "Seguridad y moderación", safetyHeroTitle: "Reglas públicas para proteger a los usuarios.", safetyImportantTitle: "Importante", safetyReportCta: "Reportar un problema", safetyForbiddenTitle: "Contenido y comportamientos prohibidos", safetyProcessTitle: "Tratamiento de reportes", safetyRulesCta: "Leer las reglas completas", safetyStepLabel: "Paso {number}",
  },
  pt: {
    publicNavHome: "Início", publicNavAbout: "Sobre", publicNavContact: "Contato", publicNavSafety: "Segurança", publicNavPrivacy: "Privacidade", publicNavTerms: "Termos", publicNavLegal: "Aviso legal",
    aboutBadge: "Plataforma social de vídeo", aboutHeroTitle: "Callo torna os encontros por vídeo mais simples, claros e responsáveis.", aboutSafetyCta: "Ver regras de segurança", aboutInfoTitle: "Informações públicas", aboutWhyTitle: "Por que estas páginas existem?",
    contactBadge: "Suporte oficial Callo", contactHeroTitle: "Contato, ajuda e denúncias.", contactBeforeTitle: "Antes de escrever", contactSupportTitle: "Suporte geral", contactReportTitle: "Denúncia de conteúdo", contactDataTitle: "Dados pessoais", contactDocsTitle: "Documentos úteis",
    safetyBadge: "Segurança e moderação", safetyHeroTitle: "Regras públicas para proteger os usuários.", safetyImportantTitle: "Importante", safetyReportCta: "Denunciar um problema", safetyForbiddenTitle: "Conteúdos e comportamentos proibidos", safetyProcessTitle: "Tratamento de denúncias", safetyRulesCta: "Ler as regras completas", safetyStepLabel: "Etapa {number}",
  },
  de: {
    publicNavHome: "Startseite", publicNavAbout: "Über uns", publicNavContact: "Kontakt", publicNavSafety: "Sicherheit", publicNavPrivacy: "Datenschutz", publicNavTerms: "Bedingungen", publicNavLegal: "Impressum",
    aboutBadge: "Soziale Videoplattform", aboutHeroTitle: "Callo macht Video-Begegnungen einfacher, klarer und verantwortungsvoller.", aboutSafetyCta: "Sicherheitsregeln ansehen", aboutInfoTitle: "Öffentliche Informationen", aboutWhyTitle: "Warum gibt es diese Seiten?",
    contactBadge: "Offizieller Callo-Support", contactHeroTitle: "Kontakt, Hilfe und Meldungen.", contactBeforeTitle: "Vor dem Schreiben", contactSupportTitle: "Allgemeiner Support", contactReportTitle: "Inhalt melden", contactDataTitle: "Personenbezogene Daten", contactDocsTitle: "Nützliche Dokumente",
    safetyBadge: "Sicherheit und Moderation", safetyHeroTitle: "Öffentliche Regeln zum Schutz der Nutzer.", safetyImportantTitle: "Wichtig", safetyReportCta: "Problem melden", safetyForbiddenTitle: "Verbotene Inhalte und Verhaltensweisen", safetyProcessTitle: "Bearbeitung von Meldungen", safetyRulesCta: "Vollständige Regeln lesen", safetyStepLabel: "Schritt {number}",
  },
  it: {
    publicNavHome: "Home", publicNavAbout: "Chi siamo", publicNavContact: "Contatto", publicNavSafety: "Sicurezza", publicNavPrivacy: "Privacy", publicNavTerms: "Termini", publicNavLegal: "Note legali",
    aboutBadge: "Piattaforma social video", aboutHeroTitle: "Callo rende gli incontri video più semplici, chiari e responsabili.", aboutSafetyCta: "Vedi le regole di sicurezza", aboutInfoTitle: "Informazioni pubbliche", aboutWhyTitle: "Perché esistono queste pagine?",
    contactBadge: "Supporto ufficiale Callo", contactHeroTitle: "Contatto, assistenza e segnalazioni.", contactBeforeTitle: "Prima di scrivere", contactSupportTitle: "Supporto generale", contactReportTitle: "Segnalazione contenuto", contactDataTitle: "Dati personali", contactDocsTitle: "Documenti utili",
    safetyBadge: "Sicurezza e moderazione", safetyHeroTitle: "Regole pubbliche per proteggere gli utenti.", safetyImportantTitle: "Importante", safetyReportCta: "Segnala un problema", safetyForbiddenTitle: "Contenuti e comportamenti vietati", safetyProcessTitle: "Gestione delle segnalazioni", safetyRulesCta: "Leggi le regole complete", safetyStepLabel: "Passaggio {number}",
  },
  ar: {
    publicNavHome: "الرئيسية", publicNavAbout: "حول", publicNavContact: "اتصال", publicNavSafety: "السلامة", publicNavPrivacy: "الخصوصية", publicNavTerms: "الشروط", publicNavLegal: "الإشعارات القانونية",
    aboutBadge: "منصة فيديو اجتماعية", aboutHeroTitle: "يجعل Callo لقاءات الفيديو أبسط وأوضح وأكثر مسؤولية.", aboutSafetyCta: "عرض قواعد السلامة", aboutInfoTitle: "معلومات عامة", aboutWhyTitle: "لماذا توجد هذه الصفحات؟",
    contactBadge: "دعم Callo الرسمي", contactHeroTitle: "الاتصال والمساعدة والبلاغات.", contactBeforeTitle: "قبل الكتابة", contactSupportTitle: "الدعم العام", contactReportTitle: "الإبلاغ عن محتوى", contactDataTitle: "البيانات الشخصية", contactDocsTitle: "مستندات مفيدة",
    safetyBadge: "السلامة والإشراف", safetyHeroTitle: "قواعد عامة لحماية المستخدمين.", safetyImportantTitle: "مهم", safetyReportCta: "الإبلاغ عن مشكلة", safetyForbiddenTitle: "المحتوى والسلوك المحظور", safetyProcessTitle: "معالجة البلاغات", safetyRulesCta: "قراءة القواعد كاملة", safetyStepLabel: "الخطوة {number}",
  },
  tr: {
    publicNavHome: "Ana sayfa", publicNavAbout: "Hakkında", publicNavContact: "İletişim", publicNavSafety: "Güvenlik", publicNavPrivacy: "Gizlilik", publicNavTerms: "Şartlar", publicNavLegal: "Yasal bildirim",
    aboutBadge: "Sosyal video platformu", aboutHeroTitle: "Callo video tanışmalarını daha basit, açık ve sorumlu hale getirir.", aboutSafetyCta: "Güvenlik kurallarını gör", aboutInfoTitle: "Herkese açık bilgiler", aboutWhyTitle: "Bu sayfalar neden var?",
    contactBadge: "Resmi Callo desteği", contactHeroTitle: "İletişim, yardım ve bildirimler.", contactBeforeTitle: "Yazmadan önce", contactSupportTitle: "Genel destek", contactReportTitle: "İçerik bildirimi", contactDataTitle: "Kişisel veriler", contactDocsTitle: "Yararlı belgeler",
    safetyBadge: "Güvenlik ve moderasyon", safetyHeroTitle: "Kullanıcıları koruyan herkese açık kurallar.", safetyImportantTitle: "Önemli", safetyReportCta: "Sorun bildir", safetyForbiddenTitle: "Yasak içerik ve davranışlar", safetyProcessTitle: "Bildirimlerin işlenmesi", safetyRulesCta: "Tüm kuralları oku", safetyStepLabel: "Adım {number}",
  },
  nl: {
    publicNavHome: "Home", publicNavAbout: "Over", publicNavContact: "Contact", publicNavSafety: "Veiligheid", publicNavPrivacy: "Privacy", publicNavTerms: "Voorwaarden", publicNavLegal: "Juridische info",
    aboutBadge: "Sociaal videoplatform", aboutHeroTitle: "Callo maakt video-ontmoetingen eenvoudiger, duidelijker en verantwoordelijker.", aboutSafetyCta: "Bekijk veiligheidsregels", aboutInfoTitle: "Openbare informatie", aboutWhyTitle: "Waarom bestaan deze pagina's?",
    contactBadge: "Officiële Callo-support", contactHeroTitle: "Contact, hulp en meldingen.", contactBeforeTitle: "Voor je schrijft", contactSupportTitle: "Algemene support", contactReportTitle: "Content melden", contactDataTitle: "Persoonsgegevens", contactDocsTitle: "Nuttige documenten",
    safetyBadge: "Veiligheid en moderatie", safetyHeroTitle: "Openbare regels om gebruikers te beschermen.", safetyImportantTitle: "Belangrijk", safetyReportCta: "Probleem melden", safetyForbiddenTitle: "Verboden inhoud en gedrag", safetyProcessTitle: "Afhandeling van meldingen", safetyRulesCta: "Lees alle regels", safetyStepLabel: "Stap {number}",
  },
  ru: {
    publicNavHome: "Главная", publicNavAbout: "О нас", publicNavContact: "Контакт", publicNavSafety: "Безопасность", publicNavPrivacy: "Конфиденциальность", publicNavTerms: "Условия", publicNavLegal: "Правовая информация",
    aboutBadge: "Социальная видеоплатформа", aboutHeroTitle: "Callo делает видеознакомства проще, понятнее и ответственнее.", aboutSafetyCta: "Смотреть правила безопасности", aboutInfoTitle: "Публичная информация", aboutWhyTitle: "Зачем нужны эти страницы?",
    contactBadge: "Официальная поддержка Callo", contactHeroTitle: "Контакты, помощь и жалобы.", contactBeforeTitle: "Перед обращением", contactSupportTitle: "Общая поддержка", contactReportTitle: "Жалоба на контент", contactDataTitle: "Персональные данные", contactDocsTitle: "Полезные документы",
    safetyBadge: "Безопасность и модерация", safetyHeroTitle: "Публичные правила для защиты пользователей.", safetyImportantTitle: "Важно", safetyReportCta: "Сообщить о проблеме", safetyForbiddenTitle: "Запрещенный контент и поведение", safetyProcessTitle: "Обработка жалоб", safetyRulesCta: "Читать все правила", safetyStepLabel: "Шаг {number}",
  },
  zh: {
    publicNavHome: "首页", publicNavAbout: "关于", publicNavContact: "联系", publicNavSafety: "安全", publicNavPrivacy: "隐私", publicNavTerms: "条款", publicNavLegal: "法律声明",
    aboutBadge: "社交视频平台", aboutHeroTitle: "Callo 让视频相遇更简单、更清晰、更负责任。", aboutSafetyCta: "查看安全规则", aboutInfoTitle: "公开信息", aboutWhyTitle: "为什么有这些页面？",
    contactBadge: "Callo 官方支持", contactHeroTitle: "联系、帮助和举报。", contactBeforeTitle: "发送前", contactSupportTitle: "通用支持", contactReportTitle: "内容举报", contactDataTitle: "个人数据", contactDocsTitle: "有用文档",
    safetyBadge: "安全与审核", safetyHeroTitle: "保护用户的公开规则。", safetyImportantTitle: "重要", safetyReportCta: "举报问题", safetyForbiddenTitle: "禁止的内容和行为", safetyProcessTitle: "举报处理", safetyRulesCta: "阅读完整规则", safetyStepLabel: "步骤 {number}",
  },
  ja: {
    publicNavHome: "ホーム", publicNavAbout: "概要", publicNavContact: "お問い合わせ", publicNavSafety: "安全", publicNavPrivacy: "プライバシー", publicNavTerms: "利用規約", publicNavLegal: "法的表示",
    aboutBadge: "ソーシャル動画プラットフォーム", aboutHeroTitle: "Callo は動画での出会いをより簡単で明確、責任あるものにします。", aboutSafetyCta: "安全ルールを見る", aboutInfoTitle: "公開情報", aboutWhyTitle: "なぜこれらのページがあるのですか？",
    contactBadge: "Callo 公式サポート", contactHeroTitle: "連絡、サポート、報告。", contactBeforeTitle: "送信前に", contactSupportTitle: "一般サポート", contactReportTitle: "コンテンツ報告", contactDataTitle: "個人データ", contactDocsTitle: "役立つ文書",
    safetyBadge: "安全とモデレーション", safetyHeroTitle: "ユーザーを守る公開ルール。", safetyImportantTitle: "重要", safetyReportCta: "問題を報告", safetyForbiddenTitle: "禁止される内容と行為", safetyProcessTitle: "報告の処理", safetyRulesCta: "全ルールを読む", safetyStepLabel: "ステップ {number}",
  },
  ko: {
    publicNavHome: "홈", publicNavAbout: "소개", publicNavContact: "연락처", publicNavSafety: "안전", publicNavPrivacy: "개인정보", publicNavTerms: "약관", publicNavLegal: "법적 고지",
    aboutBadge: "소셜 비디오 플랫폼", aboutHeroTitle: "Callo는 영상 만남을 더 쉽고 명확하며 책임 있게 만듭니다.", aboutSafetyCta: "안전 규칙 보기", aboutInfoTitle: "공개 정보", aboutWhyTitle: "이 페이지들이 왜 있나요?",
    contactBadge: "Callo 공식 지원", contactHeroTitle: "연락, 도움 및 신고.", contactBeforeTitle: "작성 전", contactSupportTitle: "일반 지원", contactReportTitle: "콘텐츠 신고", contactDataTitle: "개인 데이터", contactDocsTitle: "유용한 문서",
    safetyBadge: "안전 및 조정", safetyHeroTitle: "사용자를 보호하기 위한 공개 규칙.", safetyImportantTitle: "중요", safetyReportCta: "문제 신고", safetyForbiddenTitle: "금지된 콘텐츠와 행동", safetyProcessTitle: "신고 처리", safetyRulesCta: "전체 규칙 읽기", safetyStepLabel: "단계 {number}",
  },
  hi: {
    publicNavHome: "होम", publicNavAbout: "परिचय", publicNavContact: "संपर्क", publicNavSafety: "सुरक्षा", publicNavPrivacy: "गोपनीयता", publicNavTerms: "शर्तें", publicNavLegal: "कानूनी सूचना",
    aboutBadge: "सामाजिक वीडियो प्लेटफ़ॉर्म", aboutHeroTitle: "Callo वीडियो मुलाकातों को सरल, स्पष्ट और ज़िम्मेदार बनाता है.", aboutSafetyCta: "सुरक्षा नियम देखें", aboutInfoTitle: "सार्वजनिक जानकारी", aboutWhyTitle: "ये पेज क्यों मौजूद हैं?",
    contactBadge: "आधिकारिक Callo सहायता", contactHeroTitle: "संपर्क, सहायता और रिपोर्ट.", contactBeforeTitle: "लिखने से पहले", contactSupportTitle: "सामान्य सहायता", contactReportTitle: "सामग्री रिपोर्ट", contactDataTitle: "व्यक्तिगत डेटा", contactDocsTitle: "उपयोगी दस्तावेज़",
    safetyBadge: "सुरक्षा और मॉडरेशन", safetyHeroTitle: "उपयोगकर्ताओं की रक्षा के लिए सार्वजनिक नियम.", safetyImportantTitle: "महत्वपूर्ण", safetyReportCta: "समस्या रिपोर्ट करें", safetyForbiddenTitle: "प्रतिबंधित सामग्री और व्यवहार", safetyProcessTitle: "रिपोर्ट प्रसंस्करण", safetyRulesCta: "पूरे नियम पढ़ें", safetyStepLabel: "चरण {number}",
  },
}

const ABOUT_PAGE_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  de: {
    aboutMetaTitle: "Über Callo | Kostenlose soziale Videochat-Plattform", aboutMetaDescription: "Entdecke Callo, eine kostenlose soziale Plattform für zufällige Videochats, Livestreams, Nachrichten und Beiträge mit klaren Sicherheits- und Moderationsregeln.", aboutStructuredName: "Über Callo", aboutStructuredDescription: "Callo ist eine kostenlose soziale Plattform für zufällige Videochats, Livestreams, Nachrichten und Beiträge.", aboutHeroText: "Callo ist eine kostenlose soziale Plattform, die zufällige Videochats, Livestreams, Nachrichten und Beiträge verbindet. Der Dienst setzt auf Zugänglichkeit, Moderation und Transparenz, um Besuchern und Suchmaschinen eine verständliche Erfahrung zu bieten.",
    aboutInfoSubtitle: "Nützlich für Besucher und die AdSense-Prüfung", aboutInfoText: "Die öffentlichen Callo-Seiten erklären den Dienst, die Regeln, die Kontaktmöglichkeiten und den Datenschutz vor jeder Anmeldung.", aboutPillarVideoTitle: "Sofortiger Videochat", aboutPillarVideoText: "Zufällige Videoanrufe direkt im Browser und ohne Installation, um schnell neue Menschen kennenzulernen.", aboutPillarSocialTitle: "Sozialer Austausch", aboutPillarSocialText: "Livestreams, Nachrichten und Beiträge ermöglichen es, ein Gespräch über den ersten Anruf hinaus fortzusetzen.", aboutPillarTrustTitle: "Vertrauensrahmen", aboutPillarTrustText: "Öffentliche Regeln, Meldungen und eine schrittweise Moderation helfen, Missbrauch zu begrenzen.", aboutCommitmentFree: "Kostenloser Dienst ohne Download.", aboutCommitmentPublic: "Klare öffentliche Seiten erklären Produkt, Sicherheit und Kontaktmöglichkeiten.", aboutCommitmentAds: "Werbung bleibt auf Bereiche beschränkt, die mit den Plattformregeln vereinbar sind.", aboutCommitmentLegal: "Rechtliche Informationen, Datenschutz und Bedingungen sind auf jeder öffentlichen Seite verfügbar.", aboutStatFree: "kostenlos", aboutStatAge: "Mindestalter", aboutStatAvailable: "verfügbar", aboutWhyText: "Eine werbekompatible Website muss verständlich, zugänglich und transparent sein. Deshalb erklärt Callo öffentlich seine Funktionsweise, Regeln und Kontaktmöglichkeiten.",
  },
  it: {
    aboutMetaTitle: "Chi siamo | Piattaforma social di videochat gratuita", aboutMetaDescription: "Scopri Callo, una piattaforma social gratuita per videochat casuali, live, messaggi e post, con regole chiare di sicurezza e moderazione.", aboutStructuredName: "Chi siamo - Callo", aboutStructuredDescription: "Callo è una piattaforma social gratuita per videochat casuali, live, messaggi e post.", aboutHeroText: "Callo è una piattaforma social gratuita che combina videochat casuali, live, messaggi e post. Il servizio punta su accessibilità, moderazione e trasparenza per offrire un'esperienza chiara ai visitatori e ai motori di ricerca.",
    aboutInfoSubtitle: "Utile per i visitatori e la verifica AdSense", aboutInfoText: "Le pagine pubbliche di Callo spiegano il servizio, le regole, i contatti e la privacy prima di qualsiasi accesso.", aboutPillarVideoTitle: "Videochat istantanea", aboutPillarVideoText: "Videochiamate casuali dal browser, senza installazione, per conoscere rapidamente nuove persone.", aboutPillarSocialTitle: "Scambi sociali", aboutPillarSocialText: "Live, messaggi e post permettono di continuare una conversazione oltre la prima chiamata.", aboutPillarTrustTitle: "Quadro di fiducia", aboutPillarTrustText: "Regole pubbliche, segnalazioni e moderazione progressiva aiutano a limitare gli abusi.", aboutCommitmentFree: "Servizio gratuito e accessibile senza download.", aboutCommitmentPublic: "Pagine pubbliche chiare per spiegare il prodotto, la sicurezza e i contatti.", aboutCommitmentAds: "Pubblicità riservata agli spazi compatibili con le regole della piattaforma.", aboutCommitmentLegal: "Informazioni legali, privacy e condizioni disponibili da ogni pagina pubblica.", aboutStatFree: "gratuito", aboutStatAge: "età minima", aboutStatAvailable: "accessibile", aboutWhyText: "Un sito compatibile con la pubblicità deve essere comprensibile, accessibile e trasparente. Callo presenta quindi pubblicamente il suo funzionamento, le regole e i contatti.",
  },
  ar: {
    aboutMetaTitle: "عن Callo | منصة دردشة فيديو اجتماعية مجانية", aboutMetaDescription: "اكتشف Callo، منصة اجتماعية مجانية للدردشة العشوائية بالفيديو والبث المباشر والرسائل والمنشورات، مع قواعد واضحة للسلامة والإشراف.", aboutStructuredName: "عن Callo", aboutStructuredDescription: "Callo منصة اجتماعية مجانية للدردشة العشوائية بالفيديو والبث المباشر والرسائل والمنشورات.", aboutHeroText: "Callo منصة اجتماعية مجانية تجمع بين الدردشة العشوائية بالفيديو والبث المباشر والرسائل والمنشورات. نركز على سهولة الوصول والإشراف والشفافية لتقديم تجربة واضحة للزوار ومحركات البحث.",
    aboutInfoSubtitle: "مفيد للزوار ولمراجعة AdSense", aboutInfoText: "تشرح صفحات Callo العامة الخدمة والقواعد وطرق الاتصال والخصوصية قبل تسجيل الدخول.", aboutPillarVideoTitle: "دردشة فيديو فورية", aboutPillarVideoText: "مكالمات فيديو عشوائية من المتصفح دون تثبيت، للتعرف بسرعة على أشخاص جدد.", aboutPillarSocialTitle: "تواصل اجتماعي", aboutPillarSocialText: "تتيح البثوث المباشرة والرسائل والمنشورات مواصلة الحوار بعد المكالمة الأولى.", aboutPillarTrustTitle: "إطار من الثقة", aboutPillarTrustText: "تساعد القواعد العامة والبلاغات والإشراف التدريجي على الحد من إساءة الاستخدام.", aboutCommitmentFree: "خدمة مجانية ومتاحة دون تنزيل.", aboutCommitmentPublic: "صفحات عامة واضحة تشرح المنتج والسلامة وطرق الاتصال.", aboutCommitmentAds: "تُعرض الإعلانات في مساحات متوافقة مع قواعد المنصة.", aboutCommitmentLegal: "المعلومات القانونية والخصوصية والشروط متاحة من كل صفحة عامة.", aboutStatFree: "مجاني", aboutStatAge: "الحد الأدنى للعمر", aboutStatAvailable: "متاح", aboutWhyText: "يجب أن يكون الموقع المتوافق مع الإعلانات مفهوماً وسهل الوصول وشفافاً. لذلك تعرض Callo طريقة عملها وقواعدها وطرق الاتصال بها بشكل عام.",
  },
  tr: {
    aboutMetaTitle: "Callo Hakkında | Ücretsiz sosyal görüntülü sohbet platformu", aboutMetaDescription: "Güvenlik ve moderasyon kuralları açık olan ücretsiz rastgele görüntülü sohbet, canlı yayın, mesajlaşma ve gönderi platformu Callo'yu keşfedin.", aboutStructuredName: "Callo hakkında", aboutStructuredDescription: "Callo, rastgele görüntülü sohbet, canlı yayın, mesajlaşma ve gönderiler sunan ücretsiz bir sosyal platformdur.", aboutHeroText: "Callo, rastgele görüntülü sohbeti, canlı yayınları, mesajlaşmayı ve gönderileri bir araya getiren ücretsiz bir sosyal platformdur. Hizmet, ziyaretçilere ve arama motorlarına anlaşılır bir deneyim sunmak için erişilebilirlik, moderasyon ve şeffaflığa önem verir.",
    aboutInfoSubtitle: "Ziyaretçiler ve AdSense incelemesi için yararlı", aboutInfoText: "Callo'nun herkese açık sayfaları, kullanıcı girişi öncesinde hizmeti, kuralları, iletişim seçeneklerini ve gizliliği açıklar.", aboutPillarVideoTitle: "Anında görüntülü sohbet", aboutPillarVideoText: "Yeni insanlarla hızlıca tanışmak için kurulum gerektirmeyen, tarayıcı üzerinden rastgele görüntülü aramalar.", aboutPillarSocialTitle: "Sosyal etkileşimler", aboutPillarSocialText: "Canlı yayınlar, mesajlaşma ve gönderiler ilk görüşmenin ötesinde sohbete devam etmeyi sağlar.", aboutPillarTrustTitle: "Güven çerçevesi", aboutPillarTrustText: "Herkese açık kurallar, bildirimler ve kademeli moderasyon kötüye kullanımı sınırlamaya yardımcı olur.", aboutCommitmentFree: "İndirme gerektirmeyen ücretsiz ve erişilebilir hizmet.", aboutCommitmentPublic: "Ürünü, güvenliği ve iletişim seçeneklerini açıklayan açık herkese açık sayfalar.", aboutCommitmentAds: "Reklamlar platform kurallarıyla uyumlu alanlarla sınırlıdır.", aboutCommitmentLegal: "Yasal bilgiler, gizlilik ve şartlar her herkese açık sayfadan erişilebilir.", aboutStatFree: "ücretsiz", aboutStatAge: "minimum yaş", aboutStatAvailable: "erişilebilir", aboutWhyText: "Reklamlarla uyumlu bir site anlaşılır, erişilebilir ve şeffaf olmalıdır. Bu nedenle Callo çalışma şeklini, kurallarını ve iletişim yollarını herkese açık biçimde sunar.",
  },
  nl: {
    aboutMetaTitle: "Over Callo | Gratis sociaal videochatplatform", aboutMetaDescription: "Ontdek Callo, een gratis sociaal platform voor willekeurige videochat, lives, berichten en berichten, met duidelijke veiligheids- en moderatieregels.", aboutStructuredName: "Over Callo", aboutStructuredDescription: "Callo is een gratis sociaal platform voor willekeurige videochat, lives, berichten en posts.", aboutHeroText: "Callo is een gratis sociaal platform dat willekeurige videochat, lives, berichten en posts combineert. De dienst richt zich op toegankelijkheid, moderatie en transparantie voor een duidelijke ervaring voor bezoekers en zoekmachines.",
    aboutInfoSubtitle: "Nuttig voor bezoekers en AdSense-beoordeling", aboutInfoText: "De openbare Callo-pagina's leggen de dienst, regels, contactmogelijkheden en privacy uit voordat je inlogt.", aboutPillarVideoTitle: "Directe videochat", aboutPillarVideoText: "Willekeurige videogesprekken vanuit de browser, zonder installatie, om snel nieuwe mensen te ontmoeten.", aboutPillarSocialTitle: "Sociale uitwisseling", aboutPillarSocialText: "Lives, berichten en posts maken het mogelijk om een gesprek na het eerste gesprek voort te zetten.", aboutPillarTrustTitle: "Vertrouwenskader", aboutPillarTrustText: "Openbare regels, meldingen en stapsgewijze moderatie helpen misbruik te beperken.", aboutCommitmentFree: "Gratis dienst zonder download.", aboutCommitmentPublic: "Duidelijke openbare pagina's over het product, veiligheid en contactmogelijkheden.", aboutCommitmentAds: "Advertenties zijn beperkt tot gebieden die passen bij de platformregels.", aboutCommitmentLegal: "Juridische informatie, privacy en voorwaarden zijn vanaf elke openbare pagina beschikbaar.", aboutStatFree: "gratis", aboutStatAge: "minimumleeftijd", aboutStatAvailable: "beschikbaar", aboutWhyText: "Een advertentievriendelijke site moet begrijpelijk, toegankelijk en transparant zijn. Daarom legt Callo zijn werking, regels en contactmogelijkheden openbaar uit.",
  },
  ru: {
    aboutMetaTitle: "О Callo | Бесплатная социальная видеоплатформа", aboutMetaDescription: "Познакомьтесь с Callo — бесплатной социальной платформой для случайных видеочатов, трансляций, сообщений и публикаций с понятными правилами безопасности и модерации.", aboutStructuredName: "О Callo", aboutStructuredDescription: "Callo — бесплатная социальная платформа для случайных видеочатов, трансляций, сообщений и публикаций.", aboutHeroText: "Callo — бесплатная социальная платформа, объединяющая случайные видеочаты, трансляции, сообщения и публикации. Мы уделяем внимание доступности, модерации и прозрачности, чтобы сделать сервис понятным для посетителей и поисковых систем.",
    aboutInfoSubtitle: "Полезно для посетителей и проверки AdSense", aboutInfoText: "На публичных страницах Callo описаны сервис, правила, способы связи и конфиденциальность до входа пользователя.", aboutPillarVideoTitle: "Мгновенный видеочат", aboutPillarVideoText: "Случайные видеозвонки в браузере без установки, чтобы быстро знакомиться с новыми людьми.", aboutPillarSocialTitle: "Социальное общение", aboutPillarSocialText: "Трансляции, сообщения и публикации позволяют продолжить разговор после первого звонка.", aboutPillarTrustTitle: "Основа доверия", aboutPillarTrustText: "Публичные правила, жалобы и постепенная модерация помогают ограничивать нарушения.", aboutCommitmentFree: "Бесплатный сервис без скачивания.", aboutCommitmentPublic: "Понятные публичные страницы о продукте, безопасности и контактах.", aboutCommitmentAds: "Реклама размещается только в областях, совместимых с правилами платформы.", aboutCommitmentLegal: "Правовая информация, политика конфиденциальности и условия доступны с каждой публичной страницы.", aboutStatFree: "бесплатно", aboutStatAge: "минимальный возраст", aboutStatAvailable: "доступен", aboutWhyText: "Сайт, совместимый с рекламой, должен быть понятным, доступным и прозрачным. Поэтому Callo публично рассказывает о своей работе, правилах и способах связи.",
  },
  zh: {
    aboutMetaTitle: "关于 Callo | 免费社交视频聊天平台", aboutMetaDescription: "了解 Callo：一个提供随机视频聊天、直播、消息和帖子服务的免费社交平台，并设有清晰的安全与审核规则。", aboutStructuredName: "关于 Callo", aboutStructuredDescription: "Callo 是一个提供随机视频聊天、直播、消息和帖子的免费社交平台。", aboutHeroText: "Callo 是一个集随机视频聊天、直播、消息和帖子于一体的免费社交平台。我们重视易用性、审核和透明度，为访客和搜索引擎提供清晰的服务体验。",
    aboutInfoSubtitle: "方便访客和 AdSense 审核", aboutInfoText: "Callo 的公开页面在用户登录前说明服务、规则、联系方式和隐私政策。", aboutPillarVideoTitle: "即时视频聊天", aboutPillarVideoText: "无需安装即可在浏览器中进行随机视频通话，快速认识新朋友。", aboutPillarSocialTitle: "社交交流", aboutPillarSocialText: "直播、消息和帖子让你可以在第一次通话后继续交流。", aboutPillarTrustTitle: "信任体系", aboutPillarTrustText: "公开规则、举报和渐进式审核有助于减少滥用行为。", aboutCommitmentFree: "免费服务，无需下载。", aboutCommitmentPublic: "清晰的公开页面介绍产品、安全和联系方式。", aboutCommitmentAds: "广告仅展示在符合平台规则的区域。", aboutCommitmentLegal: "法律信息、隐私政策和条款可从每个公开页面访问。", aboutStatFree: "免费", aboutStatAge: "最低年龄", aboutStatAvailable: "可用", aboutWhyText: "适合投放广告的网站必须易于理解、方便访问并保持透明。因此，Callo 公开介绍其运作方式、规则和联系方式。",
  },
  ja: {
    aboutMetaTitle: "Calloについて | 無料のソーシャルビデオチャットプラットフォーム", aboutMetaDescription: "明確な安全・モデレーションルールを備えた、ランダムビデオチャット、ライブ配信、メッセージ、投稿の無料ソーシャルプラットフォーム Callo を紹介します。", aboutStructuredName: "Calloについて", aboutStructuredDescription: "Calloはランダムビデオチャット、ライブ配信、メッセージ、投稿を提供する無料のソーシャルプラットフォームです。", aboutHeroText: "Calloはランダムビデオチャット、ライブ配信、メッセージ、投稿を組み合わせた無料のソーシャルプラットフォームです。アクセスしやすさ、モデレーション、透明性を重視し、訪問者と検索エンジンにわかりやすいサービスを提供します。",
    aboutInfoSubtitle: "訪問者とAdSense審査に役立つ情報", aboutInfoText: "Calloの公開ページでは、ユーザーがログインする前にサービス、ルール、連絡先、プライバシーについて説明しています。", aboutPillarVideoTitle: "すぐに使えるビデオチャット", aboutPillarVideoText: "インストール不要でブラウザからランダムビデオ通話を利用し、新しい人とすぐに出会えます。", aboutPillarSocialTitle: "ソーシャルな交流", aboutPillarSocialText: "ライブ配信、メッセージ、投稿によって、最初の通話の後も会話を続けられます。", aboutPillarTrustTitle: "信頼の仕組み", aboutPillarTrustText: "公開ルール、報告機能、段階的なモデレーションが不正利用の抑制に役立ちます。", aboutCommitmentFree: "ダウンロード不要で利用できる無料サービス。", aboutCommitmentPublic: "製品、安全性、連絡先を説明するわかりやすい公開ページ。", aboutCommitmentAds: "広告はプラットフォームのルールに適合する場所に限定されます。", aboutCommitmentLegal: "法的情報、プライバシー、利用規約は各公開ページから確認できます。", aboutStatFree: "無料", aboutStatAge: "最低年齢", aboutStatAvailable: "利用可能", aboutWhyText: "広告に適したサイトは、わかりやすく、利用しやすく、透明でなければなりません。そのためCalloは、サービスの仕組み、ルール、連絡方法を公開しています。",
  },
  ko: {
    aboutMetaTitle: "Callo 소개 | 무료 소셜 영상 채팅 플랫폼", aboutMetaDescription: "명확한 안전 및 운영 규칙을 갖춘 무료 랜덤 영상 채팅, 라이브, 메시지 및 게시물 소셜 플랫폼 Callo를 만나보세요.", aboutStructuredName: "Callo 소개", aboutStructuredDescription: "Callo는 랜덤 영상 채팅, 라이브, 메시지 및 게시물을 제공하는 무료 소셜 플랫폼입니다.", aboutHeroText: "Callo는 랜덤 영상 채팅, 라이브, 메시지 및 게시물을 결합한 무료 소셜 플랫폼입니다. 방문자와 검색 엔진이 서비스를 쉽게 이해할 수 있도록 접근성, 운영 및 투명성을 중요하게 생각합니다.",
    aboutInfoSubtitle: "방문자와 AdSense 검토에 유용", aboutInfoText: "Callo의 공개 페이지에서는 로그인 전에 서비스, 규칙, 연락처 및 개인정보 보호를 설명합니다.", aboutPillarVideoTitle: "즉시 영상 채팅", aboutPillarVideoText: "설치 없이 브라우저에서 랜덤 영상 통화를 이용하고 새로운 사람을 빠르게 만날 수 있습니다.", aboutPillarSocialTitle: "소셜 교류", aboutPillarSocialText: "라이브, 메시지 및 게시물을 통해 첫 통화 이후에도 대화를 이어갈 수 있습니다.", aboutPillarTrustTitle: "신뢰의 기준", aboutPillarTrustText: "공개 규칙, 신고 및 단계적 운영은 악용을 줄이는 데 도움이 됩니다.", aboutCommitmentFree: "다운로드 없이 이용할 수 있는 무료 서비스.", aboutCommitmentPublic: "제품, 안전 및 연락처를 설명하는 명확한 공개 페이지.", aboutCommitmentAds: "광고는 플랫폼 규칙에 맞는 영역에만 표시됩니다.", aboutCommitmentLegal: "법률 정보, 개인정보 보호정책 및 약관은 모든 공개 페이지에서 확인할 수 있습니다.", aboutStatFree: "무료", aboutStatAge: "최소 연령", aboutStatAvailable: "이용 가능", aboutWhyText: "광고에 적합한 사이트는 이해하기 쉽고 접근 가능하며 투명해야 합니다. 따라서 Callo는 서비스 운영 방식, 규칙 및 연락 방법을 공개합니다.",
  },
  hi: {
    aboutMetaTitle: "Callo के बारे में | मुफ़्त सामाजिक वीडियो चैट प्लेटफ़ॉर्म", aboutMetaDescription: "Callo के बारे में जानें: स्पष्ट सुरक्षा और मॉडरेशन नियमों वाला मुफ़्त सामाजिक प्लेटफ़ॉर्म, जिसमें रैंडम वीडियो चैट, लाइव, संदेश और पोस्ट शामिल हैं।", aboutStructuredName: "Callo के बारे में", aboutStructuredDescription: "Callo रैंडम वीडियो चैट, लाइव, संदेश और पोस्ट वाला एक मुफ़्त सामाजिक प्लेटफ़ॉर्म है।", aboutHeroText: "Callo एक मुफ़्त सामाजिक प्लेटफ़ॉर्म है जो रैंडम वीडियो चैट, लाइव, संदेश और पोस्ट को एक साथ लाता है। आगंतुकों और सर्च इंजन के लिए स्पष्ट अनुभव देने के लिए सेवा पहुँच, मॉडरेशन और पारदर्शिता पर ध्यान देती है।",
    aboutInfoSubtitle: "आगंतुकों और AdSense समीक्षा के लिए उपयोगी", aboutInfoText: "Callo के सार्वजनिक पेज लॉगिन से पहले सेवा, नियमों, संपर्क विकल्पों और निजता की जानकारी देते हैं।", aboutPillarVideoTitle: "तुरंत वीडियो चैट", aboutPillarVideoText: "बिना इंस्टॉलेशन ब्राउज़र से रैंडम वीडियो कॉल करें और जल्दी नए लोगों से मिलें।", aboutPillarSocialTitle: "सामाजिक बातचीत", aboutPillarSocialText: "लाइव, संदेश और पोस्ट पहली कॉल के बाद भी बातचीत जारी रखने में मदद करते हैं।", aboutPillarTrustTitle: "विश्वास का ढाँचा", aboutPillarTrustText: "सार्वजनिक नियम, रिपोर्ट और क्रमिक मॉडरेशन दुरुपयोग को सीमित करने में मदद करते हैं।", aboutCommitmentFree: "डाउनलोड के बिना उपलब्ध मुफ़्त सेवा।", aboutCommitmentPublic: "उत्पाद, सुरक्षा और संपर्कों की जानकारी देने वाले स्पष्ट सार्वजनिक पेज।", aboutCommitmentAds: "विज्ञापन केवल प्लेटफ़ॉर्म के नियमों के अनुकूल स्थानों पर दिखाए जाते हैं।", aboutCommitmentLegal: "कानूनी जानकारी, निजता और शर्तें हर सार्वजनिक पेज से उपलब्ध हैं।", aboutStatFree: "मुफ़्त", aboutStatAge: "न्यूनतम आयु", aboutStatAvailable: "उपलब्ध", aboutWhyText: "विज्ञापन के अनुकूल साइट समझने में आसान, सुलभ और पारदर्शी होनी चाहिए। इसलिए Callo अपने काम करने के तरीके, नियमों और संपर्क विकल्पों को सार्वजनिक रूप से बताता है।",
  },
}

const CONTACT_SAFETY_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  de: {
    contactMetaTitle: "Kontakt Callo | Support, Meldungen und personenbezogene Daten", contactMetaDescription: "Kontaktiere Callo für Support, Meldungen, rechtliche Fragen, Datenschutz und Anfragen zu personenbezogenen Daten.", contactStructuredName: "Kontakt Callo", contactHeroText: "Diese Seite bündelt die öffentlichen Kontaktmöglichkeiten von Callo und erklärt, wie Nutzer, Besucher und Partner das Team je nach Anliegen erreichen.", contactBeforeTitle: "Vor dem Schreiben", contactBeforeText: "Eine präzise Anfrage lässt sich leichter bearbeiten und hilft, wichtige Meldungen zu dokumentieren.", contactSupportTitle: "Allgemeiner Support", contactSupportText: "Konto, Anmeldung, Videoanrufe, Livestreams, Nachrichten, Beiträge oder technische Probleme.", contactSupportCta: "Support schreiben", contactReportTitle: "Inhalt melden", contactReportText: "Profil, Nachricht, Livestream oder Beitrag, der gefährlich, missbräuchlich, betrügerisch oder verboten wirkt.", contactReportCta: "Meldung senden", contactDataTitle: "Personenbezogene Daten", contactDataText: "Anfrage zu Auskunft, Berichtigung, Kontolöschung oder Datenschutz.", contactDataCta: "Meine Rechte ausüben", contactChecklistEmail: "Deine Kontakt-E-Mail-Adresse.", contactChecklistUsername: "Betroffener Nutzername oder Identifier, falls vorhanden.", contactChecklistType: "Art des aufgetretenen Problems.", contactChecklistDescription: "Kurze und präzise Beschreibung der Situation.", contactDocsTitle: "Nützliche Dokumente", contactDocsText: "Bei Fragen zu Datenschutz, Nutzungsbedingungen oder redaktioneller Verantwortung lies bitte zuerst die öffentlichen Rechtsseiten.",
    safetyMetaTitle: "Sicherheit und Moderation | Öffentliche Callo-Regeln", safetyMetaDescription: "Lies die Sicherheits-, Moderations-, Melde- und Werberichtlinien von Callo.", safetyStructuredName: "Sicherheit und Moderation bei Callo", safetyStructuredDescription: "Öffentliche Regeln zu Sicherheit, Moderation, Meldungen und Werberichtlinien bei Callo.", safetyBadge: "Sicherheit und Moderation", safetyHeroTitle: "Öffentliche Regeln zum Schutz der Nutzer.", safetyHeroText: "Callo ist eine soziale Plattform mit nutzergenerierten Inhalten. Die folgenden Regeln erklären verbotene Inhalte, Moderation, Meldungen und verantwortungsvolle Werbung.", safetyImportantTitle: "Wichtig", safetyImportantText: "Werbung darf nicht auf privaten Bildschirmen, Seiten ohne nützliche Inhalte oder neben verbotenen Inhalten erscheinen.", safetyReportCta: "Problem melden", safetyBlockReportsTitle: "Meldungen zugänglich", safetyBlockReportsText: "Nutzer können Profile, Nachrichten, Livestreams oder Beiträge melden, die gegen die Regeln verstoßen.", safetyBlockAccountsTitle: "Geschützte Konten", safetyBlockAccountsText: "Für die Registrierung ist eine gültige E-Mail erforderlich; der Dienst ist ab 16 Jahren.", safetyBlockDataTitle: "Erklärte Daten", safetyBlockDataText: "Erfasste Daten, Standort und Cookies werden in der Datenschutzerklärung dokumentiert.", safetyBlockPublicTitle: "Lesbare öffentliche Seiten", safetyBlockPublicText: "Regeln und Kontakte sind ohne Anmeldung verfügbar und stärken die Transparenz.", safetyForbiddenTitle: "Verbotene Inhalte und Verhaltensweisen", safetyForbiddenText: "Diese Kategorien bilden die Grundlage der Moderation und helfen, einen verantwortungsvollen Dienst zu erhalten.", safetyForbiddenSexual: "Unerwünschte Nacktheit, explizite sexuelle Inhalte oder Ausbeutung Minderjähriger.", safetyForbiddenHarassment: "Belästigung, Drohungen, Einschüchterung, Diskriminierung oder Identitätsdiebstahl.", safetyForbiddenSpam: "Spam, Phishing, Betrug, aufdringliche Werbung oder missbräuchliche Automatisierung.", safetyForbiddenIllegal: "Illegale, gewalttätige, terroristische, hasserfüllte oder gefährliche Inhalte.", safetyForbiddenPersonalData: "Weitergabe personenbezogener Daten anderer ohne Erlaubnis.", safetyForbiddenBypass: "Versuche, Moderations- oder Sicherheitsfunktionen zu umgehen.", safetyProcessTitle: "Bearbeitung von Meldungen", safetyProcessText: "Der Prozess bleibt für Nutzer verständlich und für externe Partner nachvollziehbar.", safetyRulesCta: "Vollständige Regeln lesen", safetyStepLabel: "Schritt {number}", safetyStepReceiveTitle: "Meldung erhalten", safetyStepReceiveText: "Die Anfrage sollte möglichst viele Angaben enthalten: Profil, Inhalt, Datum und Kontext.", safetyStepReviewTitle: "Prüfung", safetyStepReviewText: "Der Inhalt wird mit den Verhaltensregeln und geltenden rechtlichen Pflichten verglichen.", safetyStepActionTitle: "Maßnahme", safetyStepActionText: "Je nach Schweregrad: Warnung, Entfernung, Sperre, Ausschluss oder Meldung an Behörden.",
  },
  it: {
    contactMetaTitle: "Contatti Callo | Supporto, segnalazioni e dati personali", contactMetaDescription: "Contatta Callo per supporto, segnalazioni, domande legali, privacy e richieste sui dati personali.", contactStructuredName: "Contatti Callo", contactHeroText: "Questa pagina raccoglie i contatti pubblici di Callo e spiega come utenti, visitatori e partner possono raggiungere il team in base alla richiesta.", contactBeforeTitle: "Prima di scrivere", contactBeforeText: "Una richiesta precisa è più facile da gestire e aiuta a documentare le segnalazioni importanti.", contactSupportTitle: "Supporto generale", contactSupportText: "Account, accesso, videochiamate, live, messaggi, post o problemi tecnici.", contactSupportCta: "Scrivi al supporto", contactReportTitle: "Segnala un contenuto", contactReportText: "Profilo, messaggio, live o post che sembra pericoloso, abusivo, fraudolento o vietato.", contactReportCta: "Invia una segnalazione", contactDataTitle: "Dati personali", contactDataText: "Richiesta di accesso, rettifica, eliminazione dell'account o domanda sulla privacy.", contactDataCta: "Esercita i miei diritti", contactChecklistEmail: "Il tuo indirizzo email di contatto.", contactChecklistUsername: "Il nome utente o identificativo interessato, se disponibile.", contactChecklistType: "Il tipo di problema riscontrato.", contactChecklistDescription: "Una descrizione breve e precisa della situazione.", contactDocsTitle: "Documenti utili", contactDocsText: "Per domande su privacy, condizioni d'uso o responsabilità editoriale, consulta prima le pagine legali pubbliche.",
    safetyMetaTitle: "Sicurezza e moderazione | Regole pubbliche Callo", safetyMetaDescription: "Consulta le regole di sicurezza, moderazione, segnalazione e conformità pubblicitaria di Callo.", safetyStructuredName: "Sicurezza e moderazione Callo", safetyStructuredDescription: "Regole pubbliche di sicurezza, moderazione, segnalazione e conformità pubblicitaria di Callo.", safetyBadge: "Sicurezza e moderazione", safetyHeroTitle: "Regole pubbliche per proteggere gli utenti.", safetyHeroText: "Callo è una piattaforma social con contenuti degli utenti. Le regole spiegano contenuti vietati, moderazione, segnalazioni e pubblicità responsabile.", safetyImportantTitle: "Importante", safetyImportantText: "Gli annunci non devono apparire su schermate private, pagine senza contenuti utili o vicino a contenuti vietati.", safetyReportCta: "Segnala un problema", safetyBlockReportsTitle: "Segnalazioni accessibili", safetyBlockReportsText: "Gli utenti possono segnalare profili, messaggi, live o post che violano le regole.", safetyBlockAccountsTitle: "Account protetti", safetyBlockAccountsText: "La registrazione richiede un'email valida e il servizio è riservato alle persone di almeno 16 anni.", safetyBlockDataTitle: "Dati spiegati", safetyBlockDataText: "Dati raccolti, posizione e cookie sono documentati nella politica sulla privacy.", safetyBlockPublicTitle: "Pagine pubbliche leggibili", safetyBlockPublicText: "Regole e contatti sono consultabili senza accesso per rafforzare la trasparenza.", safetyForbiddenTitle: "Contenuti e comportamenti vietati", safetyForbiddenText: "Queste categorie guidano la moderazione e aiutano a mantenere un ambiente responsabile.", safetyForbiddenSexual: "Nudità non richiesta, contenuti sessuali espliciti o sfruttamento di minori.", safetyForbiddenHarassment: "Molestie, minacce, intimidazione, discriminazione o furto d'identità.", safetyForbiddenSpam: "Spam, phishing, truffe, pubblicità molesta o automazione abusiva.", safetyForbiddenIllegal: "Contenuti illegali, violenti, terroristici, pieni d'odio o pericolosi.", safetyForbiddenPersonalData: "Condivisione dei dati personali altrui senza autorizzazione.", safetyForbiddenBypass: "Tentativi di aggirare gli strumenti di moderazione o sicurezza.", safetyProcessTitle: "Gestione delle segnalazioni", safetyProcessText: "Il processo deve rimanere comprensibile per gli utenti e documentabile per i partner esterni.", safetyRulesCta: "Leggi tutte le regole", safetyStepLabel: "Passaggio {number}", safetyStepReceiveTitle: "Segnalazione ricevuta", safetyStepReceiveText: "La richiesta dovrebbe contenere più dettagli utili possibile: profilo, contenuto, data e contesto.", safetyStepReviewTitle: "Valutazione", safetyStepReviewText: "Il contenuto viene confrontato con le regole di condotta e gli obblighi legali applicabili.", safetyStepActionTitle: "Azione", safetyStepActionText: "In base alla gravità: avviso, rimozione, sospensione, ban o segnalazione alle autorità.",
  },
  tr: {
    contactMetaTitle: "Callo İletişim | Destek, bildirimler ve kişisel veriler", contactMetaDescription: "Destek, bildirimler, hukuki sorular, gizlilik ve kişisel veri talepleri için Callo ile iletişime geçin.", contactStructuredName: "Callo iletişim", contactHeroText: "Bu sayfa Callo'nun herkese açık iletişim seçeneklerini toplar ve ekibe talep türüne göre nasıl ulaşılacağını açıklar.", contactBeforeTitle: "Yazmadan önce", contactBeforeText: "Açık bir talebin işlenmesi daha kolaydır ve önemli bildirimlerin belgelenmesine yardımcı olur.", contactSupportTitle: "Genel destek", contactSupportText: "Hesap, giriş, görüntülü aramalar, canlı yayınlar, mesajlar, gönderiler veya teknik sorunlar.", contactSupportCta: "Desteğe yaz", contactReportTitle: "İçerik bildirimi", contactReportText: "Tehlikeli, istismarcı, dolandırıcı veya yasak görünen profil, mesaj, canlı yayın ya da gönderi.", contactReportCta: "Bildirim gönder", contactDataTitle: "Kişisel veriler", contactDataText: "Erişim, düzeltme, hesap silme talebi veya gizlilik sorusu.", contactDataCta: "Haklarımı kullan", contactChecklistEmail: "İletişim e-posta adresiniz.", contactChecklistUsername: "Varsa ilgili kullanıcı adı veya kimlik.", contactChecklistType: "Karşılaşılan sorunun türü.", contactChecklistDescription: "Durumun kısa ve açık açıklaması.", contactDocsTitle: "Yararlı belgeler", contactDocsText: "Gizlilik, kullanım şartları veya editoryal sorumlulukla ilgili sorular için talep göndermeden önce herkese açık hukuki sayfalara bakın.",
    safetyMetaTitle: "Güvenlik ve moderasyon | Callo herkese açık kuralları", safetyMetaDescription: "Callo'nun güvenlik, moderasyon, bildirim ve reklam uyumluluğu kurallarını okuyun.", safetyStructuredName: "Callo güvenlik ve moderasyon", safetyStructuredDescription: "Callo güvenliği, moderasyonu, bildirimleri ve reklam uyumluluğu için herkese açık kurallar.", safetyBadge: "Güvenlik ve moderasyon", safetyHeroTitle: "Kullanıcıları korumak için herkese açık kurallar.", safetyHeroText: "Callo, kullanıcı içerikleri bulunan bir sosyal platformdur. Kurallar yasak içerikleri, moderasyonu, bildirimleri ve sorumlu reklamcılığı açıklar.", safetyImportantTitle: "Önemli", safetyImportantText: "Reklamlar özel ekranlarda, yararlı içeriği olmayan sayfalarda veya yasak içeriklerin yanında gösterilmemelidir.", safetyReportCta: "Sorun bildir", safetyBlockReportsTitle: "Erişilebilir bildirimler", safetyBlockReportsText: "Kullanıcılar kuralları ihlal eden profil, mesaj, canlı yayın veya gönderileri bildirebilir.", safetyBlockAccountsTitle: "Denetimli hesaplar", safetyBlockAccountsText: "Kayıt için geçerli bir e-posta gerekir ve hizmet en az 16 yaşındaki kişilere yöneliktir.", safetyBlockDataTitle: "Açıklanan veriler", safetyBlockDataText: "Toplanan veriler, konum ve çerezler gizlilik politikasında açıklanır.", safetyBlockPublicTitle: "Okunabilir herkese açık sayfalar", safetyBlockPublicText: "Şeffaflığı artırmak için kurallar ve iletişim bilgileri giriş yapmadan görülebilir.", safetyForbiddenTitle: "Yasak içerik ve davranışlar", safetyForbiddenText: "Bu kategoriler moderasyon işlemlerine temel olur ve sorumlu bir ortamın korunmasına yardım eder.", safetyForbiddenSexual: "İstenmeyen çıplaklık, açık cinsel içerik veya çocukların istismarı.", safetyForbiddenHarassment: "Taciz, tehdit, yıldırma, ayrımcılık veya kimlik hırsızlığı.", safetyForbiddenSpam: "Spam, kimlik avı, dolandırıcılık, kötüye kullanılan reklam veya otomasyon.", safetyForbiddenIllegal: "Yasadışı, şiddet içeren, terörist, nefret dolu veya tehlikeli içerik.", safetyForbiddenPersonalData: "Başkasının kişisel verilerini izinsiz paylaşmak.", safetyForbiddenBypass: "Moderasyon veya güvenlik araçlarını aşmaya çalışma.", safetyProcessTitle: "Bildirimlerin işlenmesi", safetyProcessText: "Süreç kullanıcılar için anlaşılır ve dış ortaklar için belgelenebilir olmalıdır.", safetyRulesCta: "Tüm kuralları oku", safetyStepLabel: "Adım {number}", safetyStepReceiveTitle: "Bildirim alındı", safetyStepReceiveText: "Talep mümkün olduğunca profil, içerik, tarih ve bağlam gibi yararlı bilgiler içermelidir.", safetyStepReviewTitle: "Değerlendirme", safetyStepReviewText: "İçerik davranış kuralları ve geçerli yasal yükümlülüklerle karşılaştırılır.", safetyStepActionTitle: "İşlem", safetyStepActionText: "Ciddiyetine göre uyarı, kaldırma, askıya alma, yasaklama veya yetkililere bildirim uygulanır.",
  },
  ar: {
    contactMetaTitle: "اتصل بـ Callo | الدعم والبلاغات والبيانات الشخصية", contactMetaDescription: "تواصل مع Callo للدعم والبلاغات والأسئلة القانونية والخصوصية وطلبات البيانات الشخصية.", contactStructuredName: "اتصل بـ Callo", contactHeroText: "تجمع هذه الصفحة وسائل الاتصال العامة في Callo وتوضح كيفية التواصل مع الفريق حسب نوع الطلب.", contactBeforeTitle: "قبل الكتابة", contactBeforeText: "يساعد الطلب الواضح على معالجته وتوثيق البلاغات المهمة.", contactSupportTitle: "الدعم العام", contactSupportText: "الحساب وتسجيل الدخول ومكالمات الفيديو والبثوث والرسائل والمنشورات والمشكلات التقنية.", contactSupportCta: "مراسلة الدعم", contactReportTitle: "الإبلاغ عن محتوى", contactReportText: "ملف شخصي أو رسالة أو بث أو منشور يبدو خطيراً أو مسيئاً أو احتيالياً أو محظوراً.", contactReportCta: "إرسال بلاغ", contactDataTitle: "البيانات الشخصية", contactDataText: "طلب الوصول أو التصحيح أو حذف الحساب أو سؤال عن الخصوصية.", contactDataCta: "ممارسة حقوقي", contactChecklistEmail: "عنوان بريدك الإلكتروني للتواصل.", contactChecklistUsername: "اسم المستخدم أو المعرّف المعني إن وجد.", contactChecklistType: "نوع المشكلة التي واجهتها.", contactChecklistDescription: "وصف مختصر وواضح للموقف.", contactDocsTitle: "مستندات مفيدة", contactDocsText: "لأسئلة الخصوصية أو شروط الاستخدام أو المسؤولية التحريرية، راجع الصفحات القانونية العامة أولاً.",
    safetyMetaTitle: "السلامة والإشراف | قواعد Callo العامة", safetyMetaDescription: "اطلع على قواعد السلامة والإشراف والبلاغات والامتثال الإعلاني في Callo.", safetyStructuredName: "السلامة والإشراف في Callo", safetyStructuredDescription: "قواعد عامة للسلامة والإشراف والبلاغات والامتثال الإعلاني في Callo.", safetyBadge: "السلامة والإشراف", safetyHeroTitle: "قواعد عامة لحماية المستخدمين.", safetyHeroText: "Callo منصة اجتماعية تضم محتوى المستخدمين. توضح القواعد المحتوى المحظور والإشراف والبلاغات والإعلانات المسؤولة.", safetyImportantTitle: "مهم", safetyImportantText: "يجب ألا تظهر الإعلانات على الشاشات الخاصة أو الصفحات الخالية من المحتوى المفيد أو قرب المحتوى المحظور.", safetyReportCta: "الإبلاغ عن مشكلة", safetyBlockReportsTitle: "بلاغات متاحة", safetyBlockReportsText: "يمكن للمستخدمين الإبلاغ عن ملف أو رسالة أو بث أو منشور يخالف القواعد.", safetyBlockAccountsTitle: "حسابات محمية", safetyBlockAccountsText: "يتطلب التسجيل بريداً إلكترونياً صالحاً والخدمة مخصصة لمن تبلغ أعمارهم 16 عاماً فأكثر.", safetyBlockDataTitle: "بيانات موضحة", safetyBlockDataText: "يتم توثيق البيانات والموقع وملفات تعريف الارتباط في سياسة الخصوصية.", safetyBlockPublicTitle: "صفحات عامة واضحة", safetyBlockPublicText: "يمكن الاطلاع على القواعد ووسائل الاتصال دون تسجيل دخول لتعزيز الشفافية.", safetyForbiddenTitle: "المحتوى والسلوك المحظور", safetyForbiddenText: "تساعد هذه الفئات في توجيه إجراءات الإشراف والحفاظ على بيئة مسؤولة.", safetyForbiddenSexual: "العري غير المرغوب أو المحتوى الجنسي الصريح أو استغلال القاصرين.", safetyForbiddenHarassment: "المضايقة أو التهديد أو الترهيب أو التمييز أو انتحال الهوية.", safetyForbiddenSpam: "الرسائل المزعجة أو التصيد أو الاحتيال أو الإعلانات أو الأتمتة المسيئة.", safetyForbiddenIllegal: "المحتوى غير القانوني أو العنيف أو الإرهابي أو الكاره أو الخطير.", safetyForbiddenPersonalData: "مشاركة البيانات الشخصية للآخرين دون إذن.", safetyForbiddenBypass: "محاولة تجاوز أدوات الإشراف أو السلامة.", safetyProcessTitle: "معالجة البلاغات", safetyProcessText: "يجب أن تكون العملية مفهومة للمستخدمين وقابلة للتوثيق للشركاء الخارجيين.", safetyRulesCta: "قراءة القواعد كاملة", safetyStepLabel: "الخطوة {number}", safetyStepReceiveTitle: "استلام البلاغ", safetyStepReceiveText: "ينبغي أن يتضمن الطلب أكبر قدر ممكن من المعلومات: الملف والمحتوى والتاريخ والسياق.", safetyStepReviewTitle: "التقييم", safetyStepReviewText: "تتم مقارنة المحتوى بقواعد السلوك والالتزامات القانونية المعمول بها.", safetyStepActionTitle: "الإجراء", safetyStepActionText: "حسب الخطورة: تحذير أو إزالة أو تعليق أو حظر أو إبلاغ السلطات.",
  },
  nl: {
    contactMetaTitle: "Contact Callo | Support, meldingen en persoonsgegevens", contactMetaDescription: "Neem contact op met Callo voor support, meldingen, juridische vragen, privacy en verzoeken over persoonsgegevens.", contactStructuredName: "Contact Callo", contactHeroText: "Deze pagina verzamelt de openbare contactmogelijkheden van Callo en legt uit hoe je het team per type verzoek bereikt.", contactBeforeTitle: "Voor je schrijft", contactBeforeText: "Een duidelijke aanvraag is makkelijker te behandelen en helpt belangrijke meldingen te documenteren.", contactSupportTitle: "Algemene support", contactSupportText: "Account, login, videogesprekken, lives, berichten, posts of technische problemen.", contactSupportCta: "Schrijf naar support", contactReportTitle: "Content melden", contactReportText: "Profiel, bericht, live of post die gevaarlijk, beledigend, frauduleus of verboden lijkt.", contactReportCta: "Melding versturen", contactDataTitle: "Persoonsgegevens", contactDataText: "Verzoek om inzage, correctie, accountverwijdering of een privacyvraag.", contactDataCta: "Mijn rechten uitoefenen", contactChecklistEmail: "Je contact-e-mailadres.", contactChecklistUsername: "De betreffende gebruikersnaam of identifier, indien beschikbaar.", contactChecklistType: "Het soort probleem.", contactChecklistDescription: "Een korte en duidelijke beschrijving van de situatie.", contactDocsTitle: "Nuttige documenten", contactDocsText: "Bekijk bij vragen over privacy, gebruiksvoorwaarden of redactionele verantwoordelijkheid eerst de openbare juridische pagina's.",
    safetyMetaTitle: "Veiligheid en moderatie | Openbare Callo-regels", safetyMetaDescription: "Lees de veiligheids-, moderatie-, meldings- en advertentieregels van Callo.", safetyStructuredName: "Veiligheid en moderatie van Callo", safetyStructuredDescription: "Openbare regels voor veiligheid, moderatie, meldingen en advertentiecompliance van Callo.", safetyBadge: "Veiligheid en moderatie", safetyHeroTitle: "Openbare regels om gebruikers te beschermen.", safetyHeroText: "Callo is een sociaal platform met gebruikersinhoud. Deze regels leggen verboden inhoud, moderatie, meldingen en verantwoorde advertenties uit.", safetyImportantTitle: "Belangrijk", safetyImportantText: "Advertenties mogen niet op privéschermen, pagina's zonder nuttige inhoud of naast verboden inhoud staan.", safetyReportCta: "Probleem melden", safetyBlockReportsTitle: "Toegankelijke meldingen", safetyBlockReportsText: "Gebruikers kunnen profielen, berichten, lives of posts melden die de regels overtreden.", safetyBlockAccountsTitle: "Beveiligde accounts", safetyBlockAccountsText: "Registratie vereist een geldig e-mailadres en de dienst is voor personen vanaf 16 jaar.", safetyBlockDataTitle: "Uitgelegde gegevens", safetyBlockDataText: "Verzamelde gegevens, locatie en cookies staan in het privacybeleid.", safetyBlockPublicTitle: "Leesbare openbare pagina's", safetyBlockPublicText: "Regels en contactgegevens zijn zonder login beschikbaar voor meer transparantie.", safetyForbiddenTitle: "Verboden inhoud en gedrag", safetyForbiddenText: "Deze categorieën sturen de moderatie en helpen een verantwoordelijke omgeving te behouden.", safetyForbiddenSexual: "Ongevraagde naaktheid, expliciete seksuele inhoud of uitbuiting van minderjarigen.", safetyForbiddenHarassment: "Intimidatie, bedreigingen, pesten, discriminatie of identiteitsdiefstal.", safetyForbiddenSpam: "Spam, phishing, fraude, misleidende reclame of misbruik van automatisering.", safetyForbiddenIllegal: "Illegale, gewelddadige, terroristische, haatdragende of gevaarlijke inhoud.", safetyForbiddenPersonalData: "Persoonsgegevens van anderen delen zonder toestemming.", safetyForbiddenBypass: "Proberen moderatie- of veiligheidsfuncties te omzeilen.", safetyProcessTitle: "Afhandeling van meldingen", safetyProcessText: "Het proces moet begrijpelijk zijn voor gebruikers en vastlegbaar voor externe partners.", safetyRulesCta: "Lees alle regels", safetyStepLabel: "Stap {number}", safetyStepReceiveTitle: "Melding ontvangen", safetyStepReceiveText: "De aanvraag bevat zo veel mogelijk nuttige informatie: profiel, inhoud, datum en context.", safetyStepReviewTitle: "Beoordeling", safetyStepReviewText: "De inhoud wordt vergeleken met gedragsregels en toepasselijke wettelijke verplichtingen.", safetyStepActionTitle: "Actie", safetyStepActionText: "Afhankelijk van de ernst: waarschuwing, verwijdering, schorsing, verbanning of melding aan autoriteiten.",
  },
  ru: {
    contactMetaTitle: "Контакты Callo | Поддержка, жалобы и персональные данные", contactMetaDescription: "Свяжитесь с Callo по вопросам поддержки, жалоб, права, конфиденциальности и персональных данных.", contactStructuredName: "Контакты Callo", contactHeroText: "На этой странице собраны публичные способы связи с Callo и объясняется, как обратиться в команду по типу запроса.", contactBeforeTitle: "Перед обращением", contactBeforeText: "Точный запрос проще обработать и задокументировать.", contactSupportTitle: "Общая поддержка", contactSupportText: "Аккаунт, вход, видеозвонки, трансляции, сообщения, публикации или технические проблемы.", contactSupportCta: "Написать в поддержку", contactReportTitle: "Пожаловаться на контент", contactReportText: "Профиль, сообщение, трансляция или публикация, которые кажутся опасными, мошенническими или запрещёнными.", contactReportCta: "Отправить жалобу", contactDataTitle: "Персональные данные", contactDataText: "Запрос доступа, исправления, удаления аккаунта или вопрос о конфиденциальности.", contactDataCta: "Реализовать мои права", contactChecklistEmail: "Ваш контактный адрес электронной почты.", contactChecklistUsername: "Имя пользователя или идентификатор, если известен.", contactChecklistType: "Тип возникшей проблемы.", contactChecklistDescription: "Краткое и точное описание ситуации.", contactDocsTitle: "Полезные документы", contactDocsText: "По вопросам конфиденциальности, условий использования или ответственности сначала ознакомьтесь с публичными правовыми страницами.",
    safetyMetaTitle: "Безопасность и модерация | Публичные правила Callo", safetyMetaDescription: "Ознакомьтесь с правилами безопасности, модерации, жалоб и рекламы Callo.", safetyStructuredName: "Безопасность и модерация Callo", safetyStructuredDescription: "Публичные правила безопасности, модерации, жалоб и рекламного соответствия Callo.", safetyBadge: "Безопасность и модерация", safetyHeroTitle: "Публичные правила для защиты пользователей.", safetyHeroText: "Callo — социальная платформа с пользовательским контентом. Правила описывают запрещённый контент, модерацию, жалобы и ответственную рекламу.", safetyImportantTitle: "Важно", safetyImportantText: "Реклама не должна размещаться на личных экранах, страницах без полезного содержания или рядом с запрещённым контентом.", safetyReportCta: "Сообщить о проблеме", safetyBlockReportsTitle: "Доступные жалобы", safetyBlockReportsText: "Пользователи могут пожаловаться на профиль, сообщение, трансляцию или публикацию, нарушающие правила.", safetyBlockAccountsTitle: "Защищённые аккаунты", safetyBlockAccountsText: "Регистрация требует действующий email, сервис предназначен для лиц от 16 лет.", safetyBlockDataTitle: "Объяснение данных", safetyBlockDataText: "Собранные данные, геолокация и cookies описаны в политике конфиденциальности.", safetyBlockPublicTitle: "Понятные публичные страницы", safetyBlockPublicText: "Правила и контакты доступны без входа для большей прозрачности.", safetyForbiddenTitle: "Запрещённый контент и поведение", safetyForbiddenText: "Эти категории определяют модерацию и помогают поддерживать ответственную среду.", safetyForbiddenSexual: "Нежелательная нагота, откровенный сексуальный контент или эксплуатация несовершеннолетних.", safetyForbiddenHarassment: "Преследование, угрозы, запугивание, дискриминация или кража личности.", safetyForbiddenSpam: "Спам, фишинг, мошенничество, навязчивая реклама или злоупотребление автоматизацией.", safetyForbiddenIllegal: "Незаконный, жестокий, террористический, ненавистнический или опасный контент.", safetyForbiddenPersonalData: "Передача чужих персональных данных без разрешения.", safetyForbiddenBypass: "Попытка обойти инструменты модерации или безопасности.", safetyProcessTitle: "Обработка жалоб", safetyProcessText: "Процесс должен быть понятен пользователям и документируем для внешних партнёров.", safetyRulesCta: "Читать все правила", safetyStepLabel: "Шаг {number}", safetyStepReceiveTitle: "Жалоба получена", safetyStepReceiveText: "Запрос должен содержать как можно больше деталей: профиль, контент, дату и контекст.", safetyStepReviewTitle: "Проверка", safetyStepReviewText: "Контент сравнивается с правилами поведения и применимыми законами.", safetyStepActionTitle: "Действие", safetyStepActionText: "В зависимости от тяжести: предупреждение, удаление, приостановка, блокировка или обращение к властям.",
  },
  zh: {
    contactMetaTitle: "联系 Callo | 支持、举报和个人数据", contactMetaDescription: "联系 Callo 获取支持、提交举报、咨询法律与隐私问题或提出个人数据请求。", contactStructuredName: "联系 Callo", contactHeroText: "本页面汇总 Callo 的公开联系方式，并说明用户、访客和合作伙伴如何根据请求类型联系团队。", contactBeforeTitle: "发送前", contactBeforeText: "清晰的请求更容易处理，也有助于记录重要举报。", contactSupportTitle: "一般支持", contactSupportText: "账户、登录、视频通话、直播、消息、帖子或技术问题。", contactSupportCta: "联系支持", contactReportTitle: "举报内容", contactReportText: "看起来危险、滥用、欺诈或被禁止的个人资料、消息、直播或帖子。", contactReportCta: "发送举报", contactDataTitle: "个人数据", contactDataText: "访问、更正、删除账户请求或隐私问题。", contactDataCta: "行使我的权利", contactChecklistEmail: "你的联系邮箱。", contactChecklistUsername: "相关用户名或标识（如有）。", contactChecklistType: "遇到的问题类型。", contactChecklistDescription: "简短、准确的情况说明。", contactDocsTitle: "有用文档", contactDocsText: "如有隐私、使用条款或编辑责任问题，请先查看公开法律页面。",
    safetyMetaTitle: "安全与审核 | Callo 公开规则", safetyMetaDescription: "查看 Callo 的安全、审核、举报和广告合规规则。", safetyStructuredName: "Callo 安全与审核", safetyStructuredDescription: "Callo 关于安全、审核、举报和广告合规的公开规则。", safetyBadge: "安全与审核", safetyHeroTitle: "保护用户的公开规则。", safetyHeroText: "Callo 是一个包含用户内容的社交平台。以下规则说明禁止内容、审核、举报和负责任的广告。", safetyImportantTitle: "重要", safetyImportantText: "广告不得放置在私人页面、没有有用内容的页面或禁止内容附近。", safetyReportCta: "举报问题", safetyBlockReportsTitle: "便捷举报", safetyBlockReportsText: "用户可以举报违反规则的个人资料、消息、直播或帖子。", safetyBlockAccountsTitle: "受保护的账户", safetyBlockAccountsText: "注册需要有效邮箱，服务面向年满 16 岁的用户。", safetyBlockDataTitle: "数据说明", safetyBlockDataText: "收集的数据、位置和 Cookie 记录在隐私政策中。", safetyBlockPublicTitle: "清晰的公开页面", safetyBlockPublicText: "无需登录即可查看规则和联系方式，增强服务透明度。", safetyForbiddenTitle: "禁止的内容和行为", safetyForbiddenText: "这些类别指导审核措施，帮助保持负责任的环境。", safetyForbiddenSexual: "未经同意的裸体、露骨性内容或剥削未成年人。", safetyForbiddenHarassment: "骚扰、威胁、恐吓、歧视或身份盗用。", safetyForbiddenSpam: "垃圾信息、钓鱼、诈骗、滥用广告或滥用自动化。", safetyForbiddenIllegal: "非法、暴力、恐怖主义、仇恨或危险内容。", safetyForbiddenPersonalData: "未经授权分享他人的个人数据。", safetyForbiddenBypass: "试图绕过审核或安全工具。", safetyProcessTitle: "举报处理", safetyProcessText: "处理流程应便于用户理解，也便于外部合作伙伴记录。", safetyRulesCta: "阅读完整规则", safetyStepLabel: "步骤 {number}", safetyStepReceiveTitle: "收到举报", safetyStepReceiveText: "请求应尽可能包含个人资料、内容、日期和背景等信息。", safetyStepReviewTitle: "评估", safetyStepReviewText: "内容将与行为规则和适用法律义务进行比较。", safetyStepActionTitle: "处理", safetyStepActionText: "根据严重程度采取警告、删除、暂停、封禁或向有关部门报告。",
  },
  ja: {
    contactMetaTitle: "Calloへのお問い合わせ | サポート、報告、個人データ", contactMetaDescription: "サポート、報告、法律、プライバシー、個人データに関する依頼はCalloへお問い合わせください。", contactStructuredName: "Calloへのお問い合わせ", contactHeroText: "Calloの公開連絡先をまとめ、依頼の種類に応じたチームへの連絡方法を説明します。", contactBeforeTitle: "送信前に", contactBeforeText: "具体的な依頼は処理しやすく、重要な報告の記録にも役立ちます。", contactSupportTitle: "一般サポート", contactSupportText: "アカウント、ログイン、ビデオ通話、ライブ、メッセージ、投稿、技術的な問題。", contactSupportCta: "サポートに連絡", contactReportTitle: "コンテンツを報告", contactReportText: "危険、迷惑、詐欺、禁止と見られるプロフィール、メッセージ、ライブ、投稿。", contactReportCta: "報告を送信", contactDataTitle: "個人データ", contactDataText: "アクセス、訂正、アカウント削除の依頼、プライバシーに関する質問。", contactDataCta: "権利を行使する", contactChecklistEmail: "連絡先メールアドレス。", contactChecklistUsername: "対象のユーザー名またはID（わかる場合）。", contactChecklistType: "発生した問題の種類。", contactChecklistDescription: "状況の簡潔で正確な説明。", contactDocsTitle: "役立つ文書", contactDocsText: "プライバシー、利用規約、編集責任については、依頼を送る前に公開された法的ページをご確認ください。",
    safetyMetaTitle: "安全とモデレーション | Callo公開ルール", safetyMetaDescription: "Calloの安全、モデレーション、報告、広告に関するルールをご確認ください。", safetyStructuredName: "Calloの安全とモデレーション", safetyStructuredDescription: "Calloの安全、モデレーション、報告、広告適合性に関する公開ルール。", safetyBadge: "安全とモデレーション", safetyHeroTitle: "ユーザーを守る公開ルール。", safetyHeroText: "Calloはユーザーコンテンツを扱うソーシャルプラットフォームです。禁止コンテンツ、モデレーション、報告、責任ある広告について説明します。", safetyImportantTitle: "重要", safetyImportantText: "広告は非公開画面、役立つ内容のないページ、禁止コンテンツの近くに表示してはいけません。", safetyReportCta: "問題を報告", safetyBlockReportsTitle: "報告しやすい仕組み", safetyBlockReportsText: "ルールに違反するプロフィール、メッセージ、ライブ、投稿を報告できます。", safetyBlockAccountsTitle: "管理されたアカウント", safetyBlockAccountsText: "登録には有効なメールが必要で、16歳以上の方が利用できます。", safetyBlockDataTitle: "データの説明", safetyBlockDataText: "収集データ、位置情報、Cookieはプライバシーポリシーに記載されています。", safetyBlockPublicTitle: "読みやすい公開ページ", safetyBlockPublicText: "ログインせずにルールと連絡先を確認でき、透明性を高めます。", safetyForbiddenTitle: "禁止される内容と行為", safetyForbiddenText: "これらの分類はモデレーションの基準となり、責任ある環境を保ちます。", safetyForbiddenSexual: "望まない裸体、露骨な性的コンテンツ、未成年者の搾取。", safetyForbiddenHarassment: "嫌がらせ、脅迫、威圧、差別、なりすまし。", safetyForbiddenSpam: "スパム、フィッシング、詐欺、迷惑広告、不正な自動化。", safetyForbiddenIllegal: "違法、暴力的、テロ、ヘイト、危険なコンテンツ。", safetyForbiddenPersonalData: "許可なく他人の個人データを共有すること。", safetyForbiddenBypass: "モデレーションや安全機能を回避しようとすること。", safetyProcessTitle: "報告の処理", safetyProcessText: "ユーザーにわかりやすく、外部パートナーにも記録可能な手順にします。", safetyRulesCta: "すべてのルールを読む", safetyStepLabel: "ステップ {number}", safetyStepReceiveTitle: "報告を受信", safetyStepReceiveText: "プロフィール、内容、日時、背景など、できるだけ詳しい情報を含めてください。", safetyStepReviewTitle: "確認", safetyStepReviewText: "内容を行動規則と適用される法的義務に照らして確認します。", safetyStepActionTitle: "対応", safetyStepActionText: "重大さに応じて、警告、削除、停止、禁止、当局への報告を行います。",
  },
  ko: {
    contactMetaTitle: "Callo 문의 | 지원, 신고 및 개인정보", contactMetaDescription: "지원, 신고, 법률, 개인정보 및 개인 데이터 요청은 Callo에 문의하세요.", contactStructuredName: "Callo 문의", contactHeroText: "Callo의 공개 연락 방법을 모아 요청 유형에 따라 팀에 연락하는 방법을 안내합니다.", contactBeforeTitle: "작성 전", contactBeforeText: "정확한 요청은 처리하기 쉽고 중요한 신고를 기록하는 데 도움이 됩니다.", contactSupportTitle: "일반 지원", contactSupportText: "계정, 로그인, 영상 통화, 라이브, 메시지, 게시물 또는 기술 문제.", contactSupportCta: "지원팀에 문의", contactReportTitle: "콘텐츠 신고", contactReportText: "위험하거나 악의적이거나 사기성 또는 금지된 것으로 보이는 프로필, 메시지, 라이브 또는 게시물.", contactReportCta: "신고 보내기", contactDataTitle: "개인정보", contactDataText: "열람, 정정, 계정 삭제 요청 또는 개인정보 보호 질문.", contactDataCta: "내 권리 행사", contactChecklistEmail: "연락 가능한 이메일 주소.", contactChecklistUsername: "해당 사용자 이름 또는 식별자(가능한 경우).", contactChecklistType: "발생한 문제의 유형.", contactChecklistDescription: "상황에 대한 짧고 정확한 설명.", contactDocsTitle: "유용한 문서", contactDocsText: "개인정보, 이용약관 또는 편집 책임에 관한 질문은 요청을 보내기 전에 공개 법률 페이지를 확인하세요.",
    safetyMetaTitle: "안전 및 운영 | Callo 공개 규칙", safetyMetaDescription: "Callo의 안전, 운영, 신고 및 광고 준수 규칙을 확인하세요.", safetyStructuredName: "Callo 안전 및 운영", safetyStructuredDescription: "Callo의 안전, 운영, 신고 및 광고 준수에 관한 공개 규칙.", safetyBadge: "안전 및 운영", safetyHeroTitle: "사용자를 보호하기 위한 공개 규칙.", safetyHeroText: "Callo는 사용자 콘텐츠가 있는 소셜 플랫폼입니다. 금지 콘텐츠, 운영, 신고 및 책임 있는 광고에 대해 설명합니다.", safetyImportantTitle: "중요", safetyImportantText: "광고는 비공개 화면, 유용한 콘텐츠가 없는 페이지 또는 금지 콘텐츠 근처에 표시하면 안 됩니다.", safetyReportCta: "문제 신고", safetyBlockReportsTitle: "쉬운 신고", safetyBlockReportsText: "규칙을 위반한 프로필, 메시지, 라이브 또는 게시물을 신고할 수 있습니다.", safetyBlockAccountsTitle: "관리되는 계정", safetyBlockAccountsText: "가입에는 유효한 이메일이 필요하며 16세 이상만 이용할 수 있습니다.", safetyBlockDataTitle: "설명된 데이터", safetyBlockDataText: "수집 데이터, 위치 및 쿠키는 개인정보 보호정책에 설명되어 있습니다.", safetyBlockPublicTitle: "읽기 쉬운 공개 페이지", safetyBlockPublicText: "투명성을 높이기 위해 로그인 없이 규칙과 연락처를 확인할 수 있습니다.", safetyForbiddenTitle: "금지된 콘텐츠와 행동", safetyForbiddenText: "이 분류는 운영 조치의 기준이 되어 책임 있는 환경을 유지하는 데 도움을 줍니다.", safetyForbiddenSexual: "원치 않는 노출, 노골적인 성적 콘텐츠 또는 미성년자 착취.", safetyForbiddenHarassment: "괴롭힘, 위협, 협박, 차별 또는 신원 도용.", safetyForbiddenSpam: "스팸, 피싱, 사기, 악성 광고 또는 부적절한 자동화.", safetyForbiddenIllegal: "불법적, 폭력적, 테러, 혐오 또는 위험한 콘텐츠.", safetyForbiddenPersonalData: "허가 없이 다른 사람의 개인정보를 공유하는 행위.", safetyForbiddenBypass: "운영 또는 보안 도구를 우회하려는 시도.", safetyProcessTitle: "신고 처리", safetyProcessText: "사용자가 이해하기 쉽고 외부 파트너가 기록할 수 있는 절차를 유지합니다.", safetyRulesCta: "전체 규칙 읽기", safetyStepLabel: "단계 {number}", safetyStepReceiveTitle: "신고 접수", safetyStepReceiveText: "프로필, 콘텐츠, 날짜, 상황 등 유용한 정보를 최대한 포함해야 합니다.", safetyStepReviewTitle: "검토", safetyStepReviewText: "콘텐츠를 행동 규칙과 적용 가능한 법적 의무에 따라 검토합니다.", safetyStepActionTitle: "조치", safetyStepActionText: "심각도에 따라 경고, 삭제, 정지, 차단 또는 관계 기관 신고를 진행합니다.",
  },
  hi: {
    contactMetaTitle: "Callo से संपर्क | सहायता, रिपोर्ट और व्यक्तिगत डेटा", contactMetaDescription: "सहायता, रिपोर्ट, कानूनी प्रश्न, निजता और व्यक्तिगत डेटा अनुरोधों के लिए Callo से संपर्क करें।", contactStructuredName: "Callo से संपर्क", contactHeroText: "यह पेज Callo के सार्वजनिक संपर्क विकल्पों को एक जगह रखता है और अनुरोध के प्रकार के अनुसार टीम से संपर्क करने का तरीका बताता है।", contactBeforeTitle: "लिखने से पहले", contactBeforeText: "सटीक अनुरोध को संभालना आसान होता है और महत्वपूर्ण रिपोर्ट दर्ज करने में मदद मिलती है।", contactSupportTitle: "सामान्य सहायता", contactSupportText: "खाता, लॉगिन, वीडियो कॉल, लाइव, संदेश, पोस्ट या तकनीकी समस्या।", contactSupportCta: "सहायता को लिखें", contactReportTitle: "सामग्री की रिपोर्ट", contactReportText: "ऐसी प्रोफ़ाइल, संदेश, लाइव या पोस्ट जो खतरनाक, अपमानजनक, धोखाधड़ी वाली या प्रतिबंधित लगे।", contactReportCta: "रिपोर्ट भेजें", contactDataTitle: "व्यक्तिगत डेटा", contactDataText: "डेटा देखने, सुधारने, खाता हटाने या निजता से जुड़ा अनुरोध।", contactDataCta: "अपने अधिकारों का उपयोग करें", contactChecklistEmail: "आपका संपर्क ईमेल पता।", contactChecklistUsername: "संबंधित उपयोगकर्ता नाम या पहचान, यदि उपलब्ध हो।", contactChecklistType: "समस्या का प्रकार।", contactChecklistDescription: "स्थिति का छोटा और स्पष्ट विवरण।", contactDocsTitle: "उपयोगी दस्तावेज़", contactDocsText: "निजता, उपयोग की शर्तों या संपादकीय जिम्मेदारी के प्रश्नों के लिए पहले सार्वजनिक कानूनी पेज देखें।",
    safetyMetaTitle: "सुरक्षा और मॉडरेशन | Callo के सार्वजनिक नियम", safetyMetaDescription: "Callo के सुरक्षा, मॉडरेशन, रिपोर्ट और विज्ञापन अनुपालन नियम पढ़ें।", safetyStructuredName: "Callo सुरक्षा और मॉडरेशन", safetyStructuredDescription: "Callo की सुरक्षा, मॉडरेशन, रिपोर्ट और विज्ञापन अनुपालन के सार्वजनिक नियम।", safetyBadge: "सुरक्षा और मॉडरेशन", safetyHeroTitle: "उपयोगकर्ताओं की रक्षा के लिए सार्वजनिक नियम।", safetyHeroText: "Callo उपयोगकर्ता सामग्री वाला सामाजिक प्लेटफ़ॉर्म है। नियम प्रतिबंधित सामग्री, मॉडरेशन, रिपोर्ट और जिम्मेदार विज्ञापन समझाते हैं।", safetyImportantTitle: "महत्वपूर्ण", safetyImportantText: "विज्ञापन निजी स्क्रीन, उपयोगी सामग्री रहित पेज या प्रतिबंधित सामग्री के पास नहीं होने चाहिए।", safetyReportCta: "समस्या की रिपोर्ट करें", safetyBlockReportsTitle: "आसान रिपोर्ट", safetyBlockReportsText: "उपयोगकर्ता नियमों का उल्लंघन करने वाली प्रोफ़ाइल, संदेश, लाइव या पोस्ट की रिपोर्ट कर सकते हैं।", safetyBlockAccountsTitle: "सुरक्षित खाते", safetyBlockAccountsText: "पंजीकरण के लिए मान्य ईमेल चाहिए और सेवा कम से कम 16 वर्ष के लोगों के लिए है।", safetyBlockDataTitle: "डेटा की जानकारी", safetyBlockDataText: "एकत्र डेटा, स्थान और कुकीज़ की जानकारी निजता नीति में है।", safetyBlockPublicTitle: "स्पष्ट सार्वजनिक पेज", safetyBlockPublicText: "पारदर्शिता बढ़ाने के लिए नियम और संपर्क बिना लॉगिन देखे जा सकते हैं।", safetyForbiddenTitle: "प्रतिबंधित सामग्री और व्यवहार", safetyForbiddenText: "ये श्रेणियाँ मॉडरेशन कार्रवाई का आधार हैं और जिम्मेदार वातावरण बनाए रखने में मदद करती हैं।", safetyForbiddenSexual: "बिना सहमति नग्नता, स्पष्ट यौन सामग्री या नाबालिगों का शोषण।", safetyForbiddenHarassment: "उत्पीड़न, धमकी, डराना, भेदभाव या पहचान की चोरी।", safetyForbiddenSpam: "स्पैम, फ़िशिंग, धोखाधड़ी, दुरुपयोगी विज्ञापन या अनुचित स्वचालन।", safetyForbiddenIllegal: "अवैध, हिंसक, आतंकवादी, घृणास्पद या खतरनाक सामग्री।", safetyForbiddenPersonalData: "बिना अनुमति किसी अन्य व्यक्ति का व्यक्तिगत डेटा साझा करना।", safetyForbiddenBypass: "मॉडरेशन या सुरक्षा उपकरणों को दरकिनार करने का प्रयास।", safetyProcessTitle: "रिपोर्ट प्रक्रिया", safetyProcessText: "प्रक्रिया उपयोगकर्ताओं के लिए स्पष्ट और बाहरी भागीदारों के लिए दर्ज करने योग्य होनी चाहिए।", safetyRulesCta: "पूरे नियम पढ़ें", safetyStepLabel: "चरण {number}", safetyStepReceiveTitle: "रिपोर्ट प्राप्त", safetyStepReceiveText: "अनुरोध में प्रोफ़ाइल, सामग्री, तारीख और संदर्भ जैसी अधिकतम उपयोगी जानकारी होनी चाहिए।", safetyStepReviewTitle: "समीक्षा", safetyStepReviewText: "सामग्री की तुलना आचरण नियमों और लागू कानूनी दायित्वों से की जाती है।", safetyStepActionTitle: "कार्रवाई", safetyStepActionText: "गंभीरता के अनुसार चेतावनी, हटाना, निलंबन, प्रतिबंध या अधिकारियों को रिपोर्ट किया जा सकता है।",
  },
}

const LEGAL_PAGE_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  en: { legalTermsPageTitle: "Terms of use", legalTermsMetaDescription: "Callo terms of use and rules for using the video chat platform.", legalTermsPill: "Official legal document", legalTermsHeroIntro: "These terms govern your access to the Callo platform.", legalMentionsPageTitle: "Legal notice", legalMentionsMetaDescription: "Callo legal notice and information about the website publisher.", legalMentionsHeaderSubtitle: "In accordance with Article 6 of French Law No. 2004-575 of June 21, 2004 (LCEN)", legalPrivacyPageTitle: "Privacy policy", legalPrivacyMetaDescription: "Callo privacy policy and information about how your personal data is protected.", legalLastUpdated: "Last updated: March 10, 2025" },
  es: { legalTermsPageTitle: "Términos de uso", legalTermsMetaDescription: "Términos de uso de Callo y reglas para utilizar la plataforma de videochat.", legalTermsPill: "Documento legal oficial", legalTermsHeroIntro: "Estas condiciones regulan tu acceso a la plataforma Callo.", legalMentionsPageTitle: "Aviso legal", legalMentionsMetaDescription: "Aviso legal de Callo e información sobre el editor del sitio.", legalMentionsHeaderSubtitle: "De conformidad con el artículo 6 de la ley francesa n.º 2004-575 de 21 de junio de 2004 (LCEN)", legalPrivacyPageTitle: "Política de privacidad", legalPrivacyMetaDescription: "Política de privacidad de Callo y protección de tus datos personales.", legalLastUpdated: "Última actualización: 10 de marzo de 2025" },
  pt: { legalTermsPageTitle: "Termos de uso", legalTermsMetaDescription: "Termos de uso do Callo e regras para utilizar a plataforma de videochat.", legalTermsPill: "Documento legal oficial", legalTermsHeroIntro: "Estas condições regem o seu acesso à plataforma Callo.", legalMentionsPageTitle: "Aviso legal", legalMentionsMetaDescription: "Aviso legal do Callo e informações sobre o responsável pelo site.", legalMentionsHeaderSubtitle: "De acordo com o artigo 6 da lei francesa n.º 2004-575 de 21 de junho de 2004 (LCEN)", legalPrivacyPageTitle: "Política de privacidade", legalPrivacyMetaDescription: "Política de privacidade do Callo e proteção dos seus dados pessoais.", legalLastUpdated: "Última atualização: 10 de março de 2025" },
  de: { legalTermsPageTitle: "Nutzungsbedingungen", legalTermsMetaDescription: "Callo-Nutzungsbedingungen und Regeln für die Nutzung der Videochat-Plattform.", legalTermsPill: "Offizielles Rechtsdokument", legalTermsHeroIntro: "Diese Bedingungen regeln deinen Zugang zur Callo-Plattform.", legalMentionsPageTitle: "Impressum", legalMentionsMetaDescription: "Impressum von Callo und Informationen zum Betreiber der Website.", legalMentionsHeaderSubtitle: "Gemäß Artikel 6 des französischen Gesetzes Nr. 2004-575 vom 21. Juni 2004 (LCEN)", legalPrivacyPageTitle: "Datenschutzerklärung", legalPrivacyMetaDescription: "Callo-Datenschutzerklärung und Schutz deiner personenbezogenen Daten.", legalLastUpdated: "Letzte Aktualisierung: 10. März 2025" },
  it: { legalTermsPageTitle: "Termini di utilizzo", legalTermsMetaDescription: "Termini di utilizzo di Callo e regole per usare la piattaforma di videochat.", legalTermsPill: "Documento legale ufficiale", legalTermsHeroIntro: "Queste condizioni regolano il tuo accesso alla piattaforma Callo.", legalMentionsPageTitle: "Note legali", legalMentionsMetaDescription: "Note legali di Callo e informazioni sul gestore del sito.", legalMentionsHeaderSubtitle: "Ai sensi dell'articolo 6 della legge francese n. 2004-575 del 21 giugno 2004 (LCEN)", legalPrivacyPageTitle: "Informativa sulla privacy", legalPrivacyMetaDescription: "Informativa sulla privacy di Callo e protezione dei tuoi dati personali.", legalLastUpdated: "Ultimo aggiornamento: 10 marzo 2025" },
  ar: { legalTermsPageTitle: "شروط الاستخدام", legalTermsMetaDescription: "شروط استخدام Callo وقواعد استخدام منصة الدردشة بالفيديو.", legalTermsPill: "وثيقة قانونية رسمية", legalTermsHeroIntro: "تنظم هذه الشروط وصولك إلى منصة Callo.", legalMentionsPageTitle: "الإشعارات القانونية", legalMentionsMetaDescription: "الإشعارات القانونية لـ Callo ومعلومات ناشر الموقع.", legalMentionsHeaderSubtitle: "وفقاً للمادة 6 من القانون الفرنسي رقم 2004-575 الصادر في 21 يونيو 2004 (LCEN)", legalPrivacyPageTitle: "سياسة الخصوصية", legalPrivacyMetaDescription: "سياسة خصوصية Callo وكيفية حماية بياناتك الشخصية.", legalLastUpdated: "آخر تحديث: 10 مارس 2025" },
  tr: { legalTermsPageTitle: "Kullanım şartları", legalTermsMetaDescription: "Callo kullanım şartları ve görüntülü sohbet platformu kuralları.", legalTermsPill: "Resmî hukuki belge", legalTermsHeroIntro: "Bu şartlar Callo platformuna erişiminizi düzenler.", legalMentionsPageTitle: "Yasal bildirim", legalMentionsMetaDescription: "Callo yasal bildirimi ve site yayıncısı hakkında bilgiler.", legalMentionsHeaderSubtitle: "21 Haziran 2004 tarihli 2004-575 sayılı Fransız yasasının (LCEN) 6. maddesi uyarınca", legalPrivacyPageTitle: "Gizlilik politikası", legalPrivacyMetaDescription: "Callo gizlilik politikası ve kişisel verilerinizin korunması.", legalLastUpdated: "Son güncelleme: 10 Mart 2025" },
  nl: { legalTermsPageTitle: "Gebruiksvoorwaarden", legalTermsMetaDescription: "Callo-gebruiksvoorwaarden en regels voor het videochatplatform.", legalTermsPill: "Officieel juridisch document", legalTermsHeroIntro: "Deze voorwaarden regelen je toegang tot het Callo-platform.", legalMentionsPageTitle: "Juridische informatie", legalMentionsMetaDescription: "Juridische informatie van Callo en gegevens over de websitebeheerder.", legalMentionsHeaderSubtitle: "Volgens artikel 6 van de Franse wet nr. 2004-575 van 21 juni 2004 (LCEN)", legalPrivacyPageTitle: "Privacybeleid", legalPrivacyMetaDescription: "Callo-privacybeleid en bescherming van je persoonsgegevens.", legalLastUpdated: "Laatst bijgewerkt: 10 maart 2025" },
  ru: { legalTermsPageTitle: "Условия использования", legalTermsMetaDescription: "Условия использования Callo и правила видеочат-платформы.", legalTermsPill: "Официальный правовой документ", legalTermsHeroIntro: "Эти условия регулируют доступ к платформе Callo.", legalMentionsPageTitle: "Правовая информация", legalMentionsMetaDescription: "Правовая информация Callo и сведения о владельце сайта.", legalMentionsHeaderSubtitle: "В соответствии со статьёй 6 французского закона № 2004-575 от 21 июня 2004 года (LCEN)", legalPrivacyPageTitle: "Политика конфиденциальности", legalPrivacyMetaDescription: "Политика конфиденциальности Callo и защита персональных данных.", legalLastUpdated: "Последнее обновление: 10 марта 2025 года" },
  zh: { legalTermsPageTitle: "使用条款", legalTermsMetaDescription: "Callo 使用条款以及视频聊天平台的使用规则。", legalTermsPill: "官方法律文件", legalTermsHeroIntro: "这些条款规定了你访问 Callo 平台的条件。", legalMentionsPageTitle: "法律声明", legalMentionsMetaDescription: "Callo 法律声明以及网站运营者信息。", legalMentionsHeaderSubtitle: "根据 2004 年 6 月 21 日法国第 2004-575 号法律（LCEN）第 6 条", legalPrivacyPageTitle: "隐私政策", legalPrivacyMetaDescription: "Callo 隐私政策以及我们如何保护你的个人数据。", legalLastUpdated: "最后更新：2025 年 3 月 10 日" },
  ja: { legalTermsPageTitle: "利用規約", legalTermsMetaDescription: "Calloの利用規約とビデオチャットプラットフォームのルール。", legalTermsPill: "公式法的文書", legalTermsHeroIntro: "この規約はCalloプラットフォームへのアクセスを定めます。", legalMentionsPageTitle: "法的表示", legalMentionsMetaDescription: "Calloの法的表示とサイト運営者に関する情報。", legalMentionsHeaderSubtitle: "2004年6月21日付フランス法第2004-575号（LCEN）第6条に基づく表示", legalPrivacyPageTitle: "プライバシーポリシー", legalPrivacyMetaDescription: "Calloのプライバシーポリシーと個人データの保護について。", legalLastUpdated: "最終更新日：2025年3月10日" },
  ko: { legalTermsPageTitle: "이용 약관", legalTermsMetaDescription: "Callo 이용 약관 및 영상 채팅 플랫폼 이용 규칙.", legalTermsPill: "공식 법률 문서", legalTermsHeroIntro: "이 약관은 Callo 플랫폼 이용 조건을 규정합니다.", legalMentionsPageTitle: "법적 고지", legalMentionsMetaDescription: "Callo 법적 고지 및 사이트 운영자 정보.", legalMentionsHeaderSubtitle: "2004년 6월 21일 프랑스 법률 제2004-575호(LCEN) 제6조에 따름", legalPrivacyPageTitle: "개인정보 처리방침", legalPrivacyMetaDescription: "Callo 개인정보 처리방침 및 개인 데이터 보호 방법.", legalLastUpdated: "최종 업데이트: 2025년 3월 10일" },
  hi: { legalTermsPageTitle: "उपयोग की शर्तें", legalTermsMetaDescription: "Callo की उपयोग शर्तें और वीडियो चैट प्लेटफ़ॉर्म के नियम।", legalTermsPill: "आधिकारिक कानूनी दस्तावेज़", legalTermsHeroIntro: "ये शर्तें Callo प्लेटफ़ॉर्म तक आपकी पहुँच को नियंत्रित करती हैं।", legalTermsNoticeIntro: "ये शर्तें Callo प्लेटफ़ॉर्म तक पहुँच और उसके उपयोग को नियंत्रित करती हैं।", legalTermsNav_s1: "उद्देश्य", legalTermsNav_s2: "पहुँच की शर्तें", legalTermsNav_s3: "आचार संहिता", legalTermsNav_s4: "मॉडरेशन और प्रतिबंध", legalTermsNav_s5: "बौद्धिक संपदा", legalTermsNav_s6: "जिम्मेदारी", legalTermsNav_s7: "सेवा मुफ़्त है", legalTermsNav_s8: "समापन", legalTermsNav_s9: "शर्तों में बदलाव", legalTermsNav_s10: "लागू कानून", legalTermsNav_s11: "संपर्क", legalMentionsPageTitle: "कानूनी सूचना", legalMentionsMetaDescription: "Callo की कानूनी सूचना और साइट संचालक की जानकारी।", legalMentionsHeaderSubtitle: "21 जून 2004 के फ्रांसीसी कानून संख्या 2004-575 (LCEN) के अनुच्छेद 6 के अनुसार", legalPrivacyPageTitle: "गोपनीयता नीति", legalPrivacyMetaDescription: "Callo की गोपनीयता नीति और आपके व्यक्तिगत डेटा की सुरक्षा।", legalLastUpdated: "अंतिम अपडेट: 10 मार्च 2025", legalContents: "विषय-सूची", legalInformation: "जानकारी", legalUpdated: "अपडेट", legalUpdatedDate: "जनवरी 2025", legalJurisdiction: "अधिकार क्षेत्र", legalJurisdictionValue: "फ्रांसीसी कानून · पेरिस", legalReadTime: "~3 मिनट पढ़ना", legalNotice: "प्रकाशक, डेटा सुरक्षा और बौद्धिक संपदा से संबंधित सार्वजनिक जानकारी।", legalNavPublisher: "प्रकाशक", legalNavOwnership: "स्वामित्व", legalNavData: "डेटा", legalNavCookies: "कुकीज़", legalNavLiability: "जिम्मेदारी", legalNavLinks: "लिंक", legalNavLaw: "लागू कानून", legalNavContact: "संपर्क", legalSectionPublisher: "साइट प्रकाशक", legalSectionOwnership: "बौद्धिक संपदा", legalSectionData: "व्यक्तिगत डेटा की सुरक्षा", legalSectionCookies: "कुकीज़", legalSectionLiability: "जिम्मेदारी की सीमा", legalSectionLinks: "हाइपरलिंक", legalSectionLaw: "लागू कानून", legalSectionContact: "संपर्क", legalOwnershipText1: "Callo साइट की सभी सामग्री (पाठ, चित्र, लोगो, आइकन, डिज़ाइन और स्रोत कोड) Callo या उसके भागीदारों की संपत्ति है और बौद्धिक संपदा कानूनों द्वारा सुरक्षित है।", legalOwnershipText2: "साइट के किसी भी भाग का पुनरुत्पादन, प्रकाशन या रूपांतरण पूर्व लिखित अनुमति के बिना प्रतिबंधित है।", legalDataText: "GDPR के अनुसार आपको अपने व्यक्तिगत डेटा पर अधिकार प्राप्त हैं।", legalSeePrivacy: "अधिक जानकारी के लिए हमारी", legalForDetails: "देखें।", legalCookiesText: "साइट आवश्यक तकनीकी कुकीज़ और सक्रिय होने पर दर्शक-मापन या विज्ञापन कुकीज़ का उपयोग कर सकती है।", legalLiabilityText: "Callo प्रकाशित जानकारी की गुणवत्ता सुनिश्चित करने के लिए उचित साधन अपनाता है, लेकिन उसकी पूर्णता की गारंटी नहीं देता।", legalLinksText: "साइट में जानकारी के लिए बाहरी लिंक हो सकते हैं; Callo इन साइटों को नियंत्रित नहीं करता और उनकी सामग्री के लिए जिम्मेदार नहीं है।", legalLawText: "ये कानूनी सूचनाएँ फ्रांसीसी कानून के अधीन हैं। विवाद की स्थिति में फ्रांसीसी अदालतें सक्षम होंगी।", legalContactText: "कानूनी सूचनाओं से संबंधित किसी भी प्रश्न के लिए" },
}

LEGAL_PAGE_TRANSLATIONS.hi = {
  ...LEGAL_PAGE_TRANSLATIONS.hi,
  legalSiteName: "साइट का नाम",
  legalUrl: "URL",
  legalContactLabel: "संपर्क",
}

LEGAL_PAGE_TRANSLATIONS.ar = {
  ...LEGAL_PAGE_TRANSLATIONS.ar,
  legalTermsNoticeIntro: "تنظم هذه الشروط الوصول إلى منصة Callo واستخدامها.",
}

const ARABIC_TERMS_TRANSLATION: Partial<Record<TranslationKey, string>> = {
  termsFeatureVideo: "مكالمات فيديو عشوائية", termsFeatureVideoDesc: "بين مستخدمين من جميع أنحاء العالم", termsFeatureLives: "بثوث مباشرة", termsFeatureLivesDesc: "مفتوحة للمجتمع", termsFeatureMessaging: "رسائل خاصة فورية", termsFeatureMessagingDesc: "مشفرة وآمنة", termsFeaturePosts: "موجز الأخبار", termsFeaturePostsDesc: "مع المنشورات والتفاعلات", termsAccountCreation: "2.1 · إنشاء الحساب", termsAccountSecurity: "2.2 · أمان الحساب", termsSixteen: "16 عاماً", termsMinimum: "كحد أدنى", termsValidEmail: "عنوان بريد إلكتروني صالح", termsPassword: "كلمة مرور من 8 أحرف على الأقل", termsEmailVerification: "التحقق من البريد الإلكتروني مطلوب", termsAcceptance: "قبول الشروط وسياسة الخصوصية", termsAccountSecurityText: "أنت مسؤول عن سرية بيانات الدخول الخاصة بك. تُنسب أي أنشطة من حسابك إليك. تواصل معنا فوراً إذا تم اختراق حسابك.", termsLocationIntro: "للوصول إلى Callo، يجب السماح بمشاركة الموقع. نجمع فقط", termsCityCountry: "مدينتك وبلدك", termsLocationRefusal: "إذا رفضت مشاركة موقعك، فقد يتم تقييد الوصول إلى المنصة.", termsDeleteData: "لحذف حسابك وبياناتك، افتح إعدادات ملفك الشخصي.", termsPrivacyMore: "لمزيد من المعلومات، راجع", termsExpected: "متوقع", termsRespect: "احترام المستخدمين الآخرين", termsCourtesy: "التواصل بأدب", termsReport: "الإبلاغ عن المحتوى غير المناسب", termsResponsible: "استخدام المنصة بمسؤولية", termsForbidden: "محظور", termsForbiddenIntro: "راجع الفئات الأربع أدناه للاطلاع على القائمة الكاملة للأفعال المحظورة على المنصة.", termsProhibIllegal: "محتوى غير قانوني", termsProhibHarassment: "مضايقة", termsProhibNudity: "عري / محتوى جنسي", termsProhibFraud: "احتيال / رسائل مزعجة", termsIllegal1: "مواد إباحية للأطفال", termsIllegal2: "استغلال جنسي للأطفال", termsIllegal3: "الإرهاب أو تمجيد الجرائم", termsIllegal4: "الاتجار بالمواد غير المشروعة", termsHarassment1: "مضايقة نفسية أو جنسية", termsHarassment2: "ترهيب أو تهديدات", termsHarassment3: "تمييز (عنصرية أو تمييز جنسي...)", termsHarassment4: "تشهير أو إهانات", termsNudity1: "عري غير مرغوب فيه", termsNudity2: "محتوى جنسي صريح", termsNudity3: "استدراج جنسي", termsNudity4: "استعراض فاضح", termsFraud1: "سرقة الهوية", termsFraud2: "احتيال أو تصيد", termsFraud3: "رسائل مزعجة أو إعلانات غير مرغوبة", termsFraud4: "ملفات شخصية مزيفة أو روبوتات", termsReportProcess: "يتوفر الإبلاغ في كل ملف شخصي ومحادثة. تستغرق المعالجة", termsReportHours: "من 24 إلى 48 ساعة", termsWarning: "تحذير", termsWarningDesc: "أول مخالفة بسيطة — يتم إرسال إشعار", termsSuspension: "تعليق مؤقت", termsSuspensionDesc: "مخالفة متكررة أو خطيرة — تم حظر الوصول", termsBan: "حظر نهائي", termsBanDesc: "مخالفة جسيمة أو تكرار — تم حذف الحساب", termsAuthorities: "الإبلاغ للسلطات", termsAuthoritiesDesc: "لأي محتوى غير قانوني بشكل واضح", termsOwnershipText1: "اسم Callo والشعار والتصميم وجميع محتويات المنصة ملك حصري لـ Callo. يُحظر النسخ دون إذن كتابي مسبق.", termsOwnershipText2: "عند نشر محتوى على Callo، تحتفظ بحقوق الملكية الفكرية الخاصة بك، لكنك تمنح Callo ترخيصاً عالمياً وغير حصري ومجانياً لعرض المحتوى وتوزيعه والترويج له ضمن الخدمة.", termsCalloResponsibility: "6.1 · مسؤولية Callo", termsCalloResponsibilityText: "تعمل Callo كمضيف وفقاً للمادة 6 من قانون LCEN. نزيل بسرعة أي محتوى غير قانوني بشكل واضح يتم الإبلاغ عنه.", termsUserResponsibility: "6.2 · مسؤولية المستخدم", termsUserResponsibilityText: "أنت المسؤول الوحيد عن تفاعلاتك والمحتوى الذي تنشره. لا تتحمل Callo مسؤولية الأضرار الناتجة عن تبادلاتك.", termsFreeText: "Callo مجانية 100%. جميع الميزات — مكالمات الفيديو والبثوث والرسائل والمنشورات — متاحة دون اشتراك أو دفع. يتم تمويل الخدمة من الإعلانات.", termsTerminationText1: "يمكنك حذف حسابك في أي وقت من إعدادات ملفك الشخصي. يؤدي الحذف إلى إزالة بياناتك الشخصية وفقاً لسياسة الخصوصية.", termsTerminationText2: "يمكن لـ Callo أيضاً تعليق حسابك أو حذفه عند مخالفة هذه الشروط، دون إشعار أو تعويض.", termsChangesText: "نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطارك بالتغييرات المهمة عبر البريد الإلكتروني أو التطبيق. استمرار استخدام الخدمة بعد الإشعار يعني قبول الشروط الجديدة.", termsLawText: "تخضع هذه الشروط للقانون الفرنسي. تُعرض أي نزاعات متعلقة بتفسيرها أو تنفيذها على المحاكم المختصة في باريس، فرنسا.", termsContactText: "لأي سؤال حول هذه الشروط"
}

const TERMS_PAGE_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  en: { termsContents: "Contents", termsUpdated: "Updated", termsUpdatedDate: "January 2025", termsReadTime: "~5 min read", termsJurisdiction: "French law · Paris", termsNavLocation: "Location", termsLawTitle: "Governing law and jurisdiction", termsNoticeAccept: "By creating an account or using our services, you accept these terms in full.", termsObjectIntro: "Callo is a social connection platform offering:", termsAgeTitle: "Minimum age required: 16", termsAgeText: "By creating an account, you confirm that you meet the legal age requirement in your country. False statements lead to immediate account deletion.", termsAccountCreation: "2.1 · Account creation", termsAccountSecurity: "2.2 · Account security", termsSixteen: "16 years old", termsMinimum: "minimum", termsValidEmail: "Valid email address", termsPassword: "Password of at least 8 characters", termsEmailVerification: "Email verification required", termsAcceptance: "Acceptance of the terms and privacy policy", termsAccountSecurityText: "You are responsible for keeping your credentials confidential. Activity from your account is considered to be yours. Contact us immediately if your account is compromised.", termsLocationIntro: "To access Callo, you must allow location sharing. We only collect your", termsCityCountry: "city and country", termsLocationRefusal: "If you refuse to share your location, access to the platform may be limited.", termsDeleteData: "To delete your account and data, open your profile settings.", termsPrivacyMore: "For more information, see our", termsExpected: "Expected", termsRespect: "Respect other users", termsCourtesy: "Communicate politely", termsReport: "Report inappropriate content", termsResponsible: "Use the platform responsibly", termsForbidden: "Forbidden", termsForbiddenIntro: "See the four categories below for the complete list of prohibited acts on the platform.", termsProhibIllegal: "Illegal content", termsProhibHarassment: "Harassment", termsProhibNudity: "Nudity / sexuality", termsProhibFraud: "Fraud / spam", termsIllegal1: "Child pornography", termsIllegal2: "Child sexual exploitation", termsIllegal3: "Terrorism or praise of crimes", termsIllegal4: "Illegal substance trafficking", termsHarassment1: "Psychological or sexual harassment", termsHarassment2: "Intimidation or threats", termsHarassment3: "Discrimination (racism, sexism...)", termsHarassment4: "Defamation or insults", termsNudity1: "Unsolicited nudity", termsNudity2: "Explicit sexual content", termsNudity3: "Sexual solicitation", termsNudity4: "Exhibitionism", termsFraud1: "Identity theft", termsFraud2: "Scams or phishing", termsFraud3: "Spam or unsolicited advertising", termsFraud4: "Fake profiles or bots", termsReportProcess: "Reports are available on every profile and conversation. Processing takes", termsWarning: "Warning", termsWarningDesc: "First minor violation — notification sent", termsSuspension: "Temporary suspension", termsSuspensionDesc: "Repeated or serious violation — access blocked", termsBan: "Permanent ban", termsBanDesc: "Major violation or repeat offense — account deleted", termsAuthorities: "Report to authorities", termsAuthoritiesDesc: "For clearly illegal content", termsOwnershipText1: "The name Callo, logo, design and all platform content belong exclusively to Callo. Reproduction without written permission is strictly prohibited.", termsOwnershipText2: "By publishing content on Callo, you retain your intellectual property rights but grant Callo a worldwide, non-exclusive and free licence to display, distribute and promote that content as part of the service.", termsCalloResponsibility: "6.1 · Callo responsibility", termsCalloResponsibilityText: "Callo acts as a host under Article 6 of the LCEN. We promptly remove any clearly unlawful content that is reported.", termsUserResponsibility: "6.2 · User responsibility", termsUserResponsibilityText: "You are solely responsible for your interactions and the content you publish. Callo cannot be held liable for damage resulting from your exchanges.", termsFreeText: "Callo is 100% free. All features — video calls, live streams, messaging and posts — are available without a subscription or payment. The service is funded by advertising.", termsTerminationText1: "You can delete your account at any time from your profile settings. Deletion removes your personal data in accordance with our privacy policy.", termsTerminationText2: "Callo may also suspend or delete your account if you violate these terms, without notice or compensation.", termsChangesText: "We may change these terms at any time. Important changes will be notified by email or through the app. Continuing to use the service after notification means accepting the new terms.", termsLawText: "These terms are governed by French law. Any dispute concerning their interpretation or performance will be submitted to the competent courts of Paris, France.", termsContactText: "For any question about these terms" },
  es: { termsContents: "Contenido", termsUpdated: "Actualización", termsUpdatedDate: "Enero de 2025", termsReadTime: "Lectura ~5 min", termsJurisdiction: "Derecho francés · París", termsNavLocation: "Ubicación", termsLawTitle: "Ley aplicable y jurisdicción", termsNoticeAccept: "Al crear una cuenta o utilizar nuestros servicios, aceptas estas condiciones en su totalidad.", termsObjectIntro: "Callo es una plataforma de conexión social que ofrece:", termsAgeTitle: "Edad mínima requerida: 16 años", termsAgeText: "Al crear una cuenta, confirmas que cumples la edad legal de tu país. Las declaraciones falsas provocan la eliminación inmediata de la cuenta." },
  pt: { termsContents: "Sumário", termsUpdated: "Atualização", termsUpdatedDate: "Janeiro de 2025", termsReadTime: "Leitura ~5 min", termsJurisdiction: "Direito francês · Paris", termsNavLocation: "Localização", termsLawTitle: "Lei aplicável e jurisdição", termsNoticeAccept: "Ao criar uma conta ou utilizar os nossos serviços, aceita estas condições na íntegra.", termsObjectIntro: "O Callo é uma plataforma de ligação social que oferece:", termsAgeTitle: "Idade mínima exigida: 16 anos", termsAgeText: "Ao criar uma conta, confirma que cumpre a idade legal do seu país. Declarações falsas levam à eliminação imediata da conta." },
  de: { termsContents: "Inhalt", termsUpdated: "Aktualisierung", termsUpdatedDate: "Januar 2025", termsReadTime: "~5 Min. Lesezeit", termsJurisdiction: "Französisches Recht · Paris", termsNavLocation: "Standort", termsLawTitle: "Anwendbares Recht und Gerichtsstand", termsNoticeAccept: "Mit der Erstellung eines Kontos oder der Nutzung unserer Dienste akzeptierst du diese Bedingungen vollständig.", termsObjectIntro: "Callo ist eine soziale Plattform zur Kontaktaufnahme und bietet:", termsAgeTitle: "Mindestalter: 16 Jahre", termsAgeText: "Mit der Kontoerstellung bestätigst du, dass du das gesetzliche Mindestalter deines Landes erfüllst. Falsche Angaben führen zur sofortigen Kontolöschung." },
  it: { termsContents: "Indice", termsUpdated: "Aggiornamento", termsUpdatedDate: "Gennaio 2025", termsReadTime: "Lettura ~5 min", termsJurisdiction: "Diritto francese · Parigi", termsNavLocation: "Posizione", termsLawTitle: "Legge applicabile e giurisdizione", termsNoticeAccept: "Creando un account o utilizzando i nostri servizi, accetti integralmente queste condizioni.", termsObjectIntro: "Callo è una piattaforma di connessione sociale che offre:", termsAgeTitle: "Età minima richiesta: 16 anni", termsAgeText: "Creando un account confermi di rispettare l'età prevista dalla legge del tuo Paese. Le dichiarazioni false comportano l'eliminazione immediata dell'account." },
  ar: { termsContents: "المحتويات", termsUpdated: "التحديث", termsUpdatedDate: "يناير 2025", termsReadTime: "قراءة ~5 دقائق", termsJurisdiction: "القانون الفرنسي · باريس", termsNavLocation: "الموقع", termsLawTitle: "القانون المطبق والاختصاص القضائي", termsNoticeAccept: "بإنشاء حساب أو استخدام خدماتنا، فإنك تقبل هذه الشروط بالكامل.", termsObjectIntro: "Callo منصة للتواصل الاجتماعي تقدم:", termsAgeTitle: "الحد الأدنى للعمر: 16 عاماً", termsAgeText: "بإنشاء حساب، تؤكد استيفاء السن القانوني في بلدك. تؤدي البيانات الكاذبة إلى حذف الحساب فوراً." },
  tr: { termsContents: "İçindekiler", termsUpdated: "Güncelleme", termsUpdatedDate: "Ocak 2025", termsReadTime: "~5 dk okuma", termsJurisdiction: "Fransız hukuku · Paris", termsNavLocation: "Konum", termsLawTitle: "Uygulanacak hukuk ve yargı yetkisi", termsNoticeAccept: "Hesap oluşturarak veya hizmetlerimizi kullanarak bu şartları tamamen kabul etmiş olursunuz.", termsObjectIntro: "Callo şu hizmetleri sunan sosyal bağlantı platformudur:", termsAgeTitle: "Gerekli minimum yaş: 16", termsAgeText: "Hesap oluşturarak ülkenizdeki yasal yaş şartını karşıladığınızı onaylarsınız. Yanlış beyan hesabın derhal silinmesine neden olur." },
  nl: { termsContents: "Inhoud", termsUpdated: "Bijgewerkt", termsUpdatedDate: "Januari 2025", termsReadTime: "~5 min lezen", termsJurisdiction: "Frans recht · Parijs", termsNavLocation: "Locatie", termsLawTitle: "Toepasselijk recht en bevoegde rechtbank", termsNoticeAccept: "Door een account te maken of onze diensten te gebruiken, accepteer je deze voorwaarden volledig.", termsObjectIntro: "Callo is een sociaal platform voor contact dat het volgende biedt:", termsAgeTitle: "Minimumleeftijd: 16 jaar", termsAgeText: "Bij het maken van een account bevestig je dat je voldoet aan de wettelijke leeftijd in jouw land. Onjuiste verklaringen leiden tot directe verwijdering van het account." },
  ru: { termsContents: "Содержание", termsUpdated: "Обновление", termsUpdatedDate: "Январь 2025", termsReadTime: "Чтение ~5 мин", termsJurisdiction: "Французское право · Париж", termsNavLocation: "Местоположение", termsLawTitle: "Применимое право и юрисдикция", termsNoticeAccept: "Создавая аккаунт или используя наши сервисы, вы полностью принимаете эти условия.", termsObjectIntro: "Callo — социальная платформа для общения, предлагающая:", termsAgeTitle: "Минимальный возраст: 16 лет", termsAgeText: "Создавая аккаунт, вы подтверждаете соответствие возрастному требованию вашей страны. Ложные сведения приводят к немедленному удалению аккаунта." },
  zh: { termsContents: "目录", termsUpdated: "更新", termsUpdatedDate: "2025年1月", termsReadTime: "阅读约5分钟", termsJurisdiction: "法国法律 · 巴黎", termsNavLocation: "位置", termsLawTitle: "适用法律和管辖权", termsNoticeAccept: "创建账户或使用我们的服务即表示你完全接受这些条款。", termsObjectIntro: "Callo 是一个提供以下服务的社交联系平台：", termsAgeTitle: "最低年龄要求：16岁", termsAgeText: "创建账户即表示你符合所在国家的法定年龄要求。虚假声明将导致账户立即被删除。" },
  ja: { termsContents: "目次", termsUpdated: "更新", termsUpdatedDate: "2025年1月", termsReadTime: "約5分", termsJurisdiction: "フランス法・パリ", termsNavLocation: "位置情報", termsLawTitle: "準拠法と管轄", termsNoticeAccept: "アカウントを作成するかサービスを利用することで、これらの規約に同意したものとします。", termsObjectIntro: "Calloは次のサービスを提供するソーシャル交流プラットフォームです：", termsAgeTitle: "必要な最低年齢：16歳", termsAgeText: "アカウント作成により、居住国の法定年齢要件を満たすことを確認します。虚偽の申告はアカウントの即時削除につながります。" },
  ko: { termsContents: "목차", termsUpdated: "업데이트", termsUpdatedDate: "2025년 1월", termsReadTime: "약 5분", termsJurisdiction: "프랑스 법률 · 파리", termsNavLocation: "위치", termsLawTitle: "준거법 및 관할권", termsNoticeAccept: "계정을 만들거나 서비스를 이용하면 본 약관 전체에 동의하는 것입니다.", termsObjectIntro: "Callo는 다음 서비스를 제공하는 소셜 연결 플랫폼입니다:", termsAgeTitle: "최소 연령: 16세", termsAgeText: "계정을 만들면 거주 국가의 법정 연령 요건을 충족함을 확인하는 것입니다. 허위 진술 시 계정이 즉시 삭제됩니다." },
  hi: { termsContents: "विषय-सूची", termsUpdated: "अपडेट", termsUpdatedDate: "जनवरी 2025", termsReadTime: "~5 मिनट पढ़ना", termsJurisdiction: "फ्रांसीसी कानून · पेरिस", termsNavLocation: "स्थान", termsLawTitle: "लागू कानून और अधिकार क्षेत्र", termsNoticeAccept: "खाता बनाकर या हमारी सेवाओं का उपयोग करके आप इन शर्तों को पूरी तरह स्वीकार करते हैं।", termsObjectIntro: "Callo एक सामाजिक संपर्क प्लेटफ़ॉर्म है जो प्रदान करता है:", termsFeatureVideo: "रैंडम वीडियो कॉल", termsFeatureVideoDesc: "दुनिया भर के उपयोगकर्ताओं के बीच", termsFeatureLives: "लाइव प्रसारण", termsFeatureLivesDesc: "समुदाय के लिए खुले", termsFeatureMessaging: "निजी त्वरित संदेश", termsFeatureMessagingDesc: "एन्क्रिप्टेड और सुरक्षित", termsFeaturePosts: "समाचार फ़ीड", termsFeaturePostsDesc: "पोस्ट और इंटरैक्शन के साथ", termsAgeTitle: "न्यूनतम आवश्यक आयु: 16 वर्ष", termsAgeText: "खाता बनाकर आप पुष्टि करते हैं कि आपके देश की कानूनी आयु पूरी है। गलत जानकारी देने पर खाता तुरंत हटा दिया जाएगा।", termsAccountCreation: "2.1 · खाता बनाना", termsAccountSecurity: "2.2 · खाते की सुरक्षा", termsSixteen: "16 वर्ष", termsMinimum: "न्यूनतम", termsValidEmail: "मान्य ईमेल पता", termsPassword: "कम से कम 8 अक्षरों का पासवर्ड", termsEmailVerification: "ईमेल सत्यापन आवश्यक", termsAcceptance: "शर्तों और निजता नीति की स्वीकृति", termsAccountSecurityText: "आप अपने लॉगिन विवरण की गोपनीयता के लिए जिम्मेदार हैं। आपके खाते से हुई गतिविधि आपकी मानी जाती है। खाता प्रभावित होने पर तुरंत हमसे संपर्क करें।", termsLocationIntro: "Callo तक पहुँचने के लिए स्थान साझा करने की अनुमति दें। हम केवल आपका", termsCityCountry: "शहर और देश", termsLocationRefusal: "यदि आप स्थान साझा करने से इनकार करते हैं, तो प्लेटफ़ॉर्म तक पहुँच सीमित हो सकती है।", termsDeleteData: "खाता और डेटा हटाने के लिए अपनी प्रोफ़ाइल सेटिंग खोलें।", termsPrivacyMore: "अधिक जानकारी के लिए हमारी", termsExpected: "अपेक्षित", termsRespect: "अन्य उपयोगकर्ताओं का सम्मान करें", termsCourtesy: "विनम्रता से बातचीत करें", termsReport: "अनुचित सामग्री की रिपोर्ट करें", termsResponsible: "प्लेटफ़ॉर्म का जिम्मेदारी से उपयोग करें", termsForbidden: "प्रतिबंधित", termsForbiddenIntro: "प्लेटफ़ॉर्म पर प्रतिबंधित कार्यों की पूरी सूची के लिए नीचे दी गई चार श्रेणियाँ देखें।", termsProhibIllegal: "अवैध सामग्री", termsProhibHarassment: "उत्पीड़न", termsProhibNudity: "नग्नता / यौन सामग्री", termsProhibFraud: "धोखाधड़ी / स्पैम", termsIllegal1: "बाल अश्लीलता", termsIllegal2: "बच्चों का यौन शोषण", termsIllegal3: "आतंकवाद या अपराधों का समर्थन", termsIllegal4: "अवैध पदार्थों की तस्करी", termsHarassment1: "मानसिक या यौन उत्पीड़न", termsHarassment2: "धमकी या डराना", termsHarassment3: "भेदभाव (नस्लवाद, लैंगिक भेदभाव...)", termsHarassment4: "मानहानि या अपमान", termsNudity1: "बिना सहमति नग्नता", termsNudity2: "स्पष्ट यौन सामग्री", termsNudity3: "यौन आग्रह", termsNudity4: "अश्लील प्रदर्शन", termsFraud1: "पहचान की चोरी", termsFraud2: "धोखाधड़ी या फ़िशिंग", termsFraud3: "स्पैम या अनचाहा विज्ञापन", termsFraud4: "नकली प्रोफ़ाइल या बॉट", termsReportProcess: "हर प्रोफ़ाइल और बातचीत में रिपोर्ट उपलब्ध है। प्रक्रिया में", termsReportHours: "24 से 48 घंटे", termsWarning: "चेतावनी", termsWarningDesc: "पहला छोटा उल्लंघन — सूचना भेजी जाएगी", termsSuspension: "अस्थायी निलंबन", termsSuspensionDesc: "बार-बार या गंभीर उल्लंघन — पहुँच अवरुद्ध", termsBan: "स्थायी प्रतिबंध", termsBanDesc: "बड़ा उल्लंघन या दोहराव — खाता हटाया गया", termsAuthorities: "अधिकारियों को रिपोर्ट", termsAuthoritiesDesc: "स्पष्ट रूप से अवैध सामग्री के लिए", termsOwnershipText1: "Callo नाम, लोगो, डिज़ाइन और प्लेटफ़ॉर्म की सभी सामग्री पर Callo का विशेष अधिकार है। लिखित अनुमति के बिना पुनरुत्पादन सख्त प्रतिबंधित है।", termsOwnershipText2: "Callo पर सामग्री प्रकाशित करते समय आपके बौद्धिक संपदा अधिकार बने रहते हैं, लेकिन आप सेवा के अंतर्गत सामग्री दिखाने, वितरित करने और प्रचारित करने के लिए Callo को विश्वव्यापी, गैर-अनन्य और निःशुल्क लाइसेंस देते हैं।", termsCalloResponsibility: "6.1 · Callo की जिम्मेदारी", termsCalloResponsibilityText: "LCEN के अनुच्छेद 6 के अनुसार Callo होस्ट के रूप में कार्य करता है। रिपोर्ट की गई स्पष्ट रूप से गैरकानूनी सामग्री को हम तुरंत हटाते हैं।", termsUserResponsibility: "6.2 · उपयोगकर्ता की जिम्मेदारी", termsUserResponsibilityText: "आप अपनी बातचीत और प्रकाशित सामग्री के लिए पूरी तरह जिम्मेदार हैं। आपकी बातचीत से होने वाले नुकसान के लिए Callo जिम्मेदार नहीं है।", termsFreeText: "Callo 100% मुफ़्त है। वीडियो कॉल, लाइव, संदेश और पोस्ट सहित सभी सुविधाएँ बिना सदस्यता या भुगतान के उपलब्ध हैं। सेवा विज्ञापन से वित्तपोषित है।", termsTerminationText1: "आप प्रोफ़ाइल सेटिंग से कभी भी खाता हटा सकते हैं। हटाने पर निजता नीति के अनुसार आपका व्यक्तिगत डेटा मिटा दिया जाता है।", termsTerminationText2: "इन शर्तों का उल्लंघन होने पर Callo बिना सूचना या मुआवज़े के आपका खाता निलंबित या हटा सकता है।", termsChangesText: "हम इन शर्तों को कभी भी बदल सकते हैं। महत्वपूर्ण बदलावों की सूचना ईमेल या ऐप के माध्यम से दी जाएगी। सूचना के बाद सेवा का उपयोग जारी रखना नई शर्तों की स्वीकृति माना जाएगा।", termsLawText: "ये शर्तें फ्रांसीसी कानून के अधीन हैं। इनके अर्थ या पालन से जुड़ा कोई भी विवाद पेरिस, फ्रांस की सक्षम अदालतों में प्रस्तुत किया जाएगा।", termsContactText: "इन शर्तों से जुड़े किसी भी प्रश्न के लिए" },
}

TERMS_PAGE_TRANSLATIONS.ar = ARABIC_TERMS_TRANSLATION

const TERMS_NAV_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  fr: { termsNavLocation: "Localisation", legalTermsNav_s1: "Objet", legalTermsNav_s2: "Conditions d'accès", legalTermsNav_s3: "Règles de conduite", legalTermsNav_s4: "Modération et sanctions", legalTermsNav_s5: "Propriété intellectuelle", legalTermsNav_s6: "Responsabilité", legalTermsNav_s7: "Gratuité", legalTermsNav_s8: "Résiliation", legalTermsNav_s9: "Modifications des CGU", legalTermsNav_s10: "Droit applicable", legalTermsNav_s11: "Contact" },
  en: { termsNavLocation: "Location", legalTermsNav_s1: "Purpose", legalTermsNav_s2: "Access conditions", legalTermsNav_s3: "Code of conduct", legalTermsNav_s4: "Moderation & sanctions", legalTermsNav_s5: "Intellectual property", legalTermsNav_s6: "Liability", legalTermsNav_s7: "Service is free", legalTermsNav_s8: "Termination", legalTermsNav_s9: "Changes to TOS", legalTermsNav_s10: "Governing law", legalTermsNav_s11: "Contact" },
  es: { termsNavLocation: "Ubicación", legalTermsNav_s1: "Objeto", legalTermsNav_s2: "Condiciones de acceso", legalTermsNav_s3: "Normas de conducta", legalTermsNav_s4: "Moderación y sanciones", legalTermsNav_s5: "Propiedad intelectual", legalTermsNav_s6: "Responsabilidad", legalTermsNav_s7: "Servicio gratuito", legalTermsNav_s8: "Cancelación", legalTermsNav_s9: "Cambios en los términos", legalTermsNav_s10: "Ley aplicable", legalTermsNav_s11: "Contacto" },
  pt: { termsNavLocation: "Localização", legalTermsNav_s1: "Objetivo", legalTermsNav_s2: "Condições de acesso", legalTermsNav_s3: "Código de conduta", legalTermsNav_s4: "Moderação e sanções", legalTermsNav_s5: "Propriedade intelectual", legalTermsNav_s6: "Responsabilidade", legalTermsNav_s7: "Serviço gratuito", legalTermsNav_s8: "Encerramento", legalTermsNav_s9: "Alterações dos termos", legalTermsNav_s10: "Lei aplicável", legalTermsNav_s11: "Contacto" },
  de: { termsNavLocation: "Standort", legalTermsNav_s1: "Zweck", legalTermsNav_s2: "Zugangsbedingungen", legalTermsNav_s3: "Verhaltensregeln", legalTermsNav_s4: "Moderation und Sanktionen", legalTermsNav_s5: "Geistiges Eigentum", legalTermsNav_s6: "Haftung", legalTermsNav_s7: "Kostenloser Dienst", legalTermsNav_s8: "Kündigung", legalTermsNav_s9: "Änderungen der Bedingungen", legalTermsNav_s10: "Anwendbares Recht", legalTermsNav_s11: "Kontakt" },
  it: { termsNavLocation: "Posizione", legalTermsNav_s1: "Oggetto", legalTermsNav_s2: "Condizioni di accesso", legalTermsNav_s3: "Regole di condotta", legalTermsNav_s4: "Moderazione e sanzioni", legalTermsNav_s5: "Proprietà intellettuale", legalTermsNav_s6: "Responsabilità", legalTermsNav_s7: "Servizio gratuito", legalTermsNav_s8: "Chiusura", legalTermsNav_s9: "Modifiche ai termini", legalTermsNav_s10: "Legge applicabile", legalTermsNav_s11: "Contatti" },
  ar: { termsNavLocation: "الموقع", legalTermsNav_s1: "الهدف", legalTermsNav_s2: "شروط الوصول", legalTermsNav_s3: "قواعد السلوك", legalTermsNav_s4: "الإشراف والعقوبات", legalTermsNav_s5: "الملكية الفكرية", legalTermsNav_s6: "المسؤولية", legalTermsNav_s7: "الخدمة مجانية", legalTermsNav_s8: "إنهاء الحساب", legalTermsNav_s9: "تعديلات الشروط", legalTermsNav_s10: "القانون المطبق", legalTermsNav_s11: "اتصال" },
  tr: { termsNavLocation: "Konum", legalTermsNav_s1: "Amaç", legalTermsNav_s2: "Erişim koşulları", legalTermsNav_s3: "Davranış kuralları", legalTermsNav_s4: "Moderasyon ve yaptırımlar", legalTermsNav_s5: "Fikri mülkiyet", legalTermsNav_s6: "Sorumluluk", legalTermsNav_s7: "Hizmet ücretsizdir", legalTermsNav_s8: "Fesih", legalTermsNav_s9: "Şart değişiklikleri", legalTermsNav_s10: "Uygulanacak hukuk", legalTermsNav_s11: "İletişim" },
  nl: { termsNavLocation: "Locatie", legalTermsNav_s1: "Doel", legalTermsNav_s2: "Toegangsvoorwaarden", legalTermsNav_s3: "Gedragsregels", legalTermsNav_s4: "Moderatie en sancties", legalTermsNav_s5: "Intellectueel eigendom", legalTermsNav_s6: "Aansprakelijkheid", legalTermsNav_s7: "Gratis dienst", legalTermsNav_s8: "Beëindiging", legalTermsNav_s9: "Wijzigingen in voorwaarden", legalTermsNav_s10: "Toepasselijk recht", legalTermsNav_s11: "Contact" },
  ru: { termsNavLocation: "Местоположение", legalTermsNav_s1: "Назначение", legalTermsNav_s2: "Условия доступа", legalTermsNav_s3: "Правила поведения", legalTermsNav_s4: "Модерация и санкции", legalTermsNav_s5: "Интеллектуальная собственность", legalTermsNav_s6: "Ответственность", legalTermsNav_s7: "Сервис бесплатен", legalTermsNav_s8: "Прекращение", legalTermsNav_s9: "Изменения условий", legalTermsNav_s10: "Применимое право", legalTermsNav_s11: "Контакты" },
  zh: { termsNavLocation: "位置", legalTermsNav_s1: "目的", legalTermsNav_s2: "访问条件", legalTermsNav_s3: "行为规范", legalTermsNav_s4: "审核与处罚", legalTermsNav_s5: "知识产权", legalTermsNav_s6: "责任", legalTermsNav_s7: "服务免费", legalTermsNav_s8: "终止", legalTermsNav_s9: "条款变更", legalTermsNav_s10: "适用法律", legalTermsNav_s11: "联系" },
  ja: { termsNavLocation: "位置情報", legalTermsNav_s1: "目的", legalTermsNav_s2: "利用条件", legalTermsNav_s3: "行動規範", legalTermsNav_s4: "モデレーションと制裁", legalTermsNav_s5: "知的財産", legalTermsNav_s6: "責任", legalTermsNav_s7: "無料サービス", legalTermsNav_s8: "解約", legalTermsNav_s9: "規約の変更", legalTermsNav_s10: "準拠法", legalTermsNav_s11: "お問い合わせ" },
  ko: { termsNavLocation: "위치", legalTermsNav_s1: "목적", legalTermsNav_s2: "접근 조건", legalTermsNav_s3: "행동 강령", legalTermsNav_s4: "운영 및 제재", legalTermsNav_s5: "지적 재산권", legalTermsNav_s6: "책임", legalTermsNav_s7: "무료 서비스", legalTermsNav_s8: "종료", legalTermsNav_s9: "약관 변경", legalTermsNav_s10: "준거법", legalTermsNav_s11: "연락처" },
  hi: { termsNavLocation: "स्थान", legalTermsNav_s1: "उद्देश्य", legalTermsNav_s2: "पहुँच की शर्तें", legalTermsNav_s3: "आचार संहिता", legalTermsNav_s4: "मॉडरेशन और प्रतिबंध", legalTermsNav_s5: "बौद्धिक संपदा", legalTermsNav_s6: "जिम्मेदारी", legalTermsNav_s7: "सेवा मुफ़्त है", legalTermsNav_s8: "समापन", legalTermsNav_s9: "शर्तों में बदलाव", legalTermsNav_s10: "लागू कानून", legalTermsNav_s11: "संपर्क" },
}

const PRIVACY_PAGE_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  en: {
    privacyContents: "Contents", privacyInformation: "Information", privacyUpdate: "Updated", privacyUpdateShort: "Jan. 2025", privacyJurisdiction: "French law · Paris", privacyReadTime: "~4 min read", privacyNotice: "Callo is committed to protecting your privacy — an explanation of the data collected and your rights.", privacyNavController: "Controller", privacyNavData: "Data", privacyNavLocation: "Location", privacyNavUse: "Use", privacyNavSecurity: "Security", privacyNavHosting: "Hosting", privacyNavCookies: "Cookies", privacyNavMinors: "Minors", privacyNavContact: "Contact", privacySectionController: "Data controller", privacySectionData: "Data collected", privacySectionLocation: "Location", privacySectionUse: "How data is used", privacySectionSecurity: "Security", privacySectionHosting: "Data hosting", privacySectionCookies: "Cookies", privacySectionMinors: "Protection of minors", privacySectionContact: "Contact", privacyControllerText: "The data controller is:", privacyWebsite: "Website", privacyContactLabel: "Contact", privacyDataIntro: "When you register and use the service, we collect:", privacyAccountData: "Account information (email, username, date of birth)", privacyProfileData: "Profile information (photo, biography, location)", privacyTechnicalData: "Technical and browsing data", privacyLocationIntro: "To access Callo, you must allow location sharing. We only collect your", privacyCityCountry: "city and country", privacyLocationCollectTitle: "What we collect", privacyNoGps: "No precise address or GPS coordinates are recorded", privacyLocationUseTitle: "How your data is used", privacyLocationProfile: "Displaying your location on your profile", privacyLocationImprove: "Improving your experience on the platform", privacyDeleteTitle: "Deleting your account", privacyDeleteText: "You can delete your account at any time from your profile settings. This deletes all your data, including your location.", privacySecurityTitle: "Security", privacyLocationSecurity: "Your location is processed securely and is never shared with third parties without your consent.", privacyUseText: "We use your data to provide, secure and improve the service, and to meet our legal obligations.", privacySecurityText: "Appropriate technical and organisational measures are in place to protect your data.", privacyHostingText: "Hosting: secure servers.", privacyCookiesText1: "We use technical cookies required for the service, as well as audience measurement and advertising tools when enabled in production.", privacyCookiesText2: "If Google AdSense ads are displayed, Google and its partners may use cookies to personalise or measure ads, prevent advertising fraud and improve sponsored content relevance.", privacyCookiesText3: "Login, registration, private messaging and personal areas are not intended to receive advertisements.", privacyMinorsText: "Callo is reserved for people aged", privacyContactText: "To exercise your rights or ask a question",
  },
  es: { privacyContents: "Contenido", privacyInformation: "Información", privacyUpdate: "Actualización", privacyUpdateShort: "Ene. 2025", privacyJurisdiction: "Derecho francés · París", privacyReadTime: "Lectura ~4 min", privacyNotice: "Callo se compromete a proteger tu privacidad y a explicar los datos recopilados y tus derechos.", privacyNavController: "Responsable", privacyNavData: "Datos", privacyNavLocation: "Ubicación", privacyNavUse: "Uso", privacyNavSecurity: "Seguridad", privacyNavHosting: "Alojamiento", privacyNavCookies: "Cookies", privacyNavMinors: "Menores", privacyNavContact: "Contacto", privacySectionController: "Responsable del tratamiento", privacySectionData: "Datos recopilados", privacySectionLocation: "Ubicación", privacySectionUse: "Uso de los datos", privacySectionSecurity: "Seguridad", privacySectionHosting: "Alojamiento de datos", privacySectionCookies: "Cookies", privacySectionMinors: "Protección de menores", privacySectionContact: "Contacto", privacyControllerText: "El responsable del tratamiento es:", privacyWebsite: "Sitio web", privacyContactLabel: "Contacto", privacyDataIntro: "Al registrarte y utilizar el servicio, recopilamos:", privacyAccountData: "Información de la cuenta (email, usuario, fecha de nacimiento)", privacyProfileData: "Información del perfil (foto, biografía, ubicación)", privacyTechnicalData: "Datos técnicos y de navegación", privacyLocationIntro: "Para acceder a Callo debes permitir compartir tu ubicación. Solo recopilamos tu", privacyCityCountry: "ciudad y país", privacyLocationCollectTitle: "Qué recopilamos", privacyNoGps: "No se registran direcciones precisas ni coordenadas GPS", privacyLocationUseTitle: "Cómo usamos tus datos", privacyLocationProfile: "Mostrar tu ubicación en tu perfil", privacyLocationImprove: "Mejorar tu experiencia en la plataforma", privacyDeleteTitle: "Eliminar tu cuenta", privacyDeleteText: "Puedes eliminar tu cuenta en cualquier momento desde los ajustes del perfil. Esto elimina todos tus datos, incluida tu ubicación.", privacySecurityTitle: "Seguridad", privacyLocationSecurity: "Tu ubicación se trata de forma segura y nunca se comparte sin tu consentimiento.", privacyUseText: "Usamos tus datos para prestar, proteger y mejorar el servicio y cumplir nuestras obligaciones legales.", privacySecurityText: "Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos.", privacyHostingText: "Alojamiento: servidores seguros.", privacyCookiesText1: "Usamos cookies técnicas necesarias para el servicio y herramientas de medición y publicidad cuando están activadas.", privacyCookiesText2: "Si se muestran anuncios de Google AdSense, Google y sus socios pueden usar cookies para personalizarlos o medirlos y prevenir el fraude.", privacyCookiesText3: "Las páginas de acceso, registro, mensajería privada y áreas personales no están destinadas a recibir anuncios.", privacyMinorsText: "Callo está reservado a personas de", privacyContactText: "Para ejercer tus derechos o hacer una pregunta" },
  pt: { privacyContents: "Sumário", privacyInformation: "Informações", privacyUpdate: "Atualização", privacyUpdateShort: "Jan. 2025", privacyJurisdiction: "Direito francês · Paris", privacyReadTime: "Leitura ~4 min", privacyNotice: "O Callo compromete-se a proteger a sua privacidade e a explicar os dados recolhidos e os seus direitos.", privacyNavController: "Responsável", privacyNavData: "Dados", privacyNavLocation: "Localização", privacyNavUse: "Utilização", privacyNavSecurity: "Segurança", privacyNavHosting: "Alojamento", privacyNavCookies: "Cookies", privacyNavMinors: "Menores", privacyNavContact: "Contacto", privacySectionController: "Responsável pelo tratamento", privacySectionData: "Dados recolhidos", privacySectionLocation: "Localização", privacySectionUse: "Utilização dos dados", privacySectionSecurity: "Segurança", privacySectionHosting: "Alojamento dos dados", privacySectionCookies: "Cookies", privacySectionMinors: "Proteção de menores", privacySectionContact: "Contacto", privacyControllerText: "O responsável pelo tratamento é:", privacyWebsite: "Site", privacyContactLabel: "Contacto", privacyDataIntro: "Ao registar-se e utilizar o serviço, recolhemos:", privacyAccountData: "Informações da conta (email, utilizador, data de nascimento)", privacyProfileData: "Informações do perfil (foto, biografia, localização)", privacyTechnicalData: "Dados técnicos e de navegação", privacyLocationIntro: "Para aceder ao Callo, deve permitir a partilha da localização. Recolhemos apenas a sua", privacyCityCountry: "cidade e país", privacyLocationCollectTitle: "O que recolhemos", privacyNoGps: "Não são guardados endereços precisos nem coordenadas GPS", privacyLocationUseTitle: "Como utilizamos os seus dados", privacyLocationProfile: "Mostrar a sua localização no perfil", privacyLocationImprove: "Melhorar a sua experiência na plataforma", privacyDeleteTitle: "Eliminar a conta", privacyDeleteText: "Pode eliminar a sua conta a qualquer momento nas definições do perfil. Isto elimina todos os seus dados, incluindo a localização.", privacySecurityTitle: "Segurança", privacyLocationSecurity: "A sua localização é tratada com segurança e nunca é partilhada sem o seu consentimento.", privacyUseText: "Utilizamos os seus dados para fornecer, proteger e melhorar o serviço e cumprir obrigações legais.", privacySecurityText: "Aplicamos medidas técnicas e organizacionais adequadas para proteger os seus dados.", privacyHostingText: "Alojamento: servidores seguros.", privacyCookiesText1: "Utilizamos cookies técnicos necessários ao serviço e ferramentas de medição e publicidade quando ativadas.", privacyCookiesText2: "Se forem apresentados anúncios Google AdSense, a Google e os seus parceiros podem usar cookies para os personalizar, medir e prevenir fraude.", privacyCookiesText3: "As páginas de login, registo, mensagens privadas e áreas pessoais não se destinam a receber anúncios.", privacyMinorsText: "O Callo destina-se a pessoas com", privacyContactText: "Para exercer os seus direitos ou colocar uma questão" },
  de: { privacyContents: "Inhalt", privacyInformation: "Informationen", privacyUpdate: "Aktualisierung", privacyUpdateShort: "Jan. 2025", privacyJurisdiction: "Französisches Recht · Paris", privacyReadTime: "~4 Min. Lesezeit", privacyNotice: "Callo schützt deine Privatsphäre und erklärt die erhobenen Daten und deine Rechte.", privacyNavController: "Verantwortlicher", privacyNavData: "Daten", privacyNavLocation: "Standort", privacyNavUse: "Nutzung", privacyNavSecurity: "Sicherheit", privacyNavHosting: "Hosting", privacyNavCookies: "Cookies", privacyNavMinors: "Minderjährige", privacyNavContact: "Kontakt", privacySectionController: "Verantwortlicher", privacySectionData: "Erhobene Daten", privacySectionLocation: "Standort", privacySectionUse: "Datennutzung", privacySectionSecurity: "Sicherheit", privacySectionHosting: "Datenhosting", privacySectionCookies: "Cookies", privacySectionMinors: "Schutz Minderjähriger", privacySectionContact: "Kontakt", privacyControllerText: "Verantwortlicher für die Datenverarbeitung ist:", privacyWebsite: "Website", privacyContactLabel: "Kontakt", privacyDataIntro: "Bei Registrierung und Nutzung erheben wir:", privacyAccountData: "Kontodaten (E-Mail, Nutzername, Geburtsdatum)", privacyProfileData: "Profildaten (Foto, Biografie, Standort)", privacyTechnicalData: "Technische und Navigationsdaten", privacyLocationIntro: "Für Callo musst du die Standortfreigabe erlauben. Wir erfassen nur deine", privacyCityCountry: "Stadt und dein Land", privacyLocationCollectTitle: "Was wir erfassen", privacyNoGps: "Keine genaue Adresse oder GPS-Koordinaten werden gespeichert", privacyLocationUseTitle: "Verwendung deiner Daten", privacyLocationProfile: "Anzeige deines Standorts im Profil", privacyLocationImprove: "Verbesserung deiner Plattform-Erfahrung", privacyDeleteTitle: "Konto löschen", privacyDeleteText: "Du kannst dein Konto jederzeit in den Profileinstellungen löschen. Dabei werden alle Daten einschließlich des Standorts gelöscht.", privacySecurityTitle: "Sicherheit", privacyLocationSecurity: "Dein Standort wird sicher verarbeitet und ohne Zustimmung nie an Dritte weitergegeben.", privacyUseText: "Wir nutzen deine Daten, um den Dienst bereitzustellen, zu sichern und zu verbessern sowie gesetzliche Pflichten zu erfüllen.", privacySecurityText: "Geeignete technische und organisatorische Maßnahmen schützen deine Daten.", privacyHostingText: "Hosting: sichere Server.", privacyCookiesText1: "Wir verwenden notwendige technische Cookies sowie Analyse- und Werbetools, wenn diese aktiviert sind.", privacyCookiesText2: "Bei Google-AdSense-Anzeigen können Google und Partner Cookies zur Personalisierung, Messung und Betrugsprävention verwenden.", privacyCookiesText3: "Anmelde-, Registrierungs-, privaten Nachrichten- und persönlichen Bereiche sind nicht für Werbung vorgesehen.", privacyMinorsText: "Callo ist Personen ab", privacyContactText: "Zur Ausübung deiner Rechte oder für eine Frage" },
  it: { privacyContents: "Indice", privacyInformation: "Informazioni", privacyUpdate: "Aggiornamento", privacyUpdateShort: "Gen. 2025", privacyJurisdiction: "Diritto francese · Parigi", privacyReadTime: "Lettura ~4 min", privacyNotice: "Callo si impegna a proteggere la tua privacy e a spiegare i dati raccolti e i tuoi diritti.", privacyNavController: "Titolare", privacyNavData: "Dati", privacyNavLocation: "Posizione", privacyNavUse: "Utilizzo", privacyNavSecurity: "Sicurezza", privacyNavHosting: "Hosting", privacyNavCookies: "Cookie", privacyNavMinors: "Minori", privacyNavContact: "Contatti", privacySectionController: "Titolare del trattamento", privacySectionData: "Dati raccolti", privacySectionLocation: "Posizione", privacySectionUse: "Uso dei dati", privacySectionSecurity: "Sicurezza", privacySectionHosting: "Hosting dei dati", privacySectionCookies: "Cookie", privacySectionMinors: "Protezione dei minori", privacySectionContact: "Contatti", privacyControllerText: "Il titolare del trattamento è:", privacyWebsite: "Sito web", privacyContactLabel: "Contatti", privacyDataIntro: "Durante la registrazione e l'utilizzo raccogliamo:", privacyAccountData: "Dati dell'account (email, username, data di nascita)", privacyProfileData: "Dati del profilo (foto, biografia, posizione)", privacyTechnicalData: "Dati tecnici e di navigazione", privacyLocationIntro: "Per accedere a Callo devi consentire la condivisione della posizione. Raccogliamo solo la tua", privacyCityCountry: "città e paese", privacyLocationCollectTitle: "Cosa raccogliamo", privacyNoGps: "Non salviamo indirizzi precisi o coordinate GPS", privacyLocationUseTitle: "Come usiamo i tuoi dati", privacyLocationProfile: "Mostrare la posizione sul profilo", privacyLocationImprove: "Migliorare la tua esperienza sulla piattaforma", privacyDeleteTitle: "Eliminazione dell'account", privacyDeleteText: "Puoi eliminare l'account dalle impostazioni del profilo. Verranno eliminati tutti i dati, inclusa la posizione.", privacySecurityTitle: "Sicurezza", privacyLocationSecurity: "La posizione è trattata in modo sicuro e non condivisa senza il tuo consenso.", privacyUseText: "Usiamo i dati per fornire, proteggere e migliorare il servizio e rispettare gli obblighi di legge.", privacySecurityText: "Misure tecniche e organizzative adeguate proteggono i tuoi dati.", privacyHostingText: "Hosting: server sicuri.", privacyCookiesText1: "Usiamo cookie tecnici necessari e strumenti di analisi e pubblicità quando attivati.", privacyCookiesText2: "Con gli annunci Google AdSense, Google e i partner possono usare cookie per personalizzare e misurare gli annunci e prevenire frodi.", privacyCookiesText3: "Le aree di accesso, registrazione, messaggistica privata e quelle personali non sono destinate agli annunci.", privacyMinorsText: "Callo è riservato alle persone di", privacyContactText: "Per esercitare i tuoi diritti o porre una domanda" },
  ar: { privacyContents: "المحتويات", privacyInformation: "المعلومات", privacyUpdate: "التحديث", privacyUpdateShort: "يناير 2025", privacyJurisdiction: "القانون الفرنسي · باريس", privacyReadTime: "قراءة ~4 دقائق", privacyNotice: "تلتزم Callo بحماية خصوصيتك وشرح البيانات التي يتم جمعها وحقوقك.", privacyNavController: "المسؤول", privacyNavData: "البيانات", privacyNavLocation: "الموقع", privacyNavUse: "الاستخدام", privacyNavSecurity: "السلامة", privacyNavHosting: "الاستضافة", privacyNavCookies: "ملفات الارتباط", privacyNavMinors: "القاصرون", privacyNavContact: "اتصال", privacySectionController: "مسؤول معالجة البيانات", privacySectionData: "البيانات المجمعة", privacySectionLocation: "الموقع", privacySectionUse: "استخدام البيانات", privacySectionSecurity: "السلامة", privacySectionHosting: "استضافة البيانات", privacySectionCookies: "ملفات الارتباط", privacySectionMinors: "حماية القاصرين", privacySectionContact: "اتصال", privacyControllerText: "مسؤول معالجة البيانات هو:", privacyWebsite: "الموقع الإلكتروني", privacyContactLabel: "اتصال", privacyDataIntro: "عند التسجيل واستخدام الخدمة، نجمع:", privacyAccountData: "معلومات الحساب (البريد الإلكتروني واسم المستخدم وتاريخ الميلاد)", privacyProfileData: "معلومات الملف الشخصي (الصورة والسيرة والموقع)", privacyTechnicalData: "البيانات التقنية وبيانات التصفح", privacyLocationIntro: "للوصول إلى Callo، يجب السماح بمشاركة الموقع. نجمع فقط", privacyCityCountry: "مدينتك وبلدك", privacyLocationCollectTitle: "ما نجمعه", privacyNoGps: "لا يتم حفظ عنوان دقيق أو إحداثيات GPS", privacyLocationUseTitle: "كيفية استخدام بياناتك", privacyLocationProfile: "عرض موقعك في ملفك الشخصي", privacyLocationImprove: "تحسين تجربتك على المنصة", privacyDeleteTitle: "حذف الحساب", privacyDeleteText: "يمكنك حذف حسابك من إعدادات ملفك في أي وقت. يؤدي ذلك إلى حذف جميع بياناتك، بما في ذلك موقعك.", privacySecurityTitle: "السلامة", privacyLocationSecurity: "تتم معالجة موقعك بأمان ولا تتم مشاركته مع أطراف أخرى دون موافقتك.", privacyUseText: "نستخدم بياناتك لتقديم الخدمة وتأمينها وتحسينها والوفاء بالتزاماتنا القانونية.", privacySecurityText: "نطبق إجراءات تقنية وتنظيمية مناسبة لحماية بياناتك.", privacyHostingText: "الاستضافة: خوادم آمنة.", privacyCookiesText1: "نستخدم ملفات ارتباط تقنية ضرورية وأدوات قياس وإعلانات عند تفعيلها.", privacyCookiesText2: "عند عرض إعلانات Google AdSense، قد تستخدم Google وشركاؤها ملفات الارتباط لتخصيص الإعلانات وقياسها ومنع الاحتيال.", privacyCookiesText3: "صفحات الدخول والتسجيل والرسائل الخاصة والمساحات الشخصية غير مخصصة للإعلانات.", privacyMinorsText: "خدمة Callo مخصصة للأشخاص بعمر", privacyContactText: "لممارسة حقوقك أو طرح سؤال" },
  ru: { privacyContents: "Содержание", privacyInformation: "Информация", privacyUpdate: "Обновление", privacyUpdateShort: "Янв. 2025", privacyJurisdiction: "Французское право · Париж", privacyReadTime: "Чтение ~4 мин", privacyNotice: "Callo защищает вашу конфиденциальность и объясняет, какие данные собираются и какие у вас есть права.", privacyNavController: "Ответственный", privacyNavData: "Данные", privacyNavLocation: "Местоположение", privacyNavUse: "Использование", privacyNavSecurity: "Безопасность", privacyNavHosting: "Хостинг", privacyNavCookies: "Cookies", privacyNavMinors: "Несовершеннолетние", privacyNavContact: "Контакты", privacySectionController: "Ответственный за обработку", privacySectionData: "Собираемые данные", privacySectionLocation: "Местоположение", privacySectionUse: "Использование данных", privacySectionSecurity: "Безопасность", privacySectionHosting: "Хранение данных", privacySectionCookies: "Cookies", privacySectionMinors: "Защита несовершеннолетних", privacySectionContact: "Контакты", privacyControllerText: "Ответственным за обработку является:", privacyWebsite: "Сайт", privacyContactLabel: "Контакты", privacyDataIntro: "При регистрации и использовании мы собираем:", privacyAccountData: "Данные аккаунта (email, имя пользователя, дата рождения)", privacyProfileData: "Данные профиля (фото, биография, местоположение)", privacyTechnicalData: "Технические данные и данные навигации", privacyLocationIntro: "Для доступа к Callo разрешите передачу местоположения. Мы собираем только", privacyCityCountry: "ваш город и страну", privacyLocationCollectTitle: "Что мы собираем", privacyNoGps: "Точный адрес и GPS-координаты не сохраняются", privacyLocationUseTitle: "Как используются данные", privacyLocationProfile: "Показ местоположения в профиле", privacyLocationImprove: "Улучшение работы платформы", privacyDeleteTitle: "Удаление аккаунта", privacyDeleteText: "Вы можете удалить аккаунт в настройках профиля. При этом удаляются все данные, включая местоположение.", privacySecurityTitle: "Безопасность", privacyLocationSecurity: "Местоположение обрабатывается безопасно и не передаётся третьим лицам без согласия.", privacyUseText: "Мы используем данные для предоставления, защиты и улучшения сервиса и выполнения закона.", privacySecurityText: "Для защиты данных применяются подходящие технические и организационные меры.", privacyHostingText: "Хостинг: защищённые серверы.", privacyCookiesText1: "Мы используем необходимые технические cookies и инструменты аналитики и рекламы при их включении.", privacyCookiesText2: "При показе рекламы Google AdSense Google и партнёры могут использовать cookies для настройки и измерения рекламы и предотвращения мошенничества.", privacyCookiesText3: "Страницы входа, регистрации, личных сообщений и личные разделы не предназначены для рекламы.", privacyMinorsText: "Callo предназначен для лиц старше", privacyContactText: "Чтобы реализовать права или задать вопрос" },
  zh: { privacyContents: "目录", privacyInformation: "信息", privacyUpdate: "更新", privacyUpdateShort: "2025年1月", privacyJurisdiction: "法国法律 · 巴黎", privacyReadTime: "阅读约4分钟", privacyNotice: "Callo 致力于保护你的隐私，并说明收集的数据和你的权利。", privacyNavController: "负责人", privacyNavData: "数据", privacyNavLocation: "位置", privacyNavUse: "使用", privacyNavSecurity: "安全", privacyNavHosting: "托管", privacyNavCookies: "Cookie", privacyNavMinors: "未成年人", privacyNavContact: "联系", privacySectionController: "数据负责人", privacySectionData: "收集的数据", privacySectionLocation: "位置", privacySectionUse: "数据使用", privacySectionSecurity: "安全", privacySectionHosting: "数据托管", privacySectionCookies: "Cookie", privacySectionMinors: "未成年人保护", privacySectionContact: "联系", privacyControllerText: "数据负责人是：", privacyWebsite: "网站", privacyContactLabel: "联系", privacyDataIntro: "注册和使用服务时，我们会收集：", privacyAccountData: "账户信息（邮箱、用户名、出生日期）", privacyProfileData: "个人资料信息（照片、简介、位置）", privacyTechnicalData: "技术和浏览数据", privacyLocationIntro: "访问 Callo 需要允许共享位置。我们只收集你的", privacyCityCountry: "城市和国家", privacyLocationCollectTitle: "收集的内容", privacyNoGps: "不会记录精确地址或 GPS 坐标", privacyLocationUseTitle: "数据使用方式", privacyLocationProfile: "在个人资料中显示位置", privacyLocationImprove: "改善平台体验", privacyDeleteTitle: "删除账户", privacyDeleteText: "你可以在个人资料设置中随时删除账户，包括位置在内的所有数据都会被删除。", privacySecurityTitle: "安全", privacyLocationSecurity: "你的位置会被安全处理，未经同意不会与第三方分享。", privacyUseText: "我们使用数据来提供、保护和改进服务，并履行法律义务。", privacySecurityText: "我们采取适当的技术和组织措施保护数据。", privacyHostingText: "托管：安全服务器。", privacyCookiesText1: "我们使用服务所需的技术 Cookie，以及在生产环境启用时使用分析和广告工具。", privacyCookiesText2: "如果展示 Google AdSense 广告，Google 及其合作伙伴可能使用 Cookie 来个性化和衡量广告并防止欺诈。", privacyCookiesText3: "登录、注册、私信和个人区域不用于展示广告。", privacyMinorsText: "Callo 仅供年满", privacyContactText: "如需行使权利或提出问题" },
  tr: { privacyContents: "İçindekiler", privacyInformation: "Bilgiler", privacyUpdate: "Güncelleme", privacyUpdateShort: "Oca. 2025", privacyJurisdiction: "Fransız hukuku · Paris", privacyReadTime: "~4 dk okuma", privacyNotice: "Callo gizliliğinizi korumayı ve toplanan verilerle haklarınızı açıklamayı taahhüt eder.", privacyNavController: "Sorumlu", privacyNavData: "Veriler", privacyNavLocation: "Konum", privacyNavUse: "Kullanım", privacyNavSecurity: "Güvenlik", privacyNavHosting: "Barındırma", privacyNavCookies: "Çerezler", privacyNavMinors: "Çocuklar", privacyNavContact: "İletişim", privacySectionController: "Veri sorumlusu", privacySectionData: "Toplanan veriler", privacySectionLocation: "Konum", privacySectionUse: "Verilerin kullanımı", privacySectionSecurity: "Güvenlik", privacySectionHosting: "Veri barındırma", privacySectionCookies: "Çerezler", privacySectionMinors: "Çocukların korunması", privacySectionContact: "İletişim", privacyControllerText: "Veri sorumlusu:", privacyWebsite: "Web sitesi", privacyContactLabel: "İletişim", privacyDataIntro: "Kayıt ve kullanım sırasında şunları toplarız:", privacyAccountData: "Hesap bilgileri (e-posta, kullanıcı adı, doğum tarihi)", privacyProfileData: "Profil bilgileri (fotoğraf, biyografi, konum)", privacyTechnicalData: "Teknik ve gezinme verileri", privacyLocationIntro: "Callo'ya erişmek için konum paylaşımına izin vermelisiniz. Yalnızca", privacyCityCountry: "şehrinizi ve ülkenizi", privacyLocationCollectTitle: "Topladıklarımız", privacyNoGps: "Kesin adres veya GPS koordinatı kaydedilmez", privacyLocationUseTitle: "Verileriniz nasıl kullanılır", privacyLocationProfile: "Konumunuzu profilinizde göstermek", privacyLocationImprove: "Platform deneyiminizi geliştirmek", privacyDeleteTitle: "Hesabı silme", privacyDeleteText: "Profil ayarlarından hesabınızı istediğiniz zaman silebilirsiniz. Konum dahil tüm verileriniz silinir.", privacySecurityTitle: "Güvenlik", privacyLocationSecurity: "Konumunuz güvenli şekilde işlenir ve izniniz olmadan paylaşılmaz.", privacyUseText: "Verilerinizi hizmeti sunmak, güvenli hale getirmek, geliştirmek ve yasal yükümlülükleri yerine getirmek için kullanırız.", privacySecurityText: "Verilerinizi korumak için uygun teknik ve kurumsal önlemler uygulanır.", privacyHostingText: "Barındırma: güvenli sunucular.", privacyCookiesText1: "Hizmet için gerekli teknik çerezleri ve etkinleştirildiğinde analiz ve reklam araçlarını kullanırız.", privacyCookiesText2: "Google AdSense reklamları gösterilirse Google ve ortakları reklamları kişiselleştirmek ve ölçmek için çerez kullanabilir.", privacyCookiesText3: "Giriş, kayıt, özel mesajlaşma ve kişisel alanlar reklam almak için tasarlanmamıştır.", privacyMinorsText: "Callo şu yaştaki kişiler içindir:", privacyContactText: "Haklarınızı kullanmak veya soru sormak için" },
}

const PRIVACY_REMAINING_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  nl: { privacyContents: "Inhoud", privacyInformation: "Informatie", privacyUpdate: "Bijgewerkt", privacyUpdateShort: "jan. 2025", privacyJurisdiction: "Frans recht · Parijs", privacyReadTime: "~4 min lezen", privacyNotice: "Callo beschermt je privacy en legt uit welke gegevens worden verzameld en welke rechten je hebt.", privacyNavController: "Verantwoordelijke", privacyNavData: "Gegevens", privacyNavLocation: "Locatie", privacyNavUse: "Gebruik", privacyNavSecurity: "Veiligheid", privacyNavHosting: "Hosting", privacyNavCookies: "Cookies", privacyNavMinors: "Minderjarigen", privacyNavContact: "Contact", privacySectionController: "Verwerkingsverantwoordelijke", privacySectionData: "Verzamelde gegevens", privacySectionLocation: "Locatie", privacySectionUse: "Gebruik van gegevens", privacySectionSecurity: "Veiligheid", privacySectionHosting: "Gegevenshosting", privacySectionCookies: "Cookies", privacySectionMinors: "Bescherming van minderjarigen", privacySectionContact: "Contact", privacyControllerText: "De verantwoordelijke voor de verwerking is:", privacyWebsite: "Website", privacyContactLabel: "Contact", privacyDataIntro: "Bij registratie en gebruik verzamelen we:", privacyAccountData: "Accountgegevens (e-mail, gebruikersnaam, geboortedatum)", privacyProfileData: "Profielgegevens (foto, biografie, locatie)", privacyTechnicalData: "Technische en navigatiegegevens", privacyLocationIntro: "Om toegang te krijgen tot Callo moet je het delen van je locatie toestaan. We verzamelen alleen je", privacyCityCountry: "stad en land", privacyLocationCollectTitle: "Wat we verzamelen", privacyNoGps: "Er worden geen exacte adressen of GPS-coördinaten opgeslagen", privacyLocationUseTitle: "Hoe je gegevens worden gebruikt", privacyLocationProfile: "Je locatie op je profiel tonen", privacyLocationImprove: "Je ervaring op het platform verbeteren", privacyDeleteTitle: "Je account verwijderen", privacyDeleteText: "Je kunt je account altijd verwijderen via je profielinstellingen. Al je gegevens, inclusief je locatie, worden verwijderd.", privacySecurityTitle: "Veiligheid", privacyLocationSecurity: "Je locatie wordt veilig verwerkt en zonder je toestemming nooit met derden gedeeld.", privacyUseText: "We gebruiken je gegevens om de dienst te leveren, te beveiligen en te verbeteren en om aan wettelijke verplichtingen te voldoen.", privacySecurityText: "Geschikte technische en organisatorische maatregelen beschermen je gegevens.", privacyHostingText: "Hosting: beveiligde servers.", privacyCookiesText1: "We gebruiken noodzakelijke technische cookies en analyse- en advertentietools wanneer deze zijn ingeschakeld.", privacyCookiesText2: "Bij Google AdSense-advertenties kunnen Google en partners cookies gebruiken om advertenties te personaliseren en meten en fraude te voorkomen.", privacyCookiesText3: "Login-, registratie-, privéberichten- en persoonlijke gedeelten zijn niet bedoeld voor advertenties.", privacyMinorsText: "Callo is bedoeld voor personen vanaf", privacyContactText: "Om je rechten uit te oefenen of een vraag te stellen" },
  ja: { privacyContents: "目次", privacyInformation: "情報", privacyUpdate: "更新", privacyUpdateShort: "2025年1月", privacyJurisdiction: "フランス法・パリ", privacyReadTime: "約4分", privacyNotice: "Calloはプライバシーを保護し、収集するデータと権利を説明します。", privacyNavController: "管理者", privacyNavData: "データ", privacyNavLocation: "位置情報", privacyNavUse: "利用", privacyNavSecurity: "安全", privacyNavHosting: "ホスティング", privacyNavCookies: "Cookie", privacyNavMinors: "未成年者", privacyNavContact: "お問い合わせ", privacySectionController: "データ管理者", privacySectionData: "収集するデータ", privacySectionLocation: "位置情報", privacySectionUse: "データの利用", privacySectionSecurity: "安全性", privacySectionHosting: "データのホスティング", privacySectionCookies: "Cookie", privacySectionMinors: "未成年者の保護", privacySectionContact: "お問い合わせ", privacyControllerText: "データ管理者：", privacyWebsite: "ウェブサイト", privacyContactLabel: "連絡先", privacyDataIntro: "登録・利用時に収集する情報：", privacyAccountData: "アカウント情報（メール、ユーザー名、生年月日）", privacyProfileData: "プロフィール情報（写真、自己紹介、位置情報）", privacyTechnicalData: "技術データと閲覧データ", privacyLocationIntro: "Calloを利用するには位置情報の共有を許可してください。収集するのは", privacyCityCountry: "市区町村と国", privacyLocationCollectTitle: "収集する情報", privacyNoGps: "正確な住所やGPS座標は記録されません", privacyLocationUseTitle: "データの利用方法", privacyLocationProfile: "プロフィールに位置情報を表示", privacyLocationImprove: "プラットフォーム体験を改善", privacyDeleteTitle: "アカウントの削除", privacyDeleteText: "プロフィール設定からいつでもアカウントを削除できます。位置情報を含むすべてのデータが削除されます。", privacySecurityTitle: "安全性", privacyLocationSecurity: "位置情報は安全に処理され、同意なく第三者と共有されません。", privacyUseText: "サービスの提供、安全性、改善と法的義務のためにデータを使用します。", privacySecurityText: "適切な技術的・組織的対策でデータを保護します。", privacyHostingText: "ホスティング：安全なサーバー。", privacyCookiesText1: "必要な技術Cookieと、利用可能な場合の分析・広告ツールを使用します。", privacyCookiesText2: "Google AdSense広告では、Googleとパートナーが広告の最適化や測定、不正防止のためCookieを使用する場合があります。", privacyCookiesText3: "ログイン、登録、非公開メッセージ、個人エリアは広告用ではありません。", privacyMinorsText: "Calloは", privacyContactText: "権利の行使や質問について" },
  ko: { privacyContents: "목차", privacyInformation: "정보", privacyUpdate: "업데이트", privacyUpdateShort: "2025년 1월", privacyJurisdiction: "프랑스 법률 · 파리", privacyReadTime: "약 4분", privacyNotice: "Callo는 개인정보를 보호하고 수집 데이터와 귀하의 권리를 설명합니다.", privacyNavController: "관리자", privacyNavData: "데이터", privacyNavLocation: "위치", privacyNavUse: "사용", privacyNavSecurity: "보안", privacyNavHosting: "호스팅", privacyNavCookies: "쿠키", privacyNavMinors: "미성년자", privacyNavContact: "연락처", privacySectionController: "데이터 관리자", privacySectionData: "수집 데이터", privacySectionLocation: "위치", privacySectionUse: "데이터 사용", privacySectionSecurity: "보안", privacySectionHosting: "데이터 호스팅", privacySectionCookies: "쿠키", privacySectionMinors: "미성년자 보호", privacySectionContact: "연락처", privacyControllerText: "데이터 관리자는 다음과 같습니다:", privacyWebsite: "웹사이트", privacyContactLabel: "연락처", privacyDataIntro: "가입 및 서비스 이용 시 수집하는 정보:", privacyAccountData: "계정 정보(이메일, 사용자 이름, 생년월일)", privacyProfileData: "프로필 정보(사진, 소개, 위치)", privacyTechnicalData: "기술 및 탐색 데이터", privacyLocationIntro: "Callo를 이용하려면 위치 공유를 허용해야 합니다. 수집하는 정보는", privacyCityCountry: "도시와 국가", privacyLocationCollectTitle: "수집하는 정보", privacyNoGps: "정확한 주소나 GPS 좌표는 기록되지 않습니다", privacyLocationUseTitle: "데이터 사용 방법", privacyLocationProfile: "프로필에 위치 표시", privacyLocationImprove: "플랫폼 경험 개선", privacyDeleteTitle: "계정 삭제", privacyDeleteText: "프로필 설정에서 언제든 계정을 삭제할 수 있습니다. 위치를 포함한 모든 데이터가 삭제됩니다.", privacySecurityTitle: "보안", privacyLocationSecurity: "위치는 안전하게 처리되며 동의 없이 제3자와 공유되지 않습니다.", privacyUseText: "서비스 제공, 보안, 개선 및 법적 의무 이행을 위해 데이터를 사용합니다.", privacySecurityText: "적절한 기술적·조직적 조치로 데이터를 보호합니다.", privacyHostingText: "호스팅: 보안 서버.", privacyCookiesText1: "필수 기술 쿠키와 활성화된 경우 분석 및 광고 도구를 사용합니다.", privacyCookiesText2: "Google AdSense 광고가 표시되면 Google과 파트너가 광고 맞춤화, 측정 및 사기 방지를 위해 쿠키를 사용할 수 있습니다.", privacyCookiesText3: "로그인, 가입, 비공개 메시지 및 개인 영역에는 광고를 표시하지 않습니다.", privacyMinorsText: "Callo는 다음 연령 이상을 위한 서비스입니다:", privacyContactText: "권리를 행사하거나 질문하려면" },
  hi: { privacyContents: "विषय-सूची", privacyInformation: "जानकारी", privacyUpdate: "अपडेट", privacyUpdateShort: "जन. 2025", privacyJurisdiction: "फ्रांसीसी कानून · पेरिस", privacyReadTime: "~4 मिनट पढ़ना", privacyNotice: "Callo आपकी निजता की रक्षा करने और एकत्र डेटा व आपके अधिकारों को समझाने के लिए प्रतिबद्ध है।", privacyNavController: "जिम्मेदार", privacyNavData: "डेटा", privacyNavLocation: "स्थान", privacyNavUse: "उपयोग", privacyNavSecurity: "सुरक्षा", privacyNavHosting: "होस्टिंग", privacyNavCookies: "कुकीज़", privacyNavMinors: "नाबालिग", privacyNavContact: "संपर्क", privacySectionController: "डेटा नियंत्रक", privacySectionData: "एकत्र डेटा", privacySectionLocation: "स्थान", privacySectionUse: "डेटा का उपयोग", privacySectionSecurity: "सुरक्षा", privacySectionHosting: "डेटा होस्टिंग", privacySectionCookies: "कुकीज़", privacySectionMinors: "नाबालिगों की सुरक्षा", privacySectionContact: "संपर्क", privacyControllerText: "डेटा नियंत्रक है:", privacyWebsite: "वेबसाइट", privacyContactLabel: "संपर्क", privacyDataIntro: "पंजीकरण और उपयोग के दौरान हम एकत्र करते हैं:", privacyAccountData: "खाते की जानकारी (ईमेल, उपयोगकर्ता नाम, जन्मतिथि)", privacyProfileData: "प्रोफ़ाइल जानकारी (फ़ोटो, परिचय, स्थान)", privacyTechnicalData: "तकनीकी और ब्राउज़िंग डेटा", privacyLocationIntro: "Callo तक पहुँचने के लिए स्थान साझा करने की अनुमति दें। हम केवल आपका", privacyCityCountry: "शहर और देश", privacyLocationCollectTitle: "हम क्या एकत्र करते हैं", privacyNoGps: "सटीक पता या GPS निर्देशांक दर्ज नहीं किए जाते", privacyLocationUseTitle: "आपके डेटा का उपयोग", privacyLocationProfile: "प्रोफ़ाइल पर आपका स्थान दिखाना", privacyLocationImprove: "प्लेटफ़ॉर्म अनुभव बेहतर करना", privacyDeleteTitle: "खाता हटाना", privacyDeleteText: "आप प्रोफ़ाइल सेटिंग से कभी भी खाता हटा सकते हैं। स्थान सहित आपका पूरा डेटा हटा दिया जाएगा।", privacySecurityTitle: "सुरक्षा", privacyLocationSecurity: "आपके स्थान को सुरक्षित रूप से संसाधित किया जाता है और सहमति के बिना साझा नहीं किया जाता।", privacyUseText: "हम सेवा देने, सुरक्षित रखने, सुधारने और कानूनी दायित्वों को पूरा करने के लिए डेटा का उपयोग करते हैं।", privacySecurityText: "डेटा की सुरक्षा के लिए उचित तकनीकी और संगठनात्मक उपाय लागू हैं।", privacyHostingText: "होस्टिंग: सुरक्षित सर्वर।", privacyCookiesText1: "हम आवश्यक तकनीकी कुकीज़ और सक्षम होने पर विश्लेषण व विज्ञापन उपकरणों का उपयोग करते हैं।", privacyCookiesText2: "Google AdSense विज्ञापनों में Google और उसके साझेदार विज्ञापनों को मापने, निजीकृत करने और धोखाधड़ी रोकने के लिए कुकीज़ का उपयोग कर सकते हैं।", privacyCookiesText3: "लॉगिन, पंजीकरण, निजी संदेश और व्यक्तिगत क्षेत्रों में विज्ञापन नहीं दिखाए जाते।", privacyMinorsText: "Callo कम से कम इस आयु के लोगों के लिए है:", privacyContactText: "अपने अधिकारों का उपयोग करने या प्रश्न पूछने के लिए" },
}

const PUBLIC_PAGE_COMPLETION_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  es: {
    aboutMetaTitle: "Acerca de Callo | Plataforma social gratuita de videochat", aboutMetaDescription: "Descubre Callo, una plataforma social gratuita de videochat aleatorio, directos, mensajería y publicaciones, con reglas claras de seguridad y moderación.", aboutStructuredName: "Acerca de Callo", aboutStructuredDescription: "Callo es una plataforma social gratuita de videochat aleatorio, directos, mensajería y publicaciones.", aboutHeroText: "Callo es una plataforma social gratuita que combina videochat aleatorio, directos, mensajería y publicaciones. El servicio se centra en la accesibilidad, la moderación y la transparencia para ofrecer una experiencia útil a visitantes y motores de búsqueda.",
    aboutInfoSubtitle: "Útil para visitantes y revisión de AdSense", aboutInfoText: "Las páginas públicas de Callo explican el servicio, las reglas, los contactos y la privacidad antes de iniciar sesión.", aboutPillarVideoTitle: "Videochat instantáneo", aboutPillarVideoText: "Videollamadas aleatorias desde el navegador, sin instalación, para conocer gente rápidamente.", aboutPillarSocialTitle: "Intercambios sociales", aboutPillarSocialText: "Directos, mensajes y publicaciones permiten continuar una conversación después de la primera llamada.", aboutPillarTrustTitle: "Marco de confianza", aboutPillarTrustText: "Reglas públicas, reportes y moderación progresiva ayudan a limitar los abusos.", aboutCommitmentFree: "Servicio gratuito y disponible sin descarga.", aboutCommitmentPublic: "Páginas públicas claras para explicar el producto, la seguridad y los contactos.", aboutCommitmentAds: "Publicidad reservada a espacios compatibles con las reglas de la plataforma.", aboutCommitmentLegal: "Información legal, privacidad y condiciones disponibles desde cada página pública.", aboutStatFree: "gratis", aboutStatAge: "edad mínima", aboutStatAvailable: "accesible", aboutWhyText: "Un sitio compatible con publicidad debe ser comprensible, accesible y transparente. Callo presenta públicamente su funcionamiento, sus reglas y sus medios de contacto.",
    contactMetaTitle: "Contacto Callo | Soporte, reportes y datos personales", contactMetaDescription: "Contacta con Callo para soporte, reportes, preguntas legales, privacidad y solicitudes relacionadas con datos personales.", contactStructuredName: "Contacto Callo", contactHeroText: "Esta página centraliza los medios de contacto públicos de Callo. Permite a usuarios, visitantes, socios y servicios de verificación saber cómo contactar al equipo según el tipo de solicitud.", contactBeforeText: "Una solicitud precisa es más fácil de tratar y ayuda a documentar reportes importantes.", contactSupportText: "Cuenta, conexión, videollamadas, directos, mensajes, publicaciones o problema técnico.", contactSupportCta: "Escribir al soporte", contactReportText: "Perfil, mensaje, directo o publicación que parezca peligroso, abusivo, fraudulento o prohibido.", contactReportCta: "Enviar un reporte", contactDataText: "Solicitud de acceso, rectificación, eliminación de cuenta o pregunta sobre privacidad.", contactDataCta: "Ejercer mis derechos", contactChecklistEmail: "Tu dirección de email de contacto.", contactChecklistUsername: "El nombre de usuario o identificador afectado, si está disponible.", contactChecklistType: "El tipo de problema encontrado.", contactChecklistDescription: "Una descripción corta y precisa de la situación.", contactDocsText: "Para preguntas de privacidad, condiciones de uso o responsabilidad editorial, consulta las páginas legales públicas antes de enviar tu solicitud.",
    safetyMetaTitle: "Seguridad y moderación | Reglas públicas de Callo", safetyMetaDescription: "Consulta las reglas de seguridad, moderación, reportes y conformidad publicitaria de Callo.", safetyStructuredName: "Seguridad y moderación Callo", safetyStructuredDescription: "Reglas públicas de seguridad, moderación, reportes y conformidad publicitaria de Callo.", safetyHeroText: "Callo es una plataforma social con contenido de usuarios. Las reglas siguientes explican el contenido prohibido, la moderación, los reportes y cómo la publicidad debe mantenerse compatible con un entorno responsable.", safetyImportantText: "Los anuncios no deben colocarse en pantallas privadas, páginas sin contenido útil o cerca de contenido prohibido. Las páginas públicas informativas son los espacios más adecuados.", safetyBlockReportsTitle: "Reportes accesibles", safetyBlockReportsText: "Los usuarios pueden reportar un perfil, mensaje, directo o publicación que infrinja las reglas.", safetyBlockAccountsTitle: "Cuentas supervisadas", safetyBlockAccountsText: "El registro requiere un email válido y el servicio está reservado a personas de al menos 16 años.", safetyBlockDataTitle: "Datos explicados", safetyBlockDataText: "Los datos recogidos, la localización y las cookies están documentados en la política de privacidad.", safetyBlockPublicTitle: "Páginas públicas legibles", safetyBlockPublicText: "Las reglas y contactos se pueden consultar sin iniciar sesión para reforzar la transparencia del servicio.", safetyForbiddenText: "Estas categorías sirven de base para la moderación y ayudan a mantener un entorno compatible con estándares publicitarios y comunitarios.", safetyForbiddenSexual: "Desnudez no solicitada, contenido sexual explícito o explotación de menores.", safetyForbiddenHarassment: "Acoso, amenazas, intimidación, discriminación o suplantación de identidad.", safetyForbiddenSpam: "Spam, phishing, estafa, publicidad abusiva o automatización abusiva.", safetyForbiddenIllegal: "Contenido ilegal, violento, terrorista, de odio o peligroso.", safetyForbiddenPersonalData: "Compartir datos personales de otra persona sin autorización.", safetyForbiddenBypass: "Intento de eludir herramientas de moderación o seguridad.", safetyProcessText: "El proceso debe ser claro para los usuarios y documentable para socios externos.", safetyStepReceiveTitle: "Recepción del reporte", safetyStepReceiveText: "La solicitud debe incluir tantos elementos útiles como sea posible: perfil, contenido, fecha y contexto.", safetyStepReviewTitle: "Evaluación", safetyStepReviewText: "El contenido se compara con las reglas de conducta y las obligaciones legales aplicables.", safetyStepActionTitle: "Acción", safetyStepActionText: "Según la gravedad: advertencia, retirada, suspensión, prohibición o reporte a las autoridades.",
  },
  pt: {
    aboutMetaTitle: "Sobre o Callo | Plataforma social gratuita de videochat", aboutMetaDescription: "Conheça o Callo, uma plataforma social gratuita de videochat aleatório, lives, mensagens e publicações, com regras claras de segurança e moderação.", aboutStructuredName: "Sobre o Callo", aboutStructuredDescription: "Callo é uma plataforma social gratuita de videochat aleatório, lives, mensagens e publicações.", aboutHeroText: "Callo é uma plataforma social gratuita que combina videochat aleatório, lives, mensagens e publicações. O serviço valoriza acessibilidade, moderação e transparência para oferecer uma experiência útil aos visitantes e aos mecanismos de busca.",
    aboutInfoSubtitle: "Útil para visitantes e revisão do AdSense", aboutInfoText: "As páginas públicas do Callo explicam o serviço, as regras, os contatos e a privacidade antes de qualquer login.", aboutPillarVideoTitle: "Videochat instantâneo", aboutPillarVideoText: "Chamadas de vídeo aleatórias pelo navegador, sem instalação, para conhecer novas pessoas rapidamente.", aboutPillarSocialTitle: "Interações sociais", aboutPillarSocialText: "Lives, mensagens e publicações permitem continuar uma conversa depois da primeira chamada.", aboutPillarTrustTitle: "Estrutura de confiança", aboutPillarTrustText: "Regras públicas, denúncias e moderação progressiva ajudam a limitar abusos.", aboutCommitmentFree: "Serviço gratuito e acessível sem download.", aboutCommitmentPublic: "Páginas públicas claras para explicar o produto, a segurança e os contatos.", aboutCommitmentAds: "Publicidade reservada a espaços compatíveis com as regras da plataforma.", aboutCommitmentLegal: "Informações legais, privacidade e termos disponíveis em cada página pública.", aboutStatFree: "grátis", aboutStatAge: "idade mínima", aboutStatAvailable: "acessível", aboutWhyText: "Um site compatível com publicidade deve ser compreensível, acessível e transparente. O Callo apresenta publicamente seu funcionamento, suas regras e seus meios de contato.",
    contactMetaTitle: "Contato Callo | Suporte, denúncias e dados pessoais", contactMetaDescription: "Entre em contato com o Callo para suporte, denúncias, questões legais, privacidade e solicitações relacionadas a dados pessoais.", contactStructuredName: "Contato Callo", contactHeroText: "Esta página centraliza os meios de contato públicos do Callo. Ela ajuda usuários, visitantes, parceiros e serviços de verificação a entender como falar com a equipe conforme o tipo de solicitação.", contactBeforeText: "Uma solicitação precisa é mais fácil de tratar e também ajuda a documentar denúncias importantes.", contactSupportText: "Conta, login, chamadas de vídeo, lives, mensagens, publicações ou problema técnico.", contactSupportCta: "Escrever ao suporte", contactReportText: "Perfil, mensagem, live ou publicação que pareça perigosa, abusiva, fraudulenta ou proibida.", contactReportCta: "Enviar uma denúncia", contactDataText: "Pedido de acesso, retificação, exclusão de conta ou pergunta sobre privacidade.", contactDataCta: "Exercer meus direitos", contactChecklistEmail: "Seu endereço de email de contato.", contactChecklistUsername: "O usuário ou identificador envolvido, se disponível.", contactChecklistType: "O tipo de problema encontrado.", contactChecklistDescription: "Uma descrição curta e precisa da situação.", contactDocsText: "Para questões de privacidade, termos de uso ou responsabilidade editorial, consulte as páginas legais públicas antes de enviar sua solicitação.",
    safetyMetaTitle: "Segurança e moderação | Regras públicas do Callo", safetyMetaDescription: "Consulte as regras de segurança, moderação, denúncias e conformidade publicitária do Callo.", safetyStructuredName: "Segurança e moderação Callo", safetyStructuredDescription: "Regras públicas de segurança, moderação, denúncias e conformidade publicitária do Callo.", safetyHeroText: "Callo é uma plataforma social com conteúdo de usuários. As regras abaixo explicam conteúdos proibidos, moderação, denúncias e como a publicidade deve permanecer compatível com um ambiente responsável.", safetyImportantText: "Anúncios não devem ficar em telas privadas, páginas sem conteúdo útil ou perto de conteúdos proibidos. Páginas públicas informativas são os espaços mais adequados.", safetyBlockReportsTitle: "Denúncias acessíveis", safetyBlockReportsText: "Usuários podem denunciar um perfil, mensagem, live ou publicação que viole as regras.", safetyBlockAccountsTitle: "Contas supervisionadas", safetyBlockAccountsText: "O cadastro exige email válido e o serviço é reservado a pessoas com pelo menos 16 anos.", safetyBlockDataTitle: "Dados explicados", safetyBlockDataText: "Dados coletados, localização e cookies estão documentados na política de privacidade.", safetyBlockPublicTitle: "Páginas públicas claras", safetyBlockPublicText: "Regras e contatos podem ser consultados sem login para reforçar a transparência do serviço.", safetyForbiddenText: "Essas categorias orientam ações de moderação e ajudam a manter um ambiente compatível com padrões publicitários e comunitários.", safetyForbiddenSexual: "Nudez não solicitada, conteúdo sexual explícito ou exploração de menores.", safetyForbiddenHarassment: "Assédio, ameaças, intimidação, discriminação ou falsidade de identidade.", safetyForbiddenSpam: "Spam, phishing, golpe, publicidade abusiva ou automação abusiva.", safetyForbiddenIllegal: "Conteúdo ilegal, violento, terrorista, odioso ou perigoso.", safetyForbiddenPersonalData: "Compartilhamento de dados pessoais de outra pessoa sem autorização.", safetyForbiddenBypass: "Tentativa de contornar ferramentas de moderação ou segurança.", safetyProcessText: "O processo deve permanecer claro para usuários e documentável para parceiros externos.", safetyStepReceiveTitle: "Recebimento da denúncia", safetyStepReceiveText: "A solicitação deve conter o máximo possível de elementos úteis: perfil, conteúdo, data e contexto.", safetyStepReviewTitle: "Avaliação", safetyStepReviewText: "O conteúdo é comparado às regras de conduta e obrigações legais aplicáveis.", safetyStepActionTitle: "Ação", safetyStepActionText: "Conforme a gravidade: aviso, remoção, suspensão, banimento ou denúncia às autoridades.",
  },
}

const VISITOR_PANEL_TRANSLATIONS: Record<LocaleCode, Record<string, string>> = {
  fr: {
    profileVisitorsHistoryTitle: "Historique de profil",
    profileVisitorsListTitle: "Liste des visiteurs",
    profileVisitorsTodaySummary: "Visiteurs aujourd'hui",
    profileVisitorsVisitsSummary: "Visites totales",
    profileAvatarChange: "Changer la photo",
    roleHost: "Hôte",
    roleParticipant: "Participant",
    roleViewer: "Spectateur",
    liveCameraOff: "Caméra désactivée",
    liveMuteMic: "Couper le micro",
    liveEnableMic: "Activer le micro",
    liveDisableCamera: "Couper la caméra",
    liveEnableCamera: "Activer la caméra",
    liveEndSession: "Terminer le live",
    liveLeave: "Quitter",
    liveWaitingHost: "En attente de l'hôte...",
  },
  en: {
    profileVisitorsHistoryTitle: "Profile history",
    profileVisitorsListTitle: "Visitors list",
    profileVisitorsTodaySummary: "Visitors today",
    profileVisitorsVisitsSummary: "Total visits",
    profileAvatarChange: "Change photo",
    settingsNewPassword: "New password",
    settingsConfirmNewPassword: "Confirm new password",
    settingsPasswordRules: "8 characters min, one uppercase, one lowercase, one number",
    settingsShowPassword: "Show passwords",
    settingsHidePassword: "Hide passwords",
    settingsChangePasswordButton: "Change password",
    roleHost: "Host",
    roleParticipant: "Participant",
    roleViewer: "Viewer",
    liveCameraOff: "Camera disabled",
    liveMuteMic: "Mute microphone",
    liveEnableMic: "Enable microphone",
    liveDisableCamera: "Turn camera off",
    liveEnableCamera: "Turn camera on",
    liveEndSession: "End live",
    liveLeave: "Leave",
    liveWaitingHost: "Waiting for the host...",
  },
  es: {
    authUsernameAvailable: "✓ Disponible",
    settingsInstallDesktopStep1: "Verás un icono de instalación en la barra de direcciones del navegador",
    settingsInstallDesktopStep2: "Haz clic en el icono y confirma la instalación",
    settingsInstallDeviceMobile: "Móvil",
    settingsInstallDeviceTablet: "Tableta",
    settingsInstallDeviceDesktop: "Escritorio",
    verifyCodeTitle: "Verificación de email",
    verifyCodeSubtitle: "Introduce el código de 6 dígitos enviado por correo",
    verifyCodeDigit: "Dígito",
    verifyCodeVerifying: "Verificando…",
    verifyCodeConfirm: "Confirmar",
    verifyCodeResend: "Reenviar código",
    verifyCodeResendIn: "Reenviar en",
    verifyCodeHint: "Revisa la carpeta de spam · Código válido 24h",
    verifyCodeMissingEmail: "Falta el email — vuelve a iniciar sesión usando el enlace de registro.",
    verifyCodeInvalidFormat: "Introduce un código de 6 dígitos válido.",
    verifyCodeInvalid: "Código inválido. Inténtalo de nuevo.",
    verifyCodeNetworkError: "Error de red. Comprueba tu conexión.",
    verifyCodeEnterEmailResend: "Introduce tu email para reenviar el código.",
    verifyCodeResendError: "No se pudo reenviar el código.",
    verifyCodeResendSuccess: "✓ ¡Nuevo código enviado!",
    verifyCodeNetworkShort: "Error de red.",
    verifyCodeVerifiedTitle: "Cuenta verificada",
    verifyCodeRedirectLogin: "Redirigiendo al inicio de sesión…",
    profileVisitorsHistoryTitle: "Historial del perfil",
    profileVisitorsListTitle: "Lista de visitantes",
    profileVisitorsTodaySummary: "Visitantes de hoy",
    profileVisitorsVisitsSummary: "Visitas totales",
    profileAvatarChange: "Cambiar foto",
    settingsNewPassword: "Nueva contraseña",
    settingsConfirmNewPassword: "Confirmar nueva contraseña",
    settingsPasswordRules: "Mínimo 8 caracteres, una mayúscula, una minúscula, un número",
    settingsShowPassword: "Mostrar contraseñas",
    settingsHidePassword: "Ocultar contraseñas",
    settingsChangePasswordButton: "Cambiar la contraseña",
    roleHost: "Anfitrión",
    roleParticipant: "Participante",
    roleViewer: "Espectador",
    liveCameraOff: "Cámara desactivada",
    liveMuteMic: "Silenciar micrófono",
    liveEnableMic: "Activar micrófono",
    liveDisableCamera: "Desactivar cámara",
    liveEnableCamera: "Activar cámara",
    liveEndSession: "Terminar el directo",
    liveLeave: "Salir",
    liveWaitingHost: "Esperando al anfitrión...",
    reputationTotal: "{count} reacciones en total",
reputationExcellent: "Excelente",
reputationCorrect: "Correcto",
reputationFaible: "Bajo",
  },
  pt: {
    authUsernameAvailable: "✓ Disponível",
    settingsInstallDesktopStep1: "Você verá um ícone de instalação na barra de endereços do navegador",
    settingsInstallDesktopStep2: "Clique no ícone e confirme a instalação",
    settingsInstallDeviceMobile: "Móvel",
    settingsInstallDeviceTablet: "Tablet",
    settingsInstallDeviceDesktop: "Área de trabalho",
    verifyCodeTitle: "Verificação de email",
    verifyCodeSubtitle: "Insira o código de 6 dígitos enviado por email",
    verifyCodeDigit: "Dígito",
    verifyCodeVerifying: "Verificando…",
    verifyCodeConfirm: "Confirmar",
    verifyCodeResend: "Reenviar código",
    verifyCodeResendIn: "Reenviar em",
    verifyCodeHint: "Verifique sua pasta de spam · Código válido por 24h",
    verifyCodeMissingEmail: "Email ausente — faça login novamente usando o link de registro.",
    verifyCodeInvalidFormat: "Insira um código de 6 dígitos válido.",
    verifyCodeInvalid: "Código inválido. Tente novamente.",
    verifyCodeNetworkError: "Erro de rede. Verifique sua conexão.",
    verifyCodeEnterEmailResend: "Insira seu email para reenviar o código.",
    verifyCodeResendError: "Não foi possível reenviar o código.",
    verifyCodeResendSuccess: "✓ Novo código enviado!",
    verifyCodeNetworkShort: "Erro de rede.",
    verifyCodeVerifiedTitle: "Conta verificada",
    verifyCodeRedirectLogin: "Redirecionando para entrar…",
    profileVisitorsHistoryTitle: "Histórico do perfil",
    profileVisitorsListTitle: "Lista de visitantes",
    profileVisitorsTodaySummary: "Visitantes de hoje",
    profileVisitorsVisitsSummary: "Visitas totais",
    profileAvatarChange: "Alterar foto",
    settingsNewPassword: "Nova senha",
    settingsConfirmNewPassword: "Confirme a nova senha",
    settingsPasswordRules: "Mínimo 8 caracteres, uma maiúscula, uma minúscula, um número",
    settingsShowPassword: "Mostrar senhas",
    settingsHidePassword: "Ocultar senhas",
    settingsChangePasswordButton: "Alterar a senha",
    roleHost: "Anfitrião",
    roleParticipant: "Participante",
    roleViewer: "Espectador",
    liveCameraOff: "Câmera desativada",
    liveMuteMic: "Silenciar microfone",
    liveEnableMic: "Ativar microfone",
    liveDisableCamera: "Desativar câmera",
    liveEnableCamera: "Ativar câmera",
    liveEndSession: "Encerrar live",
    liveLeave: "Sair",
    liveWaitingHost: "Aguardando o anfitrião...",
    reputationTotal: "{count} reações no total",
reputationExcellent: "Excelente",
reputationCorrect: "Razoável",
reputationFaible: "Baixo",
  },
  de: {
    authUsernameAvailable: "✓ Verfügbar",
    settingsInstallDesktopStep1: "Sie sehen ein Installationssymbol in der Adressleiste Ihres Browsers",
    settingsInstallDesktopStep2: "Klicken Sie auf das Symbol und bestätigen Sie die Installation",
    settingsInstallDeviceMobile: "Mobile",
    settingsInstallDeviceTablet: "Tablet",
    settingsInstallDeviceDesktop: "Desktop",
    verifyCodeTitle: "E-Mail Verifizierung",
    verifyCodeSubtitle: "Geben Sie den 6-stelligen Code ein, der per E-Mail gesendet wurde",
    verifyCodeDigit: "Ziffer",
    verifyCodeVerifying: "Überprüfung…",
    verifyCodeConfirm: "Bestätigen",
    verifyCodeResend: "Code erneut senden",
    verifyCodeResendIn: "Erneut senden in",
    verifyCodeHint: "Überprüfen Sie Ihren Spam-Ordner · Code 24h gültig",
    verifyCodeMissingEmail: "E-Mail fehlt — melden Sie sich erneut mit dem Registrierungslink an.",
    verifyCodeInvalidFormat: "Geben Sie einen gültigen 6-stelligen Code ein.",
    verifyCodeInvalid: "Ungültiger Code. Bitte versuchen Sie es erneut.",
    verifyCodeNetworkError: "Netzwerkfehler. Überprüfen Sie Ihre Verbindung.",
    verifyCodeEnterEmailResend: "Geben Sie Ihre E-Mail ein, um den Code erneut zu senden.",
    verifyCodeResendError: "Code konnte nicht erneut gesendet werden.",
    verifyCodeResendSuccess: "✓ Neuer Code gesendet!",
    verifyCodeNetworkShort: "Netzwerkfehler.",
    verifyCodeVerifiedTitle: "Konto verifiziert",
    verifyCodeRedirectLogin: "Weiterleitung zur Anmeldung…",
    profileVisitorsHistoryTitle: "Profilverlauf",
    profileVisitorsListTitle: "Besucherliste",
    profileVisitorsTodaySummary: "Besucher heute",
    profileVisitorsVisitsSummary: "Gesamtbesuche",
    profileAvatarChange: "Foto ändern",
    settingsNewPassword: "Neues Passwort",
    settingsConfirmNewPassword: "Neues Passwort bestätigen",
    settingsPasswordRules: "Mindestens 8 Zeichen, ein Großbuchstabe, ein Kleinbuchstabe, eine Zahl",
    settingsShowPassword: "Passwörter anzeigen",
    settingsHidePassword: "Passwörter verbergen",
    settingsChangePasswordButton: "Passwort ändern",
    roleHost: "Gastgeber",
    roleParticipant: "Teilnehmer",
    roleViewer: "Zuschauer",
    liveCameraOff: "Kamera deaktiviert",
    liveMuteMic: "Mikrofon stummschalten",
    liveEnableMic: "Mikrofon aktivieren",
    liveDisableCamera: "Kamera ausschalten",
    liveEnableCamera: "Kamera einschalten",
    liveEndSession: "Live beenden",
    liveLeave: "Verlassen",
    liveWaitingHost: "Warte auf den Gastgeber...",
    reputationTotal: "{count} Reaktionen insgesamt",
reputationExcellent: "Ausgezeichnet",
reputationCorrect: "Gut",
reputationFaible: "Niedrig",
  },
  it: {
    authUsernameAvailable: "✓ Disponibile",
    settingsInstallDesktopStep1: "Sieh ein Installationssymbol in der Adressleiste deines Browsers",
    settingsInstallDesktopStep2: "Klicca sull'icona e conferma l'installazione",
    settingsInstallDeviceMobile: "Mobile",
    settingsInstallDeviceTablet: "Tablet",
    settingsInstallDeviceDesktop: "Desktop",
    verifyCodeTitle: "Verifica email",
    verifyCodeSubtitle: "Inserisci il codice di 6 cifre inviato via email",
    verifyCodeDigit: "Cifra",
    verifyCodeVerifying: "Verifica in corso…",
    verifyCodeConfirm: "Conferma",
    verifyCodeResend: "Rinvia codice",
    verifyCodeResendIn: "Rinvia tra",
    verifyCodeHint: "Controlla la cartella spam · Codice valido 24h",
    verifyCodeMissingEmail: "Email mancante — effettua nuovamente l'accesso usando il link di registrazione.",
    verifyCodeInvalidFormat: "Inserisci un codice di 6 cifre valido.",
    verifyCodeInvalid: "Codice non valido. Riprova.",
    verifyCodeNetworkError: "Errore di rete. Controlla la connessione.",
    verifyCodeEnterEmailResend: "Inserisci la tua email per rinviare il codice.",
    verifyCodeResendError: "Impossibile rinviare il codice.",
    verifyCodeResendSuccess: "✓ Nuovo codice inviato!",
    verifyCodeNetworkShort: "Errore di rete.",
    verifyCodeVerifiedTitle: "Account verificato",
    verifyCodeRedirectLogin: "Reindirizzamento al login…",
    profileVisitorsHistoryTitle: "Cronologia del profilo",
    profileVisitorsListTitle: "Lista visitatori",
    profileVisitorsTodaySummary: "Visitatori di oggi",
    profileVisitorsVisitsSummary: "Visite totali",
    profileAvatarChange: "Cambia la foto",
    settingsNewPassword: "Nuova password",
    settingsConfirmNewPassword: "Conferma nuova password",
    settingsPasswordRules: "Minimo 8 caratteri, una maiuscola, una minuscola, un numero",
    settingsShowPassword: "Mostra le password",
    settingsHidePassword: "Nascondi le password",
    settingsChangePasswordButton: "Cambia la password",
    roleHost: "Host",
    roleParticipant: "Partecipante",
    roleViewer: "Spettatore",
    liveCameraOff: "Fotocamera disattivata",
    liveMuteMic: "Disattiva microfono",
    liveEnableMic: "Attiva microfono",
    liveDisableCamera: "Disattiva fotocamera",
    liveEnableCamera: "Attiva fotocamera",
    liveEndSession: "Termina la live",
    liveLeave: "Esci",
    liveWaitingHost: "In attesa dell'host...",
    reputationTotal: "{count} reazioni in totale",
reputationExcellent: "Eccellente",
reputationCorrect: "Discreto",
reputationFaible: "Basso",
  },
  ar: {
    authUsernameAvailable: "✓ متاح",
    settingsInstallDesktopStep1: "سترى أيقونة التثبيت في شريط عنوان المتصفح",
    settingsInstallDesktopStep2: "انقر على الأيقونة وقم بتأكيد التثبيت",
    settingsInstallDeviceMobile: "الجوال",
    settingsInstallDeviceTablet: "الكمبيوتر اللوحي",
    settingsInstallDeviceDesktop: "سطح المكتب",
    verifyCodeTitle: "التحقق من البريد الإلكتروني",
    verifyCodeSubtitle: "أدخل رمز التأكيد المكوّن من 6 أرقام المرسل عبر البريد الإلكتروني",
    verifyCodeDigit: "رقم",
    verifyCodeVerifying: "جارٍ التحقق…",
    verifyCodeConfirm: "تأكيد",
    verifyCodeResend: "إعادة إرسال الرمز",
    verifyCodeResendIn: "إعادة الإرسال خلال",
    verifyCodeHint: "تحقق من مجلد الرسائل غير المرغوب فيها · الرمز صالح لمدة 24 ساعة",
    verifyCodeMissingEmail: "البريد الإلكتروني مفقود — سجّل الدخول مرة أخرى باستخدام رابط التسجيل.",
    verifyCodeInvalidFormat: "أدخل رمزًا صالحًا مكوّنًا من 6 أرقام.",
    verifyCodeInvalid: "رمز غير صالح. حاول مرة أخرى.",
    verifyCodeNetworkError: "خطأ في الشبكة. تحقق من اتصالك.",
    verifyCodeEnterEmailResend: "أدخل بريدك الإلكتروني لإعادة إرسال الرمز.",
    verifyCodeResendError: "تعذر إعادة إرسال الرمز.",
    verifyCodeResendSuccess: "✓ تم إرسال رمز جديد!",
    verifyCodeNetworkShort: "خطأ في الشبكة.",
    verifyCodeVerifiedTitle: "تم التحقق من الحساب",
    verifyCodeRedirectLogin: "جاري إعادة التوجيه لتسجيل الدخول…",
    profileVisitorsHistoryTitle: "سجل الملف الشخصي",
    profileVisitorsListTitle: "قائمة الزوار",
    profileVisitorsTodaySummary: "زوار اليوم",
    profileVisitorsVisitsSummary: "إجمالي الزيارات",
    profileAvatarChange: "تغيير الصورة",
    settingsNewPassword: "كلمة مرور جديدة",
    settingsConfirmNewPassword: "تأكيد كلمة المرور الجديدة",
    settingsPasswordRules: "8 أحرف على الأقل، حرف كبير، حرف صغير، رقم",
    settingsShowPassword: "إظهار كلمات المرور",
    settingsHidePassword: "إخفاء كلمات المرور",
    settingsChangePasswordButton: "تغيير كلمة المرور",
    roleHost: "مضيف",
    roleParticipant: "مشارك",
    roleViewer: "مشاهد",
    liveCameraOff: "تم تعطيل الكاميرا",
    liveMuteMic: "كتم الميكروفون",
    liveEnableMic: "تفعيل الميكروفون",
    liveDisableCamera: "إيقاف الكاميرا",
    liveEnableCamera: "تشغيل الكاميرا",
    liveEndSession: "إنهاء البث",
    liveLeave: "مغادرة",
    liveWaitingHost: "انتظار المضيف...",
    reputationTotal: "{count} تفاعل إجمالاً",
reputationExcellent: "ممتاز",
reputationCorrect: "جيد",
reputationFaible: "ضعيف",
  },
  tr: {
    authUsernameAvailable: "✓ Uygun",
    settingsInstallDesktopStep1: "Tarayıcı adres çubuğunda bir yükleme simgesi göreceksiniz",
    settingsInstallDesktopStep2: "Simgesine tıklayın ve yüklemeyi onaylayın",
    settingsInstallDeviceMobile: "Mobil",
    settingsInstallDeviceTablet: "Tablet",
    settingsInstallDeviceDesktop: "Masaüstü",
    verifyCodeTitle: "E-posta doğrulaması",
    verifyCodeSubtitle: "E-posta ile gönderilen 6 haneli kodu girin",
    verifyCodeDigit: "Rakam",
    verifyCodeVerifying: "Doğrulanıyor…",
    verifyCodeConfirm: "Onayla",
    verifyCodeResend: "Kodu yeniden gönder",
    verifyCodeResendIn: "Yeniden gönderilecek",
    verifyCodeHint: "Spam klasörünüzü kontrol edin · Kod 24 saat geçerlidir",
    verifyCodeMissingEmail: "E-posta eksik — kayıt bağlantısını kullanarak tekrar giriş yapın.",
    verifyCodeInvalidFormat: "Geçerli 6 haneli bir kod girin.",
    verifyCodeInvalid: "Geçersiz kod. Lütfen tekrar deneyin.",
    verifyCodeNetworkError: "Ağ hatası. Bağlantınızı kontrol edin.",
    verifyCodeEnterEmailResend: "Kodu yeniden göndermek için e-postanızı girin.",
    verifyCodeResendError: "Kod yeniden gönderilemedi.",
    verifyCodeResendSuccess: "✓ Yeni kod gönderildi!",
    verifyCodeNetworkShort: "Ağ hatası.",
    verifyCodeVerifiedTitle: "Hesap doğrulandı",
    verifyCodeRedirectLogin: "Girişe yönlendiriliyor…",
    profileVisitorsHistoryTitle: "Profil geçmişi",
    profileVisitorsListTitle: "Ziyaretçi listesi",
    profileVisitorsTodaySummary: "Bugünün ziyaretçileri",
    profileVisitorsVisitsSummary: "Toplam ziyaretler",
    profileAvatarChange: "Fotoğrafı değiştir",
    settingsNewPassword: "Yeni şifre",
    settingsConfirmNewPassword: "Yeni şifreyi doğrulayın",
    settingsPasswordRules: "En az 8 karakter, bir büyük harf, bir küçük harf, bir sayı",
    settingsShowPassword: "Şifreleri göster",
    settingsHidePassword: "Şifreleri gizle",
    settingsChangePasswordButton: "Şifreyi değiştir",
    roleHost: "Ev sahibi",
    roleParticipant: "Katılımcı",
    roleViewer: "İzleyici",
    liveCameraOff: "Kamera devre dışı",
    liveMuteMic: "Mikrofonu sessize al",
    liveEnableMic: "Mikrofonu etkinleştir",
    liveDisableCamera: "Kamerayı kapat",
    liveEnableCamera: "Kamerayı aç",
    liveEndSession: "Canlıyı bitir",
    liveLeave: "Ayrıl",
    liveWaitingHost: "Ev sahibi bekleniyor...",
    reputationTotal: "Toplam {count} tepki",
reputationExcellent: "Mükemmel",
reputationCorrect: "İyi",
reputationFaible: "Düşük",
  },
  nl: {
    authUsernameAvailable: "✓ Beschikbaar",
    settingsInstallDesktopStep1: "Je ziet een installatiesymbool in de adresbalk van de browser",
    settingsInstallDesktopStep2: "Klik op het pictogram en bevestig de installatie",
    settingsInstallDeviceMobile: "Mobiel",
    settingsInstallDeviceTablet: "Tablet",
    settingsInstallDeviceDesktop: "Bureaublad",
    verifyCodeTitle: "E-mail verificatie",
    verifyCodeSubtitle: "Voer de 6-cijferige code in die per e-mail is verzonden",
    verifyCodeDigit: "Cijfer",
    verifyCodeVerifying: "Bezig met verifiëren…",
    verifyCodeConfirm: "Bevestigen",
    verifyCodeResend: "Code opnieuw verzenden",
    verifyCodeResendIn: "Opnieuw verzenden in",
    verifyCodeHint: "Controleer je spamfolder · Code 24u geldig",
    verifyCodeMissingEmail: "E-mail ontbreekt — log opnieuw in via de registratielink.",
    verifyCodeInvalidFormat: "Voer een geldige 6-cijferige code in.",
    verifyCodeInvalid: "Ongeldige code. Probeer het opnieuw.",
    verifyCodeNetworkError: "Netwerkfout. Controleer uw verbinding.",
    verifyCodeEnterEmailResend: "Voer uw e-mail in om de code opnieuw te verzenden.",
    verifyCodeResendError: "Kan code niet opnieuw verzenden.",
    verifyCodeResendSuccess: "✓ Nieuwe code verzonden!",
    verifyCodeNetworkShort: "Netwerkfout.",
    verifyCodeVerifiedTitle: "Account geverifieerd",
    verifyCodeRedirectLogin: "Doorsturen naar inloggen…",
    profileVisitorsHistoryTitle: "Profielgeschiedenis",
    profileVisitorsListTitle: "Bezoekerslijst",
    profileVisitorsTodaySummary: "Bezoekers van vandaag",
    profileVisitorsVisitsSummary: "Totale bezoeken",
    profileAvatarChange: "Foto wijzigen",
    settingsNewPassword: "Nieuw wachtwoord",
    settingsConfirmNewPassword: "Bevestig nieuw wachtwoord",
    settingsPasswordRules: "Minimaal 8 tekens, één hoofdletter, één kleine letter, één cijfer",
    settingsShowPassword: "Wachtwoorden tonen",
    settingsHidePassword: "Wachtwoorden verbergen",
    settingsChangePasswordButton: "Wachtwoord wijzigen",
    roleHost: "Gastheer",
    roleParticipant: "Deelnemer",
    roleViewer: "Kijker",
    liveCameraOff: "Camera uitgeschakeld",
    liveMuteMic: "Microfoon dempen",
    liveEnableMic: "Microfoon inschakelen",
    liveDisableCamera: "Camera uitschakelen",
    liveEnableCamera: "Camera inschakelen",
    liveEndSession: "Live beëindigen",
    liveLeave: "Verlaten",
    liveWaitingHost: "Wachten op de host...",
    reputationTotal: "{count} reacties in totaal",
reputationExcellent: "Uitstekend",
reputationCorrect: "Redelijk",
reputationFaible: "Laag",
  },
  ru: {
    authUsernameAvailable: "✓ Доступно",
    settingsInstallDesktopStep1: "В адресной строке браузера появится значок установки",
    settingsInstallDesktopStep2: "Нажмите на значок и подтвердите установку",
    settingsInstallDeviceMobile: "Мобильный",
    settingsInstallDeviceTablet: "Планшет",
    settingsInstallDeviceDesktop: "Настольный",
    verifyCodeTitle: "Подтверждение email",
    verifyCodeSubtitle: "Введите 6-значный код, отправленный по электронной почте",
    verifyCodeDigit: "Цифра",
    verifyCodeVerifying: "Проверка…",
    verifyCodeConfirm: "Подтвердить",
    verifyCodeResend: "Отправить код снова",
    verifyCodeResendIn: "Отправить снова через",
    verifyCodeHint: "Проверьте папку со спамом · Код действителен 24 часа",
    verifyCodeMissingEmail: "Отсутствует email — войдите снова, используя ссылку регистрации.",
    verifyCodeInvalidFormat: "Введите корректный 6-значный код.",
    verifyCodeInvalid: "Неверный код. Попробуйте еще раз.",
    verifyCodeNetworkError: "Ошибка сети. Проверьте подключение.",
    verifyCodeEnterEmailResend: "Введите ваш email, чтобы отправить код снова.",
    verifyCodeResendError: "Не удалось отправить код снова.",
    verifyCodeResendSuccess: "✓ Новый код отправлен!",
    verifyCodeNetworkShort: "Ошибка сети.",
    verifyCodeVerifiedTitle: "Аккаунт подтверждён",
    verifyCodeRedirectLogin: "Перенаправление на вход…",
    profileVisitorsHistoryTitle: "История профиля",
    profileVisitorsListTitle: "Список посетителей",
    profileVisitorsTodaySummary: "Посетители сегодня",
    profileVisitorsVisitsSummary: "Всего посещений",
    profileAvatarChange: "Изменить фото",
    settingsNewPassword: "Новый пароль",
    settingsConfirmNewPassword: "Подтвердите новый пароль",
    settingsPasswordRules: "Мин. 8 символов, одна заглавная, одна строчная, одна цифра",
    settingsShowPassword: "Показать пароли",
    settingsHidePassword: "Скрыть пароли",
    settingsChangePasswordButton: "Изменить пароль",
    roleHost: "Ведущий",
    roleParticipant: "Участник",
    roleViewer: "Зритель",
    liveCameraOff: "Камера отключена",
    liveMuteMic: "Отключить микрофон",
    liveEnableMic: "Включить микрофон",
    liveDisableCamera: "Выключить камеру",
    liveEnableCamera: "Включить камеру",
    liveEndSession: "Завершить эфир",
    liveLeave: "Выйти",
    liveWaitingHost: "Ожидание ведущего...",
    reputationTotal: "{count} реакций всего",
reputationExcellent: "Отлично",
reputationCorrect: "Хорошо",
reputationFaible: "Низко",
  },
  zh: {
    authUsernameAvailable: "✓ 可用",
    settingsInstallDesktopStep1: "您将在浏览器地址栏看到一个安装图标",
    settingsInstallDesktopStep2: "点击该图标并确认安装",
    settingsInstallDeviceMobile: "手机",
    settingsInstallDeviceTablet: "平板",
    settingsInstallDeviceDesktop: "桌面",
    verifyCodeTitle: "邮箱验证",
    verifyCodeSubtitle: "输入通过电子邮件发送的 6 位验证码",
    verifyCodeDigit: "位数",
    verifyCodeVerifying: "验证中…",
    verifyCodeConfirm: "确认",
    verifyCodeResend: "重新发送验证码",
    verifyCodeResendIn: "重新发送于",
    verifyCodeHint: "查看垃圾邮件文件夹 · 验证码有效期 24 小时",
    verifyCodeMissingEmail: "缺少邮箱 — 请使用注册链接重新登录。",
    verifyCodeInvalidFormat: "请输入有效的 6 位验证码。",
    verifyCodeInvalid: "验证码无效。请重试。",
    verifyCodeNetworkError: "网络错误。请检查您的连接。",
    verifyCodeEnterEmailResend: "输入您的邮箱以重新发送验证码。",
    verifyCodeResendError: "无法重新发送验证码。",
    verifyCodeResendSuccess: "✓ 新验证码已发送！",
    verifyCodeNetworkShort: "网络错误。",
    verifyCodeVerifiedTitle: "账户已验证",
    verifyCodeRedirectLogin: "正在重定向到登录…",
    profileVisitorsHistoryTitle: "个人资料历史",
    profileVisitorsListTitle: "访客列表",
    profileVisitorsTodaySummary: "今日访客",
    profileVisitorsVisitsSummary: "总访问次数",
    profileAvatarChange: "更换头像",
    settingsNewPassword: "新密码",
    settingsConfirmNewPassword: "确认新密码",
    settingsPasswordRules: "至少8个字符，包含一个大写字母、一个小写字母和一个数字",
    settingsShowPassword: "显示密码",
    settingsHidePassword: "隐藏密码",
    settingsChangePasswordButton: "修改密码",
    roleHost: "主持人",
    roleParticipant: "参与者",
    roleViewer: "观众",
    liveCameraOff: "摄像头已关闭",
    liveMuteMic: "静音麦克风",
    liveEnableMic: "启用麦克风",
    liveDisableCamera: "关闭摄像头",
    liveEnableCamera: "打开摄像头",
    liveEndSession: "结束直播",
    liveLeave: "离开",
    liveWaitingHost: "等待主持人...",
    reputationTotal: "共 {count} 条反应",
reputationExcellent: "优秀",
reputationCorrect: "良好",
reputationFaible: "较低",
  },
  ja: {
    authUsernameAvailable: "✓ 利用可能",
    settingsInstallDesktopStep1: "ブラウザのアドレスバーにインストールアイコンが表示されます",
    settingsInstallDesktopStep2: "アイコンをクリックしてインストールを確認してください",
    settingsInstallDeviceMobile: "モバイル",
    settingsInstallDeviceTablet: "タブレット",
    settingsInstallDeviceDesktop: "デスクトップ",
    verifyCodeTitle: "メール確認",
    verifyCodeSubtitle: "メールで送信された6桁のコードを入力してください",
    verifyCodeDigit: "桁",
    verifyCodeVerifying: "確認中…",
    verifyCodeConfirm: "確認",
    verifyCodeResend: "コードを再送信",
    verifyCodeResendIn: "再送信まで",
    verifyCodeHint: "迷惑メールフォルダを確認してください · コードは24時間有効",
    verifyCodeMissingEmail: "メールがありません — 登録リンクから再度サインインしてください。",
    verifyCodeInvalidFormat: "有効な6桁のコードを入力してください。",
    verifyCodeInvalid: "無効なコードです。もう一度お試しください。",
    verifyCodeNetworkError: "ネットワークエラー。接続を確認してください。",
    verifyCodeEnterEmailResend: "コードを再送信するにはメールアドレスを入力してください。",
    verifyCodeResendError: "コードの再送信に失敗しました。",
    verifyCodeResendSuccess: "✓ 新しいコードを送信しました！",
    verifyCodeNetworkShort: "ネットワークエラー。",
    verifyCodeVerifiedTitle: "アカウント確認済み",
    verifyCodeRedirectLogin: "サインインにリダイレクトしています…",
    profileVisitorsHistoryTitle: "プロフィール履歴",
    profileVisitorsListTitle: "訪問者リスト",
    profileVisitorsTodaySummary: "本日の訪問者",
    profileVisitorsVisitsSummary: "累計訪問数",
    profileAvatarChange: "写真を変更",
    settingsNewPassword: "新しいパスワード",
    settingsConfirmNewPassword: "新しいパスワードを確認",
    settingsPasswordRules: "8文字以上、大文字1つ、小文字1つ、数字1つ",
    settingsShowPassword: "パスワードを表示",
    settingsHidePassword: "パスワードを非表示",
    settingsChangePasswordButton: "パスワードを変更",
    roleHost: "ホスト",
    roleParticipant: "参加者",
    roleViewer: "視聴者",
    liveCameraOff: "カメラがオフです",
    liveMuteMic: "マイクをミュート",
    liveEnableMic: "マイクを有効にする",
    liveDisableCamera: "カメラをオフにする",
    liveEnableCamera: "カメラをオンにする",
    liveEndSession: "ライブを終了",
    liveLeave: "退出",
    liveWaitingHost: "ホストを待っています...",
    reputationTotal: "合計 {count} 件のリアクション",
reputationExcellent: "優秀",
reputationCorrect: "良好",
reputationFaible: "低い",
  },
  ko: {
    authUsernameAvailable: "✓ 사용 가능",
    settingsInstallDesktopStep1: "브라우저 주소 표시줄에 설치 아이콘이 표시됩니다",
    settingsInstallDesktopStep2: "아이콘을 클릭하고 설치를 확인하세요",
    settingsInstallDeviceMobile: "모바일",
    settingsInstallDeviceTablet: "태블릿",
    settingsInstallDeviceDesktop: "데스크톱",
    verifyCodeTitle: "이메일 인증",
    verifyCodeSubtitle: "이메일로 전송된 6자리 코드를 입력하세요",
    verifyCodeDigit: "숫자",
    verifyCodeVerifying: "확인 중…",
    verifyCodeConfirm: "확인",
    verifyCodeResend: "코드 재전송",
    verifyCodeResendIn: "재전송까지",
    verifyCodeHint: "스팸함을 확인하세요 · 코드 유효기간 24시간",
    verifyCodeMissingEmail: "이메일 누락 — 등록 링크로 다시 로그인하세요.",
    verifyCodeInvalidFormat: "유효한 6자리 코드를 입력하세요.",
    verifyCodeInvalid: "잘못된 코드입니다. 다시 시도하세요.",
    verifyCodeNetworkError: "네트워크 오류. 연결을 확인하세요.",
    verifyCodeEnterEmailResend: "코드를 재전송하려면 이메일을 입력하세요.",
    verifyCodeResendError: "코드 재전송에 실패했습니다.",
    verifyCodeResendSuccess: "✓ 새 코드가 전송되었습니다!",
    verifyCodeNetworkShort: "네트워크 오류.",
    verifyCodeVerifiedTitle: "계정 확인 완료",
    verifyCodeRedirectLogin: "로그인으로 리디렉션 중…",
    profileVisitorsHistoryTitle: "프로필 기록",
    profileVisitorsListTitle: "방문자 목록",
    profileVisitorsTodaySummary: "오늘의 방문자",
    profileVisitorsVisitsSummary: "전체 방문 수",
    profileAvatarChange: "사진 변경",
    settingsNewPassword: "새 비밀번호",
    settingsConfirmNewPassword: "새 비밀번호 확인",
    settingsPasswordRules: "최소 8자, 대문자 1개, 소문자 1개, 숫자 1개",
    settingsShowPassword: "비밀번호 표시",
    settingsHidePassword: "비밀번호 숨기기",
    settingsChangePasswordButton: "비밀번호 변경",
    roleHost: "호스트",
    roleParticipant: "참가자",
    roleViewer: "시청자",
    liveCameraOff: "카메라가 꺼져 있습니다",
    liveMuteMic: "마이크 음소거",
    liveEnableMic: "마이크 활성화",
    liveDisableCamera: "카메라 끄기",
    liveEnableCamera: "카메라 켜기",
    liveEndSession: "라이브 종료",
    liveLeave: "나가기",
    liveWaitingHost: "호스트를 기다리는 중...",
    reputationTotal: "총 {count}개의 반응",
reputationExcellent: "훌륭함",
reputationCorrect: "양호",
reputationFaible: "낮음",
  },
  hi: {
    authUsernameAvailable: "✓ उपयोग करने योग्य",
    settingsInstallDesktopStep1: "आपके ब्राउज़र के पता बार में एक इंस्टॉल आइकन दिखाई देगा",
    settingsInstallDesktopStep2: "आईकन पर क्लिक करें और स्थापना की पुष्टि करें",
    settingsInstallDeviceMobile: "मोबाइल",
    settingsInstallDeviceTablet: "टैबलेट",
    settingsInstallDeviceDesktop: "डेस्कटॉप",
    verifyCodeTitle: "ईमेल सत्यापन",
    verifyCodeSubtitle: "ईमेल द्वारा भेजा गया 6-अंकीय कोड दर्ज करें",
    verifyCodeDigit: "अंक",
    verifyCodeVerifying: "सत्यापित किया जा रहा है…",
    verifyCodeConfirm: "पुष्टि करें",
    verifyCodeResend: "कोड फिर से भेजें",
    verifyCodeResendIn: "में फिर से भेजें",
    verifyCodeHint: "स्पैम फ़ोल्डर जाँचें · कोड 24 घंटे के लिए मान्य है",
    verifyCodeMissingEmail: "ईमेल गुम — पंजीकरण लिंक का उपयोग करके फिर से साइन इन करें।",
    verifyCodeInvalidFormat: "कृपया मान्य 6-अंकीय कोड दर्ज करें।",
    verifyCodeInvalid: "अमान्य कोड। कृपया पुनः प्रयास करें।",
    verifyCodeNetworkError: "नेटवर्क त्रुटि। अपना कनेक्शन जांचें।",
    verifyCodeEnterEmailResend: "कोड पुन: भेजने के लिए अपना ईमेल दर्ज करें।",
    verifyCodeResendError: "कोड पुन: भेजने में असमर्थ।",
    verifyCodeResendSuccess: "✓ नया कोड भेज दिया गया!",
    verifyCodeNetworkShort: "नेटवर्क त्रुटि।",
    verifyCodeVerifiedTitle: "खाता सत्यापित",
    verifyCodeRedirectLogin: "साइन इन पर पुननिर्देशित किया जा रहा है…",
    profileVisitorsHistoryTitle: "प्रोफ़ाइल इतिहास",
    profileVisitorsListTitle: "विज़िटर सूची",
    profileVisitorsTodaySummary: "आज के विज़िटर",
    profileVisitorsVisitsSummary: "कुल विज़िट",
    profileAvatarChange: "फ़ोटो बदलें",
    settingsNewPassword: "नया पासवर्ड",
    settingsConfirmNewPassword: "नया पासवर्ड पुष्टि करें",
    settingsPasswordRules: "कम से कम 8 अक्षर, एक बड़े अक्षर, एक छोटे अक्षर, एक संख्या",
    settingsShowPassword: "पासवर्ड दिखाएँ",
    settingsHidePassword: "पासवर्ड छिपाएँ",
    settingsChangePasswordButton: "पासवर्ड बदलें",
    roleHost: "होस्ट",
    roleParticipant: "प्रतिभागी",
    roleViewer: "दर्शक",
    liveCameraOff: "कैमरा निष्क्रिय है",
    liveMuteMic: "माइक्रोफ़ोन म्यूट करें",
    liveEnableMic: "माइक्रोफ़ोन सक्षम करें",
    liveDisableCamera: "कैमरा बंद करें",
    liveEnableCamera: "कैमरा चालू करें",
    liveEndSession: "लाइव समाप्त करें",
    liveLeave: "छोड़ें",
    liveWaitingHost: "होस्ट की प्रतीक्षा...",
    reputationTotal: "कुल {count} प्रतिक्रियाएँ",
reputationExcellent: "उत्कृष्ट",
reputationCorrect: "ठीक है",
reputationFaible: "कम", 
  },
}

const translations: Record<LocaleCode, TranslationMap> = {
  fr: baseTranslations,
  en: {
    ...baseTranslations,
    settingsInstallBadgeNew: "New",
    settingsInstallBadgeInstalled: "Installed",
    settingsInstallButtonInstalled: "Installed",
    theme: "Theme",
    themeModeLight: "Light mode",
    themeModeDark: "Dark mode",
    language: "Language",
    changeLanguage: "Change language",
    selectLanguage: "Choose a language",
    defaultFrench: "French by default",
    languageHint: "Your choice stays saved until you change it.",
    rootMetaTitle: "Callo — Free video chat",
    rootMetaTitleShort: "Callo — Video chat",
    rootMetaDescription: "Callo is a free video chat with live streams and messaging. No download required.",
    rootMetaDescriptionShort: "Free video chat with live streams and messaging.",
    heroBadge: "+10,000 people online now",
    heroTitle: "Free random video chat that connects the world",
    heroSubtitle: "Video calls, live streams, messaging and posts in a modern interface.",
    landingTickerRandomVideo: "Free random video chat",
    landingTickerAltOmegle: "Omegle alternative 2026",
    landingTickerLives: "Live streams",
    landingTickerMessaging: "Instant messaging",
    landingTickerFree: "100% free",
    landingTickerUsers: "+50,000 users",
    landingTickerNoDownload: "No download",
    landingTickerAlwaysOn: "Available 24/7",
    landingHowBadge: "Easy as hello",
    landingHowTitle: "How it",
    landingHowTitleAccent: "works?",
    landingHowSubtitle: "Three steps to meet people worldwide",
    landingHowStep1Title: "Create your profile",
    landingHowStep1Desc: "Free sign-up in 30 seconds. Choose your languages and interests.",
    landingHowStep2Title: "Start a call",
    landingHowStep2Desc: "One click connects you with someone at random by video. Instant.",
    landingHowStep3Title: "Connect",
    landingHowStep3Desc: "Add your favorites as friends, chat privately, share moments.",
    landingFeaturesBadge: "Features",
    landingFeaturesTitle: "Everything you",
    landingFeaturesTitleAccent: "need",
    landingFeaturesSubtitle: "A complete social platform for video chat, live streaming, and messaging",
    landingFeatureGlobalTitle: "Global reach",
    landingFeatureGlobalDesc: "Meet people in over 18 countries. Filter by language, region, or interests.",
    landingFeatureInstantTitle: "Instant calls",
    landingFeatureInstantDesc: "One click for a random video call. Our algorithm matches you in under 3 seconds.",
    landingFeatureLivesTitle: "Live streams",
    landingFeatureLivesDesc: "Create your own live or join others. Unlimited viewers.",
    landingFeatureMessagingTitle: "Private messaging",
    landingFeatureMessagingDesc: "Chat in real time with friends. Send texts, photos, and voice messages.",
    landingFeatureCommunityTitle: "Active community",
    landingFeatureCommunityDesc: "Posts, comments, trending hashtags. A real social network built in.",
    landingFeatureSecurityTitle: "Enhanced security",
    landingFeatureSecurityDesc: "End-to-end encryption, AI moderation, and full respect for your privacy.",
    landingTagPopular: "Popular",
    landingTagNew: "New",
    landingTestimonialsBadge: "Testimonials",
    landingTestimonialsTitle: "They love",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "I met my best friend on Callo! We talk every day now. It's way better than Omegle.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "The random call is addictive. I talked with people from Japan, Brazil, Germany... incredible.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "Live streams are super fun! I love the vibe and community. And it's 100% free, no bad surprises.",
    landingCtaTitleLine1: "Ready to meet",
    landingCtaTitleLine2: "the whole world?",
    landingCtaSubtitle: "Join thousands of people who use Callo every day to connect, chat, and share.",
    landingCtaPrimary: "Create my free account",
    landingCtaSecondary: "I already have an account",
    landingFooterDesc: "Callo is the best free alternative to Omegle and Chatroulette. Random video chat, live streaming, messaging, and social network — all in one app.",
    landingFooterRegister: "Free signup",
    landingFooterLogin: "Login",
    landingFooterDiscover: "Discover",
    landingFooterLive: "Live streams",
    landingFooterTerms: "Terms of use",
    landingFooterPrivacy: "Privacy policy",
    landingFooterLegal: "Legal notice",
    landingStatFree: "Free",
    landingStatUsers: "Users",
    landingStatCountries: "Countries",
    landingStatAvailable: "Available",
    landingCopyright: "© {year} Callo. Free random video chat — Omegle & Chatroulette alternative.",
    landingLegalPrefix: "By signing up, you agree to our",
    landingLegalAnd: "and our",
    ctaLogin: "Sign in",
    ctaRegister: "Create account",
    ctaPublish: "Create a post",
    ctaBrowse: "Discover",
    feature1: "Random video calls",
    feature2: "Instant messaging",
    feature3: "Live streams",
    feature4: "Global community",
    authLoginTitle: "Welcome back!",
    authLoginSubtitle: "Sign in to find your community again",
    authRegisterTitle: "Join Callo",
    authRegisterSubtitle: "Create your account and connect with the world",
    authEmail: "Email address",
    authPassword: "Password",
    authConfirmPassword: "Confirm password",
    authName: "Full name",
    authUsername: "Username",
    authDOB: "Date of birth",
    authDOBDay: "Day",
    authDOBMonth: "Month",
    authDOBYear: "Year",
    authLanguages: "Spoken languages",
    authForgotPassword: "Forgot password?",
    authLoginLoading: "Signing in...",
    authRegisterLoading: "Creating account...",
    authNoAccount: "No account yet?",
    authSignUp: "Sign up",
    authHaveAccount: "Already have an account?",
    authSignIn: "Sign in",
    authLoginError: "Login error",
    authPasswordMismatch: "Passwords do not match",
    authSelectOneLanguage: "Please select at least one language",
    authInvalidUsername: "Invalid username (3-30 characters, letters, numbers and _)",
    authUsernameTaken: "This username is already taken",
    authRegisterError: "Registration error",
    authUsernameTakenShort: "Already taken",
    authUsernameInvalidShort: "3-30 chars, letters/numbers/_",
    authUsernameAvailable: "✓ Available",
    authMinAgeHint: "You must be at least 16 years old",
    authPasswordMinPlaceholder: "8 characters min.",
    authNamePlaceholder: "e.g. Alex Martin",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "Create a strong password",
    authConfirmPasswordPlaceholder: "Repeat your password",
    authDateOfBirthPlaceholder: "dd/mm/yyyy",
    authLegalPrefix: "By signing up, you confirm you are at least",
    authLegalAnd: "and agree to our",
    authChatMessage1: "Hi! Where are you from? 😄",
    authChatMessage2: "Hey! Nice to meet you!",
    authChatMessage3: "Want to do a live together?",
    authChatMessage4: "Callo is so cool 🔥",
    authChatMessage5: "Are you free for a call?",
    authChatMessage6: "Just joined from Tokyo! 🇯🇵",
    authChatMessage7: "Who wants to join my live?",
    authChatMessage8: "Best video chat ever! 💜",
    authNotif1: "Marie liked your post",
    authNotif2: "+3 new friends online",
    authNotif3: "Incoming video call...",
    authNotif4: "Your live has 52 viewers!",
    authNotif5: "Ahmed reacted to your story",
    authNotif6: "12 people online near you",
    authLoginMetaTitle: "Sign in to your account",
    authLoginMetaDescription: "Sign in to Callo to find your friends, private messages, and live streams.",
    authLoginMetaOgTitle: "Sign in | Callo",
    authLoginMetaOgDescription: "Access your Callo account and pick up your conversations instantly.",
    authRegisterMetaTitle: "Create a free account",
    authRegisterMetaDescription: "Sign up for free on Callo, the best alternative to Omegle and Chatroulette. Random video chat, live streams, private messaging. Join in 1 minute, no download.",
    authRegisterMetaOgTitle: "Create a free account | Callo",
    authRegisterMetaOgDescription: "Sign up for free — random video chat, live streams, messaging. Omegle & Chatroulette alternative.",
    authRegisterMetaTwitterDescription: "Free sign-up in 1 minute. Random video chat, Omegle alternative.",
    authForgotPasswordMetaTitle: "Forgot password",
    authForgotPasswordMetaDescription: "Reset your Callo password. Receive a verification code by email to create a new secure password.",
    authResetCodeMetaTitle: "Code verification",
    authResetCodeMetaDescription: "Enter the verification code sent by email to reset your Callo password.",
    authResetPasswordMetaTitle: "New password",
    authResetPasswordMetaDescription: "Create a new secure password for your Callo account.",
    forgotPasswordEmailRequired: "Please enter your email address",
    forgotPasswordSendError: "Error while sending",
    forgotPasswordSubtitle: "Enter your email and we will send you a code to reset your password",
    forgotPasswordSending: "Sending...",
    forgotPasswordSendCode: "Send code",
    forgotPasswordRemembered: "Remembered?",
    resetPasswordMinLengthError: "Password must contain at least 8 characters",
    resetPasswordSessionExpired: "Session expired. Please restart the process.",
    resetPasswordResetError: "Error while resetting password",
    resetPasswordSuccessTitle: "Password updated!",
    resetPasswordSuccessRedirect: "Redirecting to sign in…",
    resetPasswordSubtitle: "Choose a secure password to protect your account",
    resetPasswordNewPasswordLabel: "New password",
    resetPasswordRuleMinLength: "8 characters min",
    resetPasswordRuleUpper: "One uppercase",
    resetPasswordRuleLower: "One lowercase",
    resetPasswordRuleNumber: "One number",
    resetPasswordPasswordsMatch: "Passwords match",
    resetPasswordUpdating: "Updating...",
    resetPasswordSubmit: "Update password",
    profileUserNotFoundMetaTitle: "Profile not found — Callo",
    profileUserMetaTitleSuffix: "— Callo profile",
    profileUserMetaDescription: "Discover {name}'s profile on Callo — free random video chat{countryPart}.",
    profileUserMetaCountryPrefix: ", {country}",
    profileUserMetaImageAlt: "{name} — Callo",
    verifySuccessTitle: "Email verified successfully!",
    verifySuccessSubtitle: "Your Callo account has been activated. You can now sign in and start meeting people worldwide.",
    verifySuccessRedirect: "Automatic redirect to the sign-in page in 5 seconds...",
    verifySuccessLoginNow: "Sign in now",
    verifyErrorTitle: "Verification failed",
    verifyErrorMissingToken: "The verification link is incomplete. Please use the full link received by email.",
    verifyErrorInvalidToken: "This verification link is invalid or has expired. Please request a new one.",
    verifyErrorServer: "An error occurred during verification. Please try again later.",
    verifyErrorDefault: "An error occurred while verifying your email.",
    verifyErrorCreateAccount: "Create a new account",
    verifyErrorBackLogin: "Back to sign in",
    profileEditTitle: "Edit my profile",
    profileEditSubtitle: "Update your personal information",
    profileProfilePhoto: "Profile photo",
    profileFullName: "Full name",
    profileUsername: "Username",
    profileAgeAuto: "Calculated automatically from your date of birth",
    profileDobFormatHint: "Day/month/year format based on your device",
    profileBio: "Bio",
    profileBioPlaceholder: "Tell us about yourself...",
    profileCharsCount: "{count}/500 characters",
    profileLocationAuto: "Detected automatically via geolocation",
    profileAvatarTooLarge: "Image is too large (max 10 MB)",
    profileAvatarUploadError: "Error uploading image",
    profileAvatarUploading: "Uploading...",
    profileAvatarChange: "Change photo",
    profileAvatarRemove: "Remove photo",
    profileUsernameUrlHint: "Appears in your profile URL",
    verifyEmailTitle: "Email verification",
    verifyEmailLoading: "Verification in progress...",
    verifyEmailSuccess: "Email verified",
    verifyEmailFailure: "Verification error",
    verifyEmailMissingToken: "Missing verification token",
    verifyEmailError: "Verification failed",
    verifyEmailSuccessMessage: "Your email has been verified successfully!",
    verifyEmailGoToAccount: "Go to my account",
    verifyEmailBackHome: "Back to home",
    verifyCodeTitle: "Email verification",
    verifyCodeSubtitle: "Enter the 6-digit code sent by email",
    verifyCodeDigit: "Digit",
    verifyCodeVerifying: "Verifying…",
    verifyCodeConfirm: "Confirm",
    verifyCodeResend: "Resend code",
    verifyCodeResendIn: "Resend in",
    verifyCodeHint: "Check your spam folder · Code valid for 24h",
    verifyCodeMissingEmail: "Missing email — sign in again using the registration link.",
    verifyCodeInvalidFormat: "Enter a valid 6-digit code.",
    verifyCodeInvalid: "Invalid code. Please try again.",
    verifyCodeNetworkError: "Network error. Check your connection.",
    verifyCodeEnterEmailResend: "Enter your email to resend the code.",
    verifyCodeResendError: "Unable to resend the code.",
    verifyCodeResendSuccess: "✓ New code sent!",
    verifyCodeNetworkShort: "Network error.",
    verifyCodeVerifiedTitle: "Account verified",
    verifyCodeRedirectLogin: "Redirecting to sign in…",
    resetCodeTitle: "Verification",
    resetCodeSubtitle: "Enter the 6-digit code sent by email",
    resetCodeSubmit: "Verify code",
    resetCodeHint: "Check your spam folder · Code valid for 15 min",
    resetCodeMissingEmail: "Missing email",
    settingsTitle: "Settings",
    settingsSubtitle: "Personalize your Callo experience",
    settingsPreferences: "Call preferences",
    settingsAccount: "Account",
    settingsAppLanguageTitle: "App language",
    settingsAppLanguageDesc: "Set the global display language for Callo.",
    settingsLanguageSaved: "Language updated",
    postVideosTab: "Videos",
    dashboardMetaTitle: "News feed",
    dashboardMetaDescription: "Your Callo feed — posts, trends and your friends' activity.",
    friendsMetaTitle: "Friends",
    friendsMetaDescription: "Your friends and friend requests on Callo.",
    discoverMetaDescription: "Discover new people from around the world on Callo.",
    liveMetaTitle: "Lives",
    liveMetaDescription: "Watch and start live streams on Callo.",
    messagesMetaTitle: "Messages",
    messagesMetaDescription: "Your private conversations on Callo.",
    notificationsMetaTitle: "Notifications",
    notificationsMetaDescription: "Your notifications and interactions on Callo.",
    settingsMetaTitle: "Settings",
    settingsMetaDescription: "Manage your preferences and Callo account settings.",
    profileMetaTitle: "My profile",
    profileMetaDescription: "Your Callo profile — personal info and posts.",
    dashboardEmailUnverifiedTitle: "Email not verified",
    dashboardEmailUnverifiedDesc: "Please verify your email to access all features",
    dashboardMoreLanguagesAria: "Additional languages",
    dashboardSuggestionsForYou: "Suggestions for you",
    dashboardSwipeHint: "Swipe ->",
    settingsOtherRegion: "Other",
    settingsOtherLanguages: "Other languages",
    settingsRegionEurope: "Europe",
    settingsRegionNorthAmerica: "North America",
    settingsRegionSouthAmerica: "South America",
    settingsRegionAfrica: "Africa",
    settingsRegionAsia: "Asia",
    settingsRegionOceania: "Oceania",
    settingsLangGroupEuropean: "European languages",
    settingsLangGroupAsian: "Asian languages",
    settingsLangGroupAfrican: "African languages",
    settingsGenericError: "Error",
    settingsDeleteTypeConfirm: "Type DELETE to confirm",
    settingsDeletePasswordRequired: "Password required",
    settingsPreferencesDesc: "Countries, languages, age range for random calls",
    settingsFiltersCount: "{count} filters",
    settingsAccountDesc: "Information, security and account deletion",
    settingsPreferencesSaved: "Preferences saved!",
    settingsPreferencesHelp: "Configure your filters for random calls. Leave empty to accept everyone.",
    settingsCountriesTitle: "Countries",
    settingsCountriesNoFilter: "No filter — all countries",
    settingsLanguagesTitle: "Languages",
    settingsLanguagesNoFilter: "No filter — all languages",
    settingsAgeRangeTitle: "Age range",
    settingsSaving: "Saving...",
    settingsSavePreferences: "Save preferences",
    settingsFilterCountriesTitle: "Filter by countries",
    settingsFilterCountriesHelp: "Only countries with registered users are shown. You can select a whole region in one click.",
    settingsCountriesSelected: "{count} selected countries",
    settingsDeselectAll: "Deselect all",
    settingsFilterLanguagesTitle: "Filter by languages",
    settingsFilterLanguagesHelp: "Only languages spoken by registered users are shown. You can select a whole group.",
    settingsLanguagesSelected: "{count} selected language{plural}",
    settingsAgeRangeHelp: "Set the minimum and maximum age of people you want to be matched with.",
    settingsMinAge: "Minimum age",
    settingsMaxAge: "Maximum age",
    settingsAgeRangeSummary: "You will see people between {min} and {max} {years}",
    settingsAccountInfoTitle: "Account information",
    settingsAccountInfoDesc: "Email, location, registration date",
    settingsBlockedTitle: "Blocked users",
    settingsBlockedDesc: "Manage the people you have blocked",
    settingsBlockedEmpty: "No blocked users",
    settingsUnblock: "Unblock",
    settingsLoading: "Loading...",
    settingsDeleteTitle: "Delete account",
    settingsDeleteDesc: "Permanently delete your account and all your data",
    settingsLocation: "Location",
    settingsNotDetected: "Not detected",
    settingsGeolocation: "Geolocation",
    settingsAllowed: "Allowed",
    settingsNotAllowed: "Not allowed",
    settingsMemberSince: "Member since",
    settingsEditProfileHintPrefix: "To edit your name, age, bio or languages, go to",
    settingsEditProfileHintSuffix: "Location is updated automatically.",
    settingsIrreversibleAction: "Irreversible action",
    settingsDeleteKeyword: "DELETE",
    settingsDeleteWarningDesc: "Deleting your account will permanently remove all your data:",
    settingsDeleteItemProfile: "Profile and profile photo",
    settingsDeleteItemMessages: "Messages and conversations",
    settingsDeleteItemFriends: "Friends list and requests",
    settingsDeleteItemPosts: "Posts and comments",
    settingsDeleteItemCalls: "Call history",
    settingsDeleteItemReactions: "Likes, dislikes and reactions",
      settingsCurrentPassword: "Current password",
      settingsChangePasswordTitle: "Change password",
      settingsChangePasswordDesc: "Update your password to strengthen your account security",
    settingsEnterPassword: "Enter your password",
    settingsType: "Type",
    settingsToConfirm: "to confirm",
    settingsDeleting: "Deleting...",
    settingsDeleteForever: "Permanently delete my account",
    legalTermsPageTitle: "Terms of use",
    legalTermsMetaDescription: "Callo terms of use. Rules for using the video chat platform.",
    legalTermsPill: "Official legal document",
    legalTermsHeroIntro: "These terms govern your access to the platform.",
    legalTermsFeature_video: "Video calls",
    legalTermsFeature_lives: "Live streams",
    legalTermsFeature_messaging: "Messaging",
    legalTermsFeature_posts: "Posts",
    legalTermsNoticeIntro: "These Terms govern access to and use of the platform",
    legalTermsNav_s1: "Purpose",
    legalTermsNav_s2: "Access conditions",
    legalTermsNav_s3: "Code of conduct",
    legalTermsNav_s4: "Moderation & sanctions",
    legalTermsNav_s5: "Intellectual property",
    legalTermsNav_s6: "Liability",
    legalTermsNav_s7: "Service is free",
    legalTermsNav_s8: "Termination",
    legalTermsNav_s9: "Changes to TOS",
    legalTermsNav_s10: "Governing law",
    legalTermsNav_s11: "Contact",
    legalTermsProhib_illegal: "Illegal content",
    legalTermsProhib_harassment: "Harassment",
    legalTermsProhib_nudity: "Nudity / Sexual content",
    legalTermsProhib_fraud: "Fraud / Spam",
    legalOtherDocsTitle: "Other legal documents",
    legalMentionsPageTitle: "Legal notice",
    legalMentionsMetaDescription: "Callo legal notice in accordance with French LCEN law. Information about the website publisher.",
    legalMentionsHeaderSubtitle: "In accordance with Article 6 of French Law No. 2004-575 of June 21, 2004 (LCEN)",
    legalPrivacyPageTitle: "Privacy policy",
    legalPrivacyMetaDescription: "Callo privacy policy. Learn how we protect your personal data in accordance with GDPR.",
    legalLastUpdated: "Last updated: March 10, 2025",
    collapseSidebar: "Collapse",
    expandSidebar: "Expand",
    backLabel: "Back",
    yearsLabel: "years",
    allLabel: "All",
    feedLoading: "Loading...",
    feedEmptyTitle: "No posts yet",
    feedEmptySubtitle: "Be the first to share something!",
    feedUpToDate: "You are up to date",
    commentReplyLabel: "reply",
    commentEmptyTitle: "No comments yet",
    commentEmptySubtitle: "Be the first to comment!",
    commentReplyPlaceholder: "Reply to {name}…",
    commentEditPlaceholder: "Edit comment…",
    commentWritePlaceholder: "Write a comment...",
    commentJustNow: "Just now",
    commentTimeMinute: "m",
    commentTimeHour: "h",
    commentTimeDay: "d",
    commentLike: "Like",
    commentUnlike: "Unlike",
    commentDislike: "Dislike",
    commentUndo: "Undo",
    commentActions: "Actions",
    commentReply: "Reply",
    commentEdit: "Edit",
    commentDelete: "Delete",
    commentReplySub: "Reply to this comment",
    commentEditSub: "Edit your comment",
    commentDeleteSub: "Irreversible action",
    commentDeleteTitle: "Delete this comment?",
    commentDeleteConfirm: "This action is irreversible.",
    commentCancel: "Cancel",
    commentSave: "Save",
    commentSend: "Send",
    commentEditing: "Editing",
    commentEdited: "edited",
    commentInReplyTo: "in reply to",
    commentReplyTo: "Reply to",
    commentYou: "You",
    commentHide: "Hide",
    commentReplyWord: "reply",
    commentRepliesWord: "replies",
    commentCommentWord: "comment",
    commentCommentsWord: "comments",
    commentRepliesCount: "{count} {word}",
    commentMoreReplies: "See {count} more {word}",
    commentMoreComments: "See {count} more {word}",
    liveLoading: "Loading…",
    liveLoadingSession: "Loading live...",
    liveRetry: "Retry",

    liveBroadcastsLive: "{count} live broadcasts",
    liveNoBroadcasts: "No broadcasts",
    livePublicLives: "Public lives",
    liveLiveNow: "Live",
    liveEndedTitle: "Live ended",
    randomCallEndedTitle: "Call ended",
    randomCallThanks: "Thank you for participating in this call.",
    randomCallLeave: "Leave call",
    randomCallNewCall: "New call",
    randomCallCameraDisabled: "Camera disabled",
    randomCallMicMuted: "Microphone muted",
    liveRedirecting: "Redirecting to live list...",
    liveConnectingWith: "Connecting with",
    liveConnectingTo: "Connecting to",
    liveVideoSyncing: "Video sync in progress.",
    liveP2PConnecting: "P2P connection in progress",
    liveSessionPreparing: "Preparing session",
    liveInCall: "IN CALL",
    liveThanks: "Thanks for using Callo",
    liveSecure: "Secure",
    liveInstant: "Instant",
    liveOpen: "Open",
    livePrivate: "Private",
    liveFast: "Fast",
    liveLaunchCall: "Start call",
    liveNewCall: "New call",
    liveNotFoundTitle: "Live not found",
    liveNotFoundSubtitle: "This live does not exist or has ended",
    liveBackToList: "Back to lives",
    liveWaitingHost: "Waiting for the host...",
    liveMuteMic: "Mute microphone",
    liveEnableMic: "Enable microphone",
    liveDisableCamera: "Turn camera off",
    liveEnableCamera: "Turn camera on",
    liveSwitchCamera: "Switch camera",
    liveEndSession: "End live",
    liveLeave: "Leave",
    liveStepDown: "Switch to viewer",
    liveDemote: "Demote",
    liveViewerMode: "You are a viewer",
    liveJoin: "Join",
    liveFull: "Full",
    liveTrending: "Hot",
    liveViewers: "Viewers",
    liveParticipants: "Participants",
    liveRequests: "Requests",
    liveInvite: "Invite",
    liveComments: "Comments",
    liveJoinSession: "Join a session or start your own in a few seconds.",
    liveMoreLives: "More lives",
    liveCountLabel: "{count} lives",
    liveCreateLive: "Create a live",
    liveNoLive: "No live in progress",
    liveStartSession: "Be the first to start a session and invite your community in real time.",
    liveLaunchLive: "Start a live",
    liveRandomCall: "Random call",
    randomHeroConnect: "Connect.",
    randomHeroClick: "Click.",
    randomHeroSpeak: "Talk.",
    randomActionLabel: "Action",
    randomLaunchNow: "Launch now",
    randomBlockUserConfirm: "Do you really want to block {name}?",
    liveDialogSubtitle: "8 guests · unlimited viewers",
    liveTitlePlaceholder: "Title of your live...",
    liveQuickSuggestions: "Quick suggestions",
    liveSwipe: "Swipe",
    liveDescriptionOptional: "Description (optional)",
    liveStarting: "Starting...",
    liveStart: "Start live",
    liveSuggestion1: "Come talk to me!",
    liveSuggestion2: "🎥 Live questions",
    liveSuggestion3: "🔥 Open debate",
    liveSuggestion4: "🚀 Let's level up together",
    liveSuggestion5: "💬 Join the family",
    friendsNoFriendYet: "No friends yet",
    friendsNoFriendYetDesc: "Start by meeting people and add them as friends",
    friendsNoRequestYet: "No pending requests",
    friendsRequestsDesc: "Friend requests you receive will appear here",
    friendsNoSentYet: "No sent requests",
    friendsSentDesc: "Friend requests you send will appear here",
    friendsTabFriends: "Friends",
    friendsTabRequests: "Requests",
    friendsTabSent: "Sent",
    friendsTitleMyFriends: "My friends",
    friendsHeaderStats: "{contacts} contacts{onlinePart}",
    friendsOnlineLabel: "online",
    friendsSubtitleManageContacts: "Manage your contacts",
    friendsNewCall: "New call",
    friendsCallShort: "Call",
    friendsSendMessage: "Send message",
    friendsRemoveFriend: "Remove this friend",
    friendsAccept: "Accept",
    friendsReject: "Reject",
    friendsWaiting: "Pending",
    friendsNoResult: "No results",
    friendsSearchNoResult: "No friend matches \"{search}\"",
    friendsStartCall: "Start a call",
    friendsOnline: "● Online",
    friendsStartConversation: "Start a conversation",
    discoverTitle: "Discover",
    discoverForYou: "For you",
    discoverNearby: "Nearby",
    discoverOnline: "Online",
    discoverPopular: "Popular",
    discoverViewGrid: "Grid view",
    discoverViewMap: "Map view",
    discoverFilters: "Filters",
    discoverResetFilters: "Reset",
    discoverAllCountries: "All countries",
    discoverAllLanguages: "All languages",
    discoverOnlineOnly: "Online only",
    discoverNearbySection: "Nearby",
    discoverShowAll: "Show all",
    discoverClearFilters: "Clear filters",
    discoverNoUsers: "No users found",
    discoverNoUsersDesc: "Try changing your filters or search",
    discoverNoLocalizedUsers: "No local users",
    discoverNoLocalizedUsersDesc: "Users will appear here when they share their location",
    discoverFounder: "Founder",
    discoverPeopleCount: "{count} people",
    discoverSearchPlaceholder: "Name, username or bio…",
    discoverGPSRequired: "GPS required",
    discoverResultsCount: "{count} results",
    discoverAdd: "Add",
    discoverRequestSent: "Request sent",
    discoverViewProfile: "View profile",
    discoverSent: "Sent ✓",
    notificationsTitle: "Notifications",
    notificationsSubtitle: "Stay informed about your interactions",
    notificationsSomeone: "Someone",
    notificationsAnd: "and",
    notificationsOther: "other",
    notificationsOthers: "others",
    notificationsToday: "Today",
    notificationsYesterday: "Yesterday",
    notificationsThisWeek: "This week",
    notificationsOlder: "Earlier",
    notificationsAll: "All",
    notificationsUnread: "Unread",
    notificationsNoNotifications: "No notifications",
    notificationsUpToDate: "You're all caught up!",
    notificationsNoUnread: "Notifications about your interactions will appear here",
    notificationsDelete: "Delete",
    notificationsNew: "New",
    notificationsCallReactionSingle: "{name} reacted to your call",
    notificationsCallReactionMultiple: "{names} reacted to your calls",
    notificationsLikeCommentSingle: "{name} reacted to your comment",
    notificationsLikePostSingle: "{name} reacted to your post",
    notificationsLikeProfileSingle: "{name} liked your profile",
    notificationsLikeCommentMultiple: "{names} reacted to your comment",
    notificationsLikePostMultiple: "{names} reacted to your post",
    notificationsLikeProfileMultiple: "{names} liked your profile",
    notificationsDislikeCommentSingle: "{name} reacted to your comment",
    notificationsDislikePostSingle: "{name} reacted to your post",
    notificationsDislikeProfileSingle: "{name} disliked your profile",
    notificationsDislikeCommentMultiple: "{names} reacted to your comment",
    notificationsDislikePostMultiple: "{names} reacted to your post",
    notificationsDislikeProfileMultiple: "{names} disliked your profile",
    notificationsFriendRequestSingle: "{name} sent you a friend request",
    notificationsFriendRejectedSingle: "{name} declined your friend request",
    notificationsFriendAcceptedSingle: "{name} accepted your friend request",
    notificationsProfileViewSingle: "{name} viewed your profile",
    notificationsProfileViewMultiple: "{names} viewed your profile",
    notificationsMessageReplySingle: "{name} replied to your comment",
    notificationsMessageCommentSingle: "{name} commented on your post",
    notificationsMessagePostSingle: "{name} commented on your post",
    notificationsMessageDirectSingle: "{name} sent you a message",
    notificationsMessageReplyMultiple: "{names} replied to your comment",
    notificationsMessageCommentMultiple: "{names} commented on your post",
    notificationsMessagePostMultiple: "{names} commented on your post",
    notificationsMessageDirectMultiple: "{names} sent you messages",
    notificationsLiveInvitationSingle: "{name} invited you to join their live",
    notificationsLiveJoinRequestSingle: "{name} requested to join your live",
    notificationsLiveStartedSingle: "{name} is live",
    notificationsGenericSingle: "{name} interacted with you",
    notificationsGenericMultiple: "{names} interacted with you",
    notificationsCallReactionsTitle: "Reactions to your calls",
    notificationsReactionsCount: "Reactions: {count}",
    notificationsNoReactionYet: "No reactions yet",
    notificationsProfileVisitorsTitle: "Profile visitors",
    notificationsVisitorsCount: "Visits: {count}",
    notificationsNoVisitorsYet: "No visitors yet",
    notificationsPeople: "people",
    chatNoConversation: "No conversations",
    chatAllRead: "All read ✓",
    chatPersonOnline: "Nobody online",
    chatOffline: "Offline",
    chatSeenAt: "Seen at",
    chatSeenYesterdayAt: "Seen yesterday at",
    chatSeenOn: "Seen on",
    chatYourMessage: "Your message",
    chatMedia: "Media",
    chatEditContent: "Edit content",
    chatDeleteForEveryone: "Delete for everyone",
    chatRecording: "Recording…",
    chatFinish: "Finish",
    chatVoiceReady: "Voice message ready",
    chatMicAccessError: "Unable to access microphone",
    chatSearchInConversation: "Search in conversation…",
    chatStartConversationTitle: "Start the conversation",
    chatSayHello: "Say hello to {name}!",
    chatNewMessages: "New messages",
    chatDeletedMessage: "Message deleted",
    chatEditMessage: "Edit message",
    chatMessagePlaceholder: "Message…",
    chatNoMatch: "\"{search}\" not found",
    chatNewMessage: "New message",
    chatChooseContact: "Choose a contact and start instantly",
    chatSearchPlaceholder: "Search…",
    chatSearchContact: "Search contacts…",
    chatContacts: "contact{plural}",
    chatNoContactAvailable: "No contacts available",
    chatNoFriendFound: "No friends found",
    chatFriends: "Friends",
    chatRecents: "Recent",
    chatStartConversation: "Start a conversation",
    chatOpenConversation: "Open conversation",
    chatYou: "You",
    reactionLiked: "liked",
    reactionDisliked: "disliked",
    chatUnknown: "Unknown",
    chatVideo: "Video",
    chatVoiceMessage: "Voice message",
    chatPhoto: "Photo",
    chatFile: "File",
    chatUnreadFilter: "Unread",
    chatOnlineFilter: "Online",
    chatUnreadCount: "{count} unread",
    chatConversationsCount: "{count} conversation{plural}",
    chatEmptyHint: "Tap + to send your first message",
    chatYesterday: "Yesterday",
    postVisibilityPublic: "Public",
    postVisibilityFriends: "Friends",
    postVisibilityPrivate: "Private",
    postComposerPrompt: "What's new? Share something...",
    postNewPublication: "New post",
    postWriteSomething: "Write something... Use #hashtags",
    postAddImage: "Add image",
    postAddVideo: "Add video",
    postStep: "Step",
    postHashtagTip: "Tip: use #hashtags",
    postDropMedia: "Drop your images/videos or click (max 9)",
    postVisibility: "Visibility",
    postAllowComments: "Allow comments",
    postTrendingTitle: "Trending",
    postNoTrendingNow: "No trends for now",
    postCustomTags: "Custom tags",
    postAddTag: "Add a tag",
    postAdd: "Add",
    postCopyLink: "Copy link",
    postExternalShare: "External share",
    postReshare: "Reshare",
    postReport: "Report",
    postDeleteConfirm: "Delete this post?",
    postShareError: "Share error",
    postCommentsEnabled: "Comments enabled",
    postCommentsDisabled: "Comments disabled",
    postNoTextContent: "No text content",
    postReactAction: "React",
    postCommentAction: "Comment",
    postShareAction: "Share",
    postShowMore: "Show more",
    postReactionCount: "{count} reaction{plural}",
    postViewsWord: "view{plural}",
    reactionLike: "Like",
    reactionLove: "Love",
    reactionHaha: "Haha",
    reactionWow: "Wow",
    reactionSad: "Sad",
    reactionFire: "Fire",
    reactionClap: "Clap",
    profileVideoCalls: "Video calls",
    profileCallsCompleted: "completed",
    profileReputation: "Reputation",
    profilePositive: "positive",
    profileLikes: "Likes",
    profileDislikes: "Dislikes",
    profileRecentVisitorsTitle: "Recent visitors",
    profileRecentVisitorsSubtitle: "People who viewed your profile",
    profileNoRecentVisitors: "No recent visitors",
    profileTabPosts: "Posts",
    profileTabVisitors: "Visitors",
    profileTopBadge: "Top",
    profileSeePhoto: "View photo larger",
    profileEditProfile: "Edit profile",
    profileBackToDiscover: "Explore",
    profileBack: "Back",
    profilePostsSectionTitle: "Posts",
    profileFilterAll: "All",
    profileFilterPhotos: "Photos",
    profileFilterVideos: "Videos",
    profileFilterTexts: "Text",
    profileNoPosts: "No posts yet",
    profileNoPostsHint: "Posts will appear here.",
    postNotFoundMetaTitle: "Post not found — Callo",
    postMetaTitle: "{name} on Callo",
    postMetaFallbackDescription: "Post by {name} on Callo",
    postNotFoundPage: "Post not found",
    navDashboard: "Home",
    navLive: "Live",
    navMessages: "Messages",
    navDiscover: "Discover",
    navNotifications: "Notifications",
    navProfile: "Profile",
    navSettings: "Settings",
    navLogout: "Log out",
    liveJoinRequest: "Join Request",
    liveRequestSending: "Sending...",
    liveRequestPending: "Waiting for host",
    liveRequestRejected: "Declined",
    liveRequestRejectedMsg: "Your request was declined",
    reputationTotal: "{count} reactions total",
reputationExcellent: "Excellent",
reputationCorrect: "Fair",
reputationFaible: "Low",
  },
  es: {
    ...baseTranslations,
    settingsInstallBadgeNew: "Nuevo",
    theme: "Tema",
    language: "Idioma",
    changeLanguage: "Cambiar idioma",
    selectLanguage: "Elegir un idioma",
    defaultFrench: "Francés por defecto",
    languageHint: "Tu elección se guarda hasta que la cambies.",
    heroBadge: "+10.000 personas conectadas ahora",
    heroTitle: "Chat de video aleatorio gratis que conecta al mundo",
    heroSubtitle: "Videollamadas, directos, mensajería y publicaciones en una interfaz moderna.",
    ctaLogin: "Iniciar sesión",
    ctaRegister: "Crear cuenta",
    ctaPublish: "Crear una publicación",
    ctaBrowse: "Descubrir",
    feature1: "Videollamadas aleatorias",
    feature2: "Mensajería instantánea",
    feature3: "Directos en vivo",
    feature4: "Comunidad global",
    authLoginTitle: "¡Bienvenido de nuevo!",
    authLoginSubtitle: "Inicia sesión para volver a tu comunidad",
    authRegisterTitle: "Únete a Callo",
    authRegisterSubtitle: "Crea tu cuenta y conecta con el mundo",
    authEmail: "Correo electrónico",
    authPassword: "Contraseña",
    authConfirmPassword: "Confirmar contraseña",
    authName: "Nombre completo",
    authUsername: "Usuario",
    authDOB: "Fecha de nacimiento",
    authLanguages: "Idiomas hablados",
    authForgotPassword: "¿Olvidaste tu contraseña?",
    authLoginLoading: "Iniciando sesión...",
    authRegisterLoading: "Creando cuenta...",
    authNoAccount: "¿Aún no tienes cuenta?",
    authSignUp: "Regístrate",
    authHaveAccount: "¿Ya tienes cuenta?",
    authSignIn: "Iniciar sesión",
    verifySuccessTitle: "¡Correo verificado con éxito!",
    verifySuccessSubtitle: "Tu cuenta de Callo ha sido activada. Ahora puedes iniciar sesión y empezar a conocer gente de todo el mundo.",
    verifySuccessRedirect: "Redirección automática a la página de inicio de sesión en 5 segundos...",
    verifySuccessLoginNow: "Iniciar sesión ahora",
    verifyErrorTitle: "Error de verificación",
    verifyErrorMissingToken: "El enlace de verificación está incompleto. Usa el enlace completo recibido por correo.",
    verifyErrorInvalidToken: "Este enlace de verificación no es válido o ha caducado. Solicita uno nuevo.",
    verifyErrorServer: "Se produjo un error durante la verificación. Vuelve a intentarlo más tarde.",
    verifyErrorDefault: "Se produjo un error al verificar tu correo electrónico.",
    verifyErrorCreateAccount: "Crear una cuenta nueva",
    verifyErrorBackLogin: "Volver al inicio de sesión",
    profileEditTitle: "Editar mi perfil",
    profileEditSubtitle: "Actualiza tu información personal",
    themeModeLight: "Modo claro",
    themeModeDark: "Modo oscuro",
    profileProfilePhoto: "Foto de perfil",
    profileFullName: "Nombre completo",
    profileUsername: "Nombre de usuario",
    profileAgeAuto: "Calculado automáticamente a partir de tu fecha de nacimiento",
    profileDobFormatHint: "Formato día/mes/año según tu dispositivo",
    profileBio: "Biografía",
    profileBioPlaceholder: "Cuéntanos sobre ti...",
    profileCharsCount: "{count}/500 caracteres",
    profileLocationAuto: "Detectada automáticamente mediante geolocalización",
    liveDialogSubtitle: "8 invitados · espectadores ilimitados",
    liveTitlePlaceholder: "Título de tu directo...",
    liveQuickSuggestions: "Sugerencias rápidas",
    liveSwipe: "Deslizar",
    liveDescriptionOptional: "Descripción (opcional)",
    liveStarting: "Iniciando...",
    liveStart: "Iniciar directo",
    liveCreateLive: "Crear un directo",
    liveLaunchLive: "Iniciar un directo",
    liveRandomCall: "Llamada aleatoria",
    liveSuggestion1: "¡Ven a hablar conmigo!",
    liveSuggestion2: "🎥 Preguntas en directo",
    liveSuggestion3: "🔥 Debate abierto",
    liveSuggestion4: "🚀 Subimos juntos",
    liveSuggestion5: "💬 Únete a la familia",
    settingsTitle: "Ajustes",
    settingsSubtitle: "Personaliza tu experiencia en Callo",
    settingsPreferences: "Preferencias de llamadas",
    settingsAccount: "Cuenta",
    settingsAppLanguageTitle: "Idioma de la app",
    settingsAppLanguageDesc: "Define el idioma global de visualización de Callo.",
    settingsLanguageSaved: "Idioma actualizado",
    postVideosTab: "Videos",
    landingTickerRandomVideo: "Chat de video aleatorio gratis",
    landingTickerAltOmegle: "Alternativa a Omegle 2026",
    landingTickerLives: "Directos en vivo",
    landingTickerMessaging: "Mensajería instantánea",
    landingTickerFree: "100% gratis",
    landingTickerUsers: "+50.000 usuarios",
    landingTickerNoDownload: "Sin descarga",
    landingTickerAlwaysOn: "Disponible 24/7",
    landingHowBadge: "Fácil como decir hola",
    landingHowTitle: "Cómo",
    landingHowTitleAccent: "funciona?",
    landingHowSubtitle: "Tres pasos para conocer personas de todo el mundo",
    landingHowStep1Title: "Crea tu perfil",
    landingHowStep1Desc: "Registro gratis en 30 segundos. Elige tus idiomas e intereses.",
    landingHowStep2Title: "Inicia una llamada",
    landingHowStep2Desc: "Un clic basta para conectarte con alguien al azar por video. Instantáneo.",
    landingHowStep3Title: "Conéctate",
    landingHowStep3Desc: "Agrega a tus favoritos como amigos, chatea en privado y comparte momentos.",
    landingFeaturesBadge: "Funciones",
    landingFeaturesTitle: "Todo lo que",
    landingFeaturesTitleAccent: "necesitas",
    landingFeaturesSubtitle: "Una plataforma social completa de videochat, directos y mensajería",
    landingFeatureGlobalTitle: "Alcance global",
    landingFeatureGlobalDesc: "Conoce personas de más de 18 países. Filtra por idioma, región o intereses.",
    landingFeatureInstantTitle: "Llamadas instantáneas",
    landingFeatureInstantDesc: "Un clic para una videollamada aleatoria. Nuestro algoritmo te empareja en menos de 3 segundos.",
    landingFeatureLivesTitle: "Directos en vivo",
    landingFeatureLivesDesc: "Crea tu propio directo o únete al de otros. Espectadores ilimitados.",
    landingFeatureMessagingTitle: "Mensajería privada",
    landingFeatureMessagingDesc: "Chatea en tiempo real con tus amigos. Envía textos, fotos y mensajes de voz.",
    landingFeatureCommunityTitle: "Comunidad activa",
    landingFeatureCommunityDesc: "Publicaciones, comentarios, hashtags en tendencia. Una verdadera red social integrada.",
    landingFeatureSecurityTitle: "Seguridad reforzada",
    landingFeatureSecurityDesc: "Cifrado de extremo a extremo, moderación con IA y respeto total a tu privacidad.",
    landingTagPopular: "Popular",
    landingTagNew: "Nuevo",
    landingTestimonialsBadge: "Testimonios",
    landingTestimonialsTitle: "Les encanta",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Conocí a mi mejor amiga en Callo. Ahora hablamos todos los días. Es mucho mejor que Omegle.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "La llamada aleatoria es adictiva. Hablé con gente de Japón, Brasil, Alemania... increíble.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "Los directos son muy divertidos. Me encanta el ambiente y la comunidad. Y es 100% gratis, sin sorpresas.",
    landingCtaTitleLine1: "Listo para conocer",
    landingCtaTitleLine2: "a todo el mundo?",
    landingCtaSubtitle: "Únete a miles de personas que usan Callo cada día para conectar, chatear y compartir.",
    landingCtaPrimary: "Crear mi cuenta gratis",
    landingCtaSecondary: "Ya tengo una cuenta",
    landingFooterDesc: "Callo es la mejor alternativa gratuita a Omegle y Chatroulette. Chat de video aleatorio, directos, mensajería y red social: todo en una sola app.",
    landingFooterRegister: "Registro gratis",
    landingFooterLogin: "Iniciar sesión",
    landingFooterDiscover: "Descubrir",
    landingFooterLive: "Directos en vivo",
    landingFooterTerms: "Términos de uso",
    landingFooterPrivacy: "Política de privacidad",
    landingFooterLegal: "Aviso legal",
    landingStatFree: "Gratis",
    landingStatUsers: "Usuarios",
    landingStatCountries: "Países",
    landingStatAvailable: "Disponible",
    landingCopyright: "© {year} Callo. Chat de video aleatorio gratis — Alternativa a Omegle y Chatroulette.",
    landingLegalPrefix: "Al registrarte, aceptas nuestros",
    landingLegalAnd: "y nuestra",
    collapseSidebar: "Contraer",
    expandSidebar: "Expandir",
    navDashboard: "Inicio",
    navLive: "Directos",
    navMessages: "Mensajes",
    navDiscover: "Descubrir",
    navNotifications: "Notificaciones",
    navProfile: "Perfil",
    navSettings: "Ajustes",
    postCopyLink: "Copiar enlace",
    postExternalShare: "Compartir externamente",
    postReshare: "Recompartir",
    postReport: "Reportar",
    postDeleteConfirm: "¿Eliminar esta publicación?",
    postShareError: "Error al compartir",
    postReactAction: "Reaccionar",
    postCommentAction: "Comentar",
    postShareAction: "Compartir",
    postShowMore: "Ver más",
    postReactionCount: "{count} reacción{plural}",
    postViewsWord: "vista{plural}",
    reactionLike: "Me gusta",
    reactionLove: "Me encanta",
    reactionHaha: "Jaja",
    reactionWow: "Guau",
    reactionSad: "Triste",
    reactionFire: "Fuego",
    reactionClap: "Aplauso",
    profileVideoCalls: "Videollamadas",
    profileCallsCompleted: "completadas",
    profileReputation: "Reputación",
    profilePositive: "positiva",
    profileRecentVisitorsTitle: "Visitantes recientes",
    profileRecentVisitorsSubtitle: "Personas que vieron tu perfil",
    profileNoRecentVisitors: "Sin visitantes recientes",
    profileTabPosts: "Publicaciones",
    profileTabVisitors: "Visitantes",
    profileTopBadge: "Top",
    profileSeePhoto: "Ver foto en grande",
    profileEditProfile: "Editar perfil",
    profileBackToDiscover: "Explorar",
    profileBack: "Volver",
    profilePostsSectionTitle: "Publicaciones",
    profileFilterAll: "Todo",
    profileFilterPhotos: "Fotos",
    profileFilterVideos: "Vídeos",
    profileFilterTexts: "Textos",
    profileNoPosts: "Aún no hay publicaciones",
    profileNoPostsHint: "Las publicaciones aparecerán aquí.",
    navLogout: "Cerrar sesión",
  },
  pt: {
    ...baseTranslations,
    settingsInstallBadgeNew: "Novo",
    theme: "Tema",
    language: "Idioma",
    changeLanguage: "Alterar idioma",
    selectLanguage: "Escolher um idioma",
    defaultFrench: "Francês por padrão",
    languageHint: "Sua escolha fica salva até você trocar.",
    heroBadge: "+10.000 pessoas online agora",
    heroTitle: "Chat de vídeo aleatório gratuito que conecta o mundo",
    heroSubtitle: "Chamadas de vídeo, lives, mensagens e publicações em uma interface moderna.",
    ctaLogin: "Entrar",
    ctaRegister: "Criar conta",
    ctaPublish: "Criar publicação",
    ctaBrowse: "Descobrir",
    feature1: "Chamadas de vídeo aleatórias",
    feature2: "Mensagens instantâneas",
    feature3: "Lives ao vivo",
    feature4: "Comunidade global",
    authLoginTitle: "Bem-vindo de volta!",
    authLoginSubtitle: "Entre para encontrar sua comunidade novamente",
    authRegisterTitle: "Junte-se ao Callo",
    authRegisterSubtitle: "Crie sua conta e conecte-se com o mundo",
    authEmail: "Endereço de e-mail",
    authPassword: "Senha",
    authConfirmPassword: "Confirmar senha",
    authName: "Nome completo",
    authUsername: "Nome de usuário",
    authDOB: "Data de nascimento",
    authLanguages: "Idiomas falados",
    authForgotPassword: "Esqueceu a senha?",
    authLoginLoading: "Entrando...",
    authRegisterLoading: "Criando conta...",
    authNoAccount: "Ainda não tem conta?",
    authSignUp: "Cadastre-se",
    authHaveAccount: "Já tem uma conta?",
    authSignIn: "Entrar",
    verifySuccessTitle: "Email verificado com sucesso!",
    verifySuccessSubtitle: "Sua conta Callo foi ativada. Agora você pode entrar e começar a conhecer pessoas do mundo inteiro.",
    verifySuccessRedirect: "Redirecionamento automático para a página de login em 5 segundos...",
    verifySuccessLoginNow: "Entrar agora",
    verifyErrorTitle: "Falha na verificação",
    verifyErrorMissingToken: "O link de verificação está incompleto. Use o link completo recebido por email.",
    verifyErrorInvalidToken: "Este link de verificação é inválido ou expirou. Solicite um novo link.",
    verifyErrorServer: "Ocorreu um erro durante a verificação. Tente novamente mais tarde.",
    verifyErrorDefault: "Ocorreu um erro ao verificar seu email.",
    verifyErrorCreateAccount: "Criar uma nova conta",
    verifyErrorBackLogin: "Voltar ao login",
    profileEditTitle: "Editar meu perfil",
    profileEditSubtitle: "Atualize suas informações pessoais",
    themeModeLight: "Modo claro",
    themeModeDark: "Modo escuro",
    profileProfilePhoto: "Foto de perfil",
    profileFullName: "Nome completo",
    profileUsername: "Nome de usuário",
    profileAgeAuto: "Calculado automaticamente a partir da sua data de nascimento",
    profileDobFormatHint: "Formato dia/mês/ano conforme seu dispositivo",
    profileBio: "Bio",
    profileBioPlaceholder: "Fale um pouco sobre você...",
    profileCharsCount: "{count}/500 caracteres",
    profileLocationAuto: "Detectada automaticamente via geolocalização",
    liveDialogSubtitle: "8 convidados · espectadores ilimitados",
    liveTitlePlaceholder: "Título da sua live...",
    liveQuickSuggestions: "Sugestões rápidas",
    liveSwipe: "Deslize",
    liveDescriptionOptional: "Descrição (opcional)",
    liveStarting: "Iniciando...",
    liveStart: "Iniciar live",
    liveCreateLive: "Criar live",
    liveLaunchLive: "Iniciar uma live",
    liveRandomCall: "Chamada aleatória",
    liveSuggestion1: "Vem falar comigo!",
    liveSuggestion2: "🎥 Perguntas ao vivo",
    liveSuggestion3: "🔥 Debate aberto",
    liveSuggestion4: "🚀 Vamos crescer juntos",
    liveSuggestion5: "💬 Entre para a família",
    settingsTitle: "Configurações",
    settingsSubtitle: "Personalize sua experiência Callo",
    settingsPreferences: "Preferências de chamada",
    settingsAccount: "Conta",
    settingsAppLanguageTitle: "Idioma do app",
    settingsAppLanguageDesc: "Defina o idioma global de exibição do Callo.",
    settingsLanguageSaved: "Idioma atualizado",
    postVideosTab: "Vídeos",
    landingTickerRandomVideo: "Chat de vídeo aleatório grátis",
    landingTickerAltOmegle: "Alternativa ao Omegle 2026",
    landingTickerLives: "Lives ao vivo",
    landingTickerMessaging: "Mensagens instantâneas",
    landingTickerFree: "100% grátis",
    landingTickerUsers: "+50.000 usuários",
    landingTickerNoDownload: "Sem download",
    landingTickerAlwaysOn: "Disponível 24/7",
    landingHowBadge: "Fácil como dizer oi",
    landingHowTitle: "Como",
    landingHowTitleAccent: "funciona?",
    landingHowSubtitle: "Três passos para conhecer pessoas do mundo inteiro",
    landingHowStep1Title: "Crie seu perfil",
    landingHowStep1Desc: "Cadastro grátis em 30 segundos. Escolha seus idiomas e interesses.",
    landingHowStep2Title: "Inicie uma chamada",
    landingHowStep2Desc: "Um clique conecta você com alguém aleatoriamente por vídeo. Instantâneo.",
    landingHowStep3Title: "Conecte-se",
    landingHowStep3Desc: "Adicione seus favoritos como amigos, converse no privado e compartilhe momentos.",
    landingFeaturesBadge: "Funcionalidades",
    landingFeaturesTitle: "Tudo o que você",
    landingFeaturesTitleAccent: "precisa",
    landingFeaturesSubtitle: "Uma plataforma social completa de videochat, lives e mensagens",
    landingFeatureGlobalTitle: "Alcance global",
    landingFeatureGlobalDesc: "Conheça pessoas em mais de 18 países. Filtre por idioma, região ou interesses.",
    landingFeatureInstantTitle: "Chamadas instantâneas",
    landingFeatureInstantDesc: "Um clique para uma chamada de vídeo aleatória. Nosso algoritmo combina você em menos de 3 segundos.",
    landingFeatureLivesTitle: "Lives ao vivo",
    landingFeatureLivesDesc: "Crie sua própria live ou participe das outras. Espectadores ilimitados.",
    landingFeatureMessagingTitle: "Mensagens privadas",
    landingFeatureMessagingDesc: "Converse em tempo real com seus amigos. Envie textos, fotos e mensagens de voz.",
    landingFeatureCommunityTitle: "Comunidade ativa",
    landingFeatureCommunityDesc: "Publicações, comentários, hashtags em alta. Uma rede social de verdade integrada.",
    landingFeatureSecurityTitle: "Segurança reforçada",
    landingFeatureSecurityDesc: "Criptografia de ponta a ponta, moderação por IA e total respeito à sua privacidade.",
    landingTagPopular: "Popular",
    landingTagNew: "Novo",
    landingTestimonialsBadge: "Depoimentos",
    landingTestimonialsTitle: "Eles adoram",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Conheci minha melhor amiga no Callo! Agora conversamos todos os dias. É muito melhor que Omegle.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "A chamada aleatória é viciante. Falei com pessoas do Japão, Brasil, Alemanha... incrível.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "As lives são super divertidas! Adoro o clima e a comunidade. E é 100% grátis, sem surpresas.",
    landingCtaTitleLine1: "Pronto para conhecer",
    landingCtaTitleLine2: "o mundo inteiro?",
    landingCtaSubtitle: "Junte-se a milhares de pessoas que usam o Callo todos os dias para se conectar, conversar e compartilhar.",
    landingCtaPrimary: "Criar minha conta grátis",
    landingCtaSecondary: "Já tenho uma conta",
    landingFooterDesc: "Callo é a melhor alternativa grátis ao Omegle e ao Chatroulette. Chat de vídeo aleatório, lives, mensagens e rede social — tudo em um único app.",
    landingFooterRegister: "Cadastro grátis",
    landingFooterLogin: "Entrar",
    landingFooterDiscover: "Descobrir",
    landingFooterLive: "Lives ao vivo",
    landingFooterTerms: "Termos de uso",
    landingFooterPrivacy: "Política de privacidade",
    landingFooterLegal: "Aviso legal",
    landingStatFree: "Grátis",
    landingStatUsers: "Usuários",
    landingStatCountries: "Países",
    landingStatAvailable: "Disponível",
    landingCopyright: "© {year} Callo. Chat de vídeo aleatório grátis — Alternativa ao Omegle e Chatroulette.",
    landingLegalPrefix: "Ao se cadastrar, você aceita nossos",
    landingLegalAnd: "e nossa",
    collapseSidebar: "Recolher",
    expandSidebar: "Expandir",
    navDashboard: "Início",
    navLive: "Lives",
    navMessages: "Mensagens",
    navDiscover: "Descobrir",
    navNotifications: "Notificações",
    navProfile: "Perfil",
    navSettings: "Configurações",
    postCopyLink: "Copiar link",
    postExternalShare: "Compartilhar externamente",
    postReshare: "Recompartilhar",
    postReport: "Denunciar",
    postDeleteConfirm: "Excluir esta publicação?",
    postShareError: "Erro ao compartilhar",
    postReactAction: "Reagir",
    postCommentAction: "Comentar",
    postShareAction: "Compartilhar",
    postShowMore: "Mostrar mais",
    postReactionCount: "{count} reação{plural}",
    postViewsWord: "visualização{plural}",
    reactionLike: "Curtir",
    reactionLove: "Amei",
    reactionHaha: "Haha",
    reactionWow: "Uau",
    reactionSad: "Triste",
    reactionFire: "Fogo",
    reactionClap: "Aplauso",
    profileVideoCalls: "Chamadas de vídeo",
    profileCallsCompleted: "concluídas",
    profileReputation: "Reputação",
    profilePositive: "positiva",
    profileRecentVisitorsTitle: "Visitantes recentes",
    profileRecentVisitorsSubtitle: "Pessoas que visitaram seu perfil",
    profileNoRecentVisitors: "Nenhum visitante recente",
    profileTabPosts: "Publicações",
    profileTabVisitors: "Visitantes",
    profileTopBadge: "Top",
    profileSeePhoto: "Ver foto ampliada",
    profileEditProfile: "Editar perfil",
    profileBackToDiscover: "Explorar",
    profileBack: "Voltar",
    profilePostsSectionTitle: "Publicações",
    profileFilterAll: "Tudo",
    profileFilterPhotos: "Fotos",
    profileFilterVideos: "Vídeos",
    profileFilterTexts: "Textos",
    profileNoPosts: "Nenhuma publicação ainda",
    profileNoPostsHint: "As publicações aparecerão aqui.",
    navLogout: "Sair",
  },
  de: {
    ...baseTranslations,
    settingsInstallBadgeNew: "Neu",
    theme: "Design",
    language: "Sprache",
    changeLanguage: "Sprache ändern",
    selectLanguage: "Sprache auswählen",
    defaultFrench: "Standardmäßig Französisch",
    languageHint: "Deine Auswahl bleibt gespeichert, bis du sie änderst.",
    heroBadge: "+10.000 Personen jetzt online",
    heroTitle: "Kostenloser zufälliger Videochat, der die Welt verbindet",
    heroSubtitle: "Videoanrufe, Livestreams, Nachrichten und Beiträge in einer modernen Oberfläche.",
    ctaLogin: "Anmelden",
    ctaRegister: "Konto erstellen",
    ctaPublish: "Beitrag erstellen",
    ctaBrowse: "Entdecken",
    feature1: "Zufällige Videoanrufe",
    feature2: "Sofortnachrichten",
    feature3: "Live-Streams",
    feature4: "Globale Community",
    authLoginTitle: "Willkommen zurück!",
    authLoginSubtitle: "Melde dich an, um deine Community wiederzufinden",
    authRegisterTitle: "Werde Teil von Callo",
    authRegisterSubtitle: "Erstelle dein Konto und verbinde dich mit der Welt",
    authEmail: "E-Mail-Adresse",
    authPassword: "Passwort",
    authConfirmPassword: "Passwort bestätigen",
    authName: "Vollständiger Name",
    authUsername: "Benutzername",
    authDOB: "Geburtsdatum",
    authLanguages: "Gesprochene Sprachen",
    authForgotPassword: "Passwort vergessen?",
    authLoginLoading: "Anmeldung läuft...",
    authRegisterLoading: "Konto wird erstellt...",
    authNoAccount: "Noch kein Konto?",
    authSignUp: "Registrieren",
    authHaveAccount: "Schon ein Konto?",
    authSignIn: "Anmelden",
    verifySuccessTitle: "E-Mail erfolgreich verifiziert!",
    verifySuccessSubtitle: "Dein Callo-Konto wurde aktiviert. Du kannst dich jetzt anmelden und Menschen aus der ganzen Welt kennenlernen.",
    verifySuccessRedirect: "Automatische Weiterleitung zur Anmeldeseite in 5 Sekunden...",
    verifySuccessLoginNow: "Jetzt anmelden",
    verifyErrorTitle: "Verifizierung fehlgeschlagen",
    verifyErrorMissingToken: "Der Verifizierungslink ist unvollständig. Bitte nutze den vollständigen Link aus der E-Mail.",
    verifyErrorInvalidToken: "Dieser Verifizierungslink ist ungültig oder abgelaufen. Bitte fordere einen neuen Link an.",
    verifyErrorServer: "Bei der Verifizierung ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
    verifyErrorDefault: "Bei der Verifizierung deiner E-Mail ist ein Fehler aufgetreten.",
    verifyErrorCreateAccount: "Neues Konto erstellen",
    verifyErrorBackLogin: "Zurück zur Anmeldung",
    profileEditTitle: "Mein Profil bearbeiten",
    profileEditSubtitle: "Aktualisiere deine persönlichen Informationen",
    themeModeLight: "Heller Modus",
    themeModeDark: "Dunkler Modus",
    profileProfilePhoto: "Profilbild",
    profileFullName: "Vollständiger Name",
    profileUsername: "Benutzername",
    profileAgeAuto: "Automatisch aus deinem Geburtsdatum berechnet",
    profileDobFormatHint: "Tag/Monat/Jahr je nach Gerät",
    profileBio: "Bio",
    profileBioPlaceholder: "Erzähl uns etwas über dich...",
    profileCharsCount: "{count}/500 Zeichen",
    profileLocationAuto: "Automatisch per Geolokalisierung erkannt",
    liveDialogSubtitle: "8 Gäste · unbegrenzte Zuschauer",
    liveTitlePlaceholder: "Titel deines Lives...",
    liveQuickSuggestions: "Schnelle Vorschläge",
    liveSwipe: "Wischen",
    liveDescriptionOptional: "Beschreibung (optional)",
    liveStarting: "Wird gestartet...",
    liveStart: "Live starten",
    liveCreateLive: "Live erstellen",
    liveLaunchLive: "Ein Live starten",
    liveRandomCall: "Zufallsanruf",
    liveSuggestion1: "Komm, sprich mit mir!",
    liveSuggestion2: "🎥 Live-Fragen",
    liveSuggestion3: "🔥 Offene Debatte",
    liveSuggestion4: "🚀 Wir wachsen zusammen",
    liveSuggestion5: "💬 Komm in die Community",
    settingsTitle: "Einstellungen",
    settingsSubtitle: "Passe deine Callo-Erfahrung an",
    settingsPreferences: "Anruf-Einstellungen",
    settingsAccount: "Konto",
    settingsAppLanguageTitle: "App-Sprache",
    settingsAppLanguageDesc: "Lege die globale Anzeigesprache für Callo fest.",
    settingsLanguageSaved: "Sprache aktualisiert",
    postVideosTab: "Videos",
    landingTickerRandomVideo: "Kostenloser zufälliger Videochat",
    landingTickerAltOmegle: "Omegle-Alternative 2026",
    landingTickerLives: "Live-Streams",
    landingTickerMessaging: "Sofortnachrichten",
    landingTickerFree: "100% kostenlos",
    landingTickerUsers: "+50.000 Nutzer",
    landingTickerNoDownload: "Ohne Download",
    landingTickerAlwaysOn: "Verfügbar 24/7",
    landingHowBadge: "So einfach wie Hallo",
    landingHowTitle: "Wie",
    landingHowTitleAccent: "funktioniert es?",
    landingHowSubtitle: "Drei Schritte, um Menschen weltweit zu treffen",
    landingHowStep1Title: "Erstelle dein Profil",
    landingHowStep1Desc: "Kostenlose Anmeldung in 30 Sekunden. Wähle deine Sprachen und Interessen.",
    landingHowStep2Title: "Starte einen Anruf",
    landingHowStep2Desc: "Ein Klick verbindet dich zufällig per Video. Sofort.",
    landingHowStep3Title: "Vernetze dich",
    landingHowStep3Desc: "Füge deine Favoriten als Freunde hinzu, chatte privat und teile Momente.",
    landingFeaturesBadge: "Funktionen",
    landingFeaturesTitle: "Alles, was du",
    landingFeaturesTitleAccent: "brauchst",
    landingFeaturesSubtitle: "Eine komplette soziale Plattform für Videochat, Live-Streams und Nachrichten",
    landingFeatureGlobalTitle: "Globale Reichweite",
    landingFeatureGlobalDesc: "Triff Menschen in über 18 Ländern. Filtere nach Sprache, Region oder Interessen.",
    landingFeatureInstantTitle: "Sofortanrufe",
    landingFeatureInstantDesc: "Ein Klick für einen zufälligen Videoanruf. Unser Algorithmus matched dich in unter 3 Sekunden.",
    landingFeatureLivesTitle: "Live-Streams",
    landingFeatureLivesDesc: "Erstelle deinen eigenen Live-Stream oder tritt anderen bei. Unbegrenzte Zuschauer.",
    landingFeatureMessagingTitle: "Private Nachrichten",
    landingFeatureMessagingDesc: "Chatte in Echtzeit mit Freunden. Sende Texte, Fotos und Sprachnachrichten.",
    landingFeatureCommunityTitle: "Aktive Community",
    landingFeatureCommunityDesc: "Beiträge, Kommentare, trendige Hashtags. Ein echtes soziales Netzwerk integriert.",
    landingFeatureSecurityTitle: "Erhöhte Sicherheit",
    landingFeatureSecurityDesc: "Ende-zu-Ende-Verschlüsselung, KI-Moderation und voller Schutz deiner Privatsphäre.",
    landingTagPopular: "Beliebt",
    landingTagNew: "Neu",
    landingTestimonialsBadge: "Erfahrungsberichte",
    landingTestimonialsTitle: "Sie lieben",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Ich habe meine beste Freundin auf Callo kennengelernt! Wir sprechen jetzt jeden Tag. Es ist viel besser als Omegle.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "Der Zufallsanruf macht süchtig. Ich habe mit Leuten aus Japan, Brasilien, Deutschland gesprochen... unglaublich.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "Live-Streams sind super spaßig! Ich liebe die Stimmung und die Community. Und es ist 100% kostenlos, keine bösen Überraschungen.",
    landingCtaTitleLine1: "Bereit, die",
    landingCtaTitleLine2: "ganze Welt zu treffen?",
    landingCtaSubtitle: "Schließe dich Tausenden an, die Callo täglich nutzen, um sich zu verbinden, zu chatten und zu teilen.",
    landingCtaPrimary: "Mein kostenloses Konto erstellen",
    landingCtaSecondary: "Ich habe bereits ein Konto",
    landingFooterDesc: "Callo ist die beste kostenlose Alternative zu Omegle und Chatroulette. Zufälliger Videochat, Live-Streams, Nachrichten und soziales Netzwerk — alles in einer App.",
    landingFooterRegister: "Kostenlose Anmeldung",
    landingFooterLogin: "Anmelden",
    landingFooterDiscover: "Entdecken",
    landingFooterLive: "Live-Streams",
    landingFooterTerms: "Nutzungsbedingungen",
    landingFooterPrivacy: "Datenschutzerklärung",
    landingFooterLegal: "Impressum",
    landingStatFree: "Kostenlos",
    landingStatUsers: "Nutzer",
    landingStatCountries: "Länder",
    landingStatAvailable: "Verfügbar",
    landingCopyright: "© {year} Callo. Kostenloser zufälliger Videochat — Omegle- und Chatroulette-Alternative.",
    landingLegalPrefix: "Mit der Registrierung akzeptierst du unsere",
    landingLegalAnd: "und unsere",
    collapseSidebar: "Einklappen",
    expandSidebar: "Ausklappen",
    navDashboard: "Startseite",
    navLive: "Live",
    navMessages: "Nachrichten",
    navDiscover: "Entdecken",
    navNotifications: "Benachrichtigungen",
    navProfile: "Profil",
    navSettings: "Einstellungen",
    postCopyLink: "Link kopieren",
    postExternalShare: "Extern teilen",
    postReshare: "Erneut teilen",
    postReport: "Melden",
    postDeleteConfirm: "Diesen Beitrag löschen?",
    postShareError: "Fehler beim Teilen",
    postReactAction: "Reagieren",
    postCommentAction: "Kommentieren",
    postShareAction: "Teilen",
    postShowMore: "Mehr anzeigen",
    postReactionCount: "{count} Reaktion{plural}",
    postViewsWord: "Aufruf{plural}",
    reactionLike: "Gefällt mir",
    reactionLove: "Liebe ich",
    reactionHaha: "Haha",
    reactionWow: "Wow",
    reactionSad: "Traurig",
    reactionFire: "Feuer",
    reactionClap: "Applaus",
    profileVideoCalls: "Videoanrufe",
    profileCallsCompleted: "abgeschlossen",
    profileReputation: "Ruf",
    profilePositive: "positiv",
    profileRecentVisitorsTitle: "Letzte Besucher",
    profileRecentVisitorsSubtitle: "Personen, die dein Profil besucht haben",
    profileNoRecentVisitors: "Keine letzten Besucher",
    profileTabPosts: "Beiträge",
    profileTabVisitors: "Besucher",
    profileTopBadge: "Top",
    profileSeePhoto: "Foto größer ansehen",
    profileEditProfile: "Profil bearbeiten",
    profileBackToDiscover: "Entdecken",
    profileBack: "Zurück",
    profilePostsSectionTitle: "Beiträge",
    profileFilterAll: "Alle",
    profileFilterPhotos: "Fotos",
    profileFilterVideos: "Videos",
    profileFilterTexts: "Texte",
    profileNoPosts: "Noch keine Beiträge",
    profileNoPostsHint: "Beiträge werden hier angezeigt.",
    navLogout: "Abmelden",
  },
  it: {
    ...baseTranslations,
    settingsInstallBadgeNew: "Nuovo",
    theme: "Tema",
    language: "Lingua",
    changeLanguage: "Cambia lingua",
    selectLanguage: "Scegli una lingua",
    defaultFrench: "Francese predefinito",
    languageHint: "La tua scelta resta salvata finché non la cambi.",
    heroBadge: "+10.000 persone online ora",
    heroTitle: "Chat video casuale gratuita che connette il mondo",
    heroSubtitle: "Videochiamate, live, messaggi e post in un'interfaccia moderna.",
    ctaLogin: "Accedi",
    ctaRegister: "Crea account",
    ctaPublish: "Crea un post",
    ctaBrowse: "Scopri",
    feature1: "Videochiamate casuali",
    feature2: "Messaggistica istantanea",
    feature3: "Live streaming",
    feature4: "Community globale",
    authLoginTitle: "Bentornato!",
    authLoginSubtitle: "Accedi per ritrovare la tua community",
    authRegisterTitle: "Unisciti a Callo",
    authRegisterSubtitle: "Crea il tuo account e connettiti con il mondo",
    authEmail: "Indirizzo email",
    authPassword: "Password",
    authConfirmPassword: "Conferma password",
    authName: "Nome completo",
    authUsername: "Nome utente",
    authDOB: "Data di nascita",
    authLanguages: "Lingue parlate",
    authForgotPassword: "Password dimenticata?",
    authLoginLoading: "Accesso in corso...",
    authRegisterLoading: "Creazione account...",
    authNoAccount: "Non hai ancora un account?",
    authSignUp: "Iscriviti",
    authHaveAccount: "Hai già un account?",
    authSignIn: "Accedi",
    verifySuccessTitle: "Email verificata con successo!",
    verifySuccessSubtitle: "Il tuo account Callo è stato attivato. Ora puoi accedere e iniziare a conoscere persone da tutto il mondo.",
    verifySuccessRedirect: "Reindirizzamento automatico alla pagina di accesso tra 5 secondi...",
    verifySuccessLoginNow: "Accedi ora",
    verifyErrorTitle: "Verifica non riuscita",
    verifyErrorMissingToken: "Il link di verifica è incompleto. Usa il link completo ricevuto via email.",
    verifyErrorInvalidToken: "Questo link di verifica non è valido o è scaduto. Richiedine uno nuovo.",
    verifyErrorServer: "Si è verificato un errore durante la verifica. Riprova più tardi.",
    verifyErrorDefault: "Si è verificato un errore durante la verifica della tua email.",
    verifyErrorCreateAccount: "Crea un nuovo account",
    verifyErrorBackLogin: "Torna al login",
    profileEditTitle: "Modifica il mio profilo",
    profileEditSubtitle: "Aggiorna le tue informazioni personali",
    themeModeLight: "Modalità chiara",
    themeModeDark: "Modalità scura",
    profileProfilePhoto: "Foto profilo",
    profileFullName: "Nome completo",
    profileUsername: "Nome utente",
    profileAgeAuto: "Calcolata automaticamente dalla tua data di nascita",
    profileDobFormatHint: "Formato giorno/mese/anno in base al dispositivo",
    profileBio: "Bio",
    profileBioPlaceholder: "Parlaci di te...",
    profileCharsCount: "{count}/500 caratteri",
    profileLocationAuto: "Rilevata automaticamente tramite geolocalizzazione",
    liveDialogSubtitle: "8 ospiti · spettatori illimitati",
    liveTitlePlaceholder: "Titolo della tua live...",
    liveQuickSuggestions: "Suggerimenti rapidi",
    liveSwipe: "Scorri",
    liveDescriptionOptional: "Descrizione (opzionale)",
    liveStarting: "Avvio...",
    liveStart: "Avvia la live",
    liveCreateLive: "Crea una live",
    liveLaunchLive: "Avvia una live",
    liveRandomCall: "Chiamata casuale",
    liveSuggestion1: "Vieni a parlarmi!",
    liveSuggestion2: "🎥 Domande live",
    liveSuggestion3: "🔥 Dibattito aperto",
    liveSuggestion4: "🚀 Cresciamo insieme",
    liveSuggestion5: "💬 Unisciti alla famiglia",
    settingsTitle: "Impostazioni",
    settingsSubtitle: "Personalizza la tua esperienza Callo",
    settingsPreferences: "Preferenze chiamate",
    settingsAccount: "Account",
    settingsAppLanguageTitle: "Lingua dell'app",
    settingsAppLanguageDesc: "Imposta la lingua di visualizzazione globale di Callo.",
    settingsLanguageSaved: "Lingua aggiornata",
    postVideosTab: "Video",
    landingTickerRandomVideo: "Chat video casuale gratuito",
    landingTickerAltOmegle: "Alternativa a Omegle 2026",
    landingTickerLives: "Live in diretta",
    landingTickerMessaging: "Messaggistica istantanea",
    landingTickerFree: "100% gratis",
    landingTickerUsers: "+50.000 utenti",
    landingTickerNoDownload: "Senza download",
    landingTickerAlwaysOn: "Disponibile 24/7",
    landingHowBadge: "Facile come dire ciao",
    landingHowTitle: "Come",
    landingHowTitleAccent: "funziona?",
    landingHowSubtitle: "Tre passi per conoscere persone in tutto il mondo",
    landingHowStep1Title: "Crea il tuo profilo",
    landingHowStep1Desc: "Iscrizione gratuita in 30 secondi. Scegli le lingue e gli interessi.",
    landingHowStep2Title: "Avvia una chiamata",
    landingHowStep2Desc: "Un clic ti collega a qualcuno a caso in video. Istantaneo.",
    landingHowStep3Title: "Connettiti",
    landingHowStep3Desc: "Aggiungi i tuoi preferiti come amici, chatta in privato e condividi momenti.",
    landingFeaturesBadge: "Funzionalità",
    landingFeaturesTitle: "Tutto ciò di cui",
    landingFeaturesTitleAccent: "hai bisogno",
    landingFeaturesSubtitle: "Una piattaforma sociale completa di videochat, live streaming e messaggistica",
    landingFeatureGlobalTitle: "Portata globale",
    landingFeatureGlobalDesc: "Incontra persone in oltre 18 paesi. Filtra per lingua, regione o interessi.",
    landingFeatureInstantTitle: "Chiamate istantanee",
    landingFeatureInstantDesc: "Un clic per una videochiamata casuale. Il nostro algoritmo ti abbina in meno di 3 secondi.",
    landingFeatureLivesTitle: "Live in diretta",
    landingFeatureLivesDesc: "Crea la tua live o unisciti a quelle degli altri. Spettatori illimitati.",
    landingFeatureMessagingTitle: "Messaggistica privata",
    landingFeatureMessagingDesc: "Chatta in tempo reale con i tuoi amici. Invia testi, foto e messaggi vocali.",
    landingFeatureCommunityTitle: "Comunità attiva",
    landingFeatureCommunityDesc: "Post, commenti, hashtag di tendenza. Un vero social network integrato.",
    landingFeatureSecurityTitle: "Sicurezza avanzata",
    landingFeatureSecurityDesc: "Crittografia end-to-end, moderazione IA e pieno rispetto della tua privacy.",
    landingTagPopular: "Popolare",
    landingTagNew: "Nuovo",
    landingTestimonialsBadge: "Testimonianze",
    landingTestimonialsTitle: "Li adorano",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Ho incontrato la mia migliore amica su Callo! Ora ci sentiamo ogni giorno. È molto meglio di Omegle.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "La chiamata casuale crea dipendenza. Ho parlato con persone dal Giappone, Brasile, Germania... incredibile.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "Le live sono super divertenti! Adoro l’atmosfera e la community. Ed è 100% gratis, senza sorprese.",
    landingCtaTitleLine1: "Pronto a conoscere",
    landingCtaTitleLine2: "il mondo intero?",
    landingCtaSubtitle: "Unisciti a migliaia di persone che usano Callo ogni giorno per connettersi, chattare e condividere.",
    landingCtaPrimary: "Crea il mio account gratuito",
    landingCtaSecondary: "Ho già un account",
    landingFooterDesc: "Callo è la migliore alternativa gratuita a Omegle e Chatroulette. Chat video casuale, live streaming, messaggistica e social network — tutto in un’unica app.",
    landingFooterRegister: "Iscrizione gratuita",
    landingFooterLogin: "Accedi",
    landingFooterDiscover: "Scopri",
    landingFooterLive: "Live in diretta",
    landingFooterTerms: "Termini d’uso",
    landingFooterPrivacy: "Informativa sulla privacy",
    landingFooterLegal: "Note legali",
    landingStatFree: "Gratis",
    landingStatUsers: "Utenti",
    landingStatCountries: "Paesi",
    landingStatAvailable: "Disponibile",
    landingCopyright: "© {year} Callo. Chat video casuale gratuita — Alternativa a Omegle e Chatroulette.",
    landingLegalPrefix: "Registrandoti, accetti i nostri",
    landingLegalAnd: "e la nostra",
    collapseSidebar: "Comprimi",
    expandSidebar: "Espandi",
    navDashboard: "Home",
    navLive: "Live",
    navMessages: "Messaggi",
    navDiscover: "Scopri",
    navNotifications: "Notifiche",
    navProfile: "Profilo",
    navSettings: "Impostazioni",
    postCopyLink: "Copia link",
    postExternalShare: "Condividi esternamente",
    postReshare: "Ricondividi",
    postReport: "Segnala",
    postDeleteConfirm: "Eliminare questo post?",
    postShareError: "Errore di condivisione",
    postReactAction: "Reagisci",
    postCommentAction: "Commenta",
    postShareAction: "Condividi",
    postShowMore: "Mostra altro",
    postReactionCount: "{count} reazione{plural}",
    postViewsWord: "visualizzazione{plural}",
    reactionLike: "Mi piace",
    reactionLove: "Adoro",
    reactionHaha: "Haha",
    reactionWow: "Wow",
    reactionSad: "Triste",
    reactionFire: "Fuoco",
    reactionClap: "Applauso",
    profileVideoCalls: "Videochiamate",
    profileCallsCompleted: "completate",
    profileReputation: "Reputazione",
    profilePositive: "positiva",
    profileRecentVisitorsTitle: "Visitatori recenti",
    profileRecentVisitorsSubtitle: "Persone che hanno visualizzato il tuo profilo",
    profileNoRecentVisitors: "Nessun visitatore recente",
    profileTabPosts: "Post",
    profileTabVisitors: "Visitatori",
    profileTopBadge: "Top",
    profileSeePhoto: "Vedi foto grande",
    profileEditProfile: "Modifica profilo",
    profileBackToDiscover: "Esplora",
    profileBack: "Indietro",
    profilePostsSectionTitle: "Pubblicazioni",
    profileFilterAll: "Tutto",
    profileFilterPhotos: "Foto",
    profileFilterVideos: "Video",
    profileFilterTexts: "Testi",
    profileNoPosts: "Nessuna pubblicazione",
    profileNoPostsHint: "Le pubblicazioni appariranno qui.",
    navLogout: "Esci",
  },
  ar: {
    ...baseTranslations,
    settingsInstallBadgeNew: "جديد",
    landingTickerRandomVideo: "دردشة فيديو عشوائية مجانية",
    landingTickerAltOmegle: "بديل أوميغل 2026",
    landingTickerLives: "بث مباشر",
    landingTickerMessaging: "مراسلة فورية",
    landingTickerFree: "مجاني 100%",
    landingTickerUsers: "+50,000 مستخدم",
    landingTickerNoDownload: "بدون تحميل",
    landingTickerAlwaysOn: "متاح 24/7",
    landingHowBadge: "سهل مثل قول مرحبا",
    landingHowTitle: "كيف",
    landingHowTitleAccent: "يعمل؟",
    landingHowSubtitle: "ثلاث خطوات للتعرف على أشخاص من حول العالم",
    landingHowStep1Title: "أنشئ ملفك الشخصي",
    landingHowStep1Desc: "تسجيل مجاني خلال 30 ثانية. اختر لغاتك واهتماماتك.",
    landingHowStep2Title: "ابدأ مكالمة",
    landingHowStep2Desc: "نقرة واحدة توصلك بشخص عشوائي عبر الفيديو. فوري.",
    landingHowStep3Title: "تواصل",
    landingHowStep3Desc: "أضف المفضلين كأصدقاء، دردش على انفراد وشارك اللحظات.",
    landingFeaturesBadge: "الميزات",
    landingFeaturesTitle: "كل ما",
    landingFeaturesTitleAccent: "تحتاجه",
    landingFeaturesSubtitle: "منصة اجتماعية متكاملة للدردشة المرئية والبث المباشر والمراسلة",
    landingFeatureGlobalTitle: "انتشار عالمي",
    landingFeatureGlobalDesc: "تعرف على أشخاص من أكثر من 18 دولة. رشح حسب اللغة أو المنطقة أو الاهتمامات.",
    landingFeatureInstantTitle: "مكالمات فورية",
    landingFeatureInstantDesc: "نقرة واحدة لمكالمة فيديو عشوائية. خوارزميتنا تطابقك خلال أقل من 3 ثوان.",
    landingFeatureLivesTitle: "بث مباشر",
    landingFeatureLivesDesc: "أنشئ بثك الخاص أو انضم لغيرك. مشاهدون غير محدودين.",
    landingFeatureMessagingTitle: "مراسلة خاصة",
    landingFeatureMessagingDesc: "دردش في الوقت الحقيقي مع أصدقائك. أرسل نصوصا وصورا ورسائل صوتية.",
    landingFeatureCommunityTitle: "مجتمع نشط",
    landingFeatureCommunityDesc: "منشورات وتعليقات ووسوم رائجة. شبكة اجتماعية حقيقية مدمجة.",
    landingFeatureSecurityTitle: "أمان معزز",
    landingFeatureSecurityDesc: "تشفير طرفي إلى طرفي، إشراف بالذكاء الاصطناعي، واحترام كامل لخصوصيتك.",
    landingTagPopular: "شائع",
    landingTagNew: "جديد",
    landingTestimonialsBadge: "شهادات",
    landingTestimonialsTitle: "يحبونه",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "تعرفت على أفضل صديقة لي عبر Callo! نتحدث كل يوم الآن. إنه أفضل بكثير من Omegle.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "المكالمة العشوائية تسبب الإدمان. تحدثت مع أشخاص من اليابان والبرازيل وألمانيا... مذهل.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "البثوث المباشرة ممتعة جدا! أحب الأجواء والمجتمع. وهي مجانية 100% بلا مفاجآت سيئة.",
    landingCtaTitleLine1: "جاهز للتعرف على",
    landingCtaTitleLine2: "العالم كله؟",
    landingCtaSubtitle: "انضم إلى آلاف الأشخاص الذين يستخدمون Callo يوميا للتواصل والدردشة والمشاركة.",
    landingCtaPrimary: "أنشئ حسابي المجاني",
    landingCtaSecondary: "لدي حساب بالفعل",
    landingFooterDesc: "Callo هو أفضل بديل مجاني لـ Omegle وChatroulette. دردشة فيديو عشوائية وبث مباشر ومراسلة وشبكة اجتماعية — كلها في تطبيق واحد.",
    landingFooterRegister: "تسجيل مجاني",
    landingFooterLogin: "تسجيل الدخول",
    landingFooterDiscover: "اكتشف",
    landingFooterLive: "بث مباشر",
    landingFooterTerms: "شروط الاستخدام",
    landingFooterPrivacy: "سياسة الخصوصية",
    landingFooterLegal: "إشعار قانوني",
    landingStatFree: "مجاني",
    landingStatUsers: "مستخدمون",
    landingStatCountries: "دول",
    landingStatAvailable: "متاح",
    landingCopyright: "© {year} Callo. دردشة فيديو عشوائية مجانية — بديل Omegle و Chatroulette.",
    landingLegalPrefix: "بالتسجيل، فإنك توافق على",
    landingLegalAnd: "و",
    theme: "المظهر",
    language: "اللغة",
    changeLanguage: "تغيير اللغة",
    selectLanguage: "اختر لغة",
    defaultFrench: "الفرنسية افتراضيًا",
    languageHint: "يتم حفظ اختيارك حتى تغيّره لاحقًا.",
    heroBadge: "+10,000 شخص متصلون الآن",
    heroTitle: "دردشة فيديو عشوائية مجانية تربط العالم",
    heroSubtitle: "مكالمات فيديو وبث مباشر ومراسلة ومنشورات داخل واجهة عصرية.",
    ctaLogin: "تسجيل الدخول",
    ctaRegister: "إنشاء حساب",
    ctaPublish: "إنشاء منشور",
    ctaBrowse: "استكشاف",
    feature1: "مكالمات فيديو عشوائية",
    feature2: "مراسلة فورية",
    feature3: "بث مباشر",
    feature4: "مجتمع عالمي",
    authLoginTitle: "مرحبًا بعودتك!",
    authLoginSubtitle: "سجّل الدخول لتجد مجتمعك مرة أخرى",
    authRegisterTitle: "انضم إلى Callo",
    authRegisterSubtitle: "أنشئ حسابك وتواصل مع العالم",
    authEmail: "عنوان البريد الإلكتروني",
    authPassword: "كلمة المرور",
    authConfirmPassword: "تأكيد كلمة المرور",
    authName: "الاسم الكامل",
    authUsername: "اسم المستخدم",
    authDOB: "تاريخ الميلاد",
    authLanguages: "اللغات التي تتحدثها",
    authForgotPassword: "هل نسيت كلمة المرور؟",
    authLoginLoading: "جاري تسجيل الدخول...",
    authRegisterLoading: "جاري إنشاء الحساب...",
    authNoAccount: "ليس لديك حساب؟",
    authSignUp: "إنشاء حساب",
    authHaveAccount: "لديك حساب بالفعل؟",
    authSignIn: "تسجيل الدخول",
    verifySuccessTitle: "تم تأكيد البريد الإلكتروني بنجاح!",
    verifySuccessSubtitle: "تم تفعيل حسابك على Callo. يمكنك الآن تسجيل الدخول وبدء التعرف على أشخاص من جميع أنحاء العالم.",
    verifySuccessRedirect: "سيتم تحويلك تلقائيًا إلى صفحة تسجيل الدخول خلال 5 ثوان...",
    verifySuccessLoginNow: "تسجيل الدخول الآن",
    verifyErrorTitle: "فشل التحقق",
    verifyErrorMissingToken: "رابط التحقق غير مكتمل. يرجى استخدام الرابط الكامل المرسل عبر البريد الإلكتروني.",
    verifyErrorInvalidToken: "رابط التحقق هذا غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.",
    verifyErrorServer: "حدث خطأ أثناء التحقق. يرجى المحاولة لاحقًا.",
    verifyErrorDefault: "حدث خطأ أثناء التحقق من بريدك الإلكتروني.",
    verifyErrorCreateAccount: "إنشاء حساب جديد",
    verifyErrorBackLogin: "العودة إلى تسجيل الدخول",
    profileEditTitle: "تعديل ملفي الشخصي",
    profileEditSubtitle: "حدّث معلوماتك الشخصية",
    themeModeLight: "الوضع الفاتح",
    themeModeDark: "الوضع الداكن",
    profileProfilePhoto: "صورة الملف الشخصي",
    profileFullName: "الاسم الكامل",
    profileUsername: "اسم المستخدم",
    profileAgeAuto: "يتم حسابه تلقائيا من تاريخ ميلادك",
    profileDobFormatHint: "تنسيق يوم/شهر/سنة حسب جهازك",
    profileBio: "نبذة",
    profileBioPlaceholder: "أخبرنا عنك...",
    profileCharsCount: "{count}/500 حرف",
    profileLocationAuto: "يتم اكتشافه تلقائيا عبر تحديد الموقع",
    liveDialogSubtitle: "8 ضيوف · مشاهدون غير محدودين",
    liveTitlePlaceholder: "عنوان البث الخاص بك...",
    liveQuickSuggestions: "اقتراحات سريعة",
    liveSwipe: "اسحب",
    liveDescriptionOptional: "الوصف (اختياري)",
    liveStarting: "جار البدء...",
    liveStart: "بدء البث",
    liveCreateLive: "إنشاء بث",
    liveLaunchLive: "بدء بث مباشر",
    liveRandomCall: "مكالمة عشوائية",
    liveSuggestion1: "تعال وتحدث معي!",
    liveSuggestion2: "🎥 أسئلة مباشرة",
    liveSuggestion3: "🔥 نقاش مفتوح",
    liveSuggestion4: "🚀 لننطلق معا",
    liveSuggestion5: "💬 انضم إلى العائلة",
    settingsTitle: "الإعدادات",
    settingsSubtitle: "خصّص تجربتك في Callo",
    settingsPreferences: "تفضيلات المكالمات",
    settingsAccount: "الحساب",
    settingsAppLanguageTitle: "لغة التطبيق",
    settingsAppLanguageDesc: "حدّد لغة العرض العامة في Callo.",
    settingsLanguageSaved: "تم تحديث اللغة",
    postVideosTab: "فيديوهات",
    collapseSidebar: "طي",
    expandSidebar: "توسيع",
    navDashboard: "الرئيسية",
    navLive: "مباشر",
    navMessages: "الرسائل",
    navDiscover: "استكشاف",
    navNotifications: "الإشعارات",
    navProfile: "الملف الشخصي",
    navSettings: "الإعدادات",
    postCopyLink: "نسخ الرابط",
    postExternalShare: "مشاركة خارجية",
    postReshare: "إعادة المشاركة",
    postReport: "إبلاغ",
    postDeleteConfirm: "حذف هذا المنشور؟",
    postShareError: "خطأ في المشاركة",
    postReactAction: "تفاعل",
    postCommentAction: "تعليق",
    postShareAction: "مشاركة",
    postShowMore: "عرض المزيد",
    postReactionCount: "{count} تفاعل{plural}",
    postViewsWord: "مشاهدة{plural}",
    reactionLike: "إعجاب",
    reactionLove: "أحببته",
    reactionHaha: "هاها",
    reactionWow: "مذهل",
    reactionSad: "حزين",
    reactionFire: "ناري",
    reactionClap: "تصفيق",
    profileVideoCalls: "مكالمات الفيديو",
    profileCallsCompleted: "مكتملة",
    profileReputation: "السمعة",
    profilePositive: "إيجابية",
    profileRecentVisitorsTitle: "الزوار الجدد",
    profileRecentVisitorsSubtitle: "الأشخاص الذين زاروا ملفك الشخصي",
    profileNoRecentVisitors: "لا يوجد زوار حديثون",
    profileTabPosts: "المنشورات",
    profileTabVisitors: "الزوار",
    profileTopBadge: "الأفضل",
    profileSeePhoto: "عرض الصورة بحجم أكبر",
    profileEditProfile: "تعديل الملف الشخصي",
    profileBackToDiscover: "اكتشف",
    profileBack: "رجوع",
    profilePostsSectionTitle: "المنشورات",
    profileFilterAll: "الكل",
    profileFilterPhotos: "الصور",
    profileFilterVideos: "الفيديوهات",
    profileFilterTexts: "النصوص",
    profileNoPosts: "لا توجد منشورات بعد",
    profileNoPostsHint: "ستظهر المنشورات هنا.",
    navLogout: "تسجيل الخروج",
  },
  tr: {
    ...baseTranslations,
    settingsInstallBadgeNew: "Yeni",
    landingTickerRandomVideo: "Ücretsiz rastgele video sohbet",
    landingTickerAltOmegle: "Omegle alternatifi 2026",
    landingTickerLives: "Canlı yayınlar",
    landingTickerMessaging: "Anlık mesajlaşma",
    landingTickerFree: "%100 ücretsiz",
    landingTickerUsers: "+50.000 kullanıcı",
    landingTickerNoDownload: "İndirme yok",
    landingTickerAlwaysOn: "7/24 kullanılabilir",
    landingHowBadge: "Merhaba demek kadar kolay",
    landingHowTitle: "Nasıl",
    landingHowTitleAccent: "çalışır?",
    landingHowSubtitle: "Dünyadan insanlarla tanışmak için üç adım",
    landingHowStep1Title: "Profilini oluştur",
    landingHowStep1Desc: "30 saniyede ücretsiz kayıt. Dillerini ve ilgi alanlarını seç.",
    landingHowStep2Title: "Arama başlat",
    landingHowStep2Desc: "Bir tıkla rastgele birine video ile bağlan. Anında.",
    landingHowStep3Title: "Bağlan",
    landingHowStep3Desc: "Favorilerini arkadaş olarak ekle, özel sohbet et ve anılar paylaş.",
    landingFeaturesBadge: "Özellikler",
    landingFeaturesTitle: "İhtiyacın olan",
    landingFeaturesTitleAccent: "her şey",
    landingFeaturesSubtitle: "Video sohbet, canlı yayın ve mesajlaşma için eksiksiz sosyal platform",
    landingFeatureGlobalTitle: "Küresel erişim",
    landingFeatureGlobalDesc: "18'den fazla ülkeden insanlarla tanış. Dil, bölge veya ilgi alanına göre filtrele.",
    landingFeatureInstantTitle: "Anlık aramalar",
    landingFeatureInstantDesc: "Rastgele video arama için tek tık. Algoritmamız seni 3 saniyeden kısa sürede eşleştirir.",
    landingFeatureLivesTitle: "Canlı yayınlar",
    landingFeatureLivesDesc: "Kendi canlı yayınını aç veya diğerlerine katıl. Sınırsız izleyici.",
    landingFeatureMessagingTitle: "Özel mesajlaşma",
    landingFeatureMessagingDesc: "Arkadaşlarınla gerçek zamanlı sohbet et. Metin, foto ve sesli mesaj gönder.",
    landingFeatureCommunityTitle: "Aktif topluluk",
    landingFeatureCommunityDesc: "Gönderiler, yorumlar, trend hashtagler. Gerçek bir sosyal ağ entegre.",
    landingFeatureSecurityTitle: "Gelişmiş güvenlik",
    landingFeatureSecurityDesc: "Uçtan uca şifreleme, YZ moderasyonu ve gizliliğine tam saygı.",
    landingTagPopular: "Popüler",
    landingTagNew: "Yeni",
    landingTestimonialsBadge: "Kullanıcı yorumları",
    landingTestimonialsTitle: "Bayılıyorlar",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Callo'da en iyi arkadaşımı tanıdım! Artık her gün konuşuyoruz. Omegle'dan çok daha iyi.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "Rastgele arama bağımlılık yapıyor. Japonya, Brezilya, Almanya'dan insanlarla konuştum... inanılmaz.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "Canlı yayınlar çok eğlenceli! Ortamı ve topluluğu seviyorum. Ve %100 ücretsiz, kötü sürpriz yok.",
    landingCtaTitleLine1: "Dünyayı tanımaya",
    landingCtaTitleLine2: "hazır mısın?",
    landingCtaSubtitle: "Bağlanmak, sohbet etmek ve paylaşmak için Callo'yu her gün kullanan binlerce kişiye katıl.",
    landingCtaPrimary: "Ücretsiz hesabımı oluştur",
    landingCtaSecondary: "Zaten hesabım var",
    landingFooterDesc: "Callo, Omegle ve Chatroulette için en iyi ücretsiz alternatiftir. Rastgele video sohbet, canlı yayın, mesajlaşma ve sosyal ağ — hepsi tek uygulamada.",
    landingFooterRegister: "Ücretsiz kayıt",
    landingFooterLogin: "Giriş yap",
    landingFooterDiscover: "Keşfet",
    landingFooterLive: "Canlı yayınlar",
    landingFooterTerms: "Kullanım şartları",
    landingFooterPrivacy: "Gizlilik politikası",
    landingFooterLegal: "Yasal bildirim",
    landingStatFree: "Ücretsiz",
    landingStatUsers: "Kullanıcı",
    landingStatCountries: "Ülke",
    landingStatAvailable: "Müsait",
    landingCopyright: "© {year} Callo. Ücretsiz rastgele görüntülü sohbet — Omegle ve Chatroulette alternatifi.",
    landingLegalPrefix: "Kaydolarak",
    landingLegalAnd: "ve",
    theme: "Tema",
    language: "Dil",
    changeLanguage: "Dili değiştir",
    selectLanguage: "Dil seç",
    defaultFrench: "Varsayılan Fransızca",
    languageHint: "Seçiminiz değiştirene kadar kaydedilir.",
    heroBadge: "+10.000 kişi şu anda çevrimiçi",
    heroTitle: "Dünyayı bağlayan ücretsiz rastgele görüntülü sohbet",
    heroSubtitle: "Modern bir arayüzde görüntülü aramalar, canlı yayınlar, mesajlaşma ve paylaşımlar.",
    ctaLogin: "Giriş yap",
    ctaRegister: "Hesap oluştur",
    ctaPublish: "Gönderi oluştur",
    ctaBrowse: "Keşfet",
    feature1: "Rastgele görüntülü aramalar",
    feature2: "Anlık mesajlaşma",
    feature3: "Canlı yayınlar",
    feature4: "Küresel topluluk",
    authLoginTitle: "Tekrar hoş geldin!",
    authLoginSubtitle: "Topluluğunu yeniden bulmak için giriş yap",
    authRegisterTitle: "Callo'ya katıl",
    authRegisterSubtitle: "Hesabını oluştur ve dünyayla bağlantı kur",
    authEmail: "E-posta adresi",
    authPassword: "Şifre",
    authConfirmPassword: "Şifreyi onayla",
    authName: "Ad soyad",
    authUsername: "Kullanıcı adı",
    authDOB: "Doğum tarihi",
    authLanguages: "Konuşulan diller",
    authForgotPassword: "Şifreni mi unuttun?",
    authLoginLoading: "Giriş yapılıyor...",
    authRegisterLoading: "Hesap oluşturuluyor...",
    authNoAccount: "Henüz hesabın yok mu?",
    authSignUp: "Kaydol",
    authHaveAccount: "Zaten hesabın var mı?",
    authSignIn: "Giriş yap",
    verifySuccessTitle: "E-posta başarıyla doğrulandı!",
    verifySuccessSubtitle: "Callo hesabınız etkinleştirildi. Artık giriş yapabilir ve dünyanın her yerinden insanlarla tanışabilirsiniz.",
    verifySuccessRedirect: "5 saniye içinde giriş sayfasına otomatik yönlendirileceksiniz...",
    verifySuccessLoginNow: "Şimdi giriş yap",
    verifyErrorTitle: "Doğrulama başarısız",
    verifyErrorMissingToken: "Doğrulama bağlantısı eksik. Lütfen e-postadaki tam bağlantıyı kullanın.",
    verifyErrorInvalidToken: "Bu doğrulama bağlantısı geçersiz veya süresi dolmuş. Lütfen yeni bir bağlantı isteyin.",
    verifyErrorServer: "Doğrulama sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
    verifyErrorDefault: "E-postanız doğrulanırken bir hata oluştu.",
    verifyErrorCreateAccount: "Yeni hesap oluştur",
    verifyErrorBackLogin: "Girişe dön",
    profileEditTitle: "Profilimi düzenle",
    profileEditSubtitle: "Kişisel bilgilerinizi güncelleyin",
    themeModeLight: "Açık mod",
    themeModeDark: "Koyu mod",
    profileProfilePhoto: "Profil fotoğrafı",
    profileFullName: "Tam ad",
    profileUsername: "Kullanıcı adı",
    profileAgeAuto: "Doğum tarihinize göre otomatik hesaplanır",
    profileDobFormatHint: "Cihaza göre gün/ay/yıl formatı",
    profileBio: "Biyografi",
    profileBioPlaceholder: "Kendinden bahset...",
    profileCharsCount: "{count}/500 karakter",
    profileLocationAuto: "Coğrafi konumla otomatik algılanır",
    liveDialogSubtitle: "8 davetli · sınırsız izleyici",
    liveTitlePlaceholder: "Canlı yayın başlığın...",
    liveQuickSuggestions: "Hızlı öneriler",
    liveSwipe: "Kaydır",
    liveDescriptionOptional: "Açıklama (isteğe bağlı)",
    liveStarting: "Başlatılıyor...",
    liveStart: "Canlı yayını başlat",
    liveCreateLive: "Canlı yayın oluştur",
    liveLaunchLive: "Canlı yayın başlat",
    liveRandomCall: "Rastgele arama",
    liveSuggestion1: "Benimle konuş!",
    liveSuggestion2: "🎥 Canlı sorular",
    liveSuggestion3: "🔥 Açık tartışma",
    liveSuggestion4: "🚀 Birlikte yükseliyoruz",
    liveSuggestion5: "💬 Aileye katıl",
    settingsTitle: "Ayarlar",
    settingsSubtitle: "Callo deneyimini kişiselleştir",
    settingsPreferences: "Arama tercihleri",
    settingsAccount: "Hesap",
    settingsAppLanguageTitle: "Uygulama dili",
    settingsAppLanguageDesc: "Callo için genel görüntüleme dilini ayarla.",
    settingsLanguageSaved: "Dil güncellendi",
    postVideosTab: "Videolar",
    collapseSidebar: "Daralt",
    expandSidebar: "Genişlet",
    navDashboard: "Ana sayfa",
    navLive: "Canlı",
    navMessages: "Mesajlar",
    navDiscover: "Keşfet",
    navNotifications: "Bildirimler",
    navProfile: "Profil",
    navSettings: "Ayarlar",
    postCopyLink: "Bağlantıyı kopyala",
    postExternalShare: "Harici paylaş",
    postReshare: "Yeniden paylaş",
    postReport: "Bildir",
    postDeleteConfirm: "Bu gönderi silinsin mi?",
    postShareError: "Paylaşım hatası",
    postReactAction: "Tepki ver",
    postCommentAction: "Yorum yap",
    postShareAction: "Paylaş",
    postShowMore: "Daha fazla göster",
    postReactionCount: "{count} tepki{plural}",
    postViewsWord: "görüntüleme{plural}",
    reactionLike: "Beğen",
    reactionLove: "Bayıldım",
    reactionHaha: "Haha",
    reactionWow: "Vay",
    reactionSad: "Üzgün",
    reactionFire: "Ateş",
    reactionClap: "Alkış",
    profileVideoCalls: "Görüntülü aramalar",
    profileCallsCompleted: "tamamlandı",
    profileReputation: "İtibar",
    profilePositive: "pozitif",
    profileRecentVisitorsTitle: "Son ziyaretçiler",
    profileRecentVisitorsSubtitle: "Profilinizi görüntüleyen kişiler",
    profileNoRecentVisitors: "Son ziyaretçi yok",
    profileTabPosts: "Gönderiler",
    profileTabVisitors: "Ziyaretçiler",
    profileTopBadge: "En iyi",
    profileSeePhoto: "Fotoğrafı büyük göster",
    profileEditProfile: "Profili düzenle",
    profileBackToDiscover: "Keşfet",
    profileBack: "Geri",
    profilePostsSectionTitle: "Gönderiler",
    profileFilterAll: "Tümü",
    profileFilterPhotos: "Fotoğraflar",
    profileFilterVideos: "Videolar",
    profileFilterTexts: "Metinler",
    profileNoPosts: "Henüz gönderi yok",
    profileNoPostsHint: "Gönderiler burada görünecek.",
    navLogout: "Çıkış yap",
  },
  nl: {
    ...baseTranslations,
    settingsInstallBadgeNew: "Nieuw",
    landingTickerRandomVideo: "Gratis willekeurige videochat",
    landingTickerAltOmegle: "Omegle-alternatief 2026",
    landingTickerLives: "Live streams",
    landingTickerMessaging: "Directe berichten",
    landingTickerFree: "100% gratis",
    landingTickerUsers: "+50.000 gebruikers",
    landingTickerNoDownload: "Geen download",
    landingTickerAlwaysOn: "Beschikbaar 24/7",
    landingHowBadge: "Zo makkelijk als hallo zeggen",
    landingHowTitle: "Hoe",
    landingHowTitleAccent: "werkt het?",
    landingHowSubtitle: "Drie stappen om mensen wereldwijd te ontmoeten",
    landingHowStep1Title: "Maak je profiel",
    landingHowStep1Desc: "Gratis inschrijven in 30 seconden. Kies je talen en interesses.",
    landingHowStep2Title: "Start een call",
    landingHowStep2Desc: "Eén klik verbindt je willekeurig via video. Direct.",
    landingHowStep3Title: "Verbind",
    landingHowStep3Desc: "Voeg je favorieten toe als vrienden, chat privé en deel momenten.",
    landingFeaturesBadge: "Functies",
    landingFeaturesTitle: "Alles wat je",
    landingFeaturesTitleAccent: "nodig hebt",
    landingFeaturesSubtitle: "Een volledig sociaal platform voor videochat, live streaming en berichten",
    landingFeatureGlobalTitle: "Wereldwijd bereik",
    landingFeatureGlobalDesc: "Ontmoet mensen uit meer dan 18 landen. Filter op taal, regio of interesses.",
    landingFeatureInstantTitle: "Directe calls",
    landingFeatureInstantDesc: "Eén klik voor een willekeurige videocall. Ons algoritme matcht je binnen 3 seconden.",
    landingFeatureLivesTitle: "Live streams",
    landingFeatureLivesDesc: "Maak je eigen live of sluit je aan bij anderen. Onbeperkte kijkers.",
    landingFeatureMessagingTitle: "Privéberichten",
    landingFeatureMessagingDesc: "Chat in realtime met vrienden. Stuur tekst, foto's en spraakberichten.",
    landingFeatureCommunityTitle: "Actieve community",
    landingFeatureCommunityDesc: "Berichten, reacties, trending hashtags. Een echt sociaal netwerk geïntegreerd.",
    landingFeatureSecurityTitle: "Verhoogde beveiliging",
    landingFeatureSecurityDesc: "End-to-end encryptie, AI-moderatie en volledige respect voor je privacy.",
    landingTagPopular: "Populair",
    landingTagNew: "Nieuw",
    landingTestimonialsBadge: "Getuigenissen",
    landingTestimonialsTitle: "Ze zijn dol op",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Ik heb mijn beste vriendin op Callo ontmoet! We praten nu elke dag. Het is veel beter dan Omegle.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "De willekeurige call is verslavend. Ik sprak met mensen uit Japan, Brazilië, Duitsland... ongelooflijk.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "Live streams zijn superleuk! Ik hou van de sfeer en community. En het is 100% gratis, geen nare verrassingen.",
    landingCtaTitleLine1: "Klaar om",
    landingCtaTitleLine2: "de hele wereld te ontmoeten?",
    landingCtaSubtitle: "Sluit je aan bij duizenden mensen die Callo elke dag gebruiken om te verbinden, chatten en delen.",
    landingCtaPrimary: "Maak mijn gratis account",
    landingCtaSecondary: "Ik heb al een account",
    landingFooterDesc: "Callo is het beste gratis alternatief voor Omegle en Chatroulette. Willekeurige videochat, live streaming, berichten en sociaal netwerk — alles in één app.",
    landingFooterRegister: "Gratis registratie",
    landingFooterLogin: "Inloggen",
    landingFooterDiscover: "Ontdekken",
    landingFooterLive: "Live streams",
    landingFooterTerms: "Gebruiksvoorwaarden",
    landingFooterPrivacy: "Privacybeleid",
    landingFooterLegal: "Wettelijke vermeldingen",
    landingStatFree: "Gratis",
    landingStatUsers: "Gebruikers",
    landingStatCountries: "Landen",
    landingStatAvailable: "Beschikbaar",
    landingCopyright: "© {year} Callo. Gratis willekeurige videochat — alternatief voor Omegle en Chatroulette.",
    landingLegalPrefix: "Door je aan te melden ga je akkoord met onze",
    landingLegalAnd: "en ons",
    theme: "Thema",
    language: "Taal",
    changeLanguage: "Taal wijzigen",
    selectLanguage: "Kies een taal",
    defaultFrench: "Standaard Frans",
    languageHint: "Je keuze blijft opgeslagen totdat je die wijzigt.",
    heroBadge: "+10.000 mensen nu online",
    heroTitle: "Gratis willekeurige videochat die de wereld verbindt",
    heroSubtitle: "Video-oproepen, live streams, berichten en posts in een moderne interface.",
    ctaLogin: "Inloggen",
    ctaRegister: "Account aanmaken",
    ctaPublish: "Bericht maken",
    ctaBrowse: "Ontdekken",
    feature1: "Willekeurige video-oproepen",
    feature2: "Direct berichten",
    feature3: "Live streams",
    feature4: "Wereldwijde community",
    authLoginTitle: "Welkom terug!",
    authLoginSubtitle: "Log in om je community terug te vinden",
    authRegisterTitle: "Word lid van Callo",
    authRegisterSubtitle: "Maak je account aan en verbind met de wereld",
    authEmail: "E-mailadres",
    authPassword: "Wachtwoord",
    authConfirmPassword: "Wachtwoord bevestigen",
    authName: "Volledige naam",
    authUsername: "Gebruikersnaam",
    authDOB: "Geboortedatum",
    authLanguages: "Gesproken talen",
    authForgotPassword: "Wachtwoord vergeten?",
    authLoginLoading: "Aanmelden...",
    authRegisterLoading: "Account wordt aangemaakt...",
    authNoAccount: "Nog geen account?",
    authSignUp: "Registreren",
    authHaveAccount: "Al een account?",
    authSignIn: "Inloggen",
    verifySuccessTitle: "E-mail succesvol geverifieerd!",
    verifySuccessSubtitle: "Je Callo-account is geactiveerd. Je kunt nu inloggen en mensen van over de hele wereld ontmoeten.",
    verifySuccessRedirect: "Automatische doorverwijzing naar de inlogpagina over 5 seconden...",
    verifySuccessLoginNow: "Nu inloggen",
    verifyErrorTitle: "Verificatie mislukt",
    verifyErrorMissingToken: "De verificatielink is onvolledig. Gebruik de volledige link uit de e-mail.",
    verifyErrorInvalidToken: "Deze verificatielink is ongeldig of verlopen. Vraag een nieuwe link aan.",
    verifyErrorServer: "Er is een fout opgetreden tijdens de verificatie. Probeer het later opnieuw.",
    verifyErrorDefault: "Er is een fout opgetreden bij het verifiëren van je e-mail.",
    verifyErrorCreateAccount: "Nieuw account aanmaken",
    verifyErrorBackLogin: "Terug naar inloggen",
    profileEditTitle: "Mijn profiel bewerken",
    profileEditSubtitle: "Werk je persoonlijke gegevens bij",
    themeModeLight: "Lichte modus",
    themeModeDark: "Donkere modus",
    profileProfilePhoto: "Profielfoto",
    profileFullName: "Volledige naam",
    profileUsername: "Gebruikersnaam",
    profileAgeAuto: "Automatisch berekend op basis van je geboortedatum",
    profileDobFormatHint: "Dag/maand/jaar-formaat volgens je apparaat",
    profileBio: "Bio",
    profileBioPlaceholder: "Vertel iets over jezelf...",
    profileCharsCount: "{count}/500 tekens",
    profileLocationAuto: "Automatisch gedetecteerd via geolocatie",
    liveDialogSubtitle: "8 gasten · onbeperkte kijkers",
    liveTitlePlaceholder: "Titel van je live...",
    liveQuickSuggestions: "Snelle suggesties",
    liveSwipe: "Vegen",
    liveDescriptionOptional: "Beschrijving (optioneel)",
    liveStarting: "Starten...",
    liveStart: "Live starten",
    liveCreateLive: "Live maken",
    liveLaunchLive: "Een live starten",
    liveRandomCall: "Willekeurige oproep",
    liveSuggestion1: "Kom met me praten!",
    liveSuggestion2: "🎥 Live vragen",
    liveSuggestion3: "🔥 Open debat",
    liveSuggestion4: "🚀 We groeien samen",
    liveSuggestion5: "💬 Word deel van de familie",
    settingsTitle: "Instellingen",
    settingsSubtitle: "Personaliseer je Callo-ervaring",
    settingsPreferences: "Belvoorkeuren",
    settingsAccount: "Account",
    settingsAppLanguageTitle: "App-taal",
    settingsAppLanguageDesc: "Stel de algemene weergavetaal van Callo in.",
    settingsLanguageSaved: "Taal bijgewerkt",
    postVideosTab: "Video's",
    collapseSidebar: "Inklappen",
    expandSidebar: "Uitklappen",
    navDashboard: "Start",
    navLive: "Live",
    navMessages: "Berichten",
    navDiscover: "Ontdekken",
    navNotifications: "Meldingen",
    navProfile: "Profiel",
    navSettings: "Instellingen",
    postCopyLink: "Link kopiëren",
    postExternalShare: "Extern delen",
    postReshare: "Opnieuw delen",
    postReport: "Melden",
    postDeleteConfirm: "Dit bericht verwijderen?",
    postShareError: "Fout bij delen",
    postReactAction: "Reageren",
    postCommentAction: "Reageren",
    postShareAction: "Delen",
    postShowMore: "Meer tonen",
    postReactionCount: "{count} reactie{plural}",
    postViewsWord: "weergave{plural}",
    reactionLike: "Vind ik leuk",
    reactionLove: "Geweldig",
    reactionHaha: "Haha",
    reactionWow: "Wauw",
    reactionSad: "Verdrietig",
    reactionFire: "Vuur",
    reactionClap: "Applaus",
    profileVideoCalls: "Videogesprekken",
    profileCallsCompleted: "voltooid",
    profileReputation: "Reputatie",
    profilePositive: "positief",
    profileRecentVisitorsTitle: "Recente bezoekers",
    profileRecentVisitorsSubtitle: "Mensen die je profiel hebben bekeken",
    profileNoRecentVisitors: "Geen recente bezoekers",
    profileTabPosts: "Berichten",
    profileTabVisitors: "Bezoekers",
    profileCopyLink: "Link kopiëren",
    profileShareProfile: "Profiel delen",
    profileBlockUser: "Deze gebruiker blokkeren",
    profileReportUser: "Rapporteren",
    profileTopBadge: "Top",
    profileSeePhoto: "Foto groter bekijken",
    profileEditProfile: "Profiel bewerken",
    profileBackToDiscover: "Ontdekken",
    profileBack: "Terug",
    profilePostsSectionTitle: "Berichten",
    profileFilterAll: "Alles",
    profileFilterPhotos: "Foto's",
    profileFilterVideos: "Video's",
    profileFilterTexts: "Teksten",
    profileNoPosts: "Nog geen berichten",
    profileNoPostsHint: "Berichten verschijnen hier.",
    navLogout: "Uitloggen",
  },
  ru: {
    ...baseTranslations,
    settingsInstallBadgeNew: "Новое",
    landingTickerRandomVideo: "Бесплатный случайный видеочат",
    landingTickerAltOmegle: "Альтернатива Omegle 2026",
    landingTickerLives: "Прямые эфиры",
    landingTickerMessaging: "Мгновенные сообщения",
    landingTickerFree: "100% бесплатно",
    landingTickerUsers: "+50 000 пользователей",
    landingTickerNoDownload: "Без скачивания",
    landingTickerAlwaysOn: "Доступно 24/7",
    landingHowBadge: "Просто как сказать привет",
    landingHowTitle: "Как",
    landingHowTitleAccent: "это работает?",
    landingHowSubtitle: "Три шага, чтобы познакомиться с людьми по всему миру",
    landingHowStep1Title: "Создайте профиль",
    landingHowStep1Desc: "Бесплатная регистрация за 30 секунд. Выберите языки и интересы.",
    landingHowStep2Title: "Начните звонок",
    landingHowStep2Desc: "Один клик соединяет с человеком случайно по видео. Мгновенно.",
    landingHowStep3Title: "Общайтесь",
    landingHowStep3Desc: "Добавляйте избранных в друзья, общайтесь приватно и делитесь моментами.",
    landingFeaturesBadge: "Функции",
    landingFeaturesTitle: "Все, что",
    landingFeaturesTitleAccent: "нужно",
    landingFeaturesSubtitle: "Полноценная социальная платформа для видеочата, стримов и сообщений",
    landingFeatureGlobalTitle: "Глобальный охват",
    landingFeatureGlobalDesc: "Знакомьтесь с людьми из более чем 18 стран. Фильтруйте по языку, региону или интересам.",
    landingFeatureInstantTitle: "Мгновенные звонки",
    landingFeatureInstantDesc: "Один клик — случайный видеозвонок. Алгоритм подбирает за менее чем 3 секунды.",
    landingFeatureLivesTitle: "Прямые эфиры",
    landingFeatureLivesDesc: "Создайте свой эфир или присоединяйтесь к другим. Неограниченное количество зрителей.",
    landingFeatureMessagingTitle: "Личные сообщения",
    landingFeatureMessagingDesc: "Общайтесь с друзьями в реальном времени. Отправляйте тексты, фото и голосовые сообщения.",
    landingFeatureCommunityTitle: "Активное сообщество",
    landingFeatureCommunityDesc: "Публикации, комментарии, трендовые хэштеги. Настоящая социальная сеть.",
    landingFeatureSecurityTitle: "Повышенная безопасность",
    landingFeatureSecurityDesc: "Сквозное шифрование, модерация ИИ и полное уважение к приватности.",
    landingTagPopular: "Популярно",
    landingTagNew: "Новое",
    landingTestimonialsBadge: "Отзывы",
    landingTestimonialsTitle: "Им нравится",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Я нашла лучшую подругу на Callo! Теперь мы общаемся каждый день. Это намного лучше, чем Omegle.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "Случайный звонок затягивает. Я говорил с людьми из Японии, Бразилии, Германии... невероятно.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "Прямые эфиры очень веселые! Мне нравится атмосфера и сообщество. И это на 100% бесплатно, без неприятных сюрпризов.",
    landingCtaTitleLine1: "Готовы познакомиться",
    landingCtaTitleLine2: "со всем миром?",
    landingCtaSubtitle: "Присоединяйтесь к тысячам людей, которые используют Callo каждый день, чтобы общаться и делиться.",
    landingCtaPrimary: "Создать бесплатный аккаунт",
    landingCtaSecondary: "У меня уже есть аккаунт",
    landingFooterDesc: "Callo — лучшая бесплатная альтернатива Omegle и Chatroulette. Случайный видеочат, прямые эфиры, сообщения и социальная сеть — все в одном приложении.",
    landingFooterRegister: "Бесплатная регистрация",
    landingFooterLogin: "Войти",
    landingFooterDiscover: "Открыть",
    landingFooterLive: "Прямые эфиры",
    landingFooterTerms: "Условия использования",
    landingFooterPrivacy: "Политика конфиденциальности",
    landingFooterLegal: "Юридическая информация",
    landingStatFree: "Бесплатно",
    landingStatUsers: "Пользователи",
    landingStatCountries: "Страны",
    landingStatAvailable: "Доступно",
    landingCopyright: "© {year} Callo. Бесплатный случайный видеочат — альтернатива Omegle и Chatroulette.",
    landingLegalPrefix: "Регистрируясь, вы принимаете наши",
    landingLegalAnd: "и нашу",
    theme: "Тема",
    language: "Язык",
    changeLanguage: "Сменить язык",
    selectLanguage: "Выберите язык",
    defaultFrench: "Французский по умолчанию",
    languageHint: "Ваш выбор сохраняется, пока вы его не измените.",
    heroBadge: "+10 000 человек онлайн прямо сейчас",
    heroTitle: "Бесплатный случайный видеочат, соединяющий мир",
    heroSubtitle: "Видеозвонки, прямые эфиры, сообщения и публикации в современном интерфейсе.",
    ctaLogin: "Войти",
    ctaRegister: "Создать аккаунт",
    ctaPublish: "Создать публикацию",
    ctaBrowse: "Открыть",
    feature1: "Случайные видеозвонки",
    feature2: "Мгновенные сообщения",
    feature3: "Прямые эфиры",
    feature4: "Глобальное сообщество",
    authLoginTitle: "С возвращением!",
    authLoginSubtitle: "Войдите, чтобы снова найти своё сообщество",
    authRegisterTitle: "Присоединяйтесь к Callo",
    authRegisterSubtitle: "Создайте аккаунт и подключитесь к миру",
    authEmail: "Адрес электронной почты",
    authPassword: "Пароль",
    authConfirmPassword: "Подтвердите пароль",
    authName: "Полное имя",
    authUsername: "Имя пользователя",
    authDOB: "Дата рождения",
    authLanguages: "Разговорные языки",
    authForgotPassword: "Забыли пароль?",
    authLoginLoading: "Вход...",
    authRegisterLoading: "Создание аккаунта...",
    authNoAccount: "Ещё нет аккаунта?",
    authSignUp: "Зарегистрироваться",
    authHaveAccount: "Уже есть аккаунт?",
    authSignIn: "Войти",
    verifySuccessTitle: "Email успешно подтверждён!",
    verifySuccessSubtitle: "Ваш аккаунт Callo активирован. Теперь вы можете войти и знакомиться с людьми со всего мира.",
    verifySuccessRedirect: "Автоматический переход на страницу входа через 5 секунд...",
    verifySuccessLoginNow: "Войти сейчас",
    verifyErrorTitle: "Ошибка подтверждения",
    verifyErrorMissingToken: "Ссылка подтверждения неполная. Используйте полную ссылку из письма.",
    verifyErrorInvalidToken: "Эта ссылка подтверждения недействительна или истекла. Запросите новую ссылку.",
    verifyErrorServer: "Во время подтверждения произошла ошибка. Попробуйте позже.",
    verifyErrorDefault: "Произошла ошибка при подтверждении вашей почты.",
    verifyErrorCreateAccount: "Создать новый аккаунт",
    verifyErrorBackLogin: "Назад ко входу",
    profileEditTitle: "Редактировать профиль",
    profileEditSubtitle: "Обновите личную информацию",
    themeModeLight: "Светлая тема",
    themeModeDark: "Темная тема",
    profileProfilePhoto: "Фото профиля",
    profileFullName: "Полное имя",
    profileUsername: "Имя пользователя",
    profileAgeAuto: "Автоматически рассчитывается по дате рождения",
    profileDobFormatHint: "Формат день/месяц/год в зависимости от устройства",
    profileBio: "Био",
    profileBioPlaceholder: "Расскажите о себе...",
    profileCharsCount: "{count}/500 символов",
    profileLocationAuto: "Определяется автоматически по геолокации",
    liveDialogSubtitle: "8 гостей · неограниченно зрителей",
    liveTitlePlaceholder: "Название вашего эфира...",
    liveQuickSuggestions: "Быстрые подсказки",
    liveSwipe: "Листать",
    liveDescriptionOptional: "Описание (необязательно)",
    liveStarting: "Запуск...",
    liveStart: "Начать эфир",
    liveCreateLive: "Создать эфир",
    liveLaunchLive: "Запустить эфир",
    liveRandomCall: "Случайный звонок",
    liveSuggestion1: "Давай пообщаемся!",
    liveSuggestion2: "🎥 Вопросы в прямом эфире",
    liveSuggestion3: "🔥 Открытая дискуссия",
    liveSuggestion4: "🚀 Растем вместе",
    liveSuggestion5: "💬 Присоединяйся к семье",
    settingsTitle: "Настройки",
    settingsSubtitle: "Настройте свой опыт Callo",
    settingsPreferences: "Настройки звонков",
    settingsAccount: "Аккаунт",
    settingsAppLanguageTitle: "Язык приложения",
    settingsAppLanguageDesc: "Установите общий язык отображения Callo.",
    settingsLanguageSaved: "Язык обновлён",
    postVideosTab: "Видео",
    collapseSidebar: "Свернуть",
    expandSidebar: "Развернуть",
    navDashboard: "Главная",
    navLive: "Эфиры",
    navMessages: "Сообщения",
    navDiscover: "Поиск",
    navNotifications: "Уведомления",
    navProfile: "Профиль",
    navSettings: "Настройки",
    postCopyLink: "Копировать ссылку",
    postExternalShare: "Поделиться вне приложения",
    postReshare: "Поделиться снова",
    postReport: "Пожаловаться",
    postDeleteConfirm: "Удалить этот пост?",
    postShareError: "Ошибка при попытке поделиться",
    postReactAction: "Реагировать",
    postCommentAction: "Комментировать",
    postShareAction: "Поделиться",
    postShowMore: "Показать больше",
    postReactionCount: "{count} реакци{plural}",
    postViewsWord: "просмотр{plural}",
    reactionLike: "Нравится",
    reactionLove: "Обожаю",
    reactionHaha: "Ха-ха",
    reactionWow: "Вау",
    reactionSad: "Грусть",
    reactionFire: "Огонь",
    reactionClap: "Аплодисменты",
    profileVideoCalls: "Видеозвонки",
    profileCallsCompleted: "завершено",
    profileReputation: "Репутация",
    profilePositive: "положительная",
    profileRecentVisitorsTitle: "Недавние посетители",
    profileRecentVisitorsSubtitle: "Люди, просмотревшие ваш профиль",
    profileNoRecentVisitors: "Нет недавних посетителей",
    profileTabPosts: "Публикации",
    profileTabVisitors: "Посетители",
    profileCopyLink: "Скопировать ссылку",
    profileShareProfile: "Поделиться профилем",
    profileBlockUser: "Заблокировать пользователя",
    profileReportUser: "Пожаловаться",
    profileTopBadge: "Лучшее",
    profileSeePhoto: "Открыть фото крупнее",
    profileEditProfile: "Редактировать профиль",
    profileBackToDiscover: "Исследовать",
    profileBack: "Назад",
    profilePostsSectionTitle: "Публикации",
    profileFilterAll: "Все",
    profileFilterPhotos: "Фото",
    profileFilterVideos: "Видео",
    profileFilterTexts: "Тексты",
    profileNoPosts: "Пока нет публикаций",
    profileNoPostsHint: "Публикации появятся здесь.",
    navLogout: "Выйти",
  },
  zh: {
    ...baseTranslations,
    settingsInstallBadgeNew: "新",
    landingTickerRandomVideo: "免费随机视频聊天",
    landingTickerAltOmegle: "Omegle 替代方案 2026",
    landingTickerLives: "直播",
    landingTickerMessaging: "即时消息",
    landingTickerFree: "100% 免费",
    landingTickerUsers: "+50,000 用户",
    landingTickerNoDownload: "无需下载",
    landingTickerAlwaysOn: "全天 24/7",
    landingHowBadge: "像打招呼一样简单",
    landingHowTitle: "它是怎么",
    landingHowTitleAccent: "运作的?",
    landingHowSubtitle: "三步结识全球朋友",
    landingHowStep1Title: "创建你的个人资料",
    landingHowStep1Desc: "30 秒免费注册。选择你的语言和兴趣。",
    landingHowStep2Title: "开始通话",
    landingHowStep2Desc: "一键随机视频匹配。即时连接。",
    landingHowStep3Title: "建立联系",
    landingHowStep3Desc: "把喜欢的人加为好友，私聊并分享时刻。",
    landingFeaturesBadge: "功能",
    landingFeaturesTitle: "你所需要的",
    landingFeaturesTitleAccent: "一切",
    landingFeaturesSubtitle: "一个完整的视频聊天、直播和消息社交平台",
    landingFeatureGlobalTitle: "全球覆盖",
    landingFeatureGlobalDesc: "结识来自 18+ 个国家的人。按语言、地区或兴趣筛选。",
    landingFeatureInstantTitle: "即时通话",
    landingFeatureInstantDesc: "一键随机视频通话。算法在 3 秒内匹配你。",
    landingFeatureLivesTitle: "直播",
    landingFeatureLivesDesc: "创建自己的直播或加入他人。观众不限。",
    landingFeatureMessagingTitle: "私密消息",
    landingFeatureMessagingDesc: "与朋友实时聊天。发送文字、照片和语音消息。",
    landingFeatureCommunityTitle: "活跃社区",
    landingFeatureCommunityDesc: "动态、评论、热门话题标签。内置真实社交网络。",
    landingFeatureSecurityTitle: "增强安全",
    landingFeatureSecurityDesc: "端到端加密、AI 审核，全面保护隐私。",
    landingTagPopular: "热门",
    landingTagNew: "新",
    landingTestimonialsBadge: "用户评价",
    landingTestimonialsTitle: "他们喜欢",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "我在 Callo 认识了最好的朋友！现在我们每天都聊天。比 Omegle 好太多了。",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "随机通话很上头。我和来自日本、巴西、德国的人聊过……太不可思议了。",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "直播非常有趣！我喜欢氛围和社区。而且 100% 免费，没有任何套路。",
    landingCtaTitleLine1: "准备好认识",
    landingCtaTitleLine2: "全世界了吗？",
    landingCtaSubtitle: "加入每天使用 Callo 进行连接、聊天和分享的成千上万人。",
    landingCtaPrimary: "创建我的免费账号",
    landingCtaSecondary: "我已有账号",
    landingFooterDesc: "Callo 是 Omegle 和 Chatroulette 的最佳免费替代品。随机视频聊天、直播、消息和社交网络 — 全部在一个应用中。",
    landingFooterRegister: "免费注册",
    landingFooterLogin: "登录",
    landingFooterDiscover: "发现",
    landingFooterLive: "直播",
    landingFooterTerms: "使用条款",
    landingFooterPrivacy: "隐私政策",
    landingFooterLegal: "法律声明",
    landingStatFree: "免费",
    landingStatUsers: "用户",
    landingStatCountries: "国家",
    landingStatAvailable: "可用",
    landingCopyright: "© {year} Callo。免费随机视频聊天 — Omegle 和 Chatroulette 的替代方案。",
    landingLegalPrefix: "注册即表示你同意我们的",
    landingLegalAnd: "以及我们的",
    theme: "主题",
    language: "语言",
    changeLanguage: "更改语言",
    selectLanguage: "选择语言",
    defaultFrench: "默认法语",
    languageHint: "你的选择会一直保存，直到你更改它。",
    heroBadge: "当前有 10,000+ 人在线",
    heroTitle: "连接世界的免费随机视频聊天",
    heroSubtitle: "在现代界面中进行视频通话、直播、消息和发布。",
    ctaLogin: "登录",
    ctaRegister: "创建账号",
    ctaPublish: "创建帖子",
    ctaBrowse: "发现",
    feature1: "随机视频通话",
    feature2: "即时消息",
    feature3: "直播",
    feature4: "全球社区",
    authLoginTitle: "欢迎回来！",
    authLoginSubtitle: "登录以重新找到你的社区",
    authRegisterTitle: "加入 Callo",
    authRegisterSubtitle: "创建账号，连接世界",
    authEmail: "电子邮箱地址",
    authPassword: "密码",
    authConfirmPassword: "确认密码",
    authName: "姓名",
    authUsername: "用户名",
    authDOB: "出生日期",
    authLanguages: "会说的语言",
    authForgotPassword: "忘记密码？",
    authLoginLoading: "登录中...",
    authRegisterLoading: "正在创建账号...",
    authNoAccount: "还没有账号？",
    authSignUp: "注册",
    authHaveAccount: "已有账号？",
    authSignIn: "登录",
    verifySuccessTitle: "邮箱验证成功！",
    verifySuccessSubtitle: "你的 Callo 账号已激活。现在你可以登录并开始结识来自世界各地的人。",
    verifySuccessRedirect: "5 秒后将自动跳转到登录页面...",
    verifySuccessLoginNow: "立即登录",
    verifyErrorTitle: "验证失败",
    verifyErrorMissingToken: "验证链接不完整。请使用邮件中收到的完整链接。",
    verifyErrorInvalidToken: "该验证链接无效或已过期。请申请新的链接。",
    verifyErrorServer: "验证过程中发生错误，请稍后重试。",
    verifyErrorDefault: "验证你的邮箱时发生错误。",
    verifyErrorCreateAccount: "创建新账号",
    verifyErrorBackLogin: "返回登录",
    profileEditTitle: "编辑我的资料",
    profileEditSubtitle: "更新你的个人信息",
    themeModeLight: "浅色模式",
    themeModeDark: "深色模式",
    profileProfilePhoto: "头像",
    profileFullName: "姓名",
    profileUsername: "用户名",
    profileAgeAuto: "根据你的出生日期自动计算",
    profileDobFormatHint: "根据设备显示为日/月/年格式",
    profileBio: "简介",
    profileBioPlaceholder: "介绍一下你自己...",
    profileCharsCount: "{count}/500 个字符",
    profileLocationAuto: "通过地理定位自动检测",
    liveDialogSubtitle: "8 位嘉宾 · 观众不限",
    liveTitlePlaceholder: "你的直播标题...",
    liveQuickSuggestions: "快速建议",
    liveSwipe: "滑动",
    liveDescriptionOptional: "描述（可选）",
    liveStarting: "启动中...",
    liveStart: "开始直播",
    liveCreateLive: "创建直播",
    liveLaunchLive: "发起直播",
    liveRandomCall: "随机通话",
    liveSuggestion1: "来和我聊聊！",
    liveSuggestion2: "🎥 直播问答",
    liveSuggestion3: "🔥 开放辩论",
    liveSuggestion4: "🚀 一起成长",
    liveSuggestion5: "💬 加入大家庭",
    settingsTitle: "设置",
    settingsSubtitle: "个性化你的 Callo 体验",
    settingsPreferences: "通话偏好",
    settingsAccount: "账户",
    settingsAppLanguageTitle: "应用语言",
    settingsAppLanguageDesc: "设置 Callo 的全局显示语言。",
    settingsLanguageSaved: "语言已更新",
    postVideosTab: "视频",
    collapseSidebar: "收起",
    expandSidebar: "展开",
    navDashboard: "首页",
    navLive: "直播",
    navMessages: "消息",
    navDiscover: "发现",
    navNotifications: "通知",
    navProfile: "资料",
    navSettings: "设置",
    postCopyLink: "复制链接",
    postExternalShare: "外部分享",
    postReshare: "重新分享",
    postReport: "举报",
    postDeleteConfirm: "删除这条帖子？",
    postShareError: "分享失败",
    postReactAction: "回应",
    postCommentAction: "评论",
    postShareAction: "分享",
    postShowMore: "显示更多",
    postReactionCount: "{count} 条反应",
    postViewsWord: "次浏览",
    reactionLike: "点赞",
    reactionLove: "超爱",
    reactionHaha: "哈哈",
    reactionWow: "哇",
    reactionSad: "难过",
    reactionFire: "火",
    reactionClap: "鼓掌",
    profileVideoCalls: "视频通话",
    profileCallsCompleted: "已完成  次",
    profileReputation: "声誉",
    profilePositive: "正向",
    profileRecentVisitorsTitle: "最近访客",
    profileRecentVisitorsSubtitle: "查看过你个人资料的人",
    profileNoRecentVisitors: "暂无最近访客",
    profileTabPosts: "帖子",
    profileTabVisitors: "访客",
    profileCopyLink: "复制链接",
    profileShareProfile: "分享资料",
    profileBlockUser: "拉黑此用户",
    profileReportUser: "举报",
    profileTopBadge: "最佳",
    profileSeePhoto: "放大查看照片",
    profileEditProfile: "编辑资料",
    profileBackToDiscover: "探索",
    profileBack: "返回",
    profilePostsSectionTitle: "帖子",
    profileFilterAll: "全部",
    profileFilterPhotos: "照片",
    profileFilterVideos: "视频",
    profileFilterTexts: "文本",
    profileNoPosts: "还没有帖子",
    profileNoPostsHint: "帖子会显示在这里。",
    navLogout: "退出登录",
  },
  ja: {
    ...baseTranslations,
    settingsInstallBadgeNew: "新",
    theme: "テーマ",
    language: "言語",
    changeLanguage: "言語を変更",
    selectLanguage: "言語を選択",
    defaultFrench: "初期言語はフランス語",
    languageHint: "選択は変更するまで保存されます。",
    heroBadge: "現在 10,000 人以上がオンライン",
    heroTitle: "世界をつなぐ無料ランダムビデオチャット",
    heroSubtitle: "モダンな画面でビデオ通話、ライブ配信、メッセージ、投稿を利用できます。",
    landingTickerRandomVideo: "無料ランダムビデオチャット",
    landingTickerAltOmegle: "Omegle の代替 2026",
    landingTickerLives: "ライブ配信",
    landingTickerMessaging: "インスタントメッセージ",
    landingTickerFree: "100% 無料",
    landingTickerUsers: "50,000人以上のユーザー",
    landingTickerNoDownload: "ダウンロード不要",
    landingTickerAlwaysOn: "24時間いつでも利用可能",
    landingHowBadge: "とても簡単",
    landingHowTitle: "使い方",
    landingHowTitleAccent: "は？",
    landingHowSubtitle: "世界中の人と出会うための3ステップ",
    landingHowStep1Title: "プロフィールを作成",
    landingHowStep1Desc: "30秒で無料登録。話せる言語と興味を選びます。",
    landingHowStep2Title: "通話を開始",
    landingHowStep2Desc: "ワンクリックでランダムな相手とビデオ通話につながります。すぐに始まります。",
    landingHowStep3Title: "つながりを続ける",
    landingHowStep3Desc: "気に入った相手を友達に追加し、個別チャットで会話を続け、瞬間を共有できます。",
    landingFeaturesBadge: "機能",
    landingFeaturesTitle: "必要なものが",
    landingFeaturesTitleAccent: "すべて",
    landingFeaturesSubtitle: "ビデオチャット、ライブ配信、メッセージを備えた総合ソーシャルプラットフォーム",
    landingFeatureGlobalTitle: "世界とつながる",
    landingFeatureGlobalDesc: "18か国以上の人と出会えます。言語、地域、興味で絞り込めます。",
    landingFeatureInstantTitle: "すぐにつながる通話",
    landingFeatureInstantDesc: "ワンクリックでランダムビデオ通話。アルゴリズムが3秒以内に相手を見つけます。",
    landingFeatureLivesTitle: "ライブ配信",
    landingFeatureLivesDesc: "自分のライブを作成したり、他のライブに参加したりできます。視聴者数は無制限です。",
    landingFeatureMessagingTitle: "プライベートメッセージ",
    landingFeatureMessagingDesc: "友達とリアルタイムにチャット。テキスト、写真、音声メッセージを送れます。",
    landingFeatureCommunityTitle: "活発なコミュニティ",
    landingFeatureCommunityDesc: "投稿、コメント、トレンドのハッシュタグ。ソーシャルネットワーク機能を一体化しています。",
    landingFeatureSecurityTitle: "強化された安全性",
    landingFeatureSecurityDesc: "エンドツーエンド暗号化、モデレーション、プライバシーへの配慮を備えています。",
    landingTagPopular: "人気",
    landingTagNew: "新着",
    landingTestimonialsBadge: "利用者の声",
    landingTestimonialsTitle: "みんなが好きな",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Calloで親友に出会いました！今では毎日話しています。Omegleよりずっと良いです。",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "ランダム通話は夢中になります。日本、ブラジル、ドイツの人たちと話せました。本当にすごいです。",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "ライブ配信がとても楽しいです！雰囲気とコミュニティが大好き。しかも100%無料で安心です。",
    landingCtaTitleLine1: "世界中の人と",
    landingCtaTitleLine2: "出会う準備はできましたか？",
    landingCtaSubtitle: "毎日 Callo を使ってつながり、話し、共有している多くの人に参加しましょう。",
    landingCtaPrimary: "無料アカウントを作成",
    landingCtaSecondary: "すでにアカウントがあります",
    landingFooterDesc: "Callo は Omegle や Chatroulette に代わる無料サービスです。ランダムビデオチャット、ライブ配信、メッセージ、ソーシャル機能をひとつのアプリで使えます。",
    landingFooterRegister: "無料登録",
    landingFooterLogin: "ログイン",
    landingFooterDiscover: "発見",
    landingFooterLive: "ライブ配信",
    landingFooterLegal: "法的表示",
    ctaLogin: "ログイン",
    ctaRegister: "アカウント作成",
    ctaPublish: "投稿を作成",
    ctaBrowse: "見る",
    feature1: "ランダムビデオ通話",
    feature2: "即時メッセージ",
    feature3: "ライブ配信",
    feature4: "グローバルコミュニティ",
    authLoginTitle: "おかえりなさい！",
    authLoginSubtitle: "ログインしてコミュニティに戻ろう",
    authRegisterTitle: "Callo に参加",
    authRegisterSubtitle: "アカウントを作成して世界とつながろう",
    authEmail: "メールアドレス",
    authPassword: "パスワード",
    authConfirmPassword: "パスワードを確認",
    authName: "氏名",
    authUsername: "ユーザー名",
    authDOB: "生年月日",
    authLanguages: "話せる言語",
    authForgotPassword: "パスワードをお忘れですか？",
    authLoginLoading: "ログイン中...",
    authRegisterLoading: "アカウント作成中...",
    authNoAccount: "アカウントをお持ちではありませんか？",
    authSignUp: "登録する",
    authHaveAccount: "すでにアカウントがありますか？",
    authSignIn: "ログイン",
    verifySuccessTitle: "メール認証に成功しました！",
    verifySuccessSubtitle: "Callo アカウントが有効化されました。ログインして世界中の人とつながりましょう。",
    verifySuccessRedirect: "5秒後にログインページへ自動的に移動します...",
    verifySuccessLoginNow: "今すぐログイン",
    verifyErrorTitle: "認証に失敗しました",
    verifyErrorMissingToken: "認証リンクが不完全です。メールで受け取った完全なリンクを使用してください。",
    verifyErrorInvalidToken: "この認証リンクは無効または期限切れです。新しいリンクをリクエストしてください。",
    verifyErrorServer: "認証中にエラーが発生しました。後でもう一度お試しください。",
    verifyErrorDefault: "メール認証中にエラーが発生しました。",
    verifyErrorCreateAccount: "新しいアカウントを作成",
    verifyErrorBackLogin: "ログインに戻る",
    profileEditTitle: "プロフィールを編集",
    profileEditSubtitle: "個人情報を更新してください",
    themeModeLight: "ライトモード",
    themeModeDark: "ダークモード",
    profileProfilePhoto: "プロフィール写真",
    profileFullName: "氏名",
    profileUsername: "ユーザー名",
    profileAgeAuto: "生年月日から自動計算されます",
    profileDobFormatHint: "端末に応じた日/月/年形式",
    profileBio: "自己紹介",
    profileBioPlaceholder: "あなたのことを教えてください...",
    profileCharsCount: "{count}/500 文字",
    profileLocationAuto: "位置情報で自動検出",
    liveDialogSubtitle: "ゲスト8人・視聴者は無制限",
    liveTitlePlaceholder: "ライブのタイトル...",
    liveQuickSuggestions: "クイック提案",
    liveSwipe: "スワイプ",
    liveDescriptionOptional: "説明（任意）",
    liveStarting: "開始中...",
    liveStart: "ライブを開始",
    liveCreateLive: "ライブを作成",
    liveLaunchLive: "ライブを開始する",
    liveRandomCall: "ランダム通話",
    liveSuggestion1: "話しかけてね！",
    liveSuggestion2: "🎥 ライブQ&A",
    liveSuggestion3: "🔥 オープン討論",
    liveSuggestion4: "🚀 一緒に成長しよう",
    liveSuggestion5: "💬 コミュニティに参加",
    settingsTitle: "設定",
    settingsSubtitle: "Callo の体験をカスタマイズ",
    settingsPreferences: "通話設定",
    settingsAccount: "アカウント",
    settingsAppLanguageTitle: "アプリの言語",
    settingsAppLanguageDesc: "Callo の表示言語を設定します。",
    settingsLanguageSaved: "言語を更新しました",
    postVideosTab: "動画",
    landingFooterTerms: "利用規約",
    landingFooterPrivacy: "プライバシーポリシー",
    landingStatFree: "無料",
    landingStatUsers: "ユーザー",
    landingStatCountries: "国",
    landingStatAvailable: "利用可能",
    landingCopyright: "© {year} Callo。無料ランダムビデオチャット — Omegle と Chatroulette の代替。",
    landingLegalPrefix: "登録することで、あなたは当社の",
    landingLegalAnd: "および当社の",
    collapseSidebar: "折りたたむ",
    expandSidebar: "展開する",
    navDashboard: "ホーム",
    navLive: "ライブ",
    navMessages: "メッセージ",
    navDiscover: "発見",
    navNotifications: "通知",
    navProfile: "プロフィール",
    navSettings: "設定",
    postCopyLink: "リンクをコピー",
    postExternalShare: "外部共有",
    postReshare: "再共有",
    postReport: "報告",
    postDeleteConfirm: "この投稿を削除しますか？",
    postShareError: "共有エラー",
    postReactAction: "リアクション",
    postCommentAction: "コメント",
    postShareAction: "共有",
    postShowMore: "もっと見る",
    postReactionCount: "{count} 件のリアクション",
    postViewsWord: "閲覧{plural}",
    reactionLike: "いいね",
    reactionLove: "大好き",
    reactionHaha: "笑",
    reactionWow: "驚き",
    reactionSad: "悲しい",
    reactionFire: "炎",
    reactionClap: "拍手",
    profileVideoCalls: "ビデオ通話",
    profileCallsCompleted: "件完了",
    profileReputation: "評価",
    profilePositive: "ポジティブ",
    profileRecentVisitorsTitle: "最近の訪問者",
    profileRecentVisitorsSubtitle: "あなたのプロフィールを見た人",
    profileNoRecentVisitors: "最近の訪問者はいません",
    profileTabPosts: "投稿",
    profileTabVisitors: "訪問者",
    profileCopyLink: "リンクをコピー",
    profileShareProfile: "プロフィールを共有",
    profileBlockUser: "このユーザーをブロック",
    profileReportUser: "報告する",
    profileTopBadge: "トップ",
    profileSeePhoto: "写真を拡大表示",
    profileEditProfile: "プロフィールを編集",
    profileBackToDiscover: "探索する",
    profileBack: "戻る",
    profilePostsSectionTitle: "投稿",
    profileFilterAll: "すべて",
    profileFilterPhotos: "写真",
    profileFilterVideos: "動画",
    profileFilterTexts: "テキスト",
    profileNoPosts: "まだ投稿がありません",
    profileNoPostsHint: "投稿はここに表示されます。",
    navLogout: "ログアウト",
  },
  ko: {
    ...baseTranslations,
    settingsInstallBadgeNew: "새로운",
    theme: "테마",
    language: "언어",
    changeLanguage: "언어 변경",
    selectLanguage: "언어 선택",
    defaultFrench: "기본값은 프랑스어",
    languageHint: "선택은 변경할 때까지 저장됩니다.",
    heroBadge: "현재 10,000명 이상 접속 중",
    heroTitle: "세계를 연결하는 무료 랜덤 영상 채팅",
    heroSubtitle: "모던한 인터페이스에서 영상 통화, 라이브, 메시지, 게시물을 사용하세요.",
    landingTickerRandomVideo: "무료 랜덤 영상 채팅",
    landingTickerAltOmegle: "Omegle 대안 2026",
    landingTickerLives: "라이브 방송",
    landingTickerMessaging: "즉시 메시지",
    landingTickerFree: "100% 무료",
    landingTickerUsers: "50,000명 이상 사용자",
    landingTickerNoDownload: "다운로드 없음",
    landingTickerAlwaysOn: "24시간 이용 가능",
    landingHowBadge: "인사만큼 쉬워요",
    landingHowTitle: "이용",
    landingHowTitleAccent: "방법",
    landingHowSubtitle: "전 세계 사람들을 만나는 세 단계",
    landingHowStep1Title: "프로필 만들기",
    landingHowStep1Desc: "30초 만에 무료 가입. 언어와 관심사를 선택하세요.",
    landingHowStep2Title: "통화 시작",
    landingHowStep2Desc: "한 번의 클릭으로 무작위 상대와 영상으로 연결됩니다. 즉시 시작됩니다.",
    landingHowStep3Title: "계속 연결",
    landingHowStep3Desc: "마음에 드는 사람을 친구로 추가하고, 개인 채팅을 하고, 순간을 공유하세요.",
    landingFeaturesBadge: "기능",
    landingFeaturesTitle: "필요한 모든",
    landingFeaturesTitleAccent: "기능",
    landingFeaturesSubtitle: "영상 채팅, 라이브 스트리밍, 메시지를 위한 완전한 소셜 플랫폼",
    landingFeatureGlobalTitle: "전 세계 연결",
    landingFeatureGlobalDesc: "18개국 이상의 사람들을 만나보세요. 언어, 지역 또는 관심사로 필터링할 수 있습니다.",
    landingFeatureInstantTitle: "즉시 통화",
    landingFeatureInstantDesc: "한 번의 클릭으로 랜덤 영상 통화. 알고리즘이 3초 안에 매칭합니다.",
    landingFeatureLivesTitle: "라이브 방송",
    landingFeatureLivesDesc: "나만의 라이브를 만들거나 다른 라이브에 참여하세요. 시청자는 제한 없습니다.",
    landingFeatureMessagingTitle: "개인 메시지",
    landingFeatureMessagingDesc: "친구와 실시간으로 채팅하세요. 텍스트, 사진, 음성 메시지를 보낼 수 있습니다.",
    landingFeatureCommunityTitle: "활발한 커뮤니티",
    landingFeatureCommunityDesc: "게시물, 댓글, 인기 해시태그까지. 진짜 소셜 네트워크가 내장되어 있습니다.",
    landingFeatureSecurityTitle: "강화된 안전성",
    landingFeatureSecurityDesc: "종단 간 암호화, 모더레이션, 개인정보 보호를 갖춘 안전한 환경입니다.",
    landingTagPopular: "인기",
    landingTagNew: "신규",
    landingTestimonialsBadge: "후기",
    landingTestimonialsTitle: "사람들이 좋아하는",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "Callo에서 가장 친한 친구를 만났어요! 이제 매일 이야기합니다. Omegle보다 훨씬 좋아요.",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "랜덤 통화가 정말 재미있어요. 일본, 브라질, 독일 사람들과 이야기했는데 놀라웠습니다.",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "라이브가 정말 재미있어요! 분위기와 커뮤니티가 마음에 듭니다. 그리고 100% 무료라서 좋아요.",
    landingCtaTitleLine1: "전 세계를",
    landingCtaTitleLine2: "만날 준비가 되었나요?",
    landingCtaSubtitle: "매일 Callo로 연결하고, 대화하고, 공유하는 수많은 사람들과 함께하세요.",
    landingCtaPrimary: "무료 계정 만들기",
    landingCtaSecondary: "이미 계정이 있습니다",
    landingFooterDesc: "Callo는 Omegle과 Chatroulette를 대체하는 무료 서비스입니다. 랜덤 영상 채팅, 라이브 스트리밍, 메시지, 소셜 네트워크를 하나의 앱에서 제공합니다.",
    landingFooterRegister: "무료 가입",
    landingFooterLogin: "로그인",
    landingFooterDiscover: "탐색",
    landingFooterLive: "라이브 방송",
    landingFooterLegal: "법적 고지",
    ctaLogin: "로그인",
    ctaRegister: "계정 만들기",
    ctaPublish: "게시물 작성",
    ctaBrowse: "둘러보기",
    feature1: "랜덤 영상 통화",
    feature2: "즉시 메시지",
    feature3: "라이브 스트리밍",
    feature4: "글로벌 커뮤니티",
    authLoginTitle: "다시 오신 것을 환영합니다!",
    authLoginSubtitle: "로그인하여 커뮤니티를 다시 만나보세요",
    authRegisterTitle: "Callo에 가입하기",
    authRegisterSubtitle: "계정을 만들고 세상과 연결하세요",
    authEmail: "이메일 주소",
    authPassword: "비밀번호",
    authConfirmPassword: "비밀번호 확인",
    authName: "이름",
    authUsername: "사용자 이름",
    authDOB: "생년월일",
    authLanguages: "구사 언어",
    authForgotPassword: "비밀번호를 잊으셨나요?",
    authLoginLoading: "로그인 중...",
    authRegisterLoading: "계정 생성 중...",
    authNoAccount: "아직 계정이 없나요?",
    authSignUp: "가입하기",
    authHaveAccount: "이미 계정이 있나요?",
    authSignIn: "로그인",
    verifySuccessTitle: "이메일 인증이 완료되었습니다!",
    verifySuccessSubtitle: "Callo 계정이 활성화되었습니다. 이제 로그인하여 전 세계 사람들을 만나보세요.",
    verifySuccessRedirect: "5초 후 로그인 페이지로 자동 이동합니다...",
    verifySuccessLoginNow: "지금 로그인",
    verifyErrorTitle: "인증 실패",
    verifyErrorMissingToken: "인증 링크가 불완전합니다. 이메일로 받은 전체 링크를 사용하세요.",
    verifyErrorInvalidToken: "이 인증 링크는 유효하지 않거나 만료되었습니다. 새 링크를 요청하세요.",
    verifyErrorServer: "인증 중 오류가 발생했습니다. 잠시 후 다시 시도하세요.",
    verifyErrorDefault: "이메일 인증 중 오류가 발생했습니다.",
    verifyErrorCreateAccount: "새 계정 만들기",
    verifyErrorBackLogin: "로그인으로 돌아가기",
    profileEditTitle: "내 프로필 수정",
    profileEditSubtitle: "개인 정보를 업데이트하세요",
    themeModeLight: "라이트 모드",
    themeModeDark: "다크 모드",
    profileProfilePhoto: "프로필 사진",
    profileFullName: "이름",
    profileUsername: "사용자 이름",
    profileAgeAuto: "생년월일 기준으로 자동 계산됩니다",
    profileDobFormatHint: "기기에 따라 일/월/년 형식으로 표시됩니다",
    profileBio: "소개",
    profileBioPlaceholder: "자신에 대해 알려주세요...",
    profileCharsCount: "{count}/500자",
    profileLocationAuto: "위치 정보로 자동 감지됩니다",
    liveDialogSubtitle: "게스트 8명 · 시청자 무제한",
    liveTitlePlaceholder: "라이브 제목...",
    liveQuickSuggestions: "빠른 제안",
    liveSwipe: "스와이프",
    liveDescriptionOptional: "설명(선택)",
    liveStarting: "시작 중...",
    liveStart: "라이브 시작",
    liveCreateLive: "라이브 만들기",
    liveLaunchLive: "라이브 시작",
    liveRandomCall: "랜덤 통화",
    liveSuggestion1: "나랑 이야기해요!",
    liveSuggestion2: "🎥 라이브 질문",
    liveSuggestion3: "🔥 오픈 토론",
    liveSuggestion4: "🚀 함께 성장해요",
    liveSuggestion5: "💬 커뮤니티에 참여하세요",
    settingsTitle: "설정",
    settingsSubtitle: "Callo 경험을 개인화하세요",
    settingsPreferences: "통화 설정",
    settingsAccount: "계정",
    settingsAppLanguageTitle: "앱 언어",
    settingsAppLanguageDesc: "Callo의 전역 표시 언어를 설정하세요.",
    settingsLanguageSaved: "언어가 업데이트되었습니다",
    postVideosTab: "동영상",
    landingFooterTerms: "이용 약관",
    landingFooterPrivacy: "개인정보 처리방침",
    landingStatFree: "무료",
    landingStatUsers: "사용자",
    landingStatCountries: "국가",
    landingStatAvailable: "이용 가능",
    landingCopyright: "© {year} Callo. 무료 랜덤 영상 채팅 — Omegle 및 Chatroulette 대안.",
    landingLegalPrefix: "가입하면 당사의",
    landingLegalAnd: "및 당사의",
    collapseSidebar: "접기",
    expandSidebar: "펼치기",
    navDashboard: "홈",
    navLive: "라이브",
    navMessages: "메시지",
    navDiscover: "탐색",
    navNotifications: "알림",
    navProfile: "프로필",
    navSettings: "설정",
    postCopyLink: "링크 복사",
    postExternalShare: "외부 공유",
    postReshare: "다시 공유",
    postReport: "신고",
    postDeleteConfirm: "이 게시물을 삭제하시겠습니까?",
    postShareError: "공유 오류",
    postReactAction: "반응",
    postCommentAction: "댓글",
    postShareAction: "공유",
    postShowMore: "더 보기",
    postReactionCount: "반응 {count}개",
    postViewsWord: "조회{plural}",
    reactionLike: "좋아요",
    reactionLove: "사랑해요",
    reactionHaha: "하하",
    reactionWow: "와우",
    reactionSad: "슬퍼요",
    reactionFire: "불",
    reactionClap: "박수",
    profileVideoCalls: "영상 통화",
    profileCallsCompleted: "회 완료",
    profileReputation: "평판",
    profilePositive: "긍정적",
    profileRecentVisitorsTitle: "최근 방문자",
    profileRecentVisitorsSubtitle: "프로필을 본 사람들",
    profileNoRecentVisitors: "최근 방문자가 없습니다",
    profileTabPosts: "게시물",
    profileTabVisitors: "방문자",
    profileCopyLink: "링크 복사",
    profileShareProfile: "프로필 공유",
    profileBlockUser: "이 사용자를 차단",
    profileReportUser: "신고",
    profileTopBadge: "최고",
    profileSeePhoto: "사진 크게 보기",
    profileEditProfile: "프로필 편집",
    profileBackToDiscover: "탐색",
    profileBack: "뒤로",
    profilePostsSectionTitle: "게시물",
    profileFilterAll: "전체",
    profileFilterPhotos: "사진",
    profileFilterVideos: "동영상",
    profileFilterTexts: "텍스트",
    profileNoPosts: "아직 게시물이 없습니다",
    profileNoPostsHint: "게시물이 여기에 표시됩니다.",
    navLogout: "로그아웃",
  },
  hi: {
    ...baseTranslations,
    settingsInstallBadgeNew: "नया",
    theme: "थीम",
    language: "भाषा",
    changeLanguage: "भाषा बदलें",
    selectLanguage: "भाषा चुनें",
    defaultFrench: "डिफ़ॉल्ट रूप से फ़्रेंच",
    languageHint: "आपकी पसंद तब तक सहेजी रहती है जब तक आप इसे बदल न दें।",
    heroBadge: "अभी 10,000+ लोग ऑनलाइन हैं",
    heroTitle: "दुनिया को जोड़ने वाला मुफ्त रैंडम वीडियो चैट",
    heroSubtitle: "आधुनिक इंटरफ़ेस में वीडियो कॉल, लाइव, संदेश और पोस्ट।",
    landingTickerRandomVideo: "मुफ्त रैंडम वीडियो चैट",
    landingTickerAltOmegle: "Omegle विकल्प 2026",
    landingTickerLives: "लाइव स्ट्रीम",
    landingTickerMessaging: "तुरंत संदेश",
    landingTickerFree: "100% मुफ्त",
    landingTickerUsers: "50,000+ उपयोगकर्ता",
    landingTickerNoDownload: "डाउनलोड की जरूरत नहीं",
    landingTickerAlwaysOn: "24/7 उपलब्ध",
    landingHowBadge: "बहुत आसान",
    landingHowTitle: "यह कैसे",
    landingHowTitleAccent: "काम करता है?",
    landingHowSubtitle: "दुनिया भर के लोगों से मिलने के तीन चरण",
    landingHowStep1Title: "अपना प्रोफ़ाइल बनाएं",
    landingHowStep1Desc: "30 सेकंड में मुफ्त साइन अप। अपनी भाषाएँ और रुचियाँ चुनें।",
    landingHowStep2Title: "कॉल शुरू करें",
    landingHowStep2Desc: "एक क्लिक में आप वीडियो पर किसी यादृच्छिक व्यक्ति से जुड़ जाते हैं। तुरंत।",
    landingHowStep3Title: "जुड़े रहें",
    landingHowStep3Desc: "पसंदीदा लोगों को मित्र बनाएं, निजी चैट करें और पल साझा करें।",
    landingFeaturesBadge: "सुविधाएँ",
    landingFeaturesTitle: "आपको जो कुछ",
    landingFeaturesTitleAccent: "चाहिए",
    landingFeaturesSubtitle: "वीडियो चैट, लाइव स्ट्रीमिंग और संदेशों के लिए पूरा सामाजिक प्लेटफ़ॉर्म",
    landingFeatureGlobalTitle: "वैश्विक पहुँच",
    landingFeatureGlobalDesc: "18 से अधिक देशों के लोगों से मिलें। भाषा, क्षेत्र या रुचि के आधार पर फ़िल्टर करें।",
    landingFeatureInstantTitle: "तुरंत कॉल",
    landingFeatureInstantDesc: "एक क्लिक में रैंडम वीडियो कॉल। हमारा एल्गोरिदम आपको 3 सेकंड से कम में मैच करता है।",
    landingFeatureLivesTitle: "लाइव स्ट्रीम",
    landingFeatureLivesDesc: "अपना लाइव बनाएं या दूसरों से जुड़ें। दर्शकों की कोई सीमा नहीं।",
    landingFeatureMessagingTitle: "निजी संदेश",
    landingFeatureMessagingDesc: "दोस्तों से रियल टाइम में चैट करें। टेक्स्ट, फ़ोटो और वॉइस मैसेज भेजें।",
    landingFeatureCommunityTitle: "सक्रिय समुदाय",
    landingFeatureCommunityDesc: "पोस्ट, टिप्पणियाँ और ट्रेंडिंग हैशटैग। एक असली सामाजिक नेटवर्क शामिल है।",
    landingFeatureSecurityTitle: "मजबूत सुरक्षा",
    landingFeatureSecurityDesc: "एंड-टू-एंड एन्क्रिप्शन, मॉडरेशन और आपकी गोपनीयता का पूरा सम्मान।",
    landingTagPopular: "लोकप्रिय",
    landingTagNew: "नया",
    landingTestimonialsBadge: "प्रशंसापत्र",
    landingTestimonialsTitle: "लोग पसंद करते हैं",
    landingTestimonial1Name: "Marie L.",
    landingTestimonial1Text: "मैंने Callo पर अपनी सबसे अच्छी दोस्त से मुलाकात की! अब हम रोज़ बात करते हैं। यह Omegle से कहीं बेहतर है।",
    landingTestimonial2Name: "Jean K.",
    landingTestimonial2Text: "रैंडम कॉल बहुत मज़ेदार है। मैंने जापान, ब्राज़ील और जर्मनी के लोगों से बात की... कमाल है।",
    landingTestimonial3Name: "Sofia R.",
    landingTestimonial3Text: "लाइव स्ट्रीम बहुत मज़ेदार हैं! माहौल और समुदाय शानदार है। और यह 100% मुफ्त है।",
    landingCtaTitleLine1: "पूरी दुनिया से",
    landingCtaTitleLine2: "मिलने के लिए तैयार हैं?",
    landingCtaSubtitle: "हर दिन Callo का उपयोग करके जुड़ने, चैट करने और साझा करने वाले हजारों लोगों से जुड़ें।",
    landingCtaPrimary: "मेरा मुफ्त खाता बनाएं",
    landingCtaSecondary: "मेरे पास पहले से खाता है",
    landingFooterDesc: "Callo, Omegle और Chatroulette का सबसे अच्छा मुफ्त विकल्प है। रैंडम वीडियो चैट, लाइव स्ट्रीमिंग, संदेश और सामाजिक नेटवर्क — सब एक ही ऐप में।",
    landingFooterRegister: "मुफ्त साइन अप",
    landingFooterLogin: "साइन इन",
    landingFooterDiscover: "खोजें",
    landingFooterLive: "लाइव स्ट्रीम",
    landingFooterLegal: "कानूनी सूचना",
    ctaLogin: "साइन इन",
    ctaRegister: "खाता बनाएं",
    ctaPublish: "पोस्ट बनाएं",
    ctaBrowse: "खोजें",
    feature1: "रैंडम वीडियो कॉल",
    feature2: "तुरंत संदेश",
    feature3: "लाइव स्ट्रीम",
    feature4: "वैश्विक समुदाय",
    authLoginTitle: "फिर से स्वागत है!",
    authLoginSubtitle: "अपना समुदाय फिर से पाने के लिए साइन इन करें",
    authRegisterTitle: "Callo से जुड़ें",
    authRegisterSubtitle: "अपना खाता बनाएं और दुनिया से जुड़ें",
    authEmail: "ईमेल पता",
    authPassword: "पासवर्ड",
    authConfirmPassword: "पासवर्ड की पुष्टि करें",
    authName: "पूरा नाम",
    authUsername: "उपयोगकर्ता नाम",
    authDOB: "जन्म तिथि",
    authLanguages: "बोली जाने वाली भाषाएँ",
    authForgotPassword: "पासवर्ड भूल गए?",
    authLoginLoading: "साइन इन किया जा रहा है...",
    authRegisterLoading: "खाता बनाया जा रहा है...",
    authNoAccount: "अभी खाता नहीं है?",
    authSignUp: "साइन अप करें",
    authHaveAccount: "पहले से खाता है?",
    authSignIn: "साइन इन करें",
    verifySuccessTitle: "ईमेल सफलतापूर्वक सत्यापित हो गया!",
    verifySuccessSubtitle: "आपका Callo खाता सक्रिय हो गया है। अब आप साइन इन कर सकते हैं और दुनिया भर के लोगों से मिल सकते हैं।",
    verifySuccessRedirect: "5 सेकंड में लॉगिन पेज पर स्वतः रीडायरेक्ट किया जाएगा...",
    verifySuccessLoginNow: "अभी साइन इन करें",
    verifyErrorTitle: "सत्यापन विफल",
    verifyErrorMissingToken: "सत्यापन लिंक अधूरा है। कृपया ईमेल में प्राप्त पूरा लिंक उपयोग करें।",
    verifyErrorInvalidToken: "यह सत्यापन लिंक अमान्य है या समाप्त हो चुका है। कृपया नया लिंक माँगें।",
    verifyErrorServer: "सत्यापन के दौरान त्रुटि हुई। कृपया बाद में पुनः प्रयास करें।",
    verifyErrorDefault: "आपके ईमेल सत्यापन के दौरान त्रुटि हुई।",
    verifyErrorCreateAccount: "नया खाता बनाएं",
    verifyErrorBackLogin: "लॉगिन पर वापस जाएं",
    profileEditTitle: "मेरी प्रोफ़ाइल संपादित करें",
    profileEditSubtitle: "अपनी व्यक्तिगत जानकारी अपडेट करें",
    themeModeLight: "लाइट मोड",
    themeModeDark: "डार्क मोड",
    profileProfilePhoto: "प्रोफ़ाइल फोटो",
    profileFullName: "पूरा नाम",
    profileUsername: "यूज़रनेम",
    profileAgeAuto: "आपकी जन्म तिथि से स्वचालित रूप से गणना की जाती है",
    profileDobFormatHint: "आपके डिवाइस के अनुसार दिन/माह/वर्ष प्रारूप",
    profileBio: "बायो",
    profileBioPlaceholder: "अपने बारे में बताएं...",
    profileCharsCount: "{count}/500 अक्षर",
    profileLocationAuto: "जियोलोकेशन से स्वचालित रूप से पता लगाया गया",
    liveDialogSubtitle: "8 मेहमान · असीमित दर्शक",
    liveTitlePlaceholder: "आपकी लाइव का शीर्षक...",
    liveQuickSuggestions: "त्वरित सुझाव",
    liveSwipe: "स्वाइप करें",
    liveDescriptionOptional: "विवरण (वैकल्पिक)",
    liveStarting: "शुरू हो रहा है...",
    liveStart: "लाइव शुरू करें",
    liveCreateLive: "लाइव बनाएं",
    liveLaunchLive: "लाइव शुरू करें",
    liveRandomCall: "रैंडम कॉल",
    liveSuggestion1: "आओ मुझसे बात करो!",
    liveSuggestion2: "🎥 लाइव सवाल",
    liveSuggestion3: "🔥 खुली बहस",
    liveSuggestion4: "🚀 साथ में आगे बढ़ें",
    liveSuggestion5: "💬 परिवार से जुड़ें",
    settingsTitle: "सेटिंग्स",
    settingsSubtitle: "अपना Callo अनुभव अनुकूलित करें",
    settingsPreferences: "कॉल प्राथमिकताएँ",
    settingsAccount: "खाता",
    settingsAppLanguageTitle: "ऐप भाषा",
    settingsAppLanguageDesc: "Callo के लिए वैश्विक प्रदर्शन भाषा सेट करें।",
    settingsLanguageSaved: "भाषा अपडेट की गई",
    postVideosTab: "वीडियो",
    landingFooterTerms: "उपयोग की शर्तें",
    landingFooterPrivacy: "गोपनीयता नीति",
    landingStatFree: "मुफ्त",
    landingStatUsers: "उपयोगकर्ता",
    landingStatCountries: "देश",
    landingStatAvailable: "उपलब्ध",
    landingCopyright: "© {year} Callo. मुफ्त रैंडम वीडियो चैट — Omegle और Chatroulette का विकल्प।",
    landingLegalPrefix: "साइन अप करके, आप हमारी",
    landingLegalAnd: "और हमारी",
    collapseSidebar: "संकुचित करें",
    expandSidebar: "विस्तार करें",
    navDashboard: "होम",
    navLive: "लाइव",
    navMessages: "संदेश",
    navDiscover: "खोजें",
    navNotifications: "सूचनाएँ",
    navProfile: "प्रोफ़ाइल",
    navSettings: "सेटिंग्स",
    postCopyLink: "लिंक कॉपी करें",
    postExternalShare: "बाहरी शेयर",
    postReshare: "दोबारा शेयर करें",
    postReport: "रिपोर्ट करें",
    postDeleteConfirm: "क्या इस पोस्ट को हटाना है?",
    postShareError: "शेयर करने में त्रुटि",
    postReactAction: "प्रतिक्रिया दें",
    postCommentAction: "टिप्पणी करें",
    postShareAction: "शेयर करें",
    postShowMore: "और दिखाएं",
    postReactionCount: "{count} प्रतिक्रिया{plural}",
    postViewsWord: "व्यू{plural}",
    reactionLike: "पसंद",
    reactionLove: "बहुत पसंद",
    reactionHaha: "हाहा",
    reactionWow: "वाह",
    reactionSad: "उदास",
    reactionFire: "आग",
    reactionClap: "ताली",
    profileVideoCalls: "वीडियो कॉल",
    profileCallsCompleted: " पूर्ण",
    profileReputation: "प्रतिष्ठा",
    profilePositive: "सकारात्मक",
    profileRecentVisitorsTitle: "हाल के विज़िटर",
    profileRecentVisitorsSubtitle: "वे लोग जिन्होंने आपकी प्रोफ़ाइल देखी",
    profileNoRecentVisitors: "कोई हाल का विज़िटर नहीं",
    profileTabPosts: "पोस्ट",
    profileTabVisitors: "विज़िटर",
    profileCopyLink: "लिंक कॉपी करें",
    profileShareProfile: "प्रोफ़ाइल साझा करें",
    profileBlockUser: "इस उपयोगकर्ता को ब्लॉक करें",
    profileReportUser: "रिपोर्ट करें",
    profileTopBadge: "टॉप",
    profileSeePhoto: "फ़ोटो बड़ा देखें",
    profileEditProfile: "प्रोफ़ाइल संपादित करें",
    profileBackToDiscover: "एक्सप्लोर करें",
    profileBack: "वापस",
    profilePostsSectionTitle: "पोस्ट",
    profileFilterAll: "सभी",
    profileFilterPhotos: "फ़ोटो",
    profileFilterVideos: "वीडियो",
    profileFilterTexts: "टेक्स्ट",
    profileNoPosts: "अभी कोई पोस्ट नहीं",
    profileNoPostsHint: "पोस्ट यहाँ दिखाई देंगी।",
    navLogout: "साइन आउट",
  },
}

// Push/notification settings translations per-locale
// Partial because we only supply overrides for some locales (fr uses baseTranslations)
const PUSH_TRANSLATIONS: Partial<Record<LocaleCode, Partial<TranslationMap>>> = {
  en: {
    settingsNotifications: "Notifications",
    settingsNotificationsDesc: "Receive Callo notifications on your device",
    settingsPushTitle: "Notifications on this device",
    settingsPushSubtitle: "Receive Callo alerts even when the app is closed.",
    settingsPushStatusSupported: "Compatibility",
    settingsPushStatusEnabled: "Enabled",
    settingsPushStatusDisabled: "Disabled",
    settingsPushPermissionDefault: "Permission not requested",
    settingsPushPermissionGranted: "Permission granted",
    settingsPushPermissionDenied: "Permission denied",
    settingsPushEnable: "Enable notifications",
    settingsPushDisable: "Disable",
    settingsPushSaveError: "Unable to configure notifications",
    settingsPushEnabledSuccess: "Notifications enabled on this device",
    settingsPushDisabledSuccess: "Notifications disabled on this device",
    settingsPushUnsupported: "Push notifications are not supported in this browser",
    settingsPushPermissionDeniedError: "Notifications have been denied in the browser",
    settingsPushExplain: "You'll receive messages, friend requests, reactions and lives directly on your device.",
    settingsPushNeedPermission: "The browser will ask for permission before enabling.",
    settingsPushPromptTitle: "Receive notifications",
    settingsPushPromptDescription: "Hi {name}! Allow Callo to send important alerts directly to your device.",
    settingsPushPromptBenefit1: "Stay informed in real time",
    settingsPushPromptBenefit2: "Messages, friend requests, reactions and lives appear directly on your device.",
    settingsPushPromptAllow: "Allow",
    settingsPushPromptLater: "Later",
    settingsPushConsentQuestion: "Do you want to receive Callo notifications on your device?",
    settingsPushConsentExplanation: "You choose. If you continue, the browser will ask for permission next.",
    settingsPushConsentLater: "Later",
    settingsPushConsentAllow: "Allow",
    settingsDownloadAppTitle: "Download the app",
    settingsDownloadAppDesc: "Install Callo on your device for faster access and reliable notifications.",
    settingsInstallPromptTitle: "Install Callo",
    settingsInstallPromptDesc: "Get Callo directly on your device. Fast access, real-time notifications, even offline mode.",
    settingsInstallPlatformTitle: "Installation instructions",
    settingsInstallIosStep1: "Open Safari and go to callo.online",
    settingsInstallIosStep2: "Tap the share icon at the bottom (square with arrow)",
    settingsInstallIosStep3: "Select \"Add to Home Screen\"",
    settingsInstallAndroidStep1: "Open Chrome and go to callo.online",
    settingsInstallAndroidStep2: "Tap the menu (3 dots) in the top right",
    settingsInstallAndroidStep3: "Select \"Install app\"",
    settingsInstallDesktopStep1: "You'll see an install icon in your browser address bar",
    settingsInstallDesktopStep2: "Click the icon and confirm the installation",
    settingsInstallBenefitFast: "Quick access",
    settingsInstallBenefitFastDesc: "Launch Callo in one click from your home screen",
    settingsInstallBenefitNotifications: "Reliable notifications",
    settingsInstallBenefitNotificationsDesc: "Get alerts even when your browser is closed",
    settingsInstallButtonInstall: "Install now",
    settingsInstallButtonClose: "Close",
    settingsInstallSuccess: "Callo was successfully installed!",
    settingsInstallAlreadyInstalled: "Callo is already installed on this device.",
  },
  es: {
    settingsNotifications: "Notificaciones",
    settingsNotificationsDesc: "Recibe las notificaciones de Callo en tu dispositivo",
    settingsPushTitle: "Notificaciones en este dispositivo",
    settingsPushSubtitle: "Recibe alertas de Callo incluso cuando la app está cerrada.",
    settingsPushStatusSupported: "Compatibilidad",
    settingsPushStatusEnabled: "Activas",
    settingsPushStatusDisabled: "Desactivadas",
    settingsPushPermissionDefault: "Permiso no solicitado",
    settingsPushPermissionGranted: "Permiso concedido",
    settingsPushPermissionDenied: "Permiso denegado",
    settingsPushEnable: "Activar notificaciones",
    settingsPushDisable: "Desactivar",
    settingsPushSaveError: "No se pueden configurar las notificaciones",
    settingsPushEnabledSuccess: "Notificaciones activadas en este dispositivo",
    settingsPushDisabledSuccess: "Notificaciones desactivadas en este dispositivo",
    settingsPushUnsupported: "Las notificaciones push no son compatibles con este navegador",
    settingsPushPermissionDeniedError: "Las notificaciones han sido denegadas en el navegador",
    settingsPushExplain: "Recibirás mensajes, solicitudes de amistad, reacciones y directos directamente en tu dispositivo.",
    settingsPushNeedPermission: "El navegador te pedirá permiso antes de activarlas.",
    settingsPushPromptTitle: "Recibe notificaciones",
    settingsPushPromptDescription: "Hola {name}! Permite que Callo te envíe alertas importantes directamente en tu dispositivo.",
    settingsPushPromptBenefit1: "Mantente informado en tiempo real",
    settingsPushPromptBenefit2: "Mensajes, solicitudes, reacciones y directos aparecen en tu dispositivo.",
    settingsPushPromptAllow: "Permitir",
    settingsPushPromptLater: "Más tarde",
    settingsPushConsentQuestion: "¿Quieres recibir notificaciones de Callo en tu dispositivo?",
    settingsPushConsentExplanation: "Tú decides. Si continúas, el navegador te pedirá permiso a continuación.",
    settingsPushConsentLater: "Más tarde",
    settingsPushConsentAllow: "Permitir",
    settingsDownloadAppTitle: "Descargar la app",
    settingsDownloadAppDesc: "Instala Callo en tu dispositivo para acceso más rápido y notificaciones confiables.",
    settingsInstallPromptTitle: "Instalar Callo",
    settingsInstallPromptDesc: "Obtén Callo directamente en tu dispositivo. Acceso rápido, notificaciones en tiempo real, modo sin conexión.",
    settingsInstallPlatformTitle: "Instrucciones de instalación",
    settingsInstallIosStep1: "Abre Safari y ve a callo.online",
    settingsInstallIosStep2: "Toca el icono de compartir en la parte inferior (cuadrado con flecha)",
    settingsInstallIosStep3: "Selecciona \"Añadir a pantalla de inicio\"",
    settingsInstallAndroidStep1: "Abre Chrome y ve a callo.online",
    settingsInstallAndroidStep2: "Toca el menú (3 puntos) en la parte superior derecha",
    settingsInstallAndroidStep3: "Selecciona \"Instalar aplicación\"",
    settingsInstallDesktopStep1: "Verás un icono de instalación en la barra de direcciones",
    settingsInstallDesktopStep2: "Haz clic en el icono y confirma la instalación",
    settingsInstallBenefitFast: "Acceso rápido",
    settingsInstallBenefitFastDesc: "Abre Callo en un clic desde tu pantalla de inicio",
    settingsInstallBenefitNotifications: "Notificaciones confiables",
    settingsInstallBenefitNotificationsDesc: "Recibe alertas incluso cuando tu navegador está cerrado",
    settingsInstallButtonInstall: "Instalar ahora",
    settingsInstallButtonClose: "Cerrar",
    settingsInstallSuccess: "¡Callo fue instalado exitosamente!",
    settingsInstallAlreadyInstalled: "Callo ya está instalado en este dispositivo.",
  },
  pt: {
    settingsNotifications: "Notificações",
    settingsNotificationsDesc: "Receba as notificações do Callo no seu dispositivo",
    settingsPushTitle: "Notificações neste dispositivo",
    settingsPushSubtitle: "Receba alertas do Callo mesmo quando o app estiver fechado.",
    settingsPushStatusSupported: "Compatibilidade",
    settingsPushStatusEnabled: "Ativas",
    settingsPushStatusDisabled: "Desativadas",
    settingsPushPermissionDefault: "Permissão não solicitada",
    settingsPushPermissionGranted: "Permissão concedida",
    settingsPushPermissionDenied: "Permissão negada",
    settingsPushEnable: "Ativar notificações",
    settingsPushDisable: "Desativar",
    settingsPushSaveError: "Não foi possível configurar as notificações",
    settingsPushEnabledSuccess: "Notificações ativadas neste dispositivo",
    settingsPushDisabledSuccess: "Notificações desativadas neste dispositivo",
    settingsPushUnsupported: "Notificações push não são suportadas neste navegador",
    settingsPushPermissionDeniedError: "As notificações foram negadas no navegador",
    settingsPushExplain: "Você receberá mensagens, solicitações de amizade, reações e lives diretamente no seu dispositivo.",
    settingsPushNeedPermission: "O navegador solicitará permissão antes de ativar.",
    settingsPushPromptTitle: "Receba notificações",
    settingsPushPromptDescription: "Olá {name}! Permita que o Callo envie alertas importantes diretamente para o seu dispositivo.",
    settingsPushPromptBenefit1: "Fique informado em tempo real",
    settingsPushPromptBenefit2: "Mensagens, solicitações, reações e lives aparecem diretamente no seu dispositivo.",
    settingsPushPromptAllow: "Permitir",
    settingsPushPromptLater: "Mais tarde",
    settingsPushConsentQuestion: "Quer receber notificações do Callo no seu dispositivo?",
    settingsPushConsentExplanation: "Você decide. Se continuar, o navegador pedirá a permissão em seguida.",
    settingsPushConsentLater: "Mais tarde",
    settingsPushConsentAllow: "Permitir",
    settingsDownloadAppTitle: "Baixar o app",
    settingsDownloadAppDesc: "Instale Callo no seu dispositivo para acesso mais rápido e notificações confiáveis.",
    settingsInstallPromptTitle: "Instalar Callo",
    settingsInstallPromptDesc: "Obtenha Callo diretamente no seu dispositivo. Acesso rápido, notificações em tempo real, até modo offline.",
    settingsInstallPlatformTitle: "Instruções de instalação",
    settingsInstallIosStep1: "Abra o Safari e vá para callo.online",
    settingsInstallIosStep2: "Toque no ícone de compartilhamento na parte inferior (quadrado com seta)",
    settingsInstallIosStep3: "Selecione \"Adicionar à Tela de Início\"",
    settingsInstallAndroidStep1: "Abra o Chrome e vá para callo.online",
    settingsInstallAndroidStep2: "Toque no menu (3 pontos) no canto superior direito",
    settingsInstallAndroidStep3: "Selecione \"Instalar aplicativo\"",
    settingsInstallDesktopStep1: "Você verá um ícone de instalação na barra de endereços",
    settingsInstallDesktopStep2: "Clique no ícone e confirme a instalação",
    settingsInstallBenefitFast: "Acesso rápido",
    settingsInstallBenefitFastDesc: "Abra Callo em um clique na sua tela inicial",
    settingsInstallBenefitNotifications: "Notificações confiáveis",
    settingsInstallBenefitNotificationsDesc: "Receba alertas mesmo quando seu navegador está fechado",
    settingsInstallButtonInstall: "Instalar agora",
    settingsInstallButtonClose: "Fechar",
    settingsInstallSuccess: "Callo foi instalado com sucesso!",
    settingsInstallAlreadyInstalled: "O Callo já está instalado neste dispositivo.",
  },
  de: {
    settingsNotifications: "Benachrichtigungen",
    settingsNotificationsDesc: "Erhalten Sie Callo-Benachrichtigungen auf Ihrem Gerät",
    settingsPushTitle: "Benachrichtigungen auf diesem Gerät",
    settingsPushSubtitle: "Erhalten Sie Callo-Benachrichtigungen, auch wenn die App geschlossen ist.",
    settingsPushStatusSupported: "Kompatibilität",
    settingsPushStatusEnabled: "Aktiv",
    settingsPushStatusDisabled: "Deaktiviert",
    settingsPushPermissionDefault: "Berechtigung noch nicht angefordert",
    settingsPushPermissionGranted: "Berechtigung erteilt",
    settingsPushPermissionDenied: "Berechtigung verweigert",
    settingsPushEnable: "Benachrichtigungen aktivieren",
    settingsPushDisable: "Deaktivieren",
    settingsPushSaveError: "Benachrichtigungen konnten nicht konfiguriert werden",
    settingsPushEnabledSuccess: "Benachrichtigungen auf diesem Gerät aktiviert",
    settingsPushDisabledSuccess: "Benachrichtigungen auf diesem Gerät deaktiviert",
    settingsPushUnsupported: "Push-Benachrichtigungen werden in diesem Browser nicht unterstützt",
    settingsPushPermissionDeniedError: "Benachrichtigungen wurden im Browser blockiert",
    settingsPushExplain: "Sie erhalten Nachrichten, Freundschaftsanfragen, Reaktionen und Lives direkt auf Ihrem Gerät.",
    settingsPushNeedPermission: "Der Browser fragt vor der Aktivierung nach der Erlaubnis.",
    settingsPushPromptTitle: "Benachrichtigungen erhalten",
    settingsPushPromptDescription: "Hallo {name}! Erlaube Callo, wichtige Benachrichtigungen direkt auf dein Gerät zu senden.",
    settingsPushPromptBenefit1: "In Echtzeit informiert bleiben",
    settingsPushPromptBenefit2: "Nachrichten, Freundschaftsanfragen, Reaktionen und Lives erscheinen direkt auf Ihrem Gerät.",
    settingsPushPromptAllow: "Erlauben",
    settingsPushPromptLater: "Später",
    settingsPushConsentQuestion: "Möchten Sie Callo-Benachrichtigungen auf Ihrem Gerät erhalten?",
    settingsPushConsentExplanation: "Sie entscheiden. Wenn Sie fortfahren, fragt der Browser anschließend nach der Berechtigung.",
    settingsPushConsentLater: "Später",
    settingsPushConsentAllow: "Zulassen",
    settingsDownloadAppTitle: "App herunterladen",
    settingsDownloadAppDesc: "Installieren Sie Callo auf Ihrem Gerät für schnelleren Zugriff und zuverlässige Benachrichtigungen.",
    settingsInstallPromptTitle: "Callo installieren",
    settingsInstallPromptDesc: "Holen Sie sich Callo direkt auf Ihr Gerät. Schneller Zugriff, Echtzeit-Benachrichtigungen, sogar Offline-Modus.",
    settingsInstallPlatformTitle: "Installationsanleitung",
    settingsInstallIosStep1: "Öffnen Sie Safari und gehen Sie zu callo.online",
    settingsInstallIosStep2: "Tippen Sie auf das Freigabesymbol unten (Quadrat mit Pfeil)",
    settingsInstallIosStep3: "Wählen Sie \"Zum Homescreen hinzufügen\"",
    settingsInstallAndroidStep1: "Öffnen Sie Chrome und gehen Sie zu callo.online",
    settingsInstallAndroidStep2: "Tippen Sie auf das Menü (3 Punkte) oben rechts",
    settingsInstallAndroidStep3: "Wählen Sie \"App installieren\"",
    settingsInstallDesktopStep1: "Sie sehen ein Installationssymbol in der Adressleiste",
    settingsInstallDesktopStep2: "Klicken Sie auf das Symbol und bestätigen Sie die Installation",
    settingsInstallBenefitFast: "Schneller Zugriff",
    settingsInstallBenefitFastDesc: "Starten Sie Callo mit einem Klick von Ihrem Startbildschirm",
    settingsInstallBenefitNotifications: "Zuverlässige Benachrichtigungen",
    settingsInstallBenefitNotificationsDesc: "Erhalten Sie Benachrichtigungen auch wenn Ihr Browser geschlossen ist",
    settingsInstallButtonInstall: "Jetzt installieren",
    settingsInstallButtonClose: "Schließen",
    settingsInstallSuccess: "Callo wurde erfolgreich installiert!",
    settingsInstallAlreadyInstalled: "Callo ist bereits auf diesem Gerät installiert.",
  },
  it: {
    settingsNotifications: "Notifiche",
    settingsNotificationsDesc: "Ricevi le notifiche di Callo sul tuo dispositivo",
    settingsPushTitle: "Notifiche su questo dispositivo",
    settingsPushSubtitle: "Ricevi gli avvisi di Callo anche quando l'app è chiusa.",
    settingsPushStatusSupported: "Compatibilità",
    settingsPushStatusEnabled: "Attive",
    settingsPushStatusDisabled: "Disattivate",
    settingsPushPermissionDefault: "Autorizzazione non richiesta",
    settingsPushPermissionGranted: "Autorizzazione concessa",
    settingsPushPermissionDenied: "Autorizzazione negata",
    settingsPushEnable: "Abilita le notifiche",
    settingsPushDisable: "Disattiva",
    settingsPushSaveError: "Impossibile configurare le notifiche",
    settingsPushEnabledSuccess: "Notifiche abilitate su questo dispositivo",
    settingsPushDisabledSuccess: "Notifiche disabilitate su questo dispositivo",
    settingsPushUnsupported: "Le notifiche push non sono supportate in questo browser",
    settingsPushPermissionDeniedError: "Le notifiche sono state negate nel browser",
    settingsPushExplain: "Riceverai messaggi, richieste di amicizia, reazioni e live direttamente sul tuo dispositivo.",
    settingsPushNeedPermission: "Il browser richiederà l'autorizzazione prima dell'attivazione.",
    settingsPushPromptTitle: "Ricevi le notifiche",
    settingsPushPromptDescription: "Ciao {name}! Consenti a Callo di inviarti avvisi importanti direttamente sul tuo dispositivo.",
    settingsPushPromptBenefit1: "Rimani aggiornato in tempo reale",
    settingsPushPromptBenefit2: "Messaggi, richieste, reazioni e live compaiono direttamente sul tuo dispositivo.",
    settingsPushPromptAllow: "Consenti",
    settingsPushPromptLater: "Più tardi",
    settingsPushConsentQuestion: "Vuoi ricevere le notifiche di Callo sul tuo dispositivo?",
    settingsPushConsentExplanation: "Scegli tu. Se continui, il browser ti chiederà l'autorizzazione.",
    settingsPushConsentLater: "Più tardi",
    settingsPushConsentAllow: "Consenti",
    settingsDownloadAppTitle: "Scarica l'app",
    settingsDownloadAppDesc: "Installa Callo sul tuo dispositivo per un accesso più veloce e notifiche affidabili.",
    settingsInstallPromptTitle: "Installa Callo",
    settingsInstallPromptDesc: "Ottieni Callo direttamente sul tuo dispositivo. Accesso veloce, notifiche in tempo reale, anche modalità offline.",
    settingsInstallPlatformTitle: "Istruzioni di installazione",
    settingsInstallIosStep1: "Apri Safari e vai su callo.online",
    settingsInstallIosStep2: "Tocca l'icona di condivisione in basso (quadrato con freccia)",
    settingsInstallIosStep3: "Seleziona \"Aggiungi a Schermata Home\"",
    settingsInstallAndroidStep1: "Apri Chrome e vai su callo.online",
    settingsInstallAndroidStep2: "Tocca il menu (3 punti) in alto a destra",
    settingsInstallAndroidStep3: "Seleziona \"Installa app\"",
    settingsInstallDesktopStep1: "Vedrai un'icona di installazione nella barra degli indirizzi",
    settingsInstallDesktopStep2: "Fai clic sull'icona e conferma l'installazione",
    settingsInstallBenefitFast: "Accesso veloce",
    settingsInstallBenefitFastDesc: "Avvia Callo con un clic dalla tua schermata principale",
    settingsInstallBenefitNotifications: "Notifiche affidabili",
    settingsInstallBenefitNotificationsDesc: "Ricevi avvisi anche quando il tuo browser è chiuso",
    settingsInstallButtonInstall: "Installa ora",
    settingsInstallButtonClose: "Chiudi",
    settingsInstallSuccess: "Callo è stato installato con successo!",
    settingsInstallAlreadyInstalled: "Callo è già installato su questo dispositivo.",
  },
  ar: {
    settingsNotifications: "الإشعارات",
    settingsNotificationsDesc: "تلقَّ إشعارات Callo على جهازك",
    settingsPushTitle: "الإشعارات على هذا الجهاز",
    settingsPushSubtitle: "تلقى تنبيهات Callo حتى عندما يكون التطبيق مغلقًا.",
    settingsPushStatusSupported: "التوافق",
    settingsPushStatusEnabled: "مُفعلة",
    settingsPushStatusDisabled: "معطلة",
    settingsPushPermissionDefault: "لم يُطلب الإذن",
    settingsPushPermissionGranted: "تم منح الإذن",
    settingsPushPermissionDenied: "تم رفض الإذن",
    settingsPushEnable: "تفعيل الإشعارات",
    settingsPushDisable: "إيقاف",
    settingsPushSaveError: "يتعذر تكوين الإشعارات",
    settingsPushEnabledSuccess: "تم تفعيل الإشعارات على هذا الجهاز",
    settingsPushDisabledSuccess: "تم تعطيل الإشعارات على هذا الجهاز",
    settingsPushUnsupported: "إشعارات الدفع غير مدعومة في هذا المتصفح",
    settingsPushPermissionDeniedError: "تم رفض الإشعارات في المتصفح",
    settingsPushExplain: "ستتلقى الرسائل وطلبات الصداقة والتفاعلات والبثوث مباشرة على جهازك.",
    settingsPushNeedPermission: "سيطلب المتصفح الإذن قبل التفعيل.",
    settingsPushConsentQuestion: "هل تريد تلقي إشعارات Callo على جهازك؟",
    settingsPushConsentExplanation: "الاختيار لك. إذا تابعت، سيطلب المتصفح الإذن بعد ذلك.",
    settingsPushConsentLater: "لاحقًا",
    settingsPushConsentAllow: "سماح",
    settingsPushPromptTitle: "تلقي الإشعارات",
    settingsPushPromptDescription: "مرحبًا {name}! اسمح لـ Callo بإرسال التنبيهات المهمة مباشرة إلى جهازك.",
    settingsPushPromptBenefit1: "ابقَ على اطلاع في الوقت الحقيقي",
    settingsPushPromptBenefit2: "الرسائل وطلبات الصداقة والتفاعلات والبثوث تظهر مباشرة على جهازك.",
    settingsPushPromptAllow: "السماح",
    settingsPushPromptLater: "لاحقًا",
    settingsDownloadAppTitle: "تحميل التطبيق",
    settingsDownloadAppDesc: "قم بتثبيت Callo على جهازك للوصول الأسرع والإشعارات الموثوقة.",
    settingsInstallPromptTitle: "تثبيت Callo",
    settingsInstallPromptDesc: "احصل على Callo مباشرة على جهازك. وصول سريع، إشعارات في الوقت الفعلي، حتى وضع بلا إنترنت.",
    settingsInstallPlatformTitle: "تعليمات التثبيت",
    settingsInstallIosStep1: "افتح Safari وانتقل إلى callo.online",
    settingsInstallIosStep2: "اضغط على أيقونة المشاركة في الأسفل (مربع بسهم)",
    settingsInstallIosStep3: "حدد \"إضافة إلى شاشة البيت\"",
    settingsInstallAndroidStep1: "افتح Chrome وانتقل إلى callo.online",
    settingsInstallAndroidStep2: "اضغط على القائمة (3 نقاط) في الأعلى يمينًا",
    settingsInstallAndroidStep3: "حدد \"تثبيت التطبيق\"",
    settingsInstallDesktopStep1: "ستظهر أيقونة التثبيت في شريط العنوان",
    settingsInstallDesktopStep2: "انقر على الأيقونة وأكد التثبيت",
    settingsInstallBenefitFast: "وصول سريع",
    settingsInstallBenefitFastDesc: "شغّل Callo بنقرة واحدة من شاشة البيت",
    settingsInstallBenefitNotifications: "إشعارات موثوقة",
    settingsInstallBenefitNotificationsDesc: "احصل على تنبيهات حتى عندما يكون متصفحك مغلقًا",
    settingsInstallButtonInstall: "تثبيت الآن",
    settingsInstallButtonClose: "إغلاق",
    settingsInstallSuccess: "تم تثبيت Callo بنجاح!",
    settingsInstallAlreadyInstalled: "Callo مثبت بالفعل على هذا الجهاز.",
  },
  tr: {
    settingsNotifications: "Bildirimler",
    settingsNotificationsDesc: "Callo bildirimlerini cihazınızda alın",
    settingsPushTitle: "Bu cihazdaki bildirimler",
    settingsPushSubtitle: "Uygulama kapalıyken bile Callo bildirimleri alın.",
    settingsPushStatusSupported: "Uyumluluk",
    settingsPushStatusEnabled: "Etkin",
    settingsPushStatusDisabled: "Devre Dışı",
    settingsPushPermissionDefault: "İzin istenmedi",
    settingsPushPermissionGranted: "İzin verildi",
    settingsPushPermissionDenied: "İzin reddedildi",
    settingsPushEnable: "Bildirimleri etkinleştir",
    settingsPushDisable: "Devre dışı bırak",
    settingsPushSaveError: "Bildirimler yapılandırılamadı",
    settingsPushEnabledSuccess: "Bu cihazda bildirimler etkinleştirildi",
    settingsPushDisabledSuccess: "Bu cihazda bildirimler devre dışı bırakıldı",
    settingsPushUnsupported: "Push bildirimleri bu tarayıcıda desteklenmiyor",
    settingsPushPermissionDeniedError: "Tarayıcıda bildirimler reddedildi",
    settingsPushExplain: "Mesajlar, arkadaş istekleri, tepkiler ve canlı yayınlar doğrudan cihazınıza gelir.",
    settingsPushNeedPermission: "Etkinleştirmeden önce tarayıcı izin isteyecektir.",
    settingsPushConsentQuestion: "Callo bildirimlerini cihazınızda almak ister misiniz?",
    settingsPushConsentExplanation: "Seçim sizin. Devam ederseniz tarayıcı ardından izin isteyecek.",
    settingsPushConsentLater: "Daha sonra",
    settingsPushConsentAllow: "İzin ver",
    settingsPushPromptTitle: "Bildirimleri al",
    settingsPushPromptDescription: "Merhaba {name}! Callo'nun önemli bildirimleri doğrudan cihazınıza göndermesine izin verin.",
    settingsPushPromptBenefit1: "Gerçek zamanlı haberdar olun",
    settingsPushPromptBenefit2: "Mesajlar, istekler, tepkiler ve canlı yayınlar cihazınızda görünür.",
    settingsPushPromptAllow: "İzin ver",
    settingsPushPromptLater: "Daha sonra",
    settingsDownloadAppTitle: "Uygulamayı indirin",
    settingsDownloadAppDesc: "Callo'yu cihazınıza yükleyin ve daha hızlı erişim ile güvenilir bildirimler alın.",
    settingsInstallPromptTitle: "Callo'yu yükle",
    settingsInstallPromptDesc: "Callo'yu doğrudan cihazınıza alın. Hızlı erişim, gerçek zamanlı bildirimler, hatta çevrimdışı mod.",
    settingsInstallPlatformTitle: "Yükleme talimatları",
    settingsInstallIosStep1: "Safari'yi açın ve callo.online adresine gidin",
    settingsInstallIosStep2: "Altta bulunan paylaş simgesine dokunun (kare ve ok)",
    settingsInstallIosStep3: "\"Ana Ekrana Ekle\" seçeneğini seçin",
    settingsInstallAndroidStep1: "Chrome'u açın ve callo.online adresine gidin",
    settingsInstallAndroidStep2: "Sağ üstteki menüye (3 nokta) dokunun",
    settingsInstallAndroidStep3: "\"Uygulamayı yükle\" seçeneğini seçin",
    settingsInstallDesktopStep1: "Adres çubuğunda yükleme simgesini göreceksiniz",
    settingsInstallDesktopStep2: "Simgeyi tıklatın ve yüklemeyi onaylayın",
    settingsInstallBenefitFast: "Hızlı erişim",
    settingsInstallBenefitFastDesc: "Ana ekrandan bir tıkla Callo'yu başlatın",
    settingsInstallBenefitNotifications: "Güvenilir bildirimler",
    settingsInstallBenefitNotificationsDesc: "Tarayıcınız kapalıyken bile bildirim alın",
    settingsInstallButtonInstall: "Şimdi yükle",
    settingsInstallButtonClose: "Kapat",
    settingsInstallSuccess: "Callo başarıyla yüklendi!",
    settingsInstallAlreadyInstalled: "Callo bu cihazda zaten yüklü.",
  },
  nl: {
    settingsNotifications: "Meldingen",
    settingsNotificationsDesc: "Ontvang Callo-meldingen op je apparaat",
    settingsPushTitle: "Meldingen op dit apparaat",
    settingsPushSubtitle: "Ontvang Callo-meldingen, zelfs wanneer de app is gesloten.",
    settingsPushStatusSupported: "Compatibiliteit",
    settingsPushStatusEnabled: "Actief",
    settingsPushStatusDisabled: "Uitgeschakeld",
    settingsPushPermissionDefault: "Toestemming niet gevraagd",
    settingsPushPermissionGranted: "Toestemming verleend",
    settingsPushPermissionDenied: "Toestemming geweigerd",
    settingsPushEnable: "Meldingen inschakelen",
    settingsPushDisable: "Uitschakelen",
    settingsPushSaveError: "Meldingen kunnen niet worden geconfigureerd",
    settingsPushEnabledSuccess: "Meldingen ingeschakeld op dit apparaat",
    settingsPushDisabledSuccess: "Meldingen uitgeschakeld op dit apparaat",
    settingsPushUnsupported: "Pushmeldingen worden niet ondersteund in deze browser",
    settingsPushPermissionDeniedError: "Meldingen zijn geweigerd in de browser",
    settingsPushExplain: "Je ontvangt berichten, vriendschapsverzoeken, reacties en lives rechtstreeks op je apparaat.",
    settingsPushNeedPermission: "De browser vraagt om toestemming voordat het wordt ingeschakeld.",
    settingsPushConsentQuestion: "Wil je Callo-meldingen op je apparaat ontvangen?",
    settingsPushConsentExplanation: "Jij kiest. Als je doorgaat, vraagt de browser daarna om toestemming.",
    settingsPushConsentLater: "Later",
    settingsPushConsentAllow: "Toestaan",
    settingsPushPromptTitle: "Ontvang meldingen",
    settingsPushPromptDescription: "Hoi {name}! Sta Callo toe belangrijke meldingen rechtstreeks naar je apparaat te sturen.",
    settingsPushPromptBenefit1: "Blijf realtime geïnformeerd",
    settingsPushPromptBenefit2: "Berichten, verzoeken, reacties en lives verschijnen rechtstreeks op je apparaat.",
    settingsPushPromptAllow: "Toestaan",
    settingsPushPromptLater: "Later",
    settingsDownloadAppTitle: "App downloaden",
    settingsDownloadAppDesc: "Installeer Callo op je apparaat voor snellere toegang en betrouwbare meldingen.",
    settingsInstallPromptTitle: "Callo installeren",
    settingsInstallPromptDesc: "Zet Callo rechtstreeks op je apparaat. Snelle toegang, realtime meldingen, zelfs offline modus.",
    settingsInstallPlatformTitle: "Installatie-instructies",
    settingsInstallIosStep1: "Open Safari en ga naar callo.online",
    settingsInstallIosStep2: "Tik op het deelpictogram onderaan (vierkant met pijl)",
    settingsInstallIosStep3: "Selecteer \"Voeg toe aan startscherm\"",
    settingsInstallAndroidStep1: "Open Chrome en ga naar callo.online",
    settingsInstallAndroidStep2: "Tik op het menu (3 punten) rechtsboven",
    settingsInstallAndroidStep3: "Selecteer \"App installeren\"",
    settingsInstallDesktopStep1: "Je ziet een installatiepictogram in de adresbalk",
    settingsInstallDesktopStep2: "Klik op het pictogram en bevestig de installatie",
    settingsInstallBenefitFast: "Snelle toegang",
    settingsInstallBenefitFastDesc: "Start Callo in één klik vanuit je startscherm",
    settingsInstallBenefitNotifications: "Betrouwbare meldingen",
    settingsInstallBenefitNotificationsDesc: "Ontvang meldingen zelfs als je browser gesloten is",
    settingsInstallButtonInstall: "Nu installeren",
    settingsInstallButtonClose: "Sluiten",
    settingsInstallSuccess: "Callo is succesvol geïnstalleerd!",
    settingsInstallAlreadyInstalled: "Callo is al geïnstalleerd op dit apparaat.",
  },
  ru: {
    settingsNotifications: "Уведомления",
    settingsNotificationsDesc: "Получайте уведомления Callo на вашем устройстве",
    settingsPushTitle: "Уведомления на этом устройстве",
    settingsPushSubtitle: "Получайте уведомления Callo даже когда приложение закрыто.",
    settingsPushStatusSupported: "Совместимость",
    settingsPushStatusEnabled: "Включены",
    settingsPushStatusDisabled: "Отключены",
    settingsPushPermissionDefault: "Разрешение не запрошено",
    settingsPushPermissionGranted: "Разрешение предоставлено",
    settingsPushPermissionDenied: "Разрешение отклонено",
    settingsPushEnable: "Включить уведомления",
    settingsPushDisable: "Отключить",
    settingsPushSaveError: "Не удалось настроить уведомления",
    settingsPushEnabledSuccess: "Уведомления включены на этом устройстве",
    settingsPushDisabledSuccess: "Уведомления отключены на этом устройстве",
    settingsPushUnsupported: "Push-уведомления не поддерживаются в этом браузере",
    settingsPushPermissionDeniedError: "Уведомления были отклонены в браузере",
    settingsPushExplain: "Вы будете получать сообщения, запросы в друзья, реакции и прямые эфиры прямо на ваше устройство.",
    settingsPushNeedPermission: "Браузер запросит разрешение перед активацией.",
    settingsPushConsentQuestion: "Хотите получать уведомления Callo на своем устройстве?",
    settingsPushConsentExplanation: "Решение за вами. Если продолжите, затем браузер запросит разрешение.",
    settingsPushConsentLater: "Позже",
    settingsPushConsentAllow: "Разрешить",
    settingsPushPromptTitle: "Получать уведомления",
    settingsPushPromptDescription: "Привет {name}! Разрешите Callo отправлять важные оповещения прямо на ваше устройство.",
    settingsPushPromptBenefit1: "Будьте в курсе в реальном времени",
    settingsPushPromptBenefit2: "Сообщения, запросы, реакции и эфиры появляются прямо на вашем устройстве.",
    settingsPushPromptAllow: "Разрешить",
    settingsPushPromptLater: "Позже",
    settingsDownloadAppTitle: "Скачать приложение",
    settingsDownloadAppDesc: "Установите Callo на ваше устройство для более быстрого доступа и надежных уведомлений.",
    settingsInstallPromptTitle: "Установить Callo",
    settingsInstallPromptDesc: "Получите Callo прямо на ваше устройство. Быстрый доступ, уведомления в реальном времени, даже режим оффлайн.",
    settingsInstallPlatformTitle: "Инструкции по установке",
    settingsInstallIosStep1: "Откройте Safari и перейдите на callo.online",
    settingsInstallIosStep2: "Нажмите на значок «Поделиться» внизу (квадрат со стрелкой)",
    settingsInstallIosStep3: "Выберите «Добавить на главный экран»",
    settingsInstallAndroidStep1: "Откройте Chrome и перейдите на callo.online",
    settingsInstallAndroidStep2: "Нажмите на меню (3 точки) в правом верхнем углу",
    settingsInstallAndroidStep3: "Выберите «Установить приложение»",
    settingsInstallDesktopStep1: "Вы увидите значок установки в адресной строке",
    settingsInstallDesktopStep2: "Нажмите на значок и подтвердите установку",
    settingsInstallBenefitFast: "Быстрый доступ",
    settingsInstallBenefitFastDesc: "Запустите Callo одним кликом с главного экрана",
    settingsInstallBenefitNotifications: "Надежные уведомления",
    settingsInstallBenefitNotificationsDesc: "Получайте уведомления даже когда браузер закрыт",
    settingsInstallButtonInstall: "Установить сейчас",
    settingsInstallButtonClose: "Закрыть",
    settingsInstallSuccess: "Callo был успешно установлен!",
    settingsInstallAlreadyInstalled: "Callo уже установлен на этом устройстве.",
  },
  zh: {
    settingsNotifications: "通知",
    settingsNotificationsDesc: "在您的设备上接收 Callo 的通知",
    settingsPushTitle: "此设备的通知",
    settingsPushSubtitle: "即使应用程序关闭，也会收到 Callo 的警报。",
    settingsPushStatusSupported: "兼容性",
    settingsPushStatusEnabled: "已启用",
    settingsPushStatusDisabled: "已禁用",
    settingsPushPermissionDefault: "未请求权限",
    settingsPushPermissionGranted: "已授予权限",
    settingsPushPermissionDenied: "已拒绝权限",
    settingsPushEnable: "启用通知",
    settingsPushDisable: "禁用",
    settingsPushSaveError: "无法配置通知",
    settingsPushEnabledSuccess: "此设备上的通知已启用",
    settingsPushDisabledSuccess: "此设备上的通知已禁用",
    settingsPushUnsupported: "此浏览器不支持推送通知",
    settingsPushPermissionDeniedError: "浏览器已拒绝通知",
    settingsPushExplain: "您将直接在设备上收到消息、好友请求、反应和直播。",
    settingsPushNeedPermission: "启用前浏览器会请求权限。",
    settingsPushConsentQuestion: "你想在设备上接收 Callo 通知吗？",
    settingsPushConsentExplanation: "由你决定。如果继续，浏览器随后会请求权限。",
    settingsPushConsentLater: "稍后",
    settingsPushConsentAllow: "允许",
    settingsPushPromptTitle: "接收通知",
    settingsPushPromptDescription: "嗨 {name}！允许 Callo 将重要警报直接发送到您的设备。",
    settingsPushPromptBenefit1: "实时保持更新",
    settingsPushPromptBenefit2: "消息、请求、反应和直播会直接出现在您的设备上。",
    settingsPushPromptAllow: "允许",
    settingsPushPromptLater: "稍后",
    settingsDownloadAppTitle: "下载应用",
    settingsDownloadAppDesc: "在您的设备上安装 Callo，获得更快的访问和可靠的通知。",
    settingsInstallPromptTitle: "安装 Callo",
    settingsInstallPromptDesc: "直接在您的设备上获取 Callo。快速访问、实时通知，甚至离线模式。",
    settingsInstallPlatformTitle: "安装说明",
    settingsInstallIosStep1: "打开 Safari 并前往 callo.online",
    settingsInstallIosStep2: "点击底部的分享图标（带箭头的方形）",
    settingsInstallIosStep3: "选择'添加到主屏幕'",
    settingsInstallAndroidStep1: "打开 Chrome 并前往 callo.online",
    settingsInstallAndroidStep2: "点击右上角的菜单（3 个点）",
    settingsInstallAndroidStep3: "选择'安装应用'",
    settingsInstallDesktopStep1: "您将在地址栏中看到安装图标",
    settingsInstallDesktopStep2: "点击该图标并确认安装",
    settingsInstallBenefitFast: "快速访问",
    settingsInstallBenefitFastDesc: "从主屏幕一键启动 Callo",
    settingsInstallBenefitNotifications: "可靠的通知",
    settingsInstallBenefitNotificationsDesc: "即使浏览器关闭也能收到警报",
    settingsInstallButtonInstall: "立即安装",
    settingsInstallButtonClose: "关闭",
    settingsInstallSuccess: "Callo 已成功安装！",
    settingsInstallAlreadyInstalled: "Callo 已安装在此设备上。",
  },
  ja: {
    settingsNotifications: "通知",
    settingsNotificationsDesc: "デバイスで Callo の通知を受け取る",
    settingsPushTitle: "このデバイスの通知",
    settingsPushSubtitle: "アプリが閉じているときでも Callo の通知を受け取ります。",
    settingsPushStatusSupported: "互換性",
    settingsPushStatusEnabled: "有効",
    settingsPushStatusDisabled: "無効",
    settingsPushPermissionDefault: "許可未要求",
    settingsPushPermissionGranted: "許可が付与されました",
    settingsPushPermissionDenied: "許可が拒否されました",
    settingsPushEnable: "通知を有効にする",
    settingsPushDisable: "無効にする",
    settingsPushSaveError: "通知を設定できません",
    settingsPushEnabledSuccess: "このデバイスで通知が有効になりました",
    settingsPushDisabledSuccess: "このデバイスで通知が無効になりました",
    settingsPushUnsupported: "このブラウザはプッシュ通知をサポートしていません",
    settingsPushPermissionDeniedError: "ブラウザで通知が拒否されました",
    settingsPushExplain: "メッセージ、友達リクエスト、リアクション、ライブをデバイスで直接受け取ります。",
    settingsPushNeedPermission: "有効にする前にブラウザが許可を求めます。",
    settingsPushConsentQuestion: "Callo の通知をこのデバイスで受け取りますか？",
    settingsPushConsentExplanation: "選択はあなた次第です。続行すると、その後ブラウザが許可を求めます。",
    settingsPushConsentLater: "後で",
    settingsPushConsentAllow: "許可する",
    settingsPushPromptTitle: "通知を受け取る",
    settingsPushPromptDescription: "こんにちは {name}! Callo が重要なアラートをあなたのデバイスに直接送信することを許可してください。",
    settingsPushPromptBenefit1: "リアルタイムで最新情報を受け取る",
    settingsPushPromptBenefit2: "メッセージ、リクエスト、リアクション、ライブが直接デバイスに表示されます。",
    settingsPushPromptAllow: "許可する",
    settingsPushPromptLater: "後で",
    settingsDownloadAppTitle: "アプリをダウンロード",
    settingsDownloadAppDesc: "Callo をデバイスにインストールして、より高速にアクセスし、信頼できる通知を受け取ります。",
    settingsInstallPromptTitle: "Callo をインストール",
    settingsInstallPromptDesc: "Callo をデバイスに直接インストール。高速アクセス、リアルタイム通知、オフラインモードも。",
    settingsInstallPlatformTitle: "インストール手順",
    settingsInstallIosStep1: "Safari を開いて callo.online にアクセス",
    settingsInstallIosStep2: "下部の共有アイコン（矢印付きの四角形）をタップ",
    settingsInstallIosStep3: "「ホーム画面に追加」を選択",
    settingsInstallAndroidStep1: "Chrome を開いて callo.online にアクセス",
    settingsInstallAndroidStep2: "右上のメニュー（3 つのドット）をタップ",
    settingsInstallAndroidStep3: "「アプリをインストール」を選択",
    settingsInstallDesktopStep1: "アドレスバーにインストールアイコンが表示されます",
    settingsInstallDesktopStep2: "アイコンをクリックしてインストール完了",
    settingsInstallBenefitFast: "高速アクセス",
    settingsInstallBenefitFastDesc: "ホーム画面からワンクリックで Callo を起動",
    settingsInstallBenefitNotifications: "信頼できる通知",
    settingsInstallBenefitNotificationsDesc: "ブラウザが閉じていても通知を受け取ります",
    settingsInstallButtonInstall: "今すぐインストール",
    settingsInstallButtonClose: "閉じる",
    settingsInstallSuccess: "Callo が正常にインストールされました！",
    settingsInstallAlreadyInstalled: "Callo はこのデバイスにすでにインストールされています。",
  },
  ko: {
    settingsNotifications: "알림",
    settingsNotificationsDesc: "기기에서 Callo 알림을 받습니다",
    settingsPushTitle: "이 기기의 알림",
    settingsPushSubtitle: "앱이 닫혀 있어도 Callo 알림을 받습니다.",
    settingsPushStatusSupported: "호환성",
    settingsPushStatusEnabled: "활성",
    settingsPushStatusDisabled: "비활성",
    settingsPushPermissionDefault: "권한 요청 안 됨",
    settingsPushPermissionGranted: "권한 허용됨",
    settingsPushPermissionDenied: "권한 거부됨",
    settingsPushEnable: "알림 활성화",
    settingsPushDisable: "비활성화",
    settingsPushSaveError: "알림을 구성할 수 없습니다",
    settingsPushEnabledSuccess: "이 기기에서 알림이 활성화되었습니다",
    settingsPushDisabledSuccess: "이 기기에서 알림이 비활성화되었습니다",
    settingsPushUnsupported: "이 브라우저는 푸시 알림을 지원하지 않습니다",
    settingsPushPermissionDeniedError: "브라우저에서 알림이 거부되었습니다",
    settingsPushExplain: "메시지, 친구 요청, 반응 및 라이브를 기기에서 직접 받습니다.",
    settingsPushNeedPermission: "활성화하기 전에 브라우저가 권한을 요청합니다.",
    settingsPushConsentQuestion: "이 기기에서 Callo 알림을 받으시겠어요?",
    settingsPushConsentExplanation: "선택은 사용자가 합니다. 계속하면 이후 브라우저가 권한을 요청합니다.",
    settingsPushConsentLater: "나중에",
    settingsPushConsentAllow: "허용",
    settingsPushPromptTitle: "알림 받기",
    settingsPushPromptDescription: "안녕하세요 {name}! Callo가 중요한 알림을 기기로 직접 보낼 수 있도록 허용하세요.",
    settingsPushPromptBenefit1: "실시간으로 정보 유지",
    settingsPushPromptBenefit2: "메시지, 요청, 반응 및 라이브가 기기에 직접 표시됩니다.",
    settingsPushPromptAllow: "허용",
    settingsPushPromptLater: "나중에",
    settingsDownloadAppTitle: "앱 다운로드",
    settingsDownloadAppDesc: "Callo를 기기에 설치하여 더 빠른 액세스와 신뢰할 수 있는 알림을 받습니다.",
    settingsInstallPromptTitle: "Callo 설치",
    settingsInstallPromptDesc: "Callo를 기기에 직접 설치하세요. 빠른 액세스, 실시간 알림, 오프라인 모드까지.",
    settingsInstallPlatformTitle: "설치 지침",
    settingsInstallIosStep1: "Safari를 열고 callo.online으로 이동",
    settingsInstallIosStep2: "하단의 공유 아이콘(화살표가 있는 정사각형) 탭",
    settingsInstallIosStep3: "\"홈 화면에 추가\" 선택",
    settingsInstallAndroidStep1: "Chrome을 열고 callo.online으로 이동",
    settingsInstallAndroidStep2: "오른쪽 상단의 메뉴(3개 점) 탭",
    settingsInstallAndroidStep3: "\"앱 설치\" 선택",
    settingsInstallDesktopStep1: "주소 표시줄에 설치 아이콘이 표시됩니다",
    settingsInstallDesktopStep2: "아이콘을 클릭하고 설치 확인",
    settingsInstallBenefitFast: "빠른 액세스",
    settingsInstallBenefitFastDesc: "홈 화면에서 한 번의 클릭으로 Callo 시작",
    settingsInstallBenefitNotifications: "신뢰할 수 있는 알림",
    settingsInstallBenefitNotificationsDesc: "브라우저가 닫혀있어도 알림을 받습니다",
    settingsInstallButtonInstall: "지금 설치",
    settingsInstallButtonClose: "닫기",
    settingsInstallSuccess: "Callo가 성공적으로 설치되었습니다!",
    settingsInstallAlreadyInstalled: "Callo는 이미 이 기기에 설치되어 있습니다.",
  },
  hi: {
    settingsNotifications: "सूचनाएँ",
    settingsNotificationsDesc: "अपने डिवाइस पर Callo सूचनाएँ प्राप्त करें",
    settingsPushTitle: "इस डिवाइस पर सूचनाएँ",
    settingsPushSubtitle: "ऐप बंद होने पर भी Callo अलर्ट प्राप्त करें।",
    settingsPushStatusSupported: "संगतता",
    settingsPushStatusEnabled: "सक्रिय",
    settingsPushStatusDisabled: "निष्क्रिय",
    settingsPushPermissionDefault: "अनुमति नहीं मांगी गई",
    settingsPushPermissionGranted: "अनुमति दी गई",
    settingsPushPermissionDenied: "अनुमति अस्वीकार की गई",
    settingsPushEnable: "सूचनाएँ सक्षम करें",
    settingsPushDisable: "अक्षम करें",
    settingsPushSaveError: "सूचनाएँ कॉन्फ़िगर नहीं की जा सकीं",
    settingsPushEnabledSuccess: "इस डिवाइस पर सूचनाएँ सक्षम की गईं",
    settingsPushDisabledSuccess: "इस डिवाइस पर सूचनाएँ अक्षम की गईं",
    settingsPushUnsupported: "इस ब्राउज़र में पुश सूचनाएँ समर्थित नहीं हैं",
    settingsPushPermissionDeniedError: "ब्राउज़र में सूचनाएँ अस्वीकार कर दी गई हैं",
    settingsPushExplain: "आप सीधे अपने डिवाइस पर संदेश, दोस्त अनुरोध, प्रतिक्रियाएँ और लाइव प्राप्त करेंगे।",
    settingsPushNeedPermission: "सक्षम करने से पहले ब्राउज़र अनुमति मांगेगा।",
    settingsPushConsentQuestion: "क्या आप अपने डिवाइस पर Callo सूचनाएँ प्राप्त करना चाहते हैं?",
    settingsPushConsentExplanation: "चयन आपका है। यदि आप आगे बढ़ते हैं, तो ब्राउज़र बाद में अनुमति मांगेगा।",
    settingsPushConsentLater: "बाद में",
    settingsPushConsentAllow: "अनुमति दें",
    settingsPushPromptTitle: "सूचनाएँ प्राप्त करें",
    settingsPushPromptDescription: "नमस्ते {name}! Callo को आपके डिवाइस पर महत्वपूर्ण अलर्ट भेजने की अनुमति दें।",
    settingsPushPromptBenefit1: "रियल-टाइम में सूचित रहें",
    settingsPushPromptBenefit2: "संदेश, अनुरोध, प्रतिक्रियाएँ और लाइव सीधे आपके डिवाइस पर दिखाई देंगे।",
    settingsPushPromptAllow: "अनुमति दें",
    settingsPushPromptLater: "बाद में",
    settingsDownloadAppTitle: "ऐप डाउनलोड करें",
    settingsDownloadAppDesc: "अपने डिवाइस पर Callo इंस्टॉल करें और तेज़ एक्सेस और विश्वसनीय सूचनाएँ प्राप्त करें।",
    settingsInstallPromptTitle: "Callo इंस्टॉल करें",
    settingsInstallPromptDesc: "Callo को सीधे अपने डिवाइस पर प्राप्त करें। तेज़ एक्सेस, रियल-टाइम सूचनाएँ, ऑफ़लाइन मोड भी।",
    settingsInstallPlatformTitle: "इंस्टॉलेशन निर्देश",
    settingsInstallIosStep1: "Safari खोलें और callo.online पर जाएँ",
    settingsInstallIosStep2: "नीचे शेयर आइकन पर टैप करें (तीर के साथ वर्ग)",
    settingsInstallIosStep3: "\"होम स्क्रीन में जोड़ें\" चुनें",
    settingsInstallAndroidStep1: "Chrome खोलें और callo.online पर जाएँ",
    settingsInstallAndroidStep2: "दाईं ओर मेनू (3 बिंदु) पर टैप करें",
    settingsInstallAndroidStep3: "\"ऐप इंस्टॉल करें\" चुनें",
    settingsInstallDesktopStep1: "आप एड्रेस बार में इंस्टॉल आइकन देखेंगे",
    settingsInstallDesktopStep2: "आइकन पर क्लिक करें और इंस्टॉलेशन की पुष्टि करें",
    settingsInstallBenefitFast: "तेज़ एक्सेस",
    settingsInstallBenefitFastDesc: "होम स्क्रीन से एक क्लिक में Callo शुरू करें",
    settingsInstallBenefitNotifications: "विश्वसनीय सूचनाएँ",
    settingsInstallBenefitNotificationsDesc: "तब भी सूचनाएँ प्राप्त करें जब आपका ब्राउज़र बंद हो",
    settingsInstallButtonInstall: "अभी इंस्टॉल करें",
    settingsInstallButtonClose: "बंद करें",
    settingsInstallSuccess: "Callo सफलतापूर्वक इंस्टॉल हो गया!",
    settingsInstallAlreadyInstalled: "Callo पहले से ही इस डिवाइस पर इंस्टॉल है।",
  },
}

// Merge the push-specific translations into the main translations map so lookups work per-locale
Object.keys(PUSH_TRANSLATIONS).forEach((code) => {
  const locale = code as LocaleCode
  translations[locale] = {
    ...(translations[locale] || baseTranslations),
    ...(PUSH_TRANSLATIONS[locale] || {}),
  } as TranslationMap
})

export function resolveLocale(input?: string | null): LocaleCode {
  if (!input) return DEFAULT_LOCALE
  const normalized = input.toLowerCase().replace("_", "-")
  const base = normalized.split("-")[0] as LocaleCode
  return SUPPORTED_LOCALES.some((locale) => locale.code === base) ? base : DEFAULT_LOCALE
}

export function getLocaleDirection(locale: string): "ltr" | "rtl" {
  const normalized = resolveLocale(locale)
  return SUPPORTED_LOCALES.find((item) => item.code === normalized)?.dir || "ltr"
}

export function getLocaleOption(locale: string): LocaleOption {
  const normalized = resolveLocale(locale)
  return SUPPORTED_LOCALES.find((item) => item.code === normalized) || SUPPORTED_LOCALES[0]
}

const LIVE_MISSING_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  en: {
    liveInvitationPrompt: "{name} invites you to come up on the live",
    liveInvitationAccept: "Accept",
    liveInvitationReject: "Decline",
  },
  es: {
    liveNoLive: "No hay directos en curso",
    liveStartSession: "Sé el primero en iniciar una sesión e invita a tu comunidad en tiempo real.",
    liveNoBroadcasts: "No hay emisiones",
    liveBroadcastsLive: "{count} emisiones en directo",
    livePublicLives: "Directos públicos",
    liveLiveNow: "En directo",
    liveViewers: "Espectadores",
    liveParticipants: "Participantes",
    liveRequests: "Solicitudes",
    liveInvite: "Invitar",
    liveComments: "Comentarios",
    liveJoinSession: "Únete a una sesión o inicia la tuya en segundos.",
    liveMoreLives: "Más directos",
    liveCountLabel: "{count} directos",
    liveStepDown: "Pasar a espectador",
    liveInvitationPrompt: "{name} te invita a subir al live",
    liveInvitationAccept: "Aceptar",
    liveInvitationReject: "Rechazar",
    authMinAgeHint: "Debes tener al menos 16 años",
    authLegalPrefix: "Al registrarte, confirmas que tienes al menos",
    authLegalAnd: "y aceptas nuestros",
  },
  pt: {
    liveNoLive: "Nenhuma live em andamento",
    liveStartSession: "Seja o primeiro a iniciar uma sessão e convide sua comunidade em tempo real.",
    liveNoBroadcasts: "Nenhuma transmissão",
    liveBroadcastsLive: "{count} transmissões ao vivo",
    livePublicLives: "Lives públicas",
    liveLiveNow: "Ao vivo",
    liveViewers: "Espectadores",
    liveParticipants: "Participantes",
    liveRequests: "Pedidos",
    liveInvite: "Convidar",
    liveComments: "Comentários",
    liveJoinSession: "Participe de uma sessão ou inicie a sua em poucos segundos.",
    liveMoreLives: "Mais lives",
    liveCountLabel: "{count} lives",
    liveStepDown: "Passar para espectador",
    liveInvitationPrompt: "{name} convida você para entrar na live",
    liveInvitationAccept: "Aceitar",
    liveInvitationReject: "Recusar",
    authMinAgeHint: "Você deve ter pelo menos 16 anos",
    authLegalPrefix: "Ao se inscrever, você confirma que tem pelo menos",
    authLegalAnd: "e concorda com nossos",
  },
  de: {
    liveNoLive: "Kein Live derzeit aktiv",
    liveStartSession: "Starte als Erste:r eine Session und lade deine Community in Echtzeit ein.",
    liveNoBroadcasts: "Keine Übertragungen",
    liveBroadcastsLive: "{count} Live-Streams",
    livePublicLives: "Öffentliche Lives",
    liveLiveNow: "Live",
    liveViewers: "Zuschauer",
    liveParticipants: "Teilnehmer",
    liveRequests: "Anfragen",
    liveInvite: "Einladen",
    liveComments: "Kommentare",
    liveJoinSession: "Tritt einer Session bei oder starte deine eigene in wenigen Sekunden.",
    liveMoreLives: "Mehr Lives",
    liveCountLabel: "{count} Lives",
    liveStepDown: "Zu Zuschauer wechseln",
    liveInvitationPrompt: "{name} lädt dich ein, im Live dazuzukommen",
    liveInvitationAccept: "Annehmen",
    liveInvitationReject: "Ablehnen",
    authMinAgeHint: "Du musst mindestens 16 Jahre alt sein",
    authLegalPrefix: "Indem du dich anmeldest, bestätigst du, dass du mindestens",
    authLegalAnd: "und stimmst unseren",
  },
  it: {
    liveNoLive: "Nessuna live in corso",
    liveStartSession: "Sii il primo ad avviare una sessione e invita la tua community in tempo reale.",
    liveNoBroadcasts: "Nessuna trasmissione",
    liveBroadcastsLive: "{count} dirette live",
    livePublicLives: "Live pubbliche",
    liveLiveNow: "In diretta",
    liveViewers: "Spettatori",
    liveParticipants: "Partecipanti",
    liveRequests: "Richieste",
    liveInvite: "Invita",
    liveComments: "Commenti",
    liveJoinSession: "Partecipa a una sessione o avviane una tua in pochi secondi.",
    liveMoreLives: "Altre live",
    liveCountLabel: "{count} live",
    liveStepDown: "Passa a spettatore",
    liveInvitationPrompt: "{name} ti invita a salire nella live",
    liveInvitationAccept: "Accetta",
    liveInvitationReject: "Rifiuta",
    authMinAgeHint: "Devi avere almeno 16 anni",
    authLegalPrefix: "Registrandoti, confermi di avere almeno",
    authLegalAnd: "e accetti i nostri",
  },
  ar: {
    liveNoLive: "لا توجد جلسات مباشرة جارية",
    liveStartSession: "كن أول من يبدأ جلسة وادعُ مجتمعك في الوقت الفعلي.",
    liveNoBroadcasts: "لا توجد بثوث",
    liveBroadcastsLive: "{count} بث مباشر",
    livePublicLives: "جلسات مباشرة عامة",
    liveLiveNow: "مباشر",
    liveViewers: "المشاهدون",
    liveParticipants: "المشاركون",
    liveRequests: "الطلبات",
    liveInvite: "دعوة",
    liveComments: "التعليقات",
    liveJoinSession: "انضم إلى جلسة أو ابدأ جلستك خلال ثوانٍ.",
    liveMoreLives: "مزيد من البثوث",
    liveCountLabel: "{count} بث",
    liveStepDown: "التبديل إلى مشاهد",
    liveInvitationPrompt: "{name} يدعوك للصعود إلى البث المباشر",
    liveInvitationAccept: "قبول",
    liveInvitationReject: "رفض",
    authMinAgeHint: "يجب أن يكون عمرك 16 عامًا على الأقل",
    authLegalPrefix: "بإنشاء حساب، تؤكد أنك لا تقل عن",
    authLegalAnd: "وتوافق على شروطنا",
  },
  tr: {
    liveNoLive: "Devam eden canlı yayın yok",
    liveStartSession: "İlk oturumu başlatan sen ol ve topluluğunu gerçek zamanlı davet et.",
    liveNoBroadcasts: "Yayın yok",
    liveBroadcastsLive: "{count} canlı yayın",
    livePublicLives: "Herkese açık canlı yayınlar",
    liveLiveNow: "Canlı",
    liveViewers: "İzleyiciler",
    liveParticipants: "Katılımcılar",
    liveRequests: "İstekler",
    liveInvite: "Davet et",
    liveComments: "Yorumlar",
    liveJoinSession: "Bir oturuma katıl veya birkaç saniyede kendi oturumunu başlat.",
    liveMoreLives: "Daha fazla canlı yayın",
    liveCountLabel: "{count} canlı yayın",
    liveStepDown: "İzleyiciye geç",
    liveInvitationPrompt: "{name} seni canlı yayına çıkmaya davet ediyor",
    liveInvitationAccept: "Kabul et",
    liveInvitationReject: "Reddet",
    authMinAgeHint: "En az 16 yaşında olmalısınız",
    authLegalPrefix: "Kayıt olarak en az",
    authLegalAnd: "ve şartlarımızı kabul ediyorsunuz",
  },
  nl: {
    liveNoLive: "Geen live bezig",
    liveStartSession: "Start als eerste een sessie en nodig je community in realtime uit.",
    liveNoBroadcasts: "Geen uitzendingen",
    liveBroadcastsLive: "{count} live-uitzendingen",
    livePublicLives: "Openbare lives",
    liveLiveNow: "Live",
    liveViewers: "Kijkers",
    liveParticipants: "Deelnemers",
    liveRequests: "Verzoeken",
    liveInvite: "Uitnodigen",
    liveComments: "Reacties",
    liveJoinSession: "Doe mee aan een sessie of start er zelf een in enkele seconden.",
    liveMoreLives: "Meer lives",
    liveCountLabel: "{count} lives",
    liveStepDown: "Overschakelen naar kijker",
    liveInvitationPrompt: "{name} nodigt je uit om in de live te komen",
    liveInvitationAccept: "Accepteren",
    liveInvitationReject: "Weigeren",
    authMinAgeHint: "Je moet minimaal 16 jaar oud zijn",
    authLegalPrefix: "Door je aan te melden bevestig je dat je minstens",
    authLegalAnd: "en gaat u akkoord met onze",
  },
  ru: {
    liveNoLive: "Сейчас нет активных эфиров",
    liveStartSession: "Запустите сессию первым и пригласите своё сообщество в реальном времени.",
    liveNoBroadcasts: "Нет трансляций",
    liveBroadcastsLive: "{count} эфиров в прямом эфире",
    livePublicLives: "Публичные эфиры",
    liveLiveNow: "В эфире",
    liveViewers: "Зрители",
    liveParticipants: "Участники",
    liveRequests: "Запросы",
    liveInvite: "Пригласить",
    liveComments: "Комментарии",
    liveJoinSession: "Присоединяйтесь к сессии или запустите свою за несколько секунд.",
    liveMoreLives: "Больше эфиров",
    liveCountLabel: "{count} эфиров",
    liveStepDown: "Перейти в зрители",
    liveInvitationPrompt: "{name} приглашает вас выйти в эфир",
    liveInvitationAccept: "Принять",
    liveInvitationReject: "Отклонить",
    authMinAgeHint: "Вам должно быть не менее 16 лет",
    authLegalPrefix: "Регистрируясь, вы подтверждаете, что вам не менее",
    authLegalAnd: "и соглашаетесь с нашими",
  },
  zh: {
    liveNoLive: "当前没有进行中的直播",
    liveStartSession: "成为第一个开启直播的人，实时邀请你的社区加入。",
    liveNoBroadcasts: "暂无直播",
    liveBroadcastsLive: "{count} 场直播中",
    livePublicLives: "公开直播",
    liveLiveNow: "直播中",
    liveViewers: "观众",
    liveParticipants: "参与者",
    liveRequests: "申请",
    liveInvite: "邀请",
    liveComments: "评论",
    liveJoinSession: "加入一个直播，或在几秒内开启你自己的直播。",
    liveMoreLives: "更多直播",
    liveCountLabel: "{count} 场直播",
    liveStepDown: "切换为观众",
    liveInvitationPrompt: "{name} 邀请你上麦加入直播",
    liveInvitationAccept: "接受",
    liveInvitationReject: "拒绝",
    authMinAgeHint: "您必须年满16岁",
    authLegalPrefix: "注册即表示您确认已年满",
    authLegalAnd: "并同意我们的",
  },
  ja: {
    liveNoLive: "進行中のライブはありません",
    liveStartSession: "最初にセッションを開始して、コミュニティをリアルタイムで招待しましょう。",
    liveNoBroadcasts: "配信はありません",
    liveBroadcastsLive: "ライブ配信 {count} 件",
    livePublicLives: "公開ライブ",
    liveLiveNow: "ライブ",
    liveViewers: "視聴者",
    liveParticipants: "参加者",
    liveRequests: "リクエスト",
    liveInvite: "招待",
    liveComments: "コメント",
    liveJoinSession: "セッションに参加するか、数秒で自分の配信を始めましょう。",
    liveMoreLives: "他のライブ",
    liveCountLabel: "{count} 件のライブ",
    liveStepDown: "視聴者に切り替える",
    liveInvitationPrompt: "{name}さんがライブに上がるよう招待しています",
    liveInvitationAccept: "承諾",
    liveInvitationReject: "拒否",
    authMinAgeHint: "16歳以上である必要があります",
    authLegalPrefix: "サインアップすると、あなたが少なくとも",
    authLegalAnd: "であることを確認し、当社の規約に同意します",
  },
  ko: {
    liveNoLive: "진행 중인 라이브가 없습니다",
    liveStartSession: "가장 먼저 세션을 시작하고 커뮤니티를 실시간으로 초대하세요.",
    liveNoBroadcasts: "방송이 없습니다",
    liveBroadcastsLive: "라이브 방송 {count}개",
    livePublicLives: "공개 라이브",
    liveLiveNow: "라이브",
    liveViewers: "시청자",
    liveParticipants: "참가자",
    liveRequests: "요청",
    liveInvite: "초대",
    liveComments: "댓글",
    liveJoinSession: "세션에 참여하거나 몇 초 만에 직접 시작해 보세요.",
    liveMoreLives: "더 많은 라이브",
    liveCountLabel: "라이브 {count}개",
    liveStepDown: "시청자로 전환",
    liveInvitationPrompt: "{name}님이 라이브에 올라오도록 초대했습니다",
    liveInvitationAccept: "수락",
    liveInvitationReject: "거절",
    authMinAgeHint: "만 16세 이상이어야 합니다",
    authLegalPrefix: "가입하면 귀하가 최소",
    authLegalAnd: "이며 당사의 약관에 동의합니다",
  },
  hi: {
    liveNoLive: "अभी कोई लाइव जारी नहीं है",
    liveStartSession: "सबसे पहले एक सत्र शुरू करें और अपनी कम्युनिटी को रियल टाइम में आमंत्रित करें।",
    liveNoBroadcasts: "कोई प्रसारण नहीं",
    liveBroadcastsLive: "{count} लाइव प्रसारण",
    livePublicLives: "सार्वजनिक लाइव",
    liveLiveNow: "लाइव",
    liveViewers: "दर्शक",
    liveParticipants: "प्रतिभागी",
    liveRequests: "अनुरोध",
    liveInvite: "आमंत्रित करें",
    liveComments: "टिप्पणियां",
    liveJoinSession: "किसी सत्र में जुड़ें या कुछ सेकंड में अपना सत्र शुरू करें।",
    liveMoreLives: "और लाइव",
    liveCountLabel: "{count} लाइव",
    liveStepDown: "दर्शक मोड में जाएं",
    liveInvitationPrompt: "{name} आपको लाइव में आने के लिए आमंत्रित कर रहे हैं",
    liveInvitationAccept: "स्वीकार करें",
    liveInvitationReject: "अस्वीकार करें",
    authMinAgeHint: "आपकी आयु कम से कम 16 वर्ष होनी चाहिए",
    authLegalPrefix: "साइन अप करके, आप पुष्टि करते हैं कि आपकी आयु कम से कम",
    authLegalAnd: "और हमारे नियमों से सहमत हैं",
  },
}

const RANDOM_CALL_MISSING_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  es: {
    randomHeroConnect: "Conecta.",
    randomHeroClick: "Haz clic.",
    randomHeroSpeak: "Habla.",
    randomActionLabel: "Acción",
    randomLaunchNow: "Iniciar ahora",
    randomBlockUserConfirm: "¿Seguro que quieres bloquear a {name}?",
    liveLoading: "Cargando…",
    liveSessionPreparing: "Preparando sesión",
    liveConnectingWith: "Conectando con",
    liveConnectingTo: "Conectando con",
    liveVideoSyncing: "Sincronizando video.",
    liveP2PConnecting: "Conexión P2P en curso",
    liveInCall: "EN LLAMADA",
    liveLaunchCall: "Iniciar llamada",
    livePrivate: "Privado",
    liveOpen: "Abierto",
    liveInstant: "Instantáneo",
    liveSecure: "Seguro",
    liveFast: "Rápido",
    liveJoin: "Unirse",
    liveNewCall: "Nueva llamada",
  },
  pt: {
    randomHeroConnect: "Conecte.",
    randomHeroClick: "Clique.",
    randomHeroSpeak: "Converse.",
    randomActionLabel: "Ação",
    randomLaunchNow: "Iniciar agora",
    randomBlockUserConfirm: "Tem certeza de que deseja bloquear {name}?",
    liveLoading: "Carregando…",
    liveSessionPreparing: "Preparando sessão",
    liveConnectingWith: "Conectando com",
    liveConnectingTo: "Conectando com",
    liveVideoSyncing: "Sincronização de vídeo em andamento.",
    liveP2PConnecting: "Conexão P2P em andamento",
    liveInCall: "EM CHAMADA",
    liveLaunchCall: "Iniciar chamada",
    livePrivate: "Privado",
    liveOpen: "Aberto",
    liveInstant: "Instantâneo",
    liveSecure: "Seguro",
    liveFast: "Rápido",
    liveJoin: "Entrar",
    liveNewCall: "Nova chamada",
  },
  de: {
    randomHeroConnect: "Verbinde.",
    randomHeroClick: "Klicke.",
    randomHeroSpeak: "Sprich.",
    randomActionLabel: "Aktion",
    randomLaunchNow: "Jetzt starten",
    randomBlockUserConfirm: "Möchtest du {name} wirklich blockieren?",
    liveLoading: "Lädt…",
    liveSessionPreparing: "Sitzung wird vorbereitet",
    liveConnectingWith: "Verbinde mit",
    liveConnectingTo: "Verbinde mit",
    liveVideoSyncing: "Videosynchronisierung läuft.",
    liveP2PConnecting: "P2P-Verbindung wird aufgebaut",
    liveInCall: "IM ANRUF",
    liveLaunchCall: "Anruf starten",
    livePrivate: "Privat",
    liveOpen: "Offen",
    liveInstant: "Sofort",
    liveSecure: "Sicher",
    liveFast: "Schnell",
    liveJoin: "Beitreten",
    liveNewCall: "Neuer Anruf",
  },
  it: {
    randomHeroConnect: "Connettiti.",
    randomHeroClick: "Clicca.",
    randomHeroSpeak: "Parla.",
    randomActionLabel: "Azione",
    randomLaunchNow: "Avvia ora",
    randomBlockUserConfirm: "Vuoi davvero bloccare {name}?",
    liveLoading: "Caricamento…",
    liveSessionPreparing: "Preparazione sessione",
    liveConnectingWith: "Connessione con",
    liveConnectingTo: "Connessione a",
    liveVideoSyncing: "Sincronizzazione video in corso.",
    liveP2PConnecting: "Connessione P2P in corso",
    liveInCall: "IN CHIAMATA",
    liveLaunchCall: "Avvia chiamata",
    livePrivate: "Privato",
    liveOpen: "Aperto",
    liveInstant: "Istantaneo",
    liveSecure: "Sicuro",
    liveFast: "Veloce",
    liveJoin: "Partecipa",
    liveNewCall: "Nuova chiamata",
  },
  ar: {
    randomHeroConnect: "اتصل.",
    randomHeroClick: "اضغط.",
    randomHeroSpeak: "تحدث.",
    randomActionLabel: "إجراء",
    randomLaunchNow: "ابدأ الآن",
    randomBlockUserConfirm: "هل تريد حقا حظر {name}؟",
    liveLoading: "جار التحميل…",
    liveSessionPreparing: "يتم تجهيز الجلسة",
    liveConnectingWith: "جار الاتصال مع",
    liveConnectingTo: "جار الاتصال بـ",
    liveVideoSyncing: "مزامنة الفيديو قيد التقدم.",
    liveP2PConnecting: "اتصال P2P قيد التقدم",
    liveInCall: "في مكالمة",
    liveLaunchCall: "بدء مكالمة",
    livePrivate: "خاص",
    liveOpen: "عام",
    liveInstant: "فوري",
    liveSecure: "آمن",
    liveFast: "سريع",
    liveJoin: "انضم",
    liveNewCall: "مكالمة جديدة",
  },
  tr: {
    randomHeroConnect: "Bağlan.",
    randomHeroClick: "Tıkla.",
    randomHeroSpeak: "Konuş.",
    randomActionLabel: "Eylem",
    randomLaunchNow: "Şimdi başlat",
    randomBlockUserConfirm: "{name} kullanıcısını gerçekten engellemek istiyor musun?",
    liveLoading: "Yükleniyor…",
    liveSessionPreparing: "Oturum hazırlanıyor",
    liveConnectingWith: "Bağlanıyor:",
    liveConnectingTo: "Bağlanıyor:",
    liveVideoSyncing: "Video senkronizasyonu sürüyor.",
    liveP2PConnecting: "P2P bağlantısı kuruluyor",
    liveInCall: "ARAMADA",
    liveLaunchCall: "Arama başlat",
    livePrivate: "Özel",
    liveOpen: "Açık",
    liveInstant: "Anlık",
    liveSecure: "Güvenli",
    liveFast: "Hızlı",
    liveJoin: "Katıl",
    liveNewCall: "Yeni arama",
  },
  nl: {
    randomHeroConnect: "Verbind.",
    randomHeroClick: "Klik.",
    randomHeroSpeak: "Praat.",
    randomActionLabel: "Actie",
    randomLaunchNow: "Nu starten",
    randomBlockUserConfirm: "Weet je zeker dat je {name} wilt blokkeren?",
    liveLoading: "Laden…",
    liveSessionPreparing: "Sessie wordt voorbereid",
    liveConnectingWith: "Verbinden met",
    liveConnectingTo: "Verbinden met",
    liveVideoSyncing: "Videosynchronisatie bezig.",
    liveP2PConnecting: "P2P-verbinding bezig",
    liveInCall: "IN GESPREK",
    liveLaunchCall: "Gesprek starten",
    livePrivate: "Privé",
    liveOpen: "Open",
    liveInstant: "Direct",
    liveSecure: "Beveiligd",
    liveFast: "Snel",
    liveJoin: "Deelnemen",
    liveNewCall: "Nieuw gesprek",
  },
  ru: {
    randomHeroConnect: "Подключайся.",
    randomHeroClick: "Нажимай.",
    randomHeroSpeak: "Общайся.",
    randomActionLabel: "Действие",
    randomLaunchNow: "Запустить сейчас",
    randomBlockUserConfirm: "Вы действительно хотите заблокировать {name}?",
    liveLoading: "Загрузка…",
    liveSessionPreparing: "Подготовка сессии",
    liveConnectingWith: "Подключение с",
    liveConnectingTo: "Подключение к",
    liveVideoSyncing: "Синхронизация видео выполняется.",
    liveP2PConnecting: "Устанавливается P2P-соединение",
    liveInCall: "В ЗВОНКЕ",
    liveLaunchCall: "Начать звонок",
    livePrivate: "Приватный",
    liveOpen: "Открытый",
    liveInstant: "Мгновенно",
    liveSecure: "Безопасно",
    liveFast: "Быстро",
    liveJoin: "Присоединиться",
    liveNewCall: "Новый звонок",
  },
  zh: {
    randomHeroConnect: "连接。",
    randomHeroClick: "点击。",
    randomHeroSpeak: "开聊。",
    randomActionLabel: "操作",
    randomLaunchNow: "立即开始",
    randomBlockUserConfirm: "确定要屏蔽 {name} 吗？",
    liveLoading: "加载中…",
    liveSessionPreparing: "正在准备会话",
    liveConnectingWith: "正在连接",
    liveConnectingTo: "正在连接到",
    liveVideoSyncing: "视频同步进行中。",
    liveP2PConnecting: "P2P 连接进行中",
    liveInCall: "通话中",
    liveLaunchCall: "发起通话",
    livePrivate: "私密",
    liveOpen: "公开",
    liveInstant: "即时",
    liveSecure: "安全",
    liveFast: "快速",
    liveJoin: "加入",
    liveNewCall: "新通话",
  },
  ja: {
    randomHeroConnect: "つながる。",
    randomHeroClick: "クリック。",
    randomHeroSpeak: "話そう。",
    randomActionLabel: "アクション",
    randomLaunchNow: "今すぐ開始",
    randomBlockUserConfirm: "本当に {name} をブロックしますか？",
    liveLoading: "読み込み中…",
    liveSessionPreparing: "セッションを準備中",
    liveConnectingWith: "接続中:",
    liveConnectingTo: "接続先:",
    liveVideoSyncing: "動画を同期中です。",
    liveP2PConnecting: "P2P 接続中",
    liveInCall: "通話中",
    liveLaunchCall: "通話を開始",
    livePrivate: "プライベート",
    liveOpen: "公開",
    liveInstant: "即時",
    liveSecure: "安全",
    liveFast: "高速",
    liveJoin: "参加",
    liveNewCall: "新しい通話",
  },
  ko: {
    randomHeroConnect: "연결하고.",
    randomHeroClick: "클릭하고.",
    randomHeroSpeak: "대화하세요.",
    randomActionLabel: "동작",
    randomLaunchNow: "지금 시작",
    randomBlockUserConfirm: "정말로 {name} 님을 차단하시겠습니까?",
    liveLoading: "로딩 중…",
    liveSessionPreparing: "세션 준비 중",
    liveConnectingWith: "연결 중:",
    liveConnectingTo: "연결 중:",
    liveVideoSyncing: "영상 동기화 진행 중입니다.",
    liveP2PConnecting: "P2P 연결 진행 중",
    liveInCall: "통화 중",
    liveLaunchCall: "통화 시작",
    livePrivate: "비공개",
    liveOpen: "공개",
    liveInstant: "즉시",
    liveSecure: "보안",
    liveFast: "빠름",
    liveJoin: "참여",
    liveNewCall: "새 통화",
  },
  hi: {
    randomHeroConnect: "कनेक्ट करें.",
    randomHeroClick: "क्लिक करें.",
    randomHeroSpeak: "बात करें.",
    randomActionLabel: "क्रिया",
    randomLaunchNow: "अभी शुरू करें",
    randomBlockUserConfirm: "क्या आप वाकई {name} को ब्लॉक करना चाहते हैं?",
    liveLoading: "लोड हो रहा है…",
    liveSessionPreparing: "सेशन तैयार किया जा रहा है",
    liveConnectingWith: "कनेक्ट हो रहा है:",
    liveConnectingTo: "कनेक्ट हो रहा है:",
    liveVideoSyncing: "वीडियो सिंक प्रगति पर है।",
    liveP2PConnecting: "P2P कनेक्शन प्रगति पर है",
    liveInCall: "कॉल में",
    liveLaunchCall: "कॉल शुरू करें",
    livePrivate: "निजी",
    liveOpen: "खुला",
    liveInstant: "तुरंत",
    liveSecure: "सुरक्षित",
    liveFast: "तेज़",
    liveJoin: "जुड़ें",
    liveNewCall: "नई कॉल",
  },
}

const UNIVERSAL_MISSING_TRANSLATIONS: any = {
  es: {
    yearsLabel: "años",
    settingsEditProfileHintPrefix: "Para editar tu nombre, edad, bio o idiomas, ve a la sección",
    settingsEditProfileHintSuffix: "La ubicación se actualiza automáticamente.",
    authNamePlaceholder: "Ej.: Alex Martín",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "Crea una contraseña segura",
    authConfirmPasswordPlaceholder: "Repite tu contraseña",
    authDateOfBirthPlaceholder: "dd/mm/aaaa",
    authDOBDay: "Día",
    authDOBMonth: "Mes",
    authDOBYear: "Año",
    authUsernameInvalidShort: "3-30 car., letras/números/_",
    settingsFilterCountriesTitle: "Filtrar por países",
    settingsFilterCountriesHelp: "Solo se muestran los países con usuarios registrados. Puedes seleccionar una región completa con un clic.",
    settingsFilterLanguagesTitle: "Filtrar por idiomas",
    settingsFilterLanguagesHelp: "Solo se muestran los idiomas hablados por usuarios registrados. Puedes seleccionar un grupo completo.",
    settingsSavePreferences: "Guardar preferencias",
    settingsSaving: "Guardando...",
    commentSave: "Guardar",
    settingsCountriesTitle: "Países",
    settingsCountriesNoFilter: "Sin filtro — todos los países",
    settingsLanguagesNoFilter: "Sin filtro — todos los idiomas",
    settingsAgeRangeTitle: "Rango de edad",
    settingsAgeRangeHelp: "Define la edad mínima y máxima de las personas con las que quieres coincidir.",
    settingsMinAge: "Edad mínima",
    settingsMaxAge: "Edad máxima",
    settingsAgeRangeSummary: "Verás personas entre {min} y {max} {years}",
    settingsPreferencesDesc: "Países, idiomas y rango de edad para llamadas aleatorias",
    settingsPreferencesHelp: "Configura tus filtros para llamadas aleatorias. Déjalo vacío para aceptar a todos.",
    settingsAccountDesc: "Información, seguridad y eliminación de cuenta",
    settingsAccountInfoTitle: "Información de la cuenta",
    settingsLocation: "Ubicación",
    settingsMemberSince: "Miembro desde",
    settingsLanguagesTitle: "Idiomas",
    settingsIrreversibleAction: "Acción irreversible",
    settingsDeleteKeyword: "ELIMINAR",
    settingsAccountInfoDesc: "Correo electrónico, ubicación, fecha de registro",
    settingsBlockedTitle: "Usuarios bloqueados",
    settingsPushTitle: "Notificaciones en este dispositivo",
    settingsPushSubtitle: "Recibe alertas de Callo en tu dispositivo",
    settingsPushEnable: "Activar notificaciones",
    settingsPushDisable: "Desactivar",
    settingsPushSaveError: "No se pueden configurar las notificaciones",
    settingsPushEnabledSuccess: "Notificaciones activadas en este dispositivo",
    settingsPushDisabledSuccess: "Notificaciones desactivadas en este dispositivo",
    settingsPushUnsupported: "Las notificaciones push no son compatibles con este navegador",
    settingsPushPermissionDeniedError: "Las notificaciones han sido denegadas en el navegador",
    settingsPushExplain: "Recibirás mensajes, solicitudes de amistad, reacciones y lives directamente en el dispositivo.",
    settingsPushNeedPermission: "El navegador solicitará permiso antes de activar.",
    settingsPushPromptTitle: "Recibe las notificaciones",
    settingsPushPromptDescription: "¡Hola {name}! Autoriza a Callo para enviarte alertas importantes en tu dispositivo.",
    settingsPushPromptBenefit1: "Mantente informado en tiempo real",
    settingsPushPromptBenefit2: "Mensajes, solicitudes de amistad, reacciones y lives aparecen directamente en tu dispositivo.",
    settingsPushPromptAllow: "Permitir",
    settingsPushPromptLater: "Más tarde",
    settingsPushStatusSupported: "Compatibilidad",
    settingsPushStatusEnabled: "Activas",
    settingsPushStatusDisabled: "Desactivadas",
    settingsPushPermissionDefault: "Permiso no solicitado",
    settingsPushPermissionGranted: "Permiso concedido",
    settingsBlockedDesc: "Gestiona a las personas que has bloqueado",
    settingsBlockedEmpty: "No hay usuarios bloqueados",
    settingsUnblock: "Desbloquear",
    settingsLoading: "Cargando...",
    settingsDeleteTitle: "Eliminar cuenta",
    settingsDeleteDesc: "Eliminar permanentemente tu cuenta y todos tus datos",
    settingsGeolocation: "Geolocalización",
    settingsAllowed: "Permitida",
    settingsNotAllowed: "No permitida",
    settingsDeleteWarningDesc: "Eliminar tu cuenta borrará permanentemente todos tus datos:",
    settingsDeleteItemProfile: "Perfil y foto de perfil",
    settingsDeleteItemMessages: "Mensajes y conversaciones",
    settingsDeleteItemFriends: "Lista de amigos y solicitudes",
    settingsDeleteItemPosts: "Publicaciones y comentarios",
    settingsDeleteItemCalls: "Historial de llamadas",
    settingsDeleteItemReactions: "Me gusta, no me gusta y reacciones",
    settingsCurrentPassword: "Contraseña actual",
    settingsChangePasswordTitle: "Cambiar la contraseña",
    settingsChangePasswordDesc: "Actualiza tu contraseña para reforzar la seguridad de tu cuenta",
    settingsEnterPassword: "Introduce tu contraseña",
    settingsType: "Escribe",
    settingsToConfirm: "para confirmar",
    settingsDeletePasswordRequired: "Se requiere contraseña",
    settingsDeleting: "Eliminando...",
    settingsDeleteForever: "Eliminar mi cuenta permanentemente",
    notificationsTitle: "Notificaciones",
    notificationsSubtitle: "Mantente al tanto de tus interacciones",
    notificationsSomeone: "Alguien",
    notificationsAnd: "y",
    notificationsOther: "más",
    notificationsOthers: "más",
    notificationsToday: "Hoy",
    notificationsYesterday: "Ayer",
    notificationsThisWeek: "Esta semana",
    notificationsOlder: "Anteriores",
    notificationsAll: "Todas",
    notificationsUnread: "No leídas",
    notificationsNoNotifications: "Sin notificaciones",
    notificationsUpToDate: "¡Estás al día!",
    notificationsNoUnread: "Las notificaciones sobre tus interacciones aparecerán aquí",
    notificationsDelete: "Eliminar",
    notificationsNew: "Nuevo",
    notificationsCallReactionSingle: "{name} reaccionó a tu llamada",
    notificationsCallReactionMultiple: "{names} reaccionaron a tus llamadas",
    notificationsLikeCommentSingle: "{name} reaccionó a tu comentario",
    notificationsLikePostSingle: "{name} reaccionó a tu publicación",
    notificationsLikeProfileSingle: "A {name} le gustó tu perfil",
    notificationsLikeCommentMultiple: "{names} reaccionaron a tu comentario",
    notificationsLikePostMultiple: "{names} reaccionaron a tu publicación",
    notificationsLikeProfileMultiple: "A {names} les gustó tu perfil",
    notificationsDislikeCommentSingle: "{name} reaccionó a tu comentario",
    notificationsDislikePostSingle: "{name} reaccionó a tu publicación",
    notificationsDislikeProfileSingle: "A {name} no le gustó tu perfil",
    notificationsDislikeCommentMultiple: "{names} reaccionaron a tu comentario",
    notificationsDislikePostMultiple: "{names} reaccionaron a tu publicación",
    notificationsDislikeProfileMultiple: "A {names} no les gustó tu perfil",
    notificationsFriendRequestSingle: "{name} te envió una solicitud de amistad",
    notificationsFriendRejectedSingle: "{name} rechazó tu solicitud de amistad",
    notificationsFriendAcceptedSingle: "{name} aceptó tu solicitud de amistad",
    notificationsProfileViewSingle: "{name} vio tu perfil",
    notificationsProfileViewMultiple: "{names} vieron tu perfil",
    notificationsMessageReplySingle: "{name} respondió a tu comentario",
    notificationsMessageCommentSingle: "{name} comentó tu publicación",
    notificationsMessagePostSingle: "{name} comentó tu publicación",
    notificationsMessageDirectSingle: "{name} te envió un mensaje",
    notificationsMessageReplyMultiple: "{names} respondieron a tu comentario",
    notificationsMessageCommentMultiple: "{names} comentaron tu publicación",
    notificationsMessagePostMultiple: "{names} comentaron tu publicación",
    notificationsMessageDirectMultiple: "{names} te enviaron mensajes",
    notificationsLiveInvitationSingle: "{name} te invitó a su live",
    notificationsLiveJoinRequestSingle: "{name} solicitó unirse a tu live",
    notificationsLiveStartedSingle: "{name} está en live",
    notificationsGenericSingle: "{name} interactuó contigo",
    notificationsGenericMultiple: "{names} interactuaron contigo",
    notificationsCallReactionsTitle: "Reacciones a tus llamadas",
    notificationsReactionsCount: "Reacciones: {count}",
    notificationsNoReactionYet: "Aún no hay reacciones",
    notificationsProfileVisitorsTitle: "Visitantes del perfil",
    notificationsVisitorsCount: "Visitas: {count}",
    notificationsNoVisitorsYet: "Aún no hay visitantes",
    notificationsPeople: "persona(s)",
    feedEmptyTitle: "Aún no hay publicaciones",
    feedEmptySubtitle: "¡Sé el primero en compartir algo!",
    postStep: "Paso",
    postWizardStepContent: "Contenido",
    postWizardStepMedia: "Medios",
    postWizardStepTagsSettings: "Etiquetas y ajustes",
    postWizardStepPreview: "Vista previa",
    postWriteSomething: "Escribe algo... Usa #hashtags",
    postHashtagTip: "Consejo: usa #hashtags",
    dashboardSwipeHint: "Desliza ->",
    dashboardSuggestionsForYou: "Sugerencias para ti",
    friendsTitleMyFriends: "Mis amigos",
    friendsHeaderStats: "{contacts} contactos{onlinePart}",
    friendsOnlineLabel: "en línea",
    friendsSubtitleManageContacts: "Gestiona tus contactos",
    friendsNewCall: "Nueva llamada",
    friendsCallShort: "Llamar",
    friendsTabFriends: "Amigos",
    friendsTabRequests: "Solicitudes",
    friendsTabSent: "Enviadas",
    friendsNoRequestYet: "No hay solicitudes pendientes",
    friendsRequestsDesc: "Las solicitudes de amistad que recibas aparecerán aquí",
    friendsNoSentYet: "No hay solicitudes enviadas",
    friendsSentDesc: "Las solicitudes de amistad que envíes aparecerán aquí",
    friendsSendMessage: "Enviar mensaje",
    friendsAccept: "Aceptar",
    friendsReject: "Rechazar",
    friendsStartCall: "Iniciar una llamada",
    chatSearchPlaceholder: "Buscar...",
    chatNoConversation: "Sin conversaciones",
    chatAllRead: "Todo leído ✓",
    chatPersonOnline: "Nadie en línea",
    chatOffline: "Desconectado",
    chatSeenAt: "Visto a las",
    chatSeenYesterdayAt: "Visto ayer a las",
    chatSeenOn: "Visto el",
    chatYourMessage: "Tu mensaje",
    chatMedia: "Contenido multimedia",
    chatEditContent: "Editar contenido",
    chatDeleteForEveryone: "Eliminar para todos",
    chatRecording: "Grabando...",
    chatFinish: "Finalizar",
    chatVoiceReady: "Mensaje de voz listo",
    chatMicAccessError: "No se puede acceder al micrófono",
    chatSearchInConversation: "Buscar en la conversación...",
    chatStartConversationTitle: "Inicia la conversación",
    chatSayHello: "¡Saluda a {name}!",
    chatNewMessages: "Nuevos mensajes",
    chatDeletedMessage: "Mensaje eliminado",
    chatEditMessage: "Editar mensaje",
    chatMessagePlaceholder: "Mensaje...",
    chatNoMatch: "\"{search}\" no encontrado",
    chatNewMessage: "Nuevo mensaje",
    chatChooseContact: "Elige un contacto y comienza al instante",
    chatSearchContact: "Buscar contactos...",
    chatContacts: "contactos",
    chatNoContactAvailable: "No hay contactos disponibles",
    chatNoFriendFound: "No se encontraron amigos",
    chatFriends: "Amigos",
    chatRecents: "Recientes",
    chatStartConversation: "Iniciar conversación",
    chatOpenConversation: "Abrir conversación",
    chatYou: "Tú",
    reactionLiked: "le gustó",
    reactionDisliked: "no le gustó",
    chatUnknown: "Desconocido",
    chatVideo: "Video",
    chatVoiceMessage: "Mensaje de voz",
    chatPhoto: "Foto",
    chatFile: "Archivo",
    chatUnreadFilter: "No leídos",
    chatOnlineFilter: "En línea",
    chatUnreadCount: "{count} no leídos",
    chatConversationsCount: "{count} conversaciones",
    chatEmptyHint: "Pulsa + para enviar tu primer mensaje",
    chatYesterday: "Ayer",
    backLabel: "Volver",
    discoverTitle: "Descubrir",
    discoverShowAll: "Ver todo",
    discoverForYou: "Para ti",
    discoverNearby: "Cerca",
    discoverOnline: "En línea",
    discoverPopular: "Popular",
    discoverViewGrid: "Vista de cuadrícula",
    discoverViewMap: "Vista de mapa",
    discoverFilters: "Filtros",
    discoverResetFilters: "Restablecer",
    discoverAllCountries: "Todos los países",
    discoverAllLanguages: "Todos los idiomas",
    discoverOnlineOnly: "Solo en línea",
    discoverNearbySection: "Cerca",
    discoverClearFilters: "Borrar filtros",
    discoverNoUsers: "No se encontraron usuarios",
    discoverNoUsersDesc: "Prueba cambiando tus filtros o búsqueda",
    discoverNoLocalizedUsers: "No hay usuarios localizados",
    discoverNoLocalizedUsersDesc: "Los usuarios aparecerán aquí cuando compartan su ubicación",
    discoverFounder: "Fundador",
    discoverPeopleCount: "{count} personas",
    discoverSearchPlaceholder: "Nombre, usuario o bio...",
    discoverGPSRequired: "GPS requerido",
    discoverResultsCount: "{count} resultados",
    liveEndedTitle: "Live terminado",
    randomCallEndedTitle: "Llamada finalizada",
    randomCallThanks: "Gracias por participar en esta llamada.",
    randomCallLeave: "Salir de la llamada",
    randomCallNewCall: "Nueva llamada",
    randomCallCameraDisabled: "Cámara desactivada",
    randomCallMicMuted: "Micrófono silenciado",
    liveThanks: "Gracias por usar Callo",
    discoverAdd: "Agregar",
    discoverRequestSent: "Solicitud enviada",
    discoverViewProfile: "Ver perfil",
    discoverSent: "Enviado ✓",
    friendsRemoveFriend: "Eliminar este amigo",
    friendsWaiting: "Pendiente",
    postAllowComments: "Permitir comentarios",
    postVisibility: "Visibilidad",
    postYourPublication: "Tu publicación",
    postCommentsEnabled: "Comentarios activados",
    postCommentsDisabled: "Comentarios desactivados",
    postVisibilityPublicDesc: "Visible para todos",
    postVisibilityFriendsDesc: "Solo tus amigos",
    postVisibilityPrivateDesc: "Solo tú",
    nextLabel: "Siguiente",
    postNoTextContent: "Sin contenido de texto",
    postTrendingTitle: "Tendencias",
    postNoTrendingNow: "No hay tendencias por el momento",
    feedUpToDate: "¡Estás al día!",
    commentReply: "Responder",
    commentInReplyTo: "en respuesta a",
    commentActions: "Acciones",
    commentEmptyTitle: "Aún no hay comentarios",
    commentEmptySubtitle: "¡Sé el primero en comentar!",
    postReactAction: "Reaccionar",
    postCommentAction: "Comentar",
    postShareAction: "Compartir",
    commentEdit: "Editar",
    commentDelete: "Eliminar",
    commentCancel: "Cancelar",
    commentReplyLabel: "respuesta",
    commentReplyWord: "respuesta",
    commentRepliesWord: "respuestas",
    commentWritePlaceholder: "Escribe un comentario...",
    commentLike: "Me gusta",
    commentDislike: "No me gusta",
    profileLikes: "Me gusta",
    profileDislikes: "No me gusta",
  },
  pt: {
    yearsLabel: "anos",
    settingsEditProfileHintPrefix: "Para editar seu nome, idade, bio ou idiomas, vá para a seção",
    settingsEditProfileHintSuffix: "A localização é atualizada automaticamente.",
    authNamePlaceholder: "Ex.: Alex Martins",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "Crie uma senha forte",
    authConfirmPasswordPlaceholder: "Repita sua senha",
    authDateOfBirthPlaceholder: "dd/mm/aaaa",
    authDOBDay: "Dia",
    authDOBMonth: "Mês",
    authDOBYear: "Ano",
    authUsernameInvalidShort: "3-30 car., letras/números/_",
    settingsFilterCountriesTitle: "Filtrar por países",
    settingsFilterCountriesHelp: "Apenas os países com usuários cadastrados são exibidos. Você pode selecionar uma região inteira com um clique.",
    settingsFilterLanguagesTitle: "Filtrar por idiomas",
    settingsFilterLanguagesHelp: "Apenas os idiomas falados por usuários cadastrados são exibidos. Você pode selecionar um grupo inteiro.",
    settingsSavePreferences: "Salvar preferências",
    settingsSaving: "Salvando...",
    commentSave: "Salvar",
    settingsCountriesTitle: "Países",
    settingsCountriesNoFilter: "Sem filtro — todos os países",
    settingsLanguagesNoFilter: "Sem filtro — todos os idiomas",
    settingsAgeRangeTitle: "Faixa etária",
    settingsAgeRangeHelp: "Defina a idade mínima e máxima das pessoas com quem você quer ser conectado.",
    settingsMinAge: "Idade mínima",
    settingsMaxAge: "Idade máxima",
    settingsAgeRangeSummary: "Você verá pessoas entre {min} e {max} {years}",
    settingsPreferencesDesc: "Países, idiomas e faixa etária para chamadas aleatórias",
    settingsPreferencesHelp: "Configure seus filtros para chamadas aleatórias. Deixe vazio para aceitar todos.",
    settingsAccountDesc: "Informações, segurança e exclusão da conta",
    settingsAccountInfoTitle: "Informações da conta",
    settingsLocation: "Localização",
    settingsMemberSince: "Membro desde",
    settingsLanguagesTitle: "Idiomas",
    settingsIrreversibleAction: "Ação irreversível",
    settingsDeleteKeyword: "EXCLUIR",
    settingsAccountInfoDesc: "Email, localização, data de registro",
    settingsBlockedTitle: "Usuários bloqueados",
    settingsBlockedDesc: "Gerencie as pessoas que você bloqueou",
    settingsPushTitle: "Notificações neste dispositivo",
    settingsPushSubtitle: "Receba alertas do Callo no seu dispositivo",
    settingsPushEnable: "Ativar notificações",
    settingsPushDisable: "Desativar",
    settingsPushSaveError: "Não foi possível configurar as notificações",
    settingsPushEnabledSuccess: "Notificações ativadas neste dispositivo",
    settingsPushDisabledSuccess: "Notificações desativadas neste dispositivo",
    settingsPushUnsupported: "Notificações push não são suportadas neste navegador",
    settingsPushPermissionDeniedError: "As notificações foram negadas no navegador",
    settingsPushExplain: "Você receberá mensagens, solicitações de amizade, reações e lives diretamente no dispositivo.",
    settingsPushNeedPermission: "O navegador solicitará permissão antes de ativar.",
    settingsPushPromptTitle: "Receba notificações",
    settingsPushPromptDescription: "Olá {name}! Autorize o Callo a enviar alertas importantes para o seu dispositivo.",
    settingsPushPromptBenefit1: "Mantenha-se informado em tempo real",
    settingsPushPromptBenefit2: "Mensagens, solicitações de amizade, reações e lives aparecem diretamente no seu dispositivo.",
    settingsPushPromptAllow: "Permitir",
    settingsPushPromptLater: "Mais tarde",
    settingsPushStatusSupported: "Compatibilidade",
    settingsPushStatusEnabled: "Ativas",
    settingsPushStatusDisabled: "Desativadas",
    settingsPushPermissionDefault: "Permissão não solicitada",
    settingsPushPermissionGranted: "Permissão concedida",
  
  de: {
    settingsPushTitle: "Benachrichtigungen auf diesem Gerät",
    settingsPushSubtitle: "Erhalten Sie Callo-Benachrichtigungen auf Ihrem Gerät",
    settingsPushEnable: "Benachrichtigungen aktivieren",
    settingsPushDisable: "Deaktivieren",
    settingsPushPromptAllow: "Erlauben",
    settingsPushPromptLater: "Später",
    settingsPushPromptTitle: "Erhalten Sie Benachrichtigungen",
    settingsPushPromptDescription: "Hallo {name}! Erlaube Callo, dir wichtige Benachrichtigungen auf deinem Gerät zu senden.",
    settingsPushStatusSupported: "Kompatibilität",
    settingsPushStatusEnabled: "Aktiv",
    settingsPushStatusDisabled: "Deaktiviert",
    settingsPushPermissionDefault: "Berechtigung nicht angefordert",
    settingsPushPermissionGranted: "Berechtigung erteilt",
  },
  it: {
    settingsPushTitle: "Notifiche su questo dispositivo",
    settingsPushSubtitle: "Ricevi avvisi di Callo sul tuo dispositivo",
    settingsPushEnable: "Attiva notifiche",
    settingsPushDisable: "Disattiva",
    settingsPushPromptAllow: "Consenti",
    settingsPushPromptLater: "Più tardi",
    settingsPushPromptTitle: "Ricevi notifiche",
    settingsPushPromptDescription: "Ciao {name}! Consenti a Callo di inviarti avvisi importanti sul tuo dispositivo.",
    settingsPushStatusSupported: "Compatibilità",
    settingsPushStatusEnabled: "Attive",
    settingsPushStatusDisabled: "Disattivate",
    settingsPushPermissionDefault: "Autorizzazione non richiesta",
    settingsPushPermissionGranted: "Autorizzazione concessa",
  },
  ar: {
    settingsPushTitle: "الإشعارات على هذا الجهاز",
    settingsPushSubtitle: "تلقى تنبيهات Callo على جهازك",
    settingsPushEnable: "تفعيل الإشعارات",
    settingsPushDisable: "تعطيل",
    settingsPushPromptAllow: "سماح",
    settingsPushPromptLater: "لاحقًا",
    settingsPushPromptTitle: "تلقي الإشعارات",
    settingsPushPromptDescription: "مرحبًا {name}! اسمح لـ Callo بإرسال التنبيهات المهمة إلى جهازك.",
    settingsPushStatusSupported: "التوافق",
    settingsPushStatusEnabled: "مفعل",
    settingsPushStatusDisabled: "معطلة",
    settingsPushPermissionDefault: "لم يتم طلب الإذن",
    settingsPushPermissionGranted: "تم منح الإذن",
  },
  tr: {
    settingsPushTitle: "Bu cihazdaki bildirimler",
    settingsPushSubtitle: "Callo bildirimlerini cihazınızda alın",
    settingsPushEnable: "Bildirimleri etkinleştir",
    settingsPushDisable: "Devre dışı bırak",
    settingsPushPromptAllow: "İzin ver",
    settingsPushPromptLater: "Daha sonra",
    settingsPushPromptTitle: "Bildirimleri alın",
    settingsPushPromptDescription: "Merhaba {name}! Callo'nun önemli bildirimleri cihazınıza göndermesine izin verin.",
    settingsPushStatusSupported: "Uyumluluk",
    settingsPushStatusEnabled: "Etkin",
    settingsPushStatusDisabled: "Devre dışı",
    settingsPushPermissionDefault: "İzin istenmedi",
    settingsPushPermissionGranted: "İzin verildi",
  },
  nl: {
    settingsPushTitle: "Meldingen op dit apparaat",
    settingsPushSubtitle: "Ontvang Callo-meldingen op je apparaat",
    settingsPushEnable: "Meldingen inschakelen",
    settingsPushDisable: "Uitschakelen",
    settingsPushPromptAllow: "Toestaan",
    settingsPushPromptLater: "Later",
    settingsPushPromptTitle: "Ontvang meldingen",
    settingsPushPromptDescription: "Hallo {name}! Sta Callo toe belangrijke meldingen naar je apparaat te sturen.",
    settingsPushStatusSupported: "Compatibiliteit",
    settingsPushStatusEnabled: "Actief",
    settingsPushStatusDisabled: "Uitgeschakeld",
    settingsPushPermissionDefault: "Toestemming niet gevraagd",
    settingsPushPermissionGranted: "Toestemming verleend",
  },
  ru: {
    settingsPushTitle: "Уведомления на этом устройстве",
    settingsPushSubtitle: "Получайте уведомления Callo на своём устройстве",
    settingsPushEnable: "Включить уведомления",
    settingsPushDisable: "Отключить",
    settingsPushPromptAllow: "Разрешить",
    settingsPushPromptLater: "Позже",
    settingsPushPromptTitle: "Получайте уведомления",
    settingsPushPromptDescription: "Привет, {name}! Разрешите Callo отправлять важные уведомления на ваше устройство.",
    settingsPushStatusSupported: "Совместимость",
    settingsPushStatusEnabled: "Активно",
    settingsPushStatusDisabled: "Отключено",
    settingsPushPermissionDefault: "Разрешение не запрошено",
    settingsPushPermissionGranted: "Разрешение предоставлено",
  },
  zh: {
    settingsPushTitle: "在此设备上的通知",
    settingsPushSubtitle: "在您的设备上接收 Callo 通知",
    settingsPushEnable: "启用通知",
    settingsPushDisable: "禁用",
    settingsPushPromptAllow: "允许",
    settingsPushPromptLater: "稍后",
    settingsPushPromptTitle: "接收通知",
    settingsPushPromptDescription: "你好 {name}！允许 Callo 向您的设备发送重要提醒。",
    settingsPushStatusSupported: "兼容性",
    settingsPushStatusEnabled: "已启用",
    settingsPushStatusDisabled: "已禁用",
    settingsPushPermissionDefault: "未请求权限",
    settingsPushPermissionGranted: "已授予权限",
  },
  ja: {
    settingsPushTitle: "この端末での通知",
    settingsPushSubtitle: "端末でCalloの通知を受け取ります",
    settingsPushEnable: "通知を有効化",
    settingsPushDisable: "無効化",
    settingsPushPromptAllow: "許可する",
    settingsPushPromptLater: "後で",
    settingsPushPromptTitle: "通知を受け取る",
    settingsPushPromptDescription: "こんにちは {name}！Calloが重要な通知を端末に送信することを許可してください。",
    settingsPushStatusSupported: "互換性",
    settingsPushStatusEnabled: "有効",
    settingsPushStatusDisabled: "無効",
    settingsPushPermissionDefault: "許可が要求されていません",
    settingsPushPermissionGranted: "許可が付与されました",
  },
  ko: {
    settingsPushTitle: "이 기기의 알림",
    settingsPushSubtitle: "기기에서 Callo 알림을 받습니다",
    settingsPushEnable: "알림 활성화",
    settingsPushDisable: "비활성화",
    settingsPushPromptAllow: "허용",
    settingsPushPromptLater: "나중에",
    settingsPushPromptTitle: "알림 받기",
    settingsPushPromptDescription: "안녕하세요 {name}님! Callo가 기기에 중요한 알림을 보내도록 허용하세요.",
    settingsPushStatusSupported: "호환성",
    settingsPushStatusEnabled: "활성",
    settingsPushStatusDisabled: "비활성",
    settingsPushPermissionDefault: "권한 요청되지 않음",
    settingsPushPermissionGranted: "권한 부여됨",
  },
  hi: {
    settingsPushTitle: "इस डिवाइस पर सूचनाएँ",
    settingsPushSubtitle: "अपने डिवाइस पर Callo अलर्ट प्राप्त करें",
    settingsPushEnable: "सूचनाएँ सक्रिय करें",
    settingsPushDisable: "अक्षम करें",
    settingsPushPromptAllow: "अनुमति दें",
    settingsPushPromptLater: "बाद में",
    settingsPushPromptTitle: "सूचनाएँ प्राप्त करें",
    settingsPushPromptDescription: "नमस्ते {name}! Callo को आपके डिवाइस पर महत्वपूर्ण अलर्ट भेजने की अनुमति दें।",
    settingsPushStatusSupported: "अनुकूलता",
    settingsPushStatusEnabled: "सक्रिय",
    settingsPushStatusDisabled: "निष्क्रिय",
    settingsPushPermissionDefault: "अनुमति अनुरोधित नहीं",
    settingsPushPermissionGranted: "अनुमति स्वीकृत",
  },
    settingsBlockedEmpty: "Nenhum usuário bloqueado",
    settingsUnblock: "Desbloquear",
    settingsLoading: "Carregando...",
    settingsDeleteTitle: "Excluir conta",
    settingsDeleteDesc: "Excluir permanentemente sua conta e todos os seus dados",
    settingsGeolocation: "Geolocalização",
    settingsAllowed: "Permitida",
    settingsNotAllowed: "Não permitida",
    settingsDeleteWarningDesc: "Excluir sua conta removerá permanentemente todos os seus dados:",
    settingsDeleteItemProfile: "Perfil e foto de perfil",
    settingsDeleteItemMessages: "Mensagens e conversas",
    settingsDeleteItemFriends: "Lista de amigos e solicitações",
    settingsDeleteItemPosts: "Publicações e comentários",
    settingsDeleteItemCalls: "Histórico de chamadas",
    settingsDeleteItemReactions: "Curtidas, descurtidas e reações",
    settingsCurrentPassword: "Senha atual",
    settingsChangePasswordTitle: "Alterar a senha",
    settingsChangePasswordDesc: "Atualize sua senha para reforçar a segurança da sua conta",
    settingsEnterPassword: "Digite sua senha",
    settingsType: "Digite",
    settingsToConfirm: "para confirmar",
    settingsDeletePasswordRequired: "Senha obrigatória",
    settingsDeleting: "Excluindo...",
    settingsDeleteForever: "Excluir minha conta permanentemente",
    notificationsTitle: "Notificações",
    notificationsSubtitle: "Fique por dentro das suas interações",
    notificationsSomeone: "Alguém",
    notificationsAnd: "e",
    notificationsOther: "outro",
    notificationsOthers: "outros",
    notificationsToday: "Hoje",
    notificationsYesterday: "Ontem",
    notificationsThisWeek: "Esta semana",
    notificationsOlder: "Anteriores",
    notificationsAll: "Todas",
    notificationsUnread: "Não lidas",
    notificationsNoNotifications: "Sem notificações",
    notificationsUpToDate: "Você está em dia!",
    notificationsNoUnread: "As notificações sobre suas interações aparecerão aqui",
    notificationsDelete: "Excluir",
    notificationsNew: "Novo",
    notificationsCallReactionSingle: "{name} reagiu à sua chamada",
    notificationsCallReactionMultiple: "{names} reagiram às suas chamadas",
    notificationsLikeCommentSingle: "{name} reagiu ao seu comentário",
    notificationsLikePostSingle: "{name} reagiu à sua publicação",
    notificationsLikeProfileSingle: "{name} curtiu seu perfil",
    notificationsLikeCommentMultiple: "{names} reagiram ao seu comentário",
    notificationsLikePostMultiple: "{names} reagiram à sua publicação",
    notificationsLikeProfileMultiple: "{names} curtiram seu perfil",
    notificationsDislikeCommentSingle: "{name} reagiu ao seu comentário",
    notificationsDislikePostSingle: "{name} reagiu à sua publicação",
    notificationsDislikeProfileSingle: "{name} não curtiu seu perfil",
    notificationsDislikeCommentMultiple: "{names} reagiram ao seu comentário",
    notificationsDislikePostMultiple: "{names} reagiram à sua publicação",
    notificationsDislikeProfileMultiple: "{names} não curtiram seu perfil",
    notificationsFriendRequestSingle: "{name} enviou uma solicitação de amizade",
    notificationsFriendRejectedSingle: "{name} recusou sua solicitação de amizade",
    notificationsFriendAcceptedSingle: "{name} aceitou sua solicitação de amizade",
    notificationsProfileViewSingle: "{name} viu seu perfil",
    notificationsProfileViewMultiple: "{names} viram seu perfil",
    notificationsMessageReplySingle: "{name} respondeu ao seu comentário",
    notificationsMessageCommentSingle: "{name} comentou sua publicação",
    notificationsMessagePostSingle: "{name} comentou sua publicação",
    notificationsMessageDirectSingle: "{name} enviou uma mensagem para você",
    notificationsMessageReplyMultiple: "{names} responderam ao seu comentário",
    notificationsMessageCommentMultiple: "{names} comentaram sua publicação",
    notificationsMessagePostMultiple: "{names} comentaram sua publicação",
    notificationsMessageDirectMultiple: "{names} enviaram mensagens para você",
    notificationsLiveInvitationSingle: "{name} convidou você para a live",
    notificationsLiveJoinRequestSingle: "{name} pediu para entrar na sua live",
    notificationsLiveStartedSingle: "{name} iniciou uma live",
    notificationsGenericSingle: "{name} interagiu com você",
    notificationsGenericMultiple: "{names} interagiram com você",
    notificationsCallReactionsTitle: "Reações às suas chamadas",
    notificationsReactionsCount: "Reações: {count}",
    notificationsNoReactionYet: "Ainda não há reações",
    notificationsProfileVisitorsTitle: "Visitantes do perfil",
    notificationsVisitorsCount: "Visitas: {count}",
    notificationsNoVisitorsYet: "Ainda não há visitantes",
    notificationsPeople: "pessoa(s)",
    feedEmptyTitle: "Ainda não há publicações",
    feedEmptySubtitle: "Seja o primeiro a compartilhar algo!",
    postStep: "Etapa",
    postWizardStepContent: "Conteúdo",
    postWizardStepMedia: "Mídia",
    postWizardStepTagsSettings: "Tags e configurações",
    postWizardStepPreview: "Prévia",
    postWriteSomething: "Escreva algo... Use #hashtags",
    postHashtagTip: "Dica: use #hashtags",
    dashboardSwipeHint: "Deslize ->",
    dashboardSuggestionsForYou: "Sugestões para você",
    friendsTitleMyFriends: "Meus amigos",
    friendsHeaderStats: "{contacts} contatos{onlinePart}",
    friendsOnlineLabel: "online",
    friendsSubtitleManageContacts: "Gerencie seus contatos",
    friendsNewCall: "Nova chamada",
    friendsCallShort: "Chamar",
    friendsTabFriends: "Amigos",
    friendsTabRequests: "Solicitações",
    friendsTabSent: "Enviadas",
    friendsNoRequestYet: "Nenhuma solicitação pendente",
    friendsRequestsDesc: "As solicitações de amizade que você receber aparecerão aqui",
    friendsNoSentYet: "Nenhuma solicitação enviada",
    friendsSentDesc: "As solicitações de amizade que você enviar aparecerão aqui",
    friendsSendMessage: "Enviar mensagem",
    friendsAccept: "Aceitar",
    friendsReject: "Recusar",
    friendsStartCall: "Iniciar chamada",
    chatSearchPlaceholder: "Buscar...",
    chatNoConversation: "Sem conversas",
    chatAllRead: "Tudo lido ✓",
    chatPersonOnline: "Ninguém online",
    chatOffline: "Offline",
    chatSeenAt: "Visto às",
    chatSeenYesterdayAt: "Visto ontem às",
    chatSeenOn: "Visto em",
    chatYourMessage: "Sua mensagem",
    chatMedia: "Mídia",
    chatEditContent: "Editar conteúdo",
    chatDeleteForEveryone: "Excluir para todos",
    chatRecording: "Gravando...",
    chatFinish: "Concluir",
    chatVoiceReady: "Mensagem de voz pronta",
    chatMicAccessError: "Não foi possível acessar o microfone",
    chatSearchInConversation: "Buscar na conversa...",
    chatStartConversationTitle: "Comece a conversa",
    chatSayHello: "Diga oi para {name}!",
    chatNewMessages: "Novas mensagens",
    chatDeletedMessage: "Mensagem excluída",
    chatEditMessage: "Editar mensagem",
    chatMessagePlaceholder: "Mensagem...",
    chatNoMatch: "\"{search}\" não encontrado",
    chatNewMessage: "Nova mensagem",
    chatChooseContact: "Escolha um contato e comece na hora",
    chatSearchContact: "Buscar contatos...",
    chatContacts: "contatos",
    chatNoContactAvailable: "Nenhum contato disponível",
    chatNoFriendFound: "Nenhum amigo encontrado",
    chatFriends: "Amigos",
    chatRecents: "Recentes",
    chatStartConversation: "Iniciar conversa",
    chatOpenConversation: "Abrir conversa",
    chatYou: "Você",
    reactionLiked: "curtiu",
    reactionDisliked: "não curtiu",
    chatUnknown: "Desconhecido",
    chatVideo: "Vídeo",
    chatVoiceMessage: "Mensagem de voz",
    chatPhoto: "Foto",
    chatFile: "Arquivo",
    chatUnreadFilter: "Não lidas",
    chatOnlineFilter: "Online",
    chatUnreadCount: "{count} não lidas",
    chatConversationsCount: "{count} conversas",
    chatEmptyHint: "Toque em + para enviar sua primeira mensagem",
    chatYesterday: "Ontem",
    backLabel: "Voltar",
    discoverTitle: "Descobrir",
    discoverShowAll: "Ver tudo",
    discoverForYou: "Para você",
    discoverNearby: "Perto",
    discoverOnline: "Online",
    discoverPopular: "Popular",
    discoverViewGrid: "Visualização em grade",
    discoverViewMap: "Visualização em mapa",
    discoverFilters: "Filtros",
    discoverResetFilters: "Redefinir",
    discoverAllCountries: "Todos os países",
    discoverAllLanguages: "Todos os idiomas",
    discoverOnlineOnly: "Somente online",
    discoverNearbySection: "Perto",
    discoverClearFilters: "Limpar filtros",
    discoverNoUsers: "Nenhum usuário encontrado",
    discoverNoUsersDesc: "Tente alterar seus filtros ou busca",
    discoverNoLocalizedUsers: "Nenhum usuário local",
    discoverNoLocalizedUsersDesc: "Os usuários aparecerão aqui quando compartilharem a localização",
    discoverFounder: "Fundador",
    discoverPeopleCount: "{count} pessoas",
    discoverSearchPlaceholder: "Nome, usuário ou bio...",
    discoverGPSRequired: "GPS necessário",
    discoverResultsCount: "{count} resultados",
    liveEndedTitle: "Live encerrada",
    randomCallEndedTitle: "Chamada encerrada",
    randomCallThanks: "Obrigado por participar desta chamada.",
    randomCallLeave: "Sair da chamada",
    randomCallNewCall: "Nova chamada",
    randomCallCameraDisabled: "Câmera desativada",
    randomCallMicMuted: "Microfone mudo",
    liveThanks: "Obrigado por usar o Callo",
    discoverAdd: "Adicionar",
    discoverRequestSent: "Pedido enviado",
    discoverViewProfile: "Ver perfil",
    discoverSent: "Enviado ✓",
    friendsRemoveFriend: "Remover este amigo",
    friendsWaiting: "Pendente",
    postAllowComments: "Permitir comentários",
    postVisibility: "Visibilidade",
    postYourPublication: "Sua publicação",
    postCommentsEnabled: "Comentários ativados",
    postCommentsDisabled: "Comentários desativados",
    postVisibilityPublicDesc: "Visível para todos",
    postVisibilityFriendsDesc: "Somente seus amigos",
    postVisibilityPrivateDesc: "Somente você",
    nextLabel: "Seguinte",
    postNoTextContent: "Sem conteúdo de texto",
    postTrendingTitle: "Tendências",
    postNoTrendingNow: "Nenhuma tendência no momento",
    feedUpToDate: "Você está em dia!",
    commentReply: "Responder",
    commentInReplyTo: "em resposta a",
    commentActions: "Ações",
    commentEmptyTitle: "Ainda não há comentários",
    commentEmptySubtitle: "Seja o primeiro a comentar!",
    postReactAction: "Reagir",
    postCommentAction: "Comentar",
    postShareAction: "Compartilhar",
    commentEdit: "Editar",
    commentDelete: "Excluir",
    commentCancel: "Cancelar",
    commentReplyLabel: "resposta",
    commentReplyWord: "resposta",
    commentRepliesWord: "respostas",
    commentWritePlaceholder: "Escreva um comentário...",
    commentLike: "Curtir",
    commentDislike: "Não curtir",
    profileLikes: "Curtidas",
    profileDislikes: "Descurtidas",
  },
  de: {
    yearsLabel: "Jahre",
    settingsEditProfileHintPrefix: "Um deinen Namen, dein Alter, deine Bio oder Sprachen zu bearbeiten, gehe zum Bereich",
    settingsEditProfileHintSuffix: "Der Standort wird automatisch aktualisiert.",
    authNamePlaceholder: "z. B. Alex Martin",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "Erstelle ein sicheres Passwort",
    authConfirmPasswordPlaceholder: "Passwort wiederholen",
    authDateOfBirthPlaceholder: "tt/mm/jjjj",
    authDOBDay: "Tag",
    authDOBMonth: "Monat",
    authDOBYear: "Jahr",
    authUsernameInvalidShort: "3-30 Zeichen, Buchstaben/Zahlen/_",
    settingsFilterCountriesTitle: "Nach Ländern filtern",
    settingsFilterCountriesHelp: "Es werden nur Länder mit registrierten Nutzern angezeigt. Du kannst mit einem Klick eine ganze Region auswählen.",
    settingsFilterLanguagesTitle: "Nach Sprachen filtern",
    settingsFilterLanguagesHelp: "Es werden nur Sprachen angezeigt, die von registrierten Nutzern gesprochen werden. Du kannst eine ganze Gruppe auswählen.",
    settingsSavePreferences: "Einstellungen speichern",
    settingsSaving: "Speichern...",
    commentSave: "Speichern",
    settingsCountriesTitle: "Länder",
    settingsCountriesNoFilter: "Kein Filter — alle Länder",
    settingsLanguagesNoFilter: "Kein Filter — alle Sprachen",
    settingsAgeRangeTitle: "Altersbereich",
    settingsAgeRangeHelp: "Lege das Mindest- und Höchstalter der Personen fest, mit denen du gematcht werden möchtest.",
    settingsMinAge: "Mindestalter",
    settingsMaxAge: "Höchstalter",
    settingsAgeRangeSummary: "Du siehst Personen zwischen {min} und {max} {years}",
    settingsPreferencesDesc: "Länder, Sprachen und Altersbereich für zufällige Anrufe",
    settingsPreferencesHelp: "Konfiguriere deine Filter für zufällige Anrufe. Leer lassen, um alle zu akzeptieren.",
    settingsAccountDesc: "Informationen, Sicherheit und Kontolöschung",
    settingsAccountInfoTitle: "Kontoinformationen",
    settingsLocation: "Standort",
    settingsMemberSince: "Mitglied seit",
    settingsLanguagesTitle: "Sprachen",
    settingsIrreversibleAction: "Unumkehrbare Aktion",
    settingsDeleteKeyword: "LÖSCHEN",
    settingsAccountInfoDesc: "E-Mail, Standort, Registrierungsdatum",
    settingsBlockedTitle: "Gesperrte Nutzer",
    settingsBlockedDesc: "Verwalte die Personen, die du blockiert hast",
    settingsBlockedEmpty: "Keine gesperrten Nutzer",
    settingsUnblock: "Entsperren",
    settingsLoading: "Wird geladen...",
    settingsDeleteTitle: "Konto löschen",
    settingsDeleteDesc: "Dein Konto und alle Daten dauerhaft löschen",
    settingsGeolocation: "Geolokalisierung",
    settingsAllowed: "Erlaubt",
    settingsNotAllowed: "Nicht erlaubt",
    settingsDeleteWarningDesc: "Das Löschen deines Kontos entfernt dauerhaft alle deine Daten:",
    settingsDeleteItemProfile: "Profil und Profilbild",
    settingsDeleteItemMessages: "Nachrichten und Unterhaltungen",
    settingsDeleteItemFriends: "Freundesliste und Anfragen",
    settingsDeleteItemPosts: "Beiträge und Kommentare",
    settingsDeleteItemCalls: "Anrufverlauf",
    settingsDeleteItemReactions: "Likes, Dislikes und Reaktionen",
    settingsCurrentPassword: "Aktuelles Passwort",
    settingsChangePasswordTitle: "Passwort ändern",
    settingsChangePasswordDesc: "Aktualisieren Sie Ihr Passwort, um die Sicherheit Ihres Kontos zu erhöhen",
    settingsEnterPassword: "Gib dein Passwort ein",
    settingsType: "Tippe",
    settingsToConfirm: "zur Bestätigung",
    settingsDeletePasswordRequired: "Passwort erforderlich",
    settingsDeleting: "Wird gelöscht...",
    settingsDeleteForever: "Mein Konto dauerhaft löschen",
    notificationsTitle: "Benachrichtigungen",
    notificationsSubtitle: "Bleibe über deine Interaktionen informiert",
    notificationsSomeone: "Jemand",
    notificationsAnd: "und",
    notificationsOther: "weiterer",
    notificationsOthers: "weitere",
    notificationsToday: "Heute",
    notificationsYesterday: "Gestern",
    notificationsThisWeek: "Diese Woche",
    notificationsOlder: "Früher",
    notificationsAll: "Alle",
    notificationsUnread: "Ungelesen",
    notificationsNoNotifications: "Keine Benachrichtigungen",
    notificationsUpToDate: "Du bist auf dem neuesten Stand!",
    notificationsNoUnread: "Benachrichtigungen über deine Interaktionen erscheinen hier",
    notificationsDelete: "Löschen",
    notificationsNew: "Neu",
    notificationsCallReactionSingle: "{name} hat auf deinen Anruf reagiert",
    notificationsCallReactionMultiple: "{names} haben auf deine Anrufe reagiert",
    notificationsLikeCommentSingle: "{name} hat auf deinen Kommentar reagiert",
    notificationsLikePostSingle: "{name} hat auf deinen Beitrag reagiert",
    notificationsLikeProfileSingle: "{name} hat dein Profil gelikt",
    notificationsLikeCommentMultiple: "{names} haben auf deinen Kommentar reagiert",
    notificationsLikePostMultiple: "{names} haben auf deinen Beitrag reagiert",
    notificationsLikeProfileMultiple: "{names} haben dein Profil gelikt",
    notificationsDislikeCommentSingle: "{name} hat auf deinen Kommentar reagiert",
    notificationsDislikePostSingle: "{name} hat auf deinen Beitrag reagiert",
    notificationsDislikeProfileSingle: "{name} hat dein Profil disliked",
    notificationsDislikeCommentMultiple: "{names} haben auf deinen Kommentar reagiert",
    notificationsDislikePostMultiple: "{names} haben auf deinen Beitrag reagiert",
    notificationsDislikeProfileMultiple: "{names} haben dein Profil disliked",
    notificationsFriendRequestSingle: "{name} hat dir eine Freundschaftsanfrage gesendet",
    notificationsFriendRejectedSingle: "{name} hat deine Freundschaftsanfrage abgelehnt",
    notificationsFriendAcceptedSingle: "{name} hat deine Freundschaftsanfrage angenommen",
    notificationsProfileViewSingle: "{name} hat dein Profil angesehen",
    notificationsProfileViewMultiple: "{names} haben dein Profil angesehen",
    notificationsMessageReplySingle: "{name} hat auf deinen Kommentar geantwortet",
    notificationsMessageCommentSingle: "{name} hat deinen Beitrag kommentiert",
    notificationsMessagePostSingle: "{name} hat deinen Beitrag kommentiert",
    notificationsMessageDirectSingle: "{name} hat dir eine Nachricht gesendet",
    notificationsMessageReplyMultiple: "{names} haben auf deinen Kommentar geantwortet",
    notificationsMessageCommentMultiple: "{names} haben deinen Beitrag kommentiert",
    notificationsMessagePostMultiple: "{names} haben deinen Beitrag kommentiert",
    notificationsMessageDirectMultiple: "{names} haben dir Nachrichten gesendet",
    notificationsLiveInvitationSingle: "{name} hat dich zu seinem Live eingeladen",
    notificationsLiveJoinRequestSingle: "{name} möchte deinem Live beitreten",
    notificationsLiveStartedSingle: "{name} ist live",
    notificationsGenericSingle: "{name} hat mit dir interagiert",
    notificationsGenericMultiple: "{names} haben mit dir interagiert",
    notificationsCallReactionsTitle: "Reaktionen auf deine Anrufe",
    notificationsReactionsCount: "Reaktionen: {count}",
    notificationsNoReactionYet: "Noch keine Reaktionen",
    notificationsProfileVisitorsTitle: "Profilbesucher",
    notificationsVisitorsCount: "Besuche: {count}",
    notificationsNoVisitorsYet: "Noch keine Besucher",
    notificationsPeople: "Person(en)",
    feedEmptyTitle: "Noch keine Beiträge",
    feedEmptySubtitle: "Sei der Erste und teile etwas!",
    postStep: "Schritt",
    postWizardStepContent: "Inhalt",
    postWizardStepMedia: "Medien",
    postWizardStepTagsSettings: "Tags und Einstellungen",
    postWizardStepPreview: "Vorschau",
    postWriteSomething: "Schreibe etwas... Nutze #hashtags",
    postHashtagTip: "Tipp: nutze #hashtags",
    dashboardSwipeHint: "Wischen ->",
    dashboardSuggestionsForYou: "Vorschläge für dich",
    friendsTitleMyFriends: "Meine Freunde",
    friendsHeaderStats: "{contacts} Kontakte{onlinePart}",
    friendsOnlineLabel: "online",
    friendsSubtitleManageContacts: "Verwalte deine Kontakte",
    friendsNewCall: "Neuer Anruf",
    friendsCallShort: "Anruf",
    friendsTabFriends: "Freunde",
    friendsTabRequests: "Anfragen",
    friendsTabSent: "Gesendet",
    friendsNoRequestYet: "Keine ausstehenden Anfragen",
    friendsRequestsDesc: "Freundschaftsanfragen, die du erhältst, erscheinen hier",
    friendsNoSentYet: "Keine gesendeten Anfragen",
    friendsSentDesc: "Freundschaftsanfragen, die du sendest, erscheinen hier",
    friendsSendMessage: "Nachricht senden",
    friendsAccept: "Annehmen",
    friendsReject: "Ablehnen",
    friendsStartCall: "Anruf starten",
    chatSearchPlaceholder: "Suchen...",
    chatNoConversation: "Keine Unterhaltungen",
    chatAllRead: "Alles gelesen ✓",
    chatPersonOnline: "Niemand online",
    chatOffline: "Offline",
    chatSeenAt: "Gesehen um",
    chatSeenYesterdayAt: "Gestern gesehen um",
    chatSeenOn: "Gesehen am",
    chatYourMessage: "Deine Nachricht",
    chatMedia: "Medien",
    chatEditContent: "Inhalt bearbeiten",
    chatDeleteForEveryone: "Für alle löschen",
    chatRecording: "Aufnahme...",
    chatFinish: "Fertig",
    chatVoiceReady: "Sprachnachricht bereit",
    chatMicAccessError: "Kein Zugriff auf das Mikrofon",
    chatSearchInConversation: "In Unterhaltung suchen...",
    chatStartConversationTitle: "Starte die Unterhaltung",
    chatSayHello: "Sag Hallo zu {name}!",
    chatNewMessages: "Neue Nachrichten",
    chatDeletedMessage: "Nachricht gelöscht",
    chatEditMessage: "Nachricht bearbeiten",
    chatMessagePlaceholder: "Nachricht...",
    chatNoMatch: "\"{search}\" nicht gefunden",
    chatNewMessage: "Neue Nachricht",
    chatChooseContact: "Wähle einen Kontakt und starte sofort",
    chatSearchContact: "Kontakte suchen...",
    chatContacts: "Kontakte",
    chatNoContactAvailable: "Keine Kontakte verfügbar",
    chatNoFriendFound: "Keine Freunde gefunden",
    chatFriends: "Freunde",
    chatRecents: "Kürzlich",
    chatStartConversation: "Unterhaltung starten",
    chatOpenConversation: "Unterhaltung öffnen",
    chatYou: "Du",
    reactionLiked: "gefällt",
    reactionDisliked: "gefällt nicht",
    chatUnknown: "Unbekannt",
    chatVideo: "Video",
    chatVoiceMessage: "Sprachnachricht",
    chatPhoto: "Foto",
    chatFile: "Datei",
    chatUnreadFilter: "Ungelesen",
    chatOnlineFilter: "Online",
    chatUnreadCount: "{count} ungelesen",
    chatConversationsCount: "{count} Unterhaltungen",
    chatEmptyHint: "Tippe auf +, um deine erste Nachricht zu senden",
    chatYesterday: "Gestern",
    backLabel: "Zurück",
    discoverTitle: "Entdecken",
    discoverShowAll: "Alle anzeigen",
    discoverForYou: "Für dich",
    discoverNearby: "In der Nähe",
    discoverOnline: "Online",
    discoverPopular: "Beliebt",
    discoverViewGrid: "Rasteransicht",
    discoverViewMap: "Kartenansicht",
    discoverFilters: "Filter",
    discoverResetFilters: "Zurücksetzen",
    discoverAllCountries: "Alle Länder",
    discoverAllLanguages: "Alle Sprachen",
    discoverOnlineOnly: "Nur online",
    discoverNearbySection: "In der Nähe",
    discoverClearFilters: "Filter löschen",
    discoverNoUsers: "Keine Nutzer gefunden",
    discoverNoUsersDesc: "Versuche, deine Filter oder Suche zu ändern",
    discoverNoLocalizedUsers: "Keine lokalen Nutzer",
    discoverNoLocalizedUsersDesc: "Nutzer erscheinen hier, wenn sie ihren Standort teilen",
    discoverFounder: "Gründer",
    discoverPeopleCount: "{count} Personen",
    discoverSearchPlaceholder: "Name, Benutzername oder Bio...",
    discoverGPSRequired: "GPS erforderlich",
    discoverResultsCount: "{count} Ergebnisse",
    liveEndedTitle: "Live beendet",
    randomCallEndedTitle: "Anruf beendet",
    randomCallThanks: "Danke für die Teilnahme an diesem Anruf.",
    randomCallLeave: "Anruf verlassen",
    randomCallNewCall: "Neuer Anruf",
    randomCallCameraDisabled: "Kamera deaktiviert",
    randomCallMicMuted: "Mikrofon stummgeschaltet",
    liveThanks: "Danke, dass du Callo nutzt",
    discoverAdd: "Hinzufügen",
    discoverRequestSent: "Anfrage gesendet",
    discoverViewProfile: "Profil ansehen",
    discoverSent: "Gesendet ✓",
    friendsRemoveFriend: "Diesen Freund entfernen",
    friendsWaiting: "Ausstehend",
    postAllowComments: "Kommentare erlauben",
    postVisibility: "Sichtbarkeit",
    postYourPublication: "Dein Beitrag",
    postCommentsEnabled: "Kommentare aktiviert",
    postCommentsDisabled: "Kommentare deaktiviert",
    postVisibilityPublicDesc: "Für alle sichtbar",
    postVisibilityFriendsDesc: "Nur deine Freunde",
    postVisibilityPrivateDesc: "Nur du",
    nextLabel: "Weiter",
    postNoTextContent: "Kein Textinhalt",
    postTrendingTitle: "Trends",
    postNoTrendingNow: "Derzeit keine Trends",
    feedUpToDate: "Du bist auf dem neuesten Stand!",
    commentReply: "Antworten",
    commentInReplyTo: "als Antwort auf",
    commentActions: "Aktionen",
    commentEmptyTitle: "Noch keine Kommentare",
    commentEmptySubtitle: "Sei der Erste, der kommentiert!",
    postReactAction: "Reagieren",
    postCommentAction: "Kommentieren",
    postShareAction: "Teilen",
    commentEdit: "Bearbeiten",
    commentDelete: "Löschen",
    commentCancel: "Abbrechen",
    commentReplyLabel: "Antwort",
    commentReplyWord: "Antwort",
    commentRepliesWord: "Antworten",
    commentWritePlaceholder: "Schreibe einen Kommentar...",
    commentLike: "Gefällt mir",
    commentDislike: "Gefällt mir nicht",
    profileLikes: "Likes",
    profileDislikes: "Dislikes",
  },
  it: {
    yearsLabel: "anni",
    settingsEditProfileHintPrefix: "Per modificare nome, età, bio o lingue, vai alla sezione",
    settingsEditProfileHintSuffix: "La posizione viene aggiornata automaticamente.",
    authNamePlaceholder: "Es.: Alex Martin",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "Crea una password sicura",
    authConfirmPasswordPlaceholder: "Ripeti la password",
    authDateOfBirthPlaceholder: "gg/mm/aaaa",
    authDOBDay: "Giorno",
    authDOBMonth: "Mese",
    authDOBYear: "Anno",
    authUsernameInvalidShort: "3-30 car., lettere/numeri/_",
    settingsFilterCountriesTitle: "Filtra per paesi",
    settingsFilterCountriesHelp: "Sono mostrati solo i paesi con utenti registrati. Puoi selezionare un'intera regione con un clic.",
    settingsFilterLanguagesTitle: "Filtra per lingue",
    settingsFilterLanguagesHelp: "Sono mostrate solo le lingue parlate dagli utenti registrati. Puoi selezionare un intero gruppo.",
    settingsSavePreferences: "Salva preferenze",
    settingsSaving: "Salvataggio...",
    commentSave: "Salva",
    settingsCountriesTitle: "Paesi",
    settingsCountriesNoFilter: "Nessun filtro — tutti i paesi",
    settingsLanguagesNoFilter: "Nessun filtro — tutte le lingue",
    settingsAgeRangeTitle: "Fascia d'età",
    settingsAgeRangeHelp: "Imposta l'età minima e massima delle persone con cui vuoi essere abbinato.",
    settingsMinAge: "Età minima",
    settingsMaxAge: "Età massima",
    settingsAgeRangeSummary: "Vedrai persone tra {min} e {max} {years}",
    settingsPreferencesDesc: "Paesi, lingue e fascia d'età per chiamate casuali",
    settingsPreferencesHelp: "Configura i tuoi filtri per le chiamate casuali. Lascia vuoto per accettare tutti.",
    settingsAccountDesc: "Informazioni, sicurezza ed eliminazione dell'account",
    settingsAccountInfoTitle: "Informazioni account",
    settingsLocation: "Posizione",
    settingsMemberSince: "Membro dal",
    settingsLanguagesTitle: "Lingue",
    settingsIrreversibleAction: "Azione irreversibile",
    settingsDeleteKeyword: "ELIMINA",
    settingsAccountInfoDesc: "Email, posizione, data di registrazione",
    settingsBlockedTitle: "Utenti bloccati",
    settingsBlockedDesc: "Gestisci le persone che hai bloccato",
    settingsBlockedEmpty: "Nessun utente bloccato",
    settingsUnblock: "Sblocca",
    settingsLoading: "Caricamento...",
    settingsDeleteTitle: "Elimina account",
    settingsDeleteDesc: "Elimina definitivamente il tuo account e tutti i tuoi dati",
    settingsGeolocation: "Geolocalizzazione",
    settingsAllowed: "Consentita",
    settingsNotAllowed: "Non consentita",
    settingsDeleteWarningDesc: "L'eliminazione del tuo account rimuoverà definitivamente tutti i tuoi dati:",
    settingsDeleteItemProfile: "Profilo e foto profilo",
    settingsDeleteItemMessages: "Messaggi e conversazioni",
    settingsDeleteItemFriends: "Lista amici e richieste",
    settingsDeleteItemPosts: "Post e commenti",
    settingsDeleteItemCalls: "Cronologia chiamate",
    settingsDeleteItemReactions: "Mi piace, non mi piace e reazioni",
    settingsCurrentPassword: "Password attuale",
    settingsChangePasswordTitle: "Cambia la password",
    settingsChangePasswordDesc: "Aggiorna la tua password per rafforzare la sicurezza del tuo account",
    settingsEnterPassword: "Inserisci la tua password",
    settingsType: "Digita",
    settingsToConfirm: "per confermare",
    settingsDeletePasswordRequired: "Password obbligatoria",
    settingsDeleting: "Eliminazione in corso...",
    settingsDeleteForever: "Elimina definitivamente il mio account",
    notificationsTitle: "Notifiche",
    notificationsSubtitle: "Resta aggiornato sulle tue interazioni",
    notificationsSomeone: "Qualcuno",
    notificationsAnd: "e",
    notificationsOther: "altro",
    notificationsOthers: "altri",
    notificationsToday: "Oggi",
    notificationsYesterday: "Ieri",
    notificationsThisWeek: "Questa settimana",
    notificationsOlder: "Precedenti",
    notificationsAll: "Tutte",
    notificationsUnread: "Non lette",
    notificationsNoNotifications: "Nessuna notifica",
    notificationsUpToDate: "Sei aggiornato!",
    notificationsNoUnread: "Le notifiche sulle tue interazioni appariranno qui",
    notificationsDelete: "Elimina",
    notificationsNew: "Nuovo",
    notificationsCallReactionSingle: "{name} ha reagito alla tua chiamata",
    notificationsCallReactionMultiple: "{names} hanno reagito alle tue chiamate",
    notificationsLikeCommentSingle: "{name} ha reagito al tuo commento",
    notificationsLikePostSingle: "{name} ha reagito al tuo post",
    notificationsLikeProfileSingle: "A {name} piace il tuo profilo",
    notificationsLikeCommentMultiple: "{names} hanno reagito al tuo commento",
    notificationsLikePostMultiple: "{names} hanno reagito al tuo post",
    notificationsLikeProfileMultiple: "A {names} piace il tuo profilo",
    notificationsDislikeCommentSingle: "{name} ha reagito al tuo commento",
    notificationsDislikePostSingle: "{name} ha reagito al tuo post",
    notificationsDislikeProfileSingle: "A {name} non piace il tuo profilo",
    notificationsDislikeCommentMultiple: "{names} hanno reagito al tuo commento",
    notificationsDislikePostMultiple: "{names} hanno reagito al tuo post",
    notificationsDislikeProfileMultiple: "A {names} non piace il tuo profilo",
    notificationsFriendRequestSingle: "{name} ti ha inviato una richiesta di amicizia",
    notificationsFriendRejectedSingle: "{name} ha rifiutato la tua richiesta di amicizia",
    notificationsFriendAcceptedSingle: "{name} ha accettato la tua richiesta di amicizia",
    notificationsProfileViewSingle: "{name} ha visto il tuo profilo",
    notificationsProfileViewMultiple: "{names} hanno visto il tuo profilo",
    notificationsMessageReplySingle: "{name} ha risposto al tuo commento",
    notificationsMessageCommentSingle: "{name} ha commentato il tuo post",
    notificationsMessagePostSingle: "{name} ha commentato il tuo post",
    notificationsMessageDirectSingle: "{name} ti ha inviato un messaggio",
    notificationsMessageReplyMultiple: "{names} hanno risposto al tuo commento",
    notificationsMessageCommentMultiple: "{names} hanno commentato il tuo post",
    notificationsMessagePostMultiple: "{names} hanno commentato il tuo post",
    notificationsMessageDirectMultiple: "{names} ti hanno inviato messaggi",
    notificationsLiveInvitationSingle: "{name} ti ha invitato al suo live",
    notificationsLiveJoinRequestSingle: "{name} ha chiesto di unirsi al tuo live",
    notificationsLiveStartedSingle: "{name} è in live",
    notificationsGenericSingle: "{name} ha interagito con te",
    notificationsGenericMultiple: "{names} hanno interagito con te",
    notificationsCallReactionsTitle: "Reazioni alle tue chiamate",
    notificationsReactionsCount: "Reazioni: {count}",
    notificationsNoReactionYet: "Nessuna reazione per ora",
    notificationsProfileVisitorsTitle: "Visitatori del profilo",
    notificationsVisitorsCount: "Visite: {count}",
    notificationsNoVisitorsYet: "Nessun visitatore per ora",
    notificationsPeople: "persona/e",
    feedEmptyTitle: "Nessun post per ora",
    feedEmptySubtitle: "Sii il primo a condividere qualcosa!",
    postStep: "Passo",
    postWizardStepContent: "Contenuto",
    postWizardStepMedia: "Media",
    postWizardStepTagsSettings: "Tag e impostazioni",
    postWizardStepPreview: "Anteprima",
    postWriteSomething: "Scrivi qualcosa... Usa #hashtag",
    postHashtagTip: "Suggerimento: usa #hashtag",
    dashboardSwipeHint: "Scorri ->",
    dashboardSuggestionsForYou: "Suggerimenti per te",
    friendsTitleMyFriends: "I miei amici",
    friendsHeaderStats: "{contacts} contatti{onlinePart}",
    friendsOnlineLabel: "online",
    friendsSubtitleManageContacts: "Gestisci i tuoi contatti",
    friendsNewCall: "Nuova chiamata",
    friendsCallShort: "Chiama",
    friendsTabFriends: "Amici",
    friendsTabRequests: "Richieste",
    friendsTabSent: "Inviate",
    friendsNoRequestYet: "Nessuna richiesta in sospeso",
    friendsRequestsDesc: "Le richieste di amicizia ricevute appariranno qui",
    friendsNoSentYet: "Nessuna richiesta inviata",
    friendsSentDesc: "Le richieste di amicizia inviate appariranno qui",
    friendsSendMessage: "Invia messaggio",
    friendsAccept: "Accetta",
    friendsReject: "Rifiuta",
    friendsStartCall: "Avvia una chiamata",
    chatSearchPlaceholder: "Cerca...",
    chatNoConversation: "Nessuna conversazione",
    chatAllRead: "Tutto letto ✓",
    chatPersonOnline: "Nessuno online",
    chatOffline: "Offline",
    chatSeenAt: "Visto alle",
    chatSeenYesterdayAt: "Visto ieri alle",
    chatSeenOn: "Visto il",
    chatYourMessage: "Il tuo messaggio",
    chatMedia: "Media",
    chatEditContent: "Modifica contenuto",
    chatDeleteForEveryone: "Elimina per tutti",
    chatRecording: "Registrazione...",
    chatFinish: "Termina",
    chatVoiceReady: "Messaggio vocale pronto",
    chatMicAccessError: "Impossibile accedere al microfono",
    chatSearchInConversation: "Cerca nella conversazione...",
    chatStartConversationTitle: "Inizia la conversazione",
    chatSayHello: "Saluta {name}!",
    chatNewMessages: "Nuovi messaggi",
    chatDeletedMessage: "Messaggio eliminato",
    chatEditMessage: "Modifica messaggio",
    chatMessagePlaceholder: "Messaggio...",
    chatNoMatch: "\"{search}\" non trovato",
    chatNewMessage: "Nuovo messaggio",
    chatChooseContact: "Scegli un contatto e inizia subito",
    chatSearchContact: "Cerca contatti...",
    chatContacts: "contatti",
    chatNoContactAvailable: "Nessun contatto disponibile",
    chatNoFriendFound: "Nessun amico trovato",
    chatFriends: "Amici",
    chatRecents: "Recenti",
    chatStartConversation: "Avvia conversazione",
    chatOpenConversation: "Apri conversazione",
    chatYou: "Tu",
    reactionLiked: "è piaciuto",
    reactionDisliked: "non è piaciuto",
    chatUnknown: "Sconosciuto",
    chatVideo: "Video",
    chatVoiceMessage: "Messaggio vocale",
    chatPhoto: "Foto",
    chatFile: "File",
    chatUnreadFilter: "Non letti",
    chatOnlineFilter: "Online",
    chatUnreadCount: "{count} non letti",
    chatConversationsCount: "{count} conversazioni",
    chatEmptyHint: "Tocca + per inviare il tuo primo messaggio",
    chatYesterday: "Ieri",
    backLabel: "Indietro",
    discoverTitle: "Scopri",
    discoverShowAll: "Mostra tutto",
    discoverForYou: "Per te",
    discoverNearby: "Nelle vicinanze",
    discoverOnline: "Online",
    discoverPopular: "Popolari",
    discoverViewGrid: "Vista griglia",
    discoverViewMap: "Vista mappa",
    discoverFilters: "Filtri",
    discoverResetFilters: "Reimposta",
    discoverAllCountries: "Tutti i paesi",
    discoverAllLanguages: "Tutte le lingue",
    discoverOnlineOnly: "Solo online",
    discoverNearbySection: "Nelle vicinanze",
    discoverClearFilters: "Cancella filtri",
    discoverNoUsers: "Nessun utente trovato",
    discoverNoUsersDesc: "Prova a cambiare i filtri o la ricerca",
    discoverNoLocalizedUsers: "Nessun utente locale",
    discoverNoLocalizedUsersDesc: "Gli utenti appariranno qui quando condividono la posizione",
    discoverFounder: "Fondatore",
    discoverPeopleCount: "{count} persone",
    discoverSearchPlaceholder: "Nome, username o bio...",
    discoverGPSRequired: "GPS richiesto",
    discoverResultsCount: "{count} risultati",
    liveEndedTitle: "Live terminata",
    randomCallEndedTitle: "Chiamata terminata",
    randomCallThanks: "Grazie per aver partecipato a questa chiamata.",
    randomCallLeave: "Lascia la chiamata",
    randomCallNewCall: "Nuova chiamata",
    randomCallCameraDisabled: "Fotocamera disattivata",
    randomCallMicMuted: "Microfono silenziato",
    liveThanks: "Grazie per aver usato Callo",
    discoverAdd: "Aggiungi",
    discoverRequestSent: "Richiesta inviata",
    discoverViewProfile: "Vedi profilo",
    discoverSent: "Inviato ✓",
    friendsRemoveFriend: "Rimuovi questo amico",
    friendsWaiting: "In attesa",
    postAllowComments: "Consenti commenti",
    postVisibility: "Visibilità",
    postYourPublication: "Il tuo post",
    postCommentsEnabled: "Commenti attivi",
    postCommentsDisabled: "Commenti disattivati",
    postVisibilityPublicDesc: "Visibile a tutti",
    postVisibilityFriendsDesc: "Solo ai tuoi amici",
    postVisibilityPrivateDesc: "Solo tu",
    nextLabel: "Avanti",
    postNoTextContent: "Nessun contenuto testuale",
    postTrendingTitle: "Tendenze",
    postNoTrendingNow: "Nessuna tendenza al momento",
    feedUpToDate: "Sei aggiornato!",
    commentReply: "Rispondi",
    commentInReplyTo: "in risposta a",
    commentActions: "Azioni",
    commentEmptyTitle: "Nessun commento per ora",
    commentEmptySubtitle: "Sii il primo a commentare!",
    postReactAction: "Reagisci",
    postCommentAction: "Commenta",
    postShareAction: "Condividi",
    commentEdit: "Modifica",
    commentDelete: "Elimina",
    commentCancel: "Annulla",
    commentReplyLabel: "risposta",
    commentReplyWord: "risposta",
    commentRepliesWord: "risposte",
    commentWritePlaceholder: "Scrivi un commento...",
    commentLike: "Mi piace",
    commentDislike: "Non mi piace",
    profileLikes: "Mi piace",
    profileDislikes: "Non mi piace",
  },
  ar: {
    yearsLabel: "سنة",
    settingsEditProfileHintPrefix: "لتعديل الاسم أو العمر أو النبذة أو اللغات، انتقل إلى قسم",
    settingsEditProfileHintSuffix: "يتم تحديث الموقع تلقائيًا.",
    authNamePlaceholder: "مثال: أليكس مارتن",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "أنشئ كلمة مرور قوية",
    authConfirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
    authDateOfBirthPlaceholder: "يوم/شهر/سنة",
    authDOBDay: "اليوم",
    authDOBMonth: "الشهر",
    authDOBYear: "السنة",
    authUsernameInvalidShort: "3-30 حرفًا، أحرف/أرقام/_",
    settingsFilterCountriesTitle: "تصفية حسب الدول",
    settingsFilterCountriesHelp: "يتم عرض الدول التي لديها مستخدمون مسجلون فقط. يمكنك تحديد منطقة كاملة بنقرة واحدة.",
    settingsFilterLanguagesTitle: "تصفية حسب اللغات",
    settingsFilterLanguagesHelp: "يتم عرض اللغات التي يتحدث بها المستخدمون المسجلون فقط. يمكنك تحديد مجموعة كاملة.",
    settingsSavePreferences: "حفظ التفضيلات",
    settingsSaving: "جارٍ الحفظ...",
    commentSave: "حفظ",
    settingsCountriesTitle: "البلدان",
    settingsCountriesNoFilter: "بدون فلتر — جميع البلدان",
    settingsLanguagesNoFilter: "بدون فلتر — جميع اللغات",
    settingsAgeRangeTitle: "الفئة العمرية",
    settingsAgeRangeHelp: "حدِّد الحد الأدنى والحد الأقصى لعمر الأشخاص الذين تريد مطابقتك معهم.",
    settingsMinAge: "العمر الأدنى",
    settingsMaxAge: "العمر الأقصى",
    settingsAgeRangeSummary: "سترى أشخاصًا بين {min} و {max} {years}",
    settingsPreferencesDesc: "الدول واللغات والفئة العمرية للمكالمات العشوائية",
    settingsPreferencesHelp: "قم بتكوين عوامل التصفية للمكالمات العشوائية. اتركها فارغة لقبول الجميع.",
    settingsAccountDesc: "المعلومات والأمان وحذف الحساب",
    settingsAccountInfoTitle: "معلومات الحساب",
    settingsLocation: "الموقع",
    settingsMemberSince: "عضو منذ",
    settingsLanguagesTitle: "اللغات",
    settingsIrreversibleAction: "إجراء لا رجعة فيه",
    settingsDeleteKeyword: "احذف",
    settingsAccountInfoDesc: "البريد الإلكتروني، الموقع، تاريخ التسجيل",
    settingsBlockedTitle: "المستخدمون المحظورون",
    settingsBlockedDesc: "إدارة الأشخاص الذين حظرتهم",
    settingsBlockedEmpty: "لا يوجد مستخدمون محظورون",
    settingsUnblock: "إلغاء الحظر",
    settingsLoading: "جارٍ التحميل...",
    settingsDeleteTitle: "حذف الحساب",
    settingsDeleteDesc: "حذف حسابك وجميع بياناتك نهائيًا",
    settingsGeolocation: "تحديد الموقع الجغرافي",
    settingsAllowed: "مسموح",
    settingsNotAllowed: "غير مسموح",
    settingsDeleteWarningDesc: "سيؤدي حذف حسابك إلى إزالة جميع بياناتك نهائيًا:",
    settingsDeleteItemProfile: "الملف الشخصي وصورة الملف",
    settingsDeleteItemMessages: "الرسائل والمحادثات",
    settingsDeleteItemFriends: "قائمة الأصدقاء والطلبات",
    settingsDeleteItemPosts: "المنشورات والتعليقات",
    settingsDeleteItemCalls: "سجل المكالمات",
    settingsDeleteItemReactions: "الإعجابات وعدم الإعجاب والتفاعلات",
    settingsCurrentPassword: "كلمة المرور الحالية",
    settingsChangePasswordTitle: "تغيير كلمة المرور",
    settingsChangePasswordDesc: "قم بتحديث كلمة المرور لتعزيز أمان حسابك",
    settingsEnterPassword: "أدخل كلمة المرور",
    settingsType: "اكتب",
    settingsToConfirm: "للتأكيد",
    settingsDeletePasswordRequired: "كلمة المرور مطلوبة",
    settingsDeleting: "جارٍ الحذف...",
    settingsDeleteForever: "احذف حسابي نهائيًا",
    notificationsTitle: "الإشعارات",
    notificationsSubtitle: "ابقَ على اطلاع بتفاعلاتك",
    notificationsSomeone: "شخص ما",
    notificationsAnd: "و",
    notificationsOther: "آخر",
    notificationsOthers: "آخرون",
    notificationsToday: "اليوم",
    notificationsYesterday: "أمس",
    notificationsThisWeek: "هذا الأسبوع",
    notificationsOlder: "الأقدم",
    notificationsAll: "الكل",
    notificationsUnread: "غير المقروءة",
    notificationsNoNotifications: "لا توجد إشعارات",
    notificationsUpToDate: "أنت على اطلاع كامل!",
    notificationsNoUnread: "ستظهر هنا إشعارات تفاعلاتك",
    notificationsDelete: "حذف",
    notificationsNew: "جديد",
    notificationsCallReactionSingle: "{name} تفاعل مع مكالمتك",
    notificationsCallReactionMultiple: "{names} تفاعلوا مع مكالماتك",
    notificationsLikeCommentSingle: "{name} تفاعل مع تعليقك",
    notificationsLikePostSingle: "{name} تفاعل مع منشورك",
    notificationsLikeProfileSingle: "{name} أعجب بملفك الشخصي",
    notificationsLikeCommentMultiple: "{names} تفاعلوا مع تعليقك",
    notificationsLikePostMultiple: "{names} تفاعلوا مع منشورك",
    notificationsLikeProfileMultiple: "{names} أعجبوا بملفك الشخصي",
    notificationsDislikeCommentSingle: "{name} تفاعل مع تعليقك",
    notificationsDislikePostSingle: "{name} تفاعل مع منشورك",
    notificationsDislikeProfileSingle: "{name} لم يعجبه ملفك الشخصي",
    notificationsDislikeCommentMultiple: "{names} تفاعلوا مع تعليقك",
    notificationsDislikePostMultiple: "{names} تفاعلوا مع منشورك",
    notificationsDislikeProfileMultiple: "{names} لم يعجبهم ملفك الشخصي",
    notificationsFriendRequestSingle: "{name} أرسل لك طلب صداقة",
    notificationsFriendRejectedSingle: "{name} رفض طلب صداقتك",
    notificationsFriendAcceptedSingle: "{name} قبل طلب صداقتك",
    notificationsProfileViewSingle: "{name} شاهد ملفك الشخصي",
    notificationsProfileViewMultiple: "{names} شاهدوا ملفك الشخصي",
    notificationsMessageReplySingle: "{name} رد على تعليقك",
    notificationsMessageCommentSingle: "{name} علّق على منشورك",
    notificationsMessagePostSingle: "{name} علّق على منشورك",
    notificationsMessageDirectSingle: "{name} أرسل لك رسالة",
    notificationsMessageReplyMultiple: "{names} ردوا على تعليقك",
    notificationsMessageCommentMultiple: "{names} علّقوا على منشورك",
    notificationsMessagePostMultiple: "{names} علّقوا على منشورك",
    notificationsMessageDirectMultiple: "{names} أرسلوا لك رسائل",
    notificationsLiveInvitationSingle: "{name} دعاك إلى بثه المباشر",
    notificationsLiveJoinRequestSingle: "{name} طلب الانضمام إلى بثك المباشر",
    notificationsLiveStartedSingle: "{name} بدأ بثًا مباشرًا",
    notificationsGenericSingle: "{name} تفاعل معك",
    notificationsGenericMultiple: "{names} تفاعلوا معك",
    notificationsCallReactionsTitle: "تفاعلات مكالماتك",
    notificationsReactionsCount: "التفاعلات: {count}",
    notificationsNoReactionYet: "لا توجد تفاعلات بعد",
    notificationsProfileVisitorsTitle: "زوار الملف الشخصي",
    notificationsVisitorsCount: "الزيارات: {count}",
    notificationsNoVisitorsYet: "لا يوجد زوار بعد",
    notificationsPeople: "شخص",
    feedEmptyTitle: "لا توجد منشورات بعد",
    feedEmptySubtitle: "كن أول من يشارك شيئًا!",
    postStep: "الخطوة",
    postWizardStepContent: "المحتوى",
    postWizardStepMedia: "الوسائط",
    postWizardStepTagsSettings: "الوسوم والإعدادات",
    postWizardStepPreview: "معاينة",
    postWriteSomething: "اكتب شيئًا... استخدم #الوسوم",
    postHashtagTip: "نصيحة: استخدم #الوسوم",
    dashboardSwipeHint: "اسحب ->",
    dashboardSuggestionsForYou: "اقتراحات لك",
    friendsTitleMyFriends: "أصدقائي",
    friendsHeaderStats: "{contacts} جهات اتصال{onlinePart}",
    friendsOnlineLabel: "متصل",
    friendsSubtitleManageContacts: "إدارة جهات الاتصال",
    friendsNewCall: "مكالمة جديدة",
    friendsCallShort: "اتصال",
    friendsTabFriends: "الأصدقاء",
    friendsTabRequests: "الطلبات",
    friendsTabSent: "المرسلة",
    friendsNoRequestYet: "لا توجد طلبات معلقة",
    friendsRequestsDesc: "طلبات الصداقة التي تستلمها ستظهر هنا",
    friendsNoSentYet: "لا توجد طلبات مرسلة",
    friendsSentDesc: "طلبات الصداقة التي ترسلها ستظهر هنا",
    friendsSendMessage: "إرسال رسالة",
    friendsAccept: "قبول",
    friendsReject: "رفض",
    friendsStartCall: "بدء مكالمة",
    chatSearchPlaceholder: "بحث...",
    chatNoConversation: "لا توجد محادثات",
    chatAllRead: "تمت القراءة كلها ✓",
    chatPersonOnline: "لا أحد متصل",
    chatOffline: "غير متصل",
    chatSeenAt: "شوهد في",
    chatSeenYesterdayAt: "شوهد أمس في",
    chatSeenOn: "شوهد في",
    chatYourMessage: "رسالتك",
    chatMedia: "وسائط",
    chatEditContent: "تعديل المحتوى",
    chatDeleteForEveryone: "حذف للجميع",
    chatRecording: "جارٍ التسجيل...",
    chatFinish: "إنهاء",
    chatVoiceReady: "الرسالة الصوتية جاهزة",
    chatMicAccessError: "تعذر الوصول إلى الميكروفون",
    chatSearchInConversation: "ابحث في المحادثة...",
    chatStartConversationTitle: "ابدأ المحادثة",
    chatSayHello: "قل مرحبا لـ {name}!",
    chatNewMessages: "رسائل جديدة",
    chatDeletedMessage: "تم حذف الرسالة",
    chatEditMessage: "تعديل الرسالة",
    chatMessagePlaceholder: "رسالة...",
    chatNoMatch: "\"{search}\" غير موجود",
    chatNewMessage: "رسالة جديدة",
    chatChooseContact: "اختر جهة اتصال وابدأ فورًا",
    chatSearchContact: "ابحث في جهات الاتصال...",
    chatContacts: "جهات اتصال",
    chatNoContactAvailable: "لا توجد جهات اتصال متاحة",
    chatNoFriendFound: "لم يتم العثور على أصدقاء",
    chatFriends: "الأصدقاء",
    chatRecents: "الأخيرة",
    chatStartConversation: "ابدأ محادثة",
    chatOpenConversation: "افتح المحادثة",
    chatYou: "أنت",
    reactionLiked: "أعجب بـ",
    reactionDisliked: "لم يعجب",
    chatUnknown: "مجهول",
    chatVideo: "فيديو",
    chatVoiceMessage: "رسالة صوتية",
    chatPhoto: "صورة",
    chatFile: "ملف",
    chatUnreadFilter: "غير المقروءة",
    chatOnlineFilter: "متصل",
    chatUnreadCount: "{count} غير مقروءة",
    chatConversationsCount: "{count} محادثات",
    chatEmptyHint: "اضغط + لإرسال أول رسالة",
    chatYesterday: "أمس",
    backLabel: "رجوع",
    discoverTitle: "استكشاف",
    discoverShowAll: "عرض الكل",
    discoverForYou: "لك",
    discoverNearby: "بالقرب",
    discoverOnline: "متصل",
    discoverPopular: "شائع",
    discoverViewGrid: "عرض شبكي",
    discoverViewMap: "عرض الخريطة",
    discoverFilters: "الفلاتر",
    discoverResetFilters: "إعادة تعيين",
    discoverAllCountries: "كل الدول",
    discoverAllLanguages: "كل اللغات",
    discoverOnlineOnly: "المتصلون فقط",
    discoverNearbySection: "بالقرب",
    discoverClearFilters: "مسح الفلاتر",
    discoverNoUsers: "لم يتم العثور على مستخدمين",
    discoverNoUsersDesc: "جرّب تعديل الفلاتر أو البحث",
    discoverNoLocalizedUsers: "لا يوجد مستخدمون محليون",
    discoverNoLocalizedUsersDesc: "سيظهر المستخدمون هنا عند مشاركة موقعهم",
    discoverFounder: "المؤسس",
    discoverPeopleCount: "{count} أشخاص",
    discoverSearchPlaceholder: "الاسم أو اسم المستخدم أو النبذة...",
    discoverGPSRequired: "GPS مطلوب",
    discoverResultsCount: "{count} نتائج",
    liveEndedTitle: "انتهى البث",
    randomCallEndedTitle: "انتهت المكالمة",
    randomCallThanks: "شكرا لمشاركتك في هذه المكالمة.",
    randomCallLeave: "مغادرة المكالمة",
    randomCallNewCall: "مكالمة جديدة",
    randomCallCameraDisabled: "الكاميرا معطلة",
    randomCallMicMuted: "الميكروفون مكتوم",
    liveThanks: "شكرًا لاستخدام Callo",
    discoverAdd: "إضافة",
    discoverRequestSent: "تم إرسال الطلب",
    discoverViewProfile: "عرض الملف الشخصي",
    discoverSent: "تم الإرسال ✓",
    friendsRemoveFriend: "إزالة هذا الصديق",
    friendsWaiting: "قيد الانتظار",
    postAllowComments: "السماح بالتعليقات",
    postVisibility: "الرؤية",
    postYourPublication: "منشورك",
    postCommentsEnabled: "التعليقات مفعلة",
    postCommentsDisabled: "التعليقات معطلة",
    postVisibilityPublicDesc: "مرئي للجميع",
    postVisibilityFriendsDesc: "أصدقاؤك فقط",
    postVisibilityPrivateDesc: "أنت فقط",
    nextLabel: "التالي",
    postNoTextContent: "لا يوجد محتوى نصي",
    postTrendingTitle: "المواضيع الرائجة",
    postNoTrendingNow: "لا توجد مواضيع رائجة حالياً",
    feedUpToDate: "أنت على اطلاع كامل!",
    commentReply: "رد",
    commentInReplyTo: "ردًا على",
    commentActions: "إجراءات",
    commentEmptyTitle: "لا توجد تعليقات بعد",
    commentEmptySubtitle: "كن أول من يعلق!",
    postReactAction: "تفاعل",
    postCommentAction: "علّق",
    postShareAction: "مشاركة",
    commentEdit: "تعديل",
    commentDelete: "حذف",
    commentCancel: "إلغاء",
    commentReplyLabel: "رد",
    commentReplyWord: "رد",
    commentRepliesWord: "ردود",
    commentWritePlaceholder: "اكتب تعليقًا...",
    commentLike: "إعجاب",
    commentDislike: "عدم إعجاب",
    profileLikes: "إعجابات",
    profileDislikes: "عدم إعجاب",
  },
  tr: {
    yearsLabel: "yaş",
    settingsEditProfileHintPrefix: "Adını, yaşını, biyografini veya dillerini düzenlemek için şu bölüme git:",
    settingsEditProfileHintSuffix: "Konum otomatik olarak güncellenir.",
    authNamePlaceholder: "Örn: Alex Martin",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "Güçlü bir şifre oluştur",
    authConfirmPasswordPlaceholder: "Şifreni tekrar gir",
    authDateOfBirthPlaceholder: "gg/aa/yyyy",
    authDOBDay: "Gün",
    authDOBMonth: "Ay",
    authDOBYear: "Yıl",
    authUsernameInvalidShort: "3-30 krk., harf/rakam/_",
    settingsFilterCountriesTitle: "Ülkelere göre filtrele",
    settingsFilterCountriesHelp: "Yalnızca kayıtlı kullanıcıların bulunduğu ülkeler gösterilir. Tek tıklamayla tüm bir bölgeyi seçebilirsin.",
    settingsFilterLanguagesTitle: "Dillere göre filtrele",
    settingsFilterLanguagesHelp: "Yalnızca kayıtlı kullanıcıların konuştuğu diller gösterilir. Tüm bir grubu seçebilirsin.",
    settingsSavePreferences: "Tercihleri kaydet",
    settingsSaving: "Kaydediliyor...",
    commentSave: "Kaydet",
    settingsCountriesTitle: "Ülkeler",
    settingsCountriesNoFilter: "Filtre yok — tüm ülkeler",
    settingsLanguagesNoFilter: "Filtre yok — tüm diller",
    settingsAgeRangeTitle: "Yaş aralığı",
    settingsAgeRangeHelp: "Eşleşmek istediğin kişilerin minimum ve maksimum yaşını belirle.",
    settingsMinAge: "Minimum yaş",
    settingsMaxAge: "Maksimum yaş",
    settingsAgeRangeSummary: "{min} ile {max} {years} arasındaki kişileri göreceksin",
    settingsPreferencesDesc: "Rastgele aramalar için ülkeler, diller ve yaş aralığı",
    settingsPreferencesHelp: "Rastgele aramalar için filtrelerini yapılandır. Herkesi kabul etmek için boş bırak.",
    settingsAccountDesc: "Bilgiler, güvenlik ve hesap silme",
    settingsAccountInfoTitle: "Hesap bilgileri",
    settingsLocation: "Konum",
    settingsMemberSince: "Üyelik tarihi",
    settingsLanguagesTitle: "Diller",
    settingsIrreversibleAction: "Geri alınamaz işlem",
    settingsDeleteKeyword: "SIL",
    settingsAccountInfoDesc: "E-posta, konum, kayıt tarihi",
    settingsBlockedTitle: "Engellenen kullanıcılar",
    settingsBlockedDesc: "Engellediğiniz kişileri yönetin",
    settingsBlockedEmpty: "Engellenen kullanıcı yok",
    settingsUnblock: "Engeli kaldır",
    settingsLoading: "Yükleniyor...",
    settingsDeleteTitle: "Hesabı sil",
    settingsDeleteDesc: "Hesabını ve tüm verilerini kalıcı olarak sil",
    settingsGeolocation: "Coğrafi konum",
    settingsAllowed: "İzin verildi",
    settingsNotAllowed: "İzin verilmedi",
    settingsDeleteWarningDesc: "Hesabını silmek tüm verilerini kalıcı olarak kaldırır:",
    settingsDeleteItemProfile: "Profil ve profil fotoğrafı",
    settingsDeleteItemMessages: "Mesajlar ve konuşmalar",
    settingsDeleteItemFriends: "Arkadaş listesi ve istekler",
    settingsDeleteItemPosts: "Gönderiler ve yorumlar",
    settingsDeleteItemCalls: "Arama geçmişi",
    settingsDeleteItemReactions: "Beğeniler, beğenmeme ve tepkiler",
    settingsCurrentPassword: "Mevcut şifre",
    settingsChangePasswordTitle: "Şifreyi değiştir",
    settingsChangePasswordDesc: "Hesabınızın güvenliğini artırmak için şifrenizi güncelleyin",
    settingsEnterPassword: "Şifrenizi girin",
    settingsType: "Yazın",
    settingsToConfirm: "onaylamak için",
    settingsDeletePasswordRequired: "Şifre gerekli",
    settingsDeleting: "Siliniyor...",
    settingsDeleteForever: "Hesabımı kalıcı olarak sil",
    notificationsTitle: "Bildirimler",
    notificationsSubtitle: "Etkileşimlerinden haberdar ol",
    notificationsSomeone: "Birisi",
    notificationsAnd: "ve",
    notificationsOther: "diğer",
    notificationsOthers: "diğerleri",
    notificationsToday: "Bugün",
    notificationsYesterday: "Dün",
    notificationsThisWeek: "Bu hafta",
    notificationsOlder: "Daha eski",
    notificationsAll: "Tümü",
    notificationsUnread: "Okunmamış",
    notificationsNoNotifications: "Bildirim yok",
    notificationsUpToDate: "Her şey güncel!",
    notificationsNoUnread: "Etkileşimlerinle ilgili bildirimler burada görünecek",
    notificationsDelete: "Sil",
    notificationsNew: "Yeni",
    notificationsCallReactionSingle: "{name} aramana tepki verdi",
    notificationsCallReactionMultiple: "{names} aramalarına tepki verdi",
    notificationsLikeCommentSingle: "{name} yorumuna tepki verdi",
    notificationsLikePostSingle: "{name} gönderine tepki verdi",
    notificationsLikeProfileSingle: "{name} profilini beğendi",
    notificationsLikeCommentMultiple: "{names} yorumuna tepki verdi",
    notificationsLikePostMultiple: "{names} gönderine tepki verdi",
    notificationsLikeProfileMultiple: "{names} profilini beğendi",
    notificationsDislikeCommentSingle: "{name} yorumuna tepki verdi",
    notificationsDislikePostSingle: "{name} gönderine tepki verdi",
    notificationsDislikeProfileSingle: "{name} profilini beğenmedi",
    notificationsDislikeCommentMultiple: "{names} yorumuna tepki verdi",
    notificationsDislikePostMultiple: "{names} gönderine tepki verdi",
    notificationsDislikeProfileMultiple: "{names} profilini beğenmedi",
    notificationsFriendRequestSingle: "{name} sana arkadaşlık isteği gönderdi",
    notificationsFriendRejectedSingle: "{name} arkadaşlık isteğini reddetti",
    notificationsFriendAcceptedSingle: "{name} arkadaşlık isteğini kabul etti",
    notificationsProfileViewSingle: "{name} profilini görüntüledi",
    notificationsProfileViewMultiple: "{names} profilini görüntüledi",
    notificationsMessageReplySingle: "{name} yorumuna yanıt verdi",
    notificationsMessageCommentSingle: "{name} gönderine yorum yaptı",
    notificationsMessagePostSingle: "{name} gönderine yorum yaptı",
    notificationsMessageDirectSingle: "{name} sana mesaj gönderdi",
    notificationsMessageReplyMultiple: "{names} yorumuna yanıt verdi",
    notificationsMessageCommentMultiple: "{names} gönderine yorum yaptı",
    notificationsMessagePostMultiple: "{names} gönderine yorum yaptı",
    notificationsMessageDirectMultiple: "{names} sana mesaj gönderdi",
    notificationsLiveInvitationSingle: "{name} seni canlı yayınına davet etti",
    notificationsLiveJoinRequestSingle: "{name} canlı yayınına katılmak istedi",
    notificationsLiveStartedSingle: "{name} canlı yayına başladı",
    notificationsGenericSingle: "{name} seninle etkileşime geçti",
    notificationsGenericMultiple: "{names} seninle etkileşime geçti",
    notificationsCallReactionsTitle: "Aramalarına gelen tepkiler",
    notificationsReactionsCount: "Tepkiler: {count}",
    notificationsNoReactionYet: "Henüz tepki yok",
    notificationsProfileVisitorsTitle: "Profil ziyaretçileri",
    notificationsVisitorsCount: "Ziyaret: {count}",
    notificationsNoVisitorsYet: "Henüz ziyaretçi yok",
    notificationsPeople: "kişi",
    feedEmptyTitle: "Henüz gönderi yok",
    feedEmptySubtitle: "Bir şey paylaşan ilk kişi ol!",
    postStep: "Adım",
    postWizardStepContent: "İçerik",
    postWizardStepMedia: "Medya",
    postWizardStepTagsSettings: "Etiketler ve ayarlar",
    postWizardStepPreview: "Önizleme",
    postWriteSomething: "Bir şey yaz... #etiket kullan",
    postHashtagTip: "İpucu: #etiket kullan",
    dashboardSwipeHint: "Kaydır ->",
    dashboardSuggestionsForYou: "Sana öneriler",
    friendsTitleMyFriends: "Arkadaşlarım",
    friendsHeaderStats: "{contacts} kişi{onlinePart}",
    friendsOnlineLabel: "çevrimiçi",
    friendsSubtitleManageContacts: "Kişilerini yönet",
    friendsNewCall: "Yeni arama",
    friendsCallShort: "Ara",
    friendsTabFriends: "Arkadaşlar",
    friendsTabRequests: "İstekler",
    friendsTabSent: "Gönderilen",
    friendsNoRequestYet: "Bekleyen istek yok",
    friendsRequestsDesc: "Aldığın arkadaşlık istekleri burada görünür",
    friendsNoSentYet: "Gönderilmiş istek yok",
    friendsSentDesc: "Gönderdiğin arkadaşlık istekleri burada görünür",
    friendsSendMessage: "Mesaj gönder",
    friendsAccept: "Kabul et",
    friendsReject: "Reddet",
    friendsStartCall: "Arama başlat",
    chatSearchPlaceholder: "Ara...",
    chatNoConversation: "Konuşma yok",
    chatAllRead: "Hepsi okundu ✓",
    chatPersonOnline: "Kimse çevrimiçi değil",
    chatOffline: "Çevrimdışı",
    chatSeenAt: "Görüldü:",
    chatSeenYesterdayAt: "Dün görüldü:",
    chatSeenOn: "Şu tarihte görüldü:",
    chatYourMessage: "Mesajın",
    chatMedia: "Medya",
    chatEditContent: "İçeriği düzenle",
    chatDeleteForEveryone: "Herkes için sil",
    chatRecording: "Kaydediliyor...",
    chatFinish: "Bitir",
    chatVoiceReady: "Sesli mesaj hazır",
    chatMicAccessError: "Mikrofona erişilemiyor",
    chatSearchInConversation: "Konuşmada ara...",
    chatStartConversationTitle: "Konuşmayı başlat",
    chatSayHello: "{name} için merhaba de!",
    chatNewMessages: "Yeni mesajlar",
    chatDeletedMessage: "Mesaj silindi",
    chatEditMessage: "Mesajı düzenle",
    chatMessagePlaceholder: "Mesaj...",
    chatNoMatch: "\"{search}\" bulunamadı",
    chatNewMessage: "Yeni mesaj",
    chatChooseContact: "Bir kişi seç ve hemen başla",
    chatSearchContact: "Kişilerde ara...",
    chatContacts: "kişi",
    chatNoContactAvailable: "Kullanılabilir kişi yok",
    chatNoFriendFound: "Arkadaş bulunamadı",
    chatFriends: "Arkadaşlar",
    chatRecents: "Son",
    chatStartConversation: "Konuşma başlat",
    chatOpenConversation: "Konuşmayı aç",
    chatYou: "Sen",
    reactionLiked: "beğendi",
    reactionDisliked: "beğenmedi",
    chatUnknown: "Bilinmeyen",
    chatVideo: "Video",
    chatVoiceMessage: "Sesli mesaj",
    chatPhoto: "Fotoğraf",
    chatFile: "Dosya",
    chatUnreadFilter: "Okunmamış",
    chatOnlineFilter: "Çevrimiçi",
    chatUnreadCount: "{count} okunmamış",
    chatConversationsCount: "{count} konuşma",
    chatEmptyHint: "İlk mesajını göndermek için + düğmesine dokun",
    chatYesterday: "Dün",
    backLabel: "Geri",
    discoverTitle: "Keşfet",
    discoverShowAll: "Tümünü göster",
    discoverForYou: "Senin için",
    discoverNearby: "Yakındakiler",
    discoverOnline: "Çevrimiçi",
    discoverPopular: "Popüler",
    discoverViewGrid: "Izgara görünümü",
    discoverViewMap: "Harita görünümü",
    discoverFilters: "Filtreler",
    discoverResetFilters: "Sıfırla",
    discoverAllCountries: "Tüm ülkeler",
    discoverAllLanguages: "Tüm diller",
    discoverOnlineOnly: "Sadece çevrimiçi",
    discoverNearbySection: "Yakındakiler",
    discoverClearFilters: "Filtreleri temizle",
    discoverNoUsers: "Kullanıcı bulunamadı",
    discoverNoUsersDesc: "Filtrelerini veya aramanı değiştirmeyi dene",
    discoverNoLocalizedUsers: "Yerel kullanıcı yok",
    discoverNoLocalizedUsersDesc: "Kullanıcılar konum paylaştığında burada görünecek",
    discoverFounder: "Kurucu",
    discoverPeopleCount: "{count} kişi",
    discoverSearchPlaceholder: "Ad, kullanıcı adı veya biyografi...",
    discoverGPSRequired: "GPS gerekli",
    discoverResultsCount: "{count} sonuç",
    liveEndedTitle: "Canlı yayın bitti",
    randomCallEndedTitle: "Arama bitti",
    randomCallThanks: "Bu aramaya katıldığınız için teşekkürler.",
    randomCallLeave: "Aramadan ayrıl",
    randomCallNewCall: "Yeni arama",
    randomCallCameraDisabled: "Kamera devre dışı",
    randomCallMicMuted: "Mikrofon sessize alındı",
    liveThanks: "Callo'yu kullandığınız için teşekkürler",
    discoverAdd: "Ekle",
    discoverRequestSent: "İstek gönderildi",
    discoverViewProfile: "Profili görüntüle",
    discoverSent: "Gönderildi ✓",
    friendsRemoveFriend: "Bu arkadaşı kaldır",
    friendsWaiting: "Beklemede",
    postAllowComments: "Yorumlara izin ver",
    postVisibility: "Görünürlük",
    postYourPublication: "Gönderin",
    postCommentsEnabled: "Yorumlar etkin",
    postCommentsDisabled: "Yorumlar devre dışı",
    postVisibilityPublicDesc: "Herkese açık",
    postVisibilityFriendsDesc: "Sadece arkadaşların",
    postVisibilityPrivateDesc: "Sadece sen",
    nextLabel: "Sonraki",
    postNoTextContent: "Metin içeriği yok",
    postTrendingTitle: "Trendler",
    postNoTrendingNow: "Şu anda trend yok",
    feedUpToDate: "Her şey güncel!",
    commentReply: "Yanıtla",
    commentInReplyTo: "yanıt olarak",
    commentActions: "İşlemler",
    commentEmptyTitle: "Henüz yorum yok",
    commentEmptySubtitle: "İlk yorumu sen yap!",
    postReactAction: "Tepki ver",
    postCommentAction: "Yorum yap",
    postShareAction: "Paylaş",
    commentEdit: "Düzenle",
    commentDelete: "Sil",
    commentCancel: "İptal",
    commentReplyLabel: "yanıt",
    commentReplyWord: "yanıt",
    commentRepliesWord: "yanıtlar",
    commentWritePlaceholder: "Yorum yaz...",
    commentLike: "Beğen",
    commentDislike: "Beğenme",
    profileLikes: "Beğeniler",
    profileDislikes: "Beğenmeme",
  },
  nl: {
    yearsLabel: "jaar",
    settingsEditProfileHintPrefix: "Om je naam, leeftijd, bio of talen te bewerken, ga naar de sectie",
    settingsEditProfileHintSuffix: "Locatie wordt automatisch bijgewerkt.",
    authNamePlaceholder: "Bijv. Alex Martin",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "Maak een sterk wachtwoord",
    authConfirmPasswordPlaceholder: "Herhaal je wachtwoord",
    authDateOfBirthPlaceholder: "dd/mm/jjjj",
    authDOBDay: "Dag",
    authDOBMonth: "Maand",
    authDOBYear: "Jaar",
    authUsernameInvalidShort: "3-30 tekens, letters/cijfers/_",
    settingsFilterCountriesTitle: "Filteren op landen",
    settingsFilterCountriesHelp: "Alleen landen met geregistreerde gebruikers worden getoond. Je kunt met één klik een hele regio selecteren.",
    settingsFilterLanguagesTitle: "Filteren op talen",
    settingsFilterLanguagesHelp: "Alleen talen die door geregistreerde gebruikers worden gesproken, worden getoond. Je kunt een hele groep selecteren.",
    settingsSavePreferences: "Voorkeuren opslaan",
    settingsSaving: "Opslaan...",
    commentSave: "Opslaan",
    settingsCountriesTitle: "Landen",
    settingsCountriesNoFilter: "Geen filter — alle landen",
    settingsLanguagesNoFilter: "Geen filter — alle talen",
    settingsAgeRangeTitle: "Leeftijdsbereik",
    settingsAgeRangeHelp: "Stel de minimum- en maximumleeftijd in van mensen met wie je gematcht wilt worden.",
    settingsMinAge: "Minimumleeftijd",
    settingsMaxAge: "Maximumleeftijd",
    settingsAgeRangeSummary: "Je ziet mensen tussen {min} en {max} {years}",
    settingsPreferencesDesc: "Landen, talen en leeftijdsbereik voor willekeurige gesprekken",
    settingsPreferencesHelp: "Stel je filters in voor willekeurige gesprekken. Laat leeg om iedereen te accepteren.",
    settingsAccountDesc: "Informatie, beveiliging en accountverwijdering",
    settingsAccountInfoTitle: "Accountinformatie",
    settingsLocation: "Locatie",
    settingsMemberSince: "Lid sinds",
    settingsLanguagesTitle: "Talen",
    settingsIrreversibleAction: "Onomkeerbare actie",
    settingsDeleteKeyword: "VERWIJDER",
    settingsAccountInfoDesc: "E-mail, locatie, registratiedatum",
    settingsBlockedTitle: "Geblokkeerde gebruikers",
    settingsBlockedDesc: "Beheer de mensen die je hebt geblokkeerd",
    settingsBlockedEmpty: "Geen geblokkeerde gebruikers",
    settingsUnblock: "Deblokkeren",
    settingsLoading: "Laden...",
    settingsDeleteTitle: "Account verwijderen",
    settingsDeleteDesc: "Verwijder je account en al je gegevens permanent",
    settingsGeolocation: "Geolocatie",
    settingsAllowed: "Toegestaan",
    settingsNotAllowed: "Niet toegestaan",
    settingsDeleteWarningDesc: "Het verwijderen van je account verwijdert al je gegevens permanent:",
    settingsDeleteItemProfile: "Profiel en profielfoto",
    settingsDeleteItemMessages: "Berichten en gesprekken",
    settingsDeleteItemFriends: "Vriendenlijst en verzoeken",
    settingsDeleteItemPosts: "Berichten en reacties",
    settingsDeleteItemCalls: "Belgeschiedenis",
    settingsDeleteItemReactions: "Likes, dislikes en reacties",
    settingsCurrentPassword: "Huidig wachtwoord",
    settingsChangePasswordTitle: "Wachtwoord wijzigen",
    settingsChangePasswordDesc: "Werk je wachtwoord bij om de beveiliging van je account te versterken",
    settingsEnterPassword: "Voer je wachtwoord in",
    settingsType: "Typ",
    settingsToConfirm: "om te bevestigen",
    settingsDeletePasswordRequired: "Wachtwoord vereist",
    settingsDeleting: "Bezig met verwijderen...",
    settingsDeleteForever: "Mijn account permanent verwijderen",
    notificationsTitle: "Meldingen",
    notificationsSubtitle: "Blijf op de hoogte van je interacties",
    notificationsSomeone: "Iemand",
    notificationsAnd: "en",
    notificationsOther: "andere",
    notificationsOthers: "anderen",
    notificationsToday: "Vandaag",
    notificationsYesterday: "Gisteren",
    notificationsThisWeek: "Deze week",
    notificationsOlder: "Eerder",
    notificationsAll: "Alle",
    notificationsUnread: "Ongelezen",
    notificationsNoNotifications: "Geen meldingen",
    notificationsUpToDate: "Je bent helemaal bij!",
    notificationsNoUnread: "Meldingen over je interacties verschijnen hier",
    notificationsDelete: "Verwijderen",
    notificationsNew: "Nieuw",
    notificationsCallReactionSingle: "{name} reageerde op je gesprek",
    notificationsCallReactionMultiple: "{names} reageerden op je gesprekken",
    notificationsLikeCommentSingle: "{name} reageerde op je reactie",
    notificationsLikePostSingle: "{name} reageerde op je bericht",
    notificationsLikeProfileSingle: "{name} vond je profiel leuk",
    notificationsLikeCommentMultiple: "{names} reageerden op je reactie",
    notificationsLikePostMultiple: "{names} reageerden op je bericht",
    notificationsLikeProfileMultiple: "{names} vonden je profiel leuk",
    notificationsDislikeCommentSingle: "{name} reageerde op je reactie",
    notificationsDislikePostSingle: "{name} reageerde op je bericht",
    notificationsDislikeProfileSingle: "{name} vond je profiel niet leuk",
    notificationsDislikeCommentMultiple: "{names} reageerden op je reactie",
    notificationsDislikePostMultiple: "{names} reageerden op je bericht",
    notificationsDislikeProfileMultiple: "{names} vonden je profiel niet leuk",
    notificationsFriendRequestSingle: "{name} stuurde je een vriendschapsverzoek",
    notificationsFriendRejectedSingle: "{name} wees je vriendschapsverzoek af",
    notificationsFriendAcceptedSingle: "{name} accepteerde je vriendschapsverzoek",
    notificationsProfileViewSingle: "{name} bekeek je profiel",
    notificationsProfileViewMultiple: "{names} bekeken je profiel",
    notificationsMessageReplySingle: "{name} antwoordde op je reactie",
    notificationsMessageCommentSingle: "{name} reageerde op je bericht",
    notificationsMessagePostSingle: "{name} reageerde op je bericht",
    notificationsMessageDirectSingle: "{name} stuurde je een bericht",
    notificationsMessageReplyMultiple: "{names} antwoordden op je reactie",
    notificationsMessageCommentMultiple: "{names} reageerden op je bericht",
    notificationsMessagePostMultiple: "{names} reageerden op je bericht",
    notificationsMessageDirectMultiple: "{names} stuurden je berichten",
    notificationsLiveInvitationSingle: "{name} nodigde je uit voor de live",
    notificationsLiveJoinRequestSingle: "{name} wil deelnemen aan je live",
    notificationsLiveStartedSingle: "{name} is live",
    notificationsGenericSingle: "{name} had interactie met je",
    notificationsGenericMultiple: "{names} hadden interactie met je",
    notificationsCallReactionsTitle: "Reacties op je gesprekken",
    notificationsReactionsCount: "Reacties: {count}",
    notificationsNoReactionYet: "Nog geen reacties",
    notificationsProfileVisitorsTitle: "Profielbezoekers",
    notificationsVisitorsCount: "Bezoeken: {count}",
    notificationsNoVisitorsYet: "Nog geen bezoekers",
    notificationsPeople: "persoon/personen",
    feedEmptyTitle: "Nog geen berichten",
    feedEmptySubtitle: "Wees de eerste die iets deelt!",
    postStep: "Stap",
    postWizardStepContent: "Inhoud",
    postWizardStepMedia: "Media",
    postWizardStepTagsSettings: "Tags en instellingen",
    postWizardStepPreview: "Voorbeeld",
    postWriteSomething: "Schrijf iets... Gebruik #hashtags",
    postHashtagTip: "Tip: gebruik #hashtags",
    dashboardSwipeHint: "Swipe ->",
    dashboardSuggestionsForYou: "Suggesties voor jou",
    friendsTitleMyFriends: "Mijn vrienden",
    friendsHeaderStats: "{contacts} contacten{onlinePart}",
    friendsOnlineLabel: "online",
    friendsSubtitleManageContacts: "Beheer je contacten",
    friendsNewCall: "Nieuw gesprek",
    friendsCallShort: "Bellen",
    friendsTabFriends: "Vrienden",
    friendsTabRequests: "Verzoeken",
    friendsTabSent: "Verzonden",
    friendsNoRequestYet: "Geen openstaande verzoeken",
    friendsRequestsDesc: "Vriendschapsverzoeken die je ontvangt verschijnen hier",
    friendsNoSentYet: "Geen verzonden verzoeken",
    friendsSentDesc: "Vriendschapsverzoeken die je verstuurt verschijnen hier",
    friendsSendMessage: "Bericht sturen",
    friendsAccept: "Accepteren",
    friendsReject: "Afwijzen",
    friendsStartCall: "Gesprek starten",
    chatSearchPlaceholder: "Zoeken...",
    chatNoConversation: "Geen gesprekken",
    chatAllRead: "Alles gelezen ✓",
    chatPersonOnline: "Niemand online",
    chatOffline: "Offline",
    chatSeenAt: "Gezien om",
    chatSeenYesterdayAt: "Gisteren gezien om",
    chatSeenOn: "Gezien op",
    chatYourMessage: "Jouw bericht",
    chatMedia: "Media",
    chatEditContent: "Inhoud bewerken",
    chatDeleteForEveryone: "Verwijderen voor iedereen",
    chatRecording: "Opnemen...",
    chatFinish: "Voltooien",
    chatVoiceReady: "Spraakbericht klaar",
    chatMicAccessError: "Geen toegang tot microfoon",
    chatSearchInConversation: "Zoeken in gesprek...",
    chatStartConversationTitle: "Start het gesprek",
    chatSayHello: "Zeg hallo tegen {name}!",
    chatNewMessages: "Nieuwe berichten",
    chatDeletedMessage: "Bericht verwijderd",
    chatEditMessage: "Bericht bewerken",
    chatMessagePlaceholder: "Bericht...",
    chatNoMatch: "\"{search}\" niet gevonden",
    chatNewMessage: "Nieuw bericht",
    chatChooseContact: "Kies een contact en begin meteen",
    chatSearchContact: "Zoek contacten...",
    chatContacts: "contacten",
    chatNoContactAvailable: "Geen contacten beschikbaar",
    chatNoFriendFound: "Geen vrienden gevonden",
    chatFriends: "Vrienden",
    chatRecents: "Recent",
    chatStartConversation: "Start gesprek",
    chatOpenConversation: "Open gesprek",
    chatYou: "Jij",
    reactionLiked: "leuk gevonden",
    reactionDisliked: "vond het niet leuk",
    chatUnknown: "Onbekend",
    chatVideo: "Video",
    chatVoiceMessage: "Spraakbericht",
    chatPhoto: "Foto",
    chatFile: "Bestand",
    chatUnreadFilter: "Ongelezen",
    chatOnlineFilter: "Online",
    chatUnreadCount: "{count} ongelezen",
    chatConversationsCount: "{count} gesprekken",
    chatEmptyHint: "Tik op + om je eerste bericht te sturen",
    chatYesterday: "Gisteren",
    backLabel: "Terug",
    discoverTitle: "Ontdekken",
    discoverShowAll: "Alles tonen",
    discoverForYou: "Voor jou",
    discoverNearby: "In de buurt",
    discoverOnline: "Online",
    discoverPopular: "Populair",
    discoverViewGrid: "Rasterweergave",
    discoverViewMap: "Kaartweergave",
    discoverFilters: "Filters",
    discoverResetFilters: "Resetten",
    discoverAllCountries: "Alle landen",
    discoverAllLanguages: "Alle talen",
    discoverOnlineOnly: "Alleen online",
    discoverNearbySection: "In de buurt",
    discoverClearFilters: "Filters wissen",
    discoverNoUsers: "Geen gebruikers gevonden",
    discoverNoUsersDesc: "Probeer je filters of zoekopdracht te wijzigen",
    discoverNoLocalizedUsers: "Geen lokale gebruikers",
    discoverNoLocalizedUsersDesc: "Gebruikers verschijnen hier wanneer ze hun locatie delen",
    discoverFounder: "Oprichter",
    discoverPeopleCount: "{count} mensen",
    discoverSearchPlaceholder: "Naam, gebruikersnaam of bio...",
    discoverGPSRequired: "GPS vereist",
    discoverResultsCount: "{count} resultaten",
    liveEndedTitle: "Live beëindigd",
    randomCallEndedTitle: "Gesprek beëindigd",
    randomCallThanks: "Bedankt voor je deelname aan dit gesprek.",
    randomCallLeave: "Gesprek verlaten",
    randomCallNewCall: "Nieuw gesprek",
    randomCallCameraDisabled: "Camera uitgeschakeld",
    randomCallMicMuted: "Microfoon gedempt",
    liveThanks: "Bedankt voor het gebruiken van Callo",
    discoverAdd: "Toevoegen",
    discoverRequestSent: "Verzoek verzonden",
    discoverViewProfile: "Bekijk profiel",
    discoverSent: "Verzonden ✓",
    friendsRemoveFriend: "Deze vriend verwijderen",
    friendsWaiting: "In behandeling",
    postAllowComments: "Reacties toestaan",
    postVisibility: "Zichtbaarheid",
    postYourPublication: "Jouw bericht",
    postCommentsEnabled: "Reacties ingeschakeld",
    postCommentsDisabled: "Reacties uitgeschakeld",
    postVisibilityPublicDesc: "Voor iedereen zichtbaar",
    postVisibilityFriendsDesc: "Alleen je vrienden",
    postVisibilityPrivateDesc: "Alleen jij",
    nextLabel: "Volgende",
    postNoTextContent: "Geen tekstinhoud",
    postTrendingTitle: "Trends",
    postNoTrendingNow: "Momenteel geen trends",
    feedUpToDate: "Je bent helemaal bij!",
    commentReply: "Antwoorden",
    commentInReplyTo: "als reactie op",
    commentActions: "Acties",
    commentEmptyTitle: "Nog geen reacties",
    commentEmptySubtitle: "Wees de eerste die reageert!",
    postReactAction: "Reageren",
    postCommentAction: "Reageren",
    postShareAction: "Delen",
    commentEdit: "Bewerken",
    commentDelete: "Verwijderen",
    commentCancel: "Annuleren",
    commentReplyLabel: "reactie",
    commentReplyWord: "reactie",
    commentRepliesWord: "reacties",
    commentWritePlaceholder: "Schrijf een reactie...",
    commentLike: "Vind ik leuk",
    commentDislike: "Vind ik niet leuk",
    profileLikes: "Likes",
    profileDislikes: "Dislikes",
  },
  ru: {
    yearsLabel: "лет",
    settingsEditProfileHintPrefix: "Чтобы изменить имя, возраст, био или языки, перейдите в раздел",
    settingsEditProfileHintSuffix: "Местоположение обновляется автоматически.",
    authNamePlaceholder: "Напр.: Алекс Мартин",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "Создайте надежный пароль",
    authConfirmPasswordPlaceholder: "Повторите пароль",
    authDateOfBirthPlaceholder: "дд/мм/гггг",
    authDOBDay: "День",
    authDOBMonth: "Месяц",
    authDOBYear: "Год",
    authUsernameInvalidShort: "3-30 симв., буквы/цифры/_",
    settingsFilterCountriesTitle: "Фильтр по странам",
    settingsFilterCountriesHelp: "Показываются только страны с зарегистрированными пользователями. Можно выбрать целый регион одним нажатием.",
    settingsFilterLanguagesTitle: "Фильтр по языкам",
    settingsFilterLanguagesHelp: "Показываются только языки, на которых говорят зарегистрированные пользователи. Можно выбрать целую группу.",
    settingsSavePreferences: "Сохранить настройки",
    settingsSaving: "Сохранение...",
    commentSave: "Сохранить",
    settingsCountriesTitle: "Страны",
    settingsCountriesNoFilter: "Без фильтра — все страны",
    settingsLanguagesNoFilter: "Без фильтра — все языки",
    settingsAgeRangeTitle: "Возрастной диапазон",
    settingsAgeRangeHelp: "Укажите минимальный и максимальный возраст людей, с которыми вы хотите совпадать.",
    settingsMinAge: "Минимальный возраст",
    settingsMaxAge: "Максимальный возраст",
    settingsAgeRangeSummary: "Вы будете видеть людей от {min} до {max} {years}",
    settingsPreferencesDesc: "Страны, языки и возрастной диапазон для случайных звонков",
    settingsPreferencesHelp: "Настройте фильтры для случайных звонков. Оставьте пустым, чтобы принимать всех.",
    settingsAccountDesc: "Информация, безопасность и удаление аккаунта",
    settingsAccountInfoTitle: "Информация об аккаунте",
    settingsLocation: "Местоположение",
    settingsMemberSince: "Участник с",
    settingsLanguagesTitle: "Языки",
    settingsIrreversibleAction: "Необратимое действие",
    settingsDeleteKeyword: "УДАЛИТЬ",
    settingsAccountInfoDesc: "Email, местоположение, дата регистрации",
    settingsBlockedTitle: "Заблокированные пользователи",
    settingsBlockedDesc: "Управляйте людьми, которых вы заблокировали",
    settingsBlockedEmpty: "Нет заблокированных пользователей",
    settingsUnblock: "Разблокировать",
    settingsLoading: "Загрузка...",
    settingsDeleteTitle: "Удалить аккаунт",
    settingsDeleteDesc: "Удалить аккаунт и все данные навсегда",
    settingsGeolocation: "Геолокация",
    settingsAllowed: "Разрешено",
    settingsNotAllowed: "Не разрешено",
    settingsDeleteWarningDesc: "Удаление аккаунта безвозвратно удалит все ваши данные:",
    settingsDeleteItemProfile: "Профиль и фото профиля",
    settingsDeleteItemMessages: "Сообщения и диалоги",
    settingsDeleteItemFriends: "Список друзей и запросы",
    settingsDeleteItemPosts: "Публикации и комментарии",
    settingsDeleteItemCalls: "История звонков",
    settingsDeleteItemReactions: "Лайки, дизлайки и реакции",
    settingsCurrentPassword: "Текущий пароль",
    settingsChangePasswordTitle: "Изменить пароль",
    settingsChangePasswordDesc: "Обновите пароль, чтобы усилить безопасность вашей учетной записи",
    settingsEnterPassword: "Введите пароль",
    settingsType: "Введите",
    settingsToConfirm: "для подтверждения",
    settingsDeletePasswordRequired: "Требуется пароль",
    settingsDeleting: "Удаление...",
    settingsDeleteForever: "Удалить мой аккаунт навсегда",
    notificationsTitle: "Уведомления",
    notificationsSubtitle: "Будьте в курсе ваших взаимодействий",
    notificationsSomeone: "Кто-то",
    notificationsAnd: "и",
    notificationsOther: "другой",
    notificationsOthers: "других",
    notificationsToday: "Сегодня",
    notificationsYesterday: "Вчера",
    notificationsThisWeek: "На этой неделе",
    notificationsOlder: "Ранее",
    notificationsAll: "Все",
    notificationsUnread: "Непрочитанные",
    notificationsNoNotifications: "Нет уведомлений",
    notificationsUpToDate: "У вас всё актуально!",
    notificationsNoUnread: "Уведомления о ваших взаимодействиях будут отображаться здесь",
    notificationsDelete: "Удалить",
    notificationsNew: "Новое",
    notificationsCallReactionSingle: "{name} отреагировал(а) на ваш звонок",
    notificationsCallReactionMultiple: "{names} отреагировали на ваши звонки",
    notificationsLikeCommentSingle: "{name} отреагировал(а) на ваш комментарий",
    notificationsLikePostSingle: "{name} отреагировал(а) на ваш пост",
    notificationsLikeProfileSingle: "{name} понравился ваш профиль",
    notificationsLikeCommentMultiple: "{names} отреагировали на ваш комментарий",
    notificationsLikePostMultiple: "{names} отреагировали на ваш пост",
    notificationsLikeProfileMultiple: "{names} понравился ваш профиль",
    notificationsDislikeCommentSingle: "{name} отреагировал(а) на ваш комментарий",
    notificationsDislikePostSingle: "{name} отреагировал(а) на ваш пост",
    notificationsDislikeProfileSingle: "{name} не понравился ваш профиль",
    notificationsDislikeCommentMultiple: "{names} отреагировали на ваш комментарий",
    notificationsDislikePostMultiple: "{names} отреагировали на ваш пост",
    notificationsDislikeProfileMultiple: "{names} не понравился ваш профиль",
    notificationsFriendRequestSingle: "{name} отправил(а) вам запрос в друзья",
    notificationsFriendRejectedSingle: "{name} отклонил(а) ваш запрос в друзья",
    notificationsFriendAcceptedSingle: "{name} принял(а) ваш запрос в друзья",
    notificationsProfileViewSingle: "{name} посмотрел(а) ваш профиль",
    notificationsProfileViewMultiple: "{names} посмотрели ваш профиль",
    notificationsMessageReplySingle: "{name} ответил(а) на ваш комментарий",
    notificationsMessageCommentSingle: "{name} прокомментировал(а) ваш пост",
    notificationsMessagePostSingle: "{name} прокомментировал(а) ваш пост",
    notificationsMessageDirectSingle: "{name} отправил(а) вам сообщение",
    notificationsMessageReplyMultiple: "{names} ответили на ваш комментарий",
    notificationsMessageCommentMultiple: "{names} прокомментировали ваш пост",
    notificationsMessagePostMultiple: "{names} прокомментировали ваш пост",
    notificationsMessageDirectMultiple: "{names} отправили вам сообщения",
    notificationsLiveInvitationSingle: "{name} пригласил(а) вас в свой эфир",
    notificationsLiveJoinRequestSingle: "{name} запросил(а) присоединение к вашему эфиру",
    notificationsLiveStartedSingle: "{name} вышел(вышла) в эфир",
    notificationsGenericSingle: "{name} взаимодействовал(а) с вами",
    notificationsGenericMultiple: "{names} взаимодействовали с вами",
    notificationsCallReactionsTitle: "Реакции на ваши звонки",
    notificationsReactionsCount: "Реакции: {count}",
    notificationsNoReactionYet: "Пока нет реакций",
    notificationsProfileVisitorsTitle: "Посетители профиля",
    notificationsVisitorsCount: "Посещения: {count}",
    notificationsNoVisitorsYet: "Пока нет посетителей",
    notificationsPeople: "чел.",
    feedEmptyTitle: "Пока нет постов",
    feedEmptySubtitle: "Будьте первым, кто чем-то поделится!",
    postStep: "Шаг",
    postWizardStepContent: "Контент",
    postWizardStepMedia: "Медиа",
    postWizardStepTagsSettings: "Теги и настройки",
    postWizardStepPreview: "Предпросмотр",
    postWriteSomething: "Напишите что-нибудь... Используйте #хэштеги",
    postHashtagTip: "Совет: используйте #хэштеги",
    dashboardSwipeHint: "Свайп ->",
    dashboardSuggestionsForYou: "Рекомендации для вас",
    friendsTitleMyFriends: "Мои друзья",
    friendsHeaderStats: "{contacts} контактов{onlinePart}",
    friendsOnlineLabel: "в сети",
    friendsSubtitleManageContacts: "Управляйте своими контактами",
    friendsNewCall: "Новый звонок",
    friendsCallShort: "Позвонить",
    friendsTabFriends: "Друзья",
    friendsTabRequests: "Запросы",
    friendsTabSent: "Отправленные",
    friendsNoRequestYet: "Нет ожидающих запросов",
    friendsRequestsDesc: "Полученные запросы в друзья будут отображаться здесь",
    friendsNoSentYet: "Нет отправленных запросов",
    friendsSentDesc: "Отправленные вами запросы в друзья будут отображаться здесь",
    friendsSendMessage: "Отправить сообщение",
    friendsAccept: "Принять",
    friendsReject: "Отклонить",
    friendsStartCall: "Начать звонок",
    chatSearchPlaceholder: "Поиск...",
    chatNoConversation: "Нет диалогов",
    chatAllRead: "Всё прочитано ✓",
    chatPersonOnline: "Никого онлайн",
    chatOffline: "Не в сети",
    chatSeenAt: "Был(а) в сети в",
    chatSeenYesterdayAt: "Был(а) в сети вчера в",
    chatSeenOn: "Был(а) в сети",
    chatYourMessage: "Ваше сообщение",
    chatMedia: "Медиа",
    chatEditContent: "Изменить содержимое",
    chatDeleteForEveryone: "Удалить для всех",
    chatRecording: "Запись...",
    chatFinish: "Завершить",
    chatVoiceReady: "Голосовое сообщение готово",
    chatMicAccessError: "Не удалось получить доступ к микрофону",
    chatSearchInConversation: "Поиск в диалоге...",
    chatStartConversationTitle: "Начните разговор",
    chatSayHello: "Поздоровайтесь с {name}!",
    chatNewMessages: "Новые сообщения",
    chatDeletedMessage: "Сообщение удалено",
    chatEditMessage: "Редактировать сообщение",
    chatMessagePlaceholder: "Сообщение...",
    chatNoMatch: "\"{search}\" не найдено",
    chatNewMessage: "Новое сообщение",
    chatChooseContact: "Выберите контакт и начните сразу",
    chatSearchContact: "Поиск контактов...",
    chatContacts: "контактов",
    chatNoContactAvailable: "Нет доступных контактов",
    chatNoFriendFound: "Друзья не найдены",
    chatFriends: "Друзья",
    chatRecents: "Недавние",
    chatStartConversation: "Начать разговор",
    chatOpenConversation: "Открыть разговор",
    chatYou: "Вы",
    reactionLiked: "понравилось",
    reactionDisliked: "не понравилось",
    chatUnknown: "Неизвестно",
    chatVideo: "Видео",
    chatVoiceMessage: "Голосовое сообщение",
    chatPhoto: "Фото",
    chatFile: "Файл",
    chatUnreadFilter: "Непрочитанные",
    chatOnlineFilter: "Онлайн",
    chatUnreadCount: "{count} непрочитанных",
    chatConversationsCount: "{count} диалогов",
    chatEmptyHint: "Нажмите +, чтобы отправить первое сообщение",
    chatYesterday: "Вчера",
    backLabel: "Назад",
    discoverTitle: "Поиск",
    discoverShowAll: "Показать все",
    discoverForYou: "Для вас",
    discoverNearby: "Рядом",
    discoverOnline: "В сети",
    discoverPopular: "Популярное",
    discoverViewGrid: "Вид сеткой",
    discoverViewMap: "Вид карты",
    discoverFilters: "Фильтры",
    discoverResetFilters: "Сбросить",
    discoverAllCountries: "Все страны",
    discoverAllLanguages: "Все языки",
    discoverOnlineOnly: "Только онлайн",
    discoverNearbySection: "Рядом",
    discoverClearFilters: "Очистить фильтры",
    discoverNoUsers: "Пользователи не найдены",
    discoverNoUsersDesc: "Попробуйте изменить фильтры или поиск",
    discoverNoLocalizedUsers: "Нет локальных пользователей",
    discoverNoLocalizedUsersDesc: "Пользователи появятся здесь, когда поделятся местоположением",
    discoverFounder: "Основатель",
    discoverPeopleCount: "{count} человек",
    discoverSearchPlaceholder: "Имя, username или bio...",
    discoverGPSRequired: "Требуется GPS",
    discoverResultsCount: "{count} результатов",
    liveEndedTitle: "Эфир завершен",
    randomCallEndedTitle: "Звонок завершен",
    randomCallThanks: "Спасибо за участие в этом звонке.",
    randomCallLeave: "Покинуть звонок",
    randomCallNewCall: "Новый звонок",
    randomCallCameraDisabled: "Камера отключена",
    randomCallMicMuted: "Микрофон выключен",
    liveThanks: "Спасибо за использование Callo",
    discoverAdd: "Добавить",
    discoverRequestSent: "Запрос отправлен",
    discoverViewProfile: "Открыть профиль",
    discoverSent: "Отправлено ✓",
    friendsRemoveFriend: "Удалить этого друга",
    friendsWaiting: "В ожидании",
    postAllowComments: "Разрешить комментарии",
    postVisibility: "Видимость",
    postYourPublication: "Ваша публикация",
    postCommentsEnabled: "Комментарии включены",
    postCommentsDisabled: "Комментарии отключены",
    postVisibilityPublicDesc: "Видно всем",
    postVisibilityFriendsDesc: "Только вашим друзьям",
    postVisibilityPrivateDesc: "Только вам",
    nextLabel: "Далее",
    postNoTextContent: "Нет текстового содержимого",
    postTrendingTitle: "Тренды",
    postNoTrendingNow: "Пока нет трендов",
    feedUpToDate: "У вас всё актуально!",
    commentReply: "Ответить",
    commentInReplyTo: "в ответ на",
    commentActions: "Действия",
    commentEmptyTitle: "Комментариев пока нет",
    commentEmptySubtitle: "Будьте первым, кто прокомментирует!",
    postReactAction: "Реагировать",
    postCommentAction: "Комментировать",
    postShareAction: "Поделиться",
    commentEdit: "Редактировать",
    commentDelete: "Удалить",
    commentCancel: "Отмена",
    commentReplyLabel: "ответ",
    commentReplyWord: "ответ",
    commentRepliesWord: "ответов",
    commentWritePlaceholder: "Напишите комментарий...",
    commentLike: "Нравится",
    commentDislike: "Не нравится",
    profileLikes: "Лайки",
    profileDislikes: "Дизлайки",
  },
  zh: {
    yearsLabel: "岁",
    settingsEditProfileHintPrefix: "如需修改姓名、年龄、简介或语言，请前往",
    settingsEditProfileHintSuffix: "位置会自动更新。",
    authNamePlaceholder: "例如：Alex Chen",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "创建一个强密码",
    authConfirmPasswordPlaceholder: "再次输入密码",
    authDateOfBirthPlaceholder: "yyyy/mm/dd",
    authDOBDay: "日",
    authDOBMonth: "月",
    authDOBYear: "年",
    authUsernameInvalidShort: "3-30 个字符，字母/数字/_",
    settingsFilterCountriesTitle: "按国家筛选",
    settingsFilterCountriesHelp: "仅显示有已注册用户的国家。你可以一键选择整个地区。",
    settingsFilterLanguagesTitle: "按语言筛选",
    settingsFilterLanguagesHelp: "仅显示注册用户所说的语言。你可以选择整个分组。",
    settingsSavePreferences: "保存偏好",
    settingsSaving: "保存中...",
    commentSave: "保存",
    settingsCountriesTitle: "国家",
    settingsCountriesNoFilter: "无筛选 — 所有国家",
    settingsLanguagesNoFilter: "无筛选 — 所有语言",
    settingsAgeRangeTitle: "年龄范围",
    settingsAgeRangeHelp: "设置你希望匹配的人群最小和最大年龄。",
    settingsMinAge: "最小年龄",
    settingsMaxAge: "最大年龄",
    settingsAgeRangeSummary: "你将看到年龄在 {min} 到 {max} {years} 之间的人",
    settingsPreferencesDesc: "随机通话的国家、语言和年龄范围",
    settingsPreferencesHelp: "配置你的随机通话筛选器。留空即可接受所有人。",
    settingsAccountDesc: "信息、安全与账户删除",
    settingsAccountInfoTitle: "账户信息",
    settingsLocation: "位置",
    settingsMemberSince: "加入时间",
    settingsLanguagesTitle: "语言",
    settingsIrreversibleAction: "不可逆操作",
    settingsDeleteKeyword: "删除",
    settingsAccountInfoDesc: "邮箱、位置、注册日期",
    settingsBlockedTitle: "已屏蔽的用户",
    settingsBlockedDesc: "管理你已屏蔽的用户",
    settingsBlockedEmpty: "没有已屏蔽的用户",
    settingsUnblock: "取消屏蔽",
    settingsLoading: "加载中...",
    settingsDeleteTitle: "删除账户",
    settingsDeleteDesc: "永久删除你的账户及所有数据",
    settingsGeolocation: "地理定位",
    settingsAllowed: "已允许",
    settingsNotAllowed: "未允许",
    settingsDeleteWarningDesc: "删除账户将永久清除你的所有数据：",
    settingsDeleteItemProfile: "个人资料和头像",
    settingsDeleteItemMessages: "消息与会话",
    settingsDeleteItemFriends: "好友列表和请求",
    settingsDeleteItemPosts: "发布和评论",
    settingsDeleteItemCalls: "通话记录",
    settingsDeleteItemReactions: "点赞、点踩和反应",
    settingsCurrentPassword: "当前密码",
    settingsChangePasswordTitle: "修改密码",
    settingsChangePasswordDesc: "更新您的密码以增强帐户安全",
    settingsEnterPassword: "输入你的密码",
    settingsType: "输入",
    settingsToConfirm: "以确认",
    settingsDeletePasswordRequired: "需要密码",
    settingsDeleting: "删除中...",
    settingsDeleteForever: "永久删除我的账户",
    notificationsTitle: "通知",
    notificationsSubtitle: "随时了解你的互动",
    notificationsSomeone: "有人",
    notificationsAnd: "和",
    notificationsOther: "其他",
    notificationsOthers: "其他人",
    notificationsToday: "今天",
    notificationsYesterday: "昨天",
    notificationsThisWeek: "本周",
    notificationsOlder: "更早",
    notificationsAll: "全部",
    notificationsUnread: "未读",
    notificationsNoNotifications: "暂无通知",
    notificationsUpToDate: "你已是最新状态！",
    notificationsNoUnread: "与你互动相关的通知会显示在这里",
    notificationsDelete: "删除",
    notificationsNew: "新",
    notificationsCallReactionSingle: "{name} 对你的通话做出了反应",
    notificationsCallReactionMultiple: "{names} 对你的通话做出了反应",
    notificationsLikeCommentSingle: "{name} 对你的评论做出了反应",
    notificationsLikePostSingle: "{name} 对你的帖子做出了反应",
    notificationsLikeProfileSingle: "{name} 喜欢了你的资料",
    notificationsLikeCommentMultiple: "{names} 对你的评论做出了反应",
    notificationsLikePostMultiple: "{names} 对你的帖子做出了反应",
    notificationsLikeProfileMultiple: "{names} 喜欢了你的资料",
    notificationsDislikeCommentSingle: "{name} 对你的评论做出了反应",
    notificationsDislikePostSingle: "{name} 对你的帖子做出了反应",
    notificationsDislikeProfileSingle: "{name} 不喜欢你的资料",
    notificationsDislikeCommentMultiple: "{names} 对你的评论做出了反应",
    notificationsDislikePostMultiple: "{names} 对你的帖子做出了反应",
    notificationsDislikeProfileMultiple: "{names} 不喜欢你的资料",
    notificationsFriendRequestSingle: "{name} 向你发送了好友请求",
    notificationsFriendRejectedSingle: "{name} 拒绝了你的好友请求",
    notificationsFriendAcceptedSingle: "{name} 接受了你的好友请求",
    notificationsProfileViewSingle: "{name} 查看了你的资料",
    notificationsProfileViewMultiple: "{names} 查看了你的资料",
    notificationsMessageReplySingle: "{name} 回复了你的评论",
    notificationsMessageCommentSingle: "{name} 评论了你的帖子",
    notificationsMessagePostSingle: "{name} 评论了你的帖子",
    notificationsMessageDirectSingle: "{name} 给你发送了消息",
    notificationsMessageReplyMultiple: "{names} 回复了你的评论",
    notificationsMessageCommentMultiple: "{names} 评论了你的帖子",
    notificationsMessagePostMultiple: "{names} 评论了你的帖子",
    notificationsMessageDirectMultiple: "{names} 给你发送了消息",
    notificationsLiveInvitationSingle: "{name} 邀请你加入其直播",
    notificationsLiveJoinRequestSingle: "{name} 请求加入你的直播",
    notificationsLiveStartedSingle: "{name} 开始直播了",
    notificationsGenericSingle: "{name} 与你发生了互动",
    notificationsGenericMultiple: "{names} 与你发生了互动",
    notificationsCallReactionsTitle: "你的通话反应",
    notificationsReactionsCount: "反应数：{count}",
    notificationsNoReactionYet: "暂无反应",
    notificationsProfileVisitorsTitle: "资料访客",
    notificationsVisitorsCount: "访问数：{count}",
    notificationsNoVisitorsYet: "暂无访客",
    notificationsPeople: "人",
    feedEmptyTitle: "还没有帖子",
    feedEmptySubtitle: "做第一个分享的人吧！",
    postStep: "步骤",
    postWizardStepContent: "内容",
    postWizardStepMedia: "媒体",
    postWizardStepTagsSettings: "标签与设置",
    postWizardStepPreview: "预览",
    postWriteSomething: "写点什么... 使用 #话题",
    postHashtagTip: "提示：使用 #话题",
    dashboardSwipeHint: "滑动 ->",
    dashboardSuggestionsForYou: "为你推荐",
    friendsTitleMyFriends: "我的好友",
    friendsHeaderStats: "{contacts} 位联系人{onlinePart}",
    friendsOnlineLabel: "在线",
    friendsSubtitleManageContacts: "管理你的联系人",
    friendsNewCall: "新通话",
    friendsCallShort: "呼叫",
    friendsTabFriends: "好友",
    friendsTabRequests: "请求",
    friendsTabSent: "已发送",
    friendsNoRequestYet: "没有待处理请求",
    friendsRequestsDesc: "你收到的好友请求会显示在这里",
    friendsNoSentYet: "没有已发送请求",
    friendsSentDesc: "你发送的好友请求会显示在这里",
    friendsSendMessage: "发送消息",
    friendsAccept: "接受",
    friendsReject: "拒绝",
    friendsStartCall: "开始通话",
    chatSearchPlaceholder: "搜索...",
    chatNoConversation: "暂无会话",
    chatAllRead: "全部已读 ✓",
    chatPersonOnline: "无人在线",
    chatOffline: "离线",
    chatSeenAt: "最后在线",
    chatSeenYesterdayAt: "昨天最后在线",
    chatSeenOn: "最后在线于",
    chatYourMessage: "你的消息",
    chatMedia: "媒体",
    chatEditContent: "编辑内容",
    chatDeleteForEveryone: "为所有人删除",
    chatRecording: "录音中...",
    chatFinish: "完成",
    chatVoiceReady: "语音消息已就绪",
    chatMicAccessError: "无法访问麦克风",
    chatSearchInConversation: "在会话中搜索...",
    chatStartConversationTitle: "开始聊天",
    chatSayHello: "和 {name} 打个招呼！",
    chatNewMessages: "新消息",
    chatDeletedMessage: "消息已删除",
    chatEditMessage: "编辑消息",
    chatMessagePlaceholder: "消息...",
    chatNoMatch: "未找到 \"{search}\"",
    chatNewMessage: "新消息",
    chatChooseContact: "选择联系人并立即开始",
    chatSearchContact: "搜索联系人...",
    chatContacts: "联系人",
    chatNoContactAvailable: "暂无可用联系人",
    chatNoFriendFound: "未找到好友",
    chatFriends: "好友",
    chatRecents: "最近",
    chatStartConversation: "开始会话",
    chatOpenConversation: "打开会话",
    chatYou: "你",
    reactionLiked: "喜欢了",
    reactionDisliked: "不喜欢",
    chatUnknown: "未知",
    chatVideo: "视频",
    chatVoiceMessage: "语音消息",
    chatPhoto: "照片",
    chatFile: "文件",
    chatUnreadFilter: "未读",
    chatOnlineFilter: "在线",
    chatUnreadCount: "{count} 条未读",
    chatConversationsCount: "{count} 个会话",
    chatEmptyHint: "点击 + 发送你的第一条消息",
    chatYesterday: "昨天",
    backLabel: "返回",
    discoverTitle: "发现",
    discoverShowAll: "查看全部",
    discoverForYou: "为你",
    discoverNearby: "附近",
    discoverOnline: "在线",
    discoverPopular: "热门",
    discoverViewGrid: "网格视图",
    discoverViewMap: "地图视图",
    discoverFilters: "筛选",
    discoverResetFilters: "重置",
    discoverAllCountries: "所有国家",
    discoverAllLanguages: "所有语言",
    discoverOnlineOnly: "仅在线",
    discoverNearbySection: "附近",
    discoverClearFilters: "清除筛选",
    discoverNoUsers: "未找到用户",
    discoverNoUsersDesc: "请尝试更改筛选或搜索",
    discoverNoLocalizedUsers: "暂无本地用户",
    discoverNoLocalizedUsersDesc: "当用户共享位置后会显示在这里",
    discoverFounder: "创始人",
    discoverPeopleCount: "{count} 人",
    discoverSearchPlaceholder: "姓名、用户名或简介...",
    discoverGPSRequired: "需要 GPS",
    discoverResultsCount: "{count} 条结果",
    liveEndedTitle: "直播已结束",
    randomCallEndedTitle: "通话结束",
    randomCallThanks: "感谢您参与本次通话。",
    randomCallLeave: "离开通话",
    randomCallNewCall: "新通话",
    randomCallCameraDisabled: "摄像头已禁用",
    randomCallMicMuted: "麦克风已静音",
    liveThanks: "感谢使用 Callo",
    discoverAdd: "添加",
    discoverRequestSent: "请求已发送",
    discoverViewProfile: "查看资料",
    discoverSent: "已发送 ✓",
    friendsRemoveFriend: "移除此好友",
    friendsWaiting: "待处理",
    postAllowComments: "允许评论",
    postVisibility: "可见性",
    postYourPublication: "你的发布",
    postCommentsEnabled: "已启用评论",
    postCommentsDisabled: "已禁用评论",
    postVisibilityPublicDesc: "所有人可见",
    postVisibilityFriendsDesc: "仅好友可见",
    postVisibilityPrivateDesc: "仅自己可见",
    nextLabel: "下一步",
    postNoTextContent: "无文字内容",
    postTrendingTitle: "趋势",
    postNoTrendingNow: "暂无趋势",
    feedUpToDate: "你已是最新状态！",
    commentReply: "回复",
    commentInReplyTo: "回复于",
    commentActions: "操作",
    commentEmptyTitle: "暂无评论",
    commentEmptySubtitle: "来做第一个评论的人吧！",
    postReactAction: "反应",
    postCommentAction: "评论",
    postShareAction: "分享",
    commentEdit: "编辑",
    commentDelete: "删除",
    commentCancel: "取消",
    commentReplyLabel: "回复",
    commentReplyWord: "回复",
    commentRepliesWord: "回复",
    commentWritePlaceholder: "写评论...",
    commentLike: "点赞",
    commentDislike: "点踩",
    profileLikes: "点赞",
    profileDislikes: "点踩",
  },
  ja: {
    yearsLabel: "歳",
    settingsEditProfileHintPrefix: "名前・年齢・自己紹介・言語を編集するには、次のセクションへ：",
    settingsEditProfileHintSuffix: "位置情報は自動で更新されます。",
    authNamePlaceholder: "例: Alex Martin",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "強力なパスワードを作成",
    authConfirmPasswordPlaceholder: "パスワードを再入力",
    authDateOfBirthPlaceholder: "yyyy/mm/dd",
    authDOBDay: "日",
    authDOBMonth: "月",
    authDOBYear: "年",
    authUsernameInvalidShort: "3〜30文字、英字/数字/_",
    settingsFilterCountriesTitle: "国で絞り込む",
    settingsFilterCountriesHelp: "登録ユーザーがいる国のみ表示されます。ワンクリックで地域全体を選択できます。",
    settingsFilterLanguagesTitle: "言語で絞り込む",
    settingsFilterLanguagesHelp: "登録ユーザーが話す言語のみ表示されます。グループ全体を選択できます。",
    settingsSavePreferences: "設定を保存",
    settingsSaving: "保存中...",
    commentSave: "保存",
    settingsCountriesTitle: "国",
    settingsCountriesNoFilter: "フィルターなし — すべての国",
    settingsLanguagesNoFilter: "フィルターなし — すべての言語",
    settingsAgeRangeTitle: "年齢範囲",
    settingsAgeRangeHelp: "マッチしたい相手の最小年齢と最大年齢を設定します。",
    settingsMinAge: "最小年齢",
    settingsMaxAge: "最大年齢",
    settingsAgeRangeSummary: "{min} から {max} {years} の人が表示されます",
    settingsPreferencesDesc: "ランダム通話向けの国・言語・年齢範囲",
    settingsPreferencesHelp: "ランダム通話のフィルターを設定します。全員を受け入れるには空欄のままにしてください。",
    settingsAccountDesc: "情報、セキュリティ、アカウント削除",
    settingsAccountInfoTitle: "アカウント情報",
    settingsLocation: "場所",
    settingsMemberSince: "登録日",
    settingsLanguagesTitle: "言語",
    settingsIrreversibleAction: "取り消せない操作",
    settingsDeleteKeyword: "削除",
    settingsAccountInfoDesc: "メール、位置情報、登録日",
    settingsBlockedTitle: "ブロックしたユーザー",
    settingsBlockedDesc: "ブロックした相手を管理します",
    settingsBlockedEmpty: "ブロックしたユーザーはいません",
    settingsUnblock: "ブロック解除",
    settingsLoading: "読み込み中...",
    settingsDeleteTitle: "アカウントを削除",
    settingsDeleteDesc: "アカウントとすべてのデータを完全に削除します",
    settingsGeolocation: "位置情報",
    settingsAllowed: "許可済み",
    settingsNotAllowed: "未許可",
    settingsDeleteWarningDesc: "アカウントを削除すると、すべてのデータが完全に失われます：",
    settingsDeleteItemProfile: "プロフィールとプロフィール画像",
    settingsDeleteItemMessages: "メッセージと会話",
    settingsDeleteItemFriends: "友だちリストとリクエスト",
    settingsDeleteItemPosts: "投稿とコメント",
    settingsDeleteItemCalls: "通話履歴",
    settingsDeleteItemReactions: "いいね、よくないね、リアクション",
    settingsCurrentPassword: "現在のパスワード",
    settingsChangePasswordTitle: "パスワードを変更",
    settingsChangePasswordDesc: "アカウントのセキュリティを高めるためにパスワードを更新してください",
    settingsEnterPassword: "パスワードを入力",
    settingsType: "入力",
    settingsToConfirm: "して確認",
    settingsDeletePasswordRequired: "パスワードが必要です",
    settingsDeleting: "削除中...",
    settingsDeleteForever: "アカウントを完全に削除する",
    notificationsTitle: "通知",
    notificationsSubtitle: "あなたのやり取りを確認しましょう",
    notificationsSomeone: "誰か",
    notificationsAnd: "と",
    notificationsOther: "他",
    notificationsOthers: "他",
    notificationsToday: "今日",
    notificationsYesterday: "昨日",
    notificationsThisWeek: "今週",
    notificationsOlder: "以前",
    notificationsAll: "すべて",
    notificationsUnread: "未読",
    notificationsNoNotifications: "通知はありません",
    notificationsUpToDate: "すべて最新です！",
    notificationsNoUnread: "あなたへの通知はここに表示されます",
    notificationsDelete: "削除",
    notificationsNew: "新着",
    notificationsCallReactionSingle: "{name}さんがあなたの通話にリアクションしました",
    notificationsCallReactionMultiple: "{names}があなたの通話にリアクションしました",
    notificationsLikeCommentSingle: "{name}さんがあなたのコメントにリアクションしました",
    notificationsLikePostSingle: "{name}さんがあなたの投稿にリアクションしました",
    notificationsLikeProfileSingle: "{name}さんがあなたのプロフィールを気に入りました",
    notificationsLikeCommentMultiple: "{names}があなたのコメントにリアクションしました",
    notificationsLikePostMultiple: "{names}があなたの投稿にリアクションしました",
    notificationsLikeProfileMultiple: "{names}があなたのプロフィールを気に入りました",
    notificationsDislikeCommentSingle: "{name}さんがあなたのコメントにリアクションしました",
    notificationsDislikePostSingle: "{name}さんがあなたの投稿にリアクションしました",
    notificationsDislikeProfileSingle: "{name}さんがあなたのプロフィールを低評価しました",
    notificationsDislikeCommentMultiple: "{names}があなたのコメントにリアクションしました",
    notificationsDislikePostMultiple: "{names}があなたの投稿にリアクションしました",
    notificationsDislikeProfileMultiple: "{names}があなたのプロフィールを低評価しました",
    notificationsFriendRequestSingle: "{name}さんが友だち申請を送りました",
    notificationsFriendRejectedSingle: "{name}さんが友だち申請を拒否しました",
    notificationsFriendAcceptedSingle: "{name}さんが友だち申請を承認しました",
    notificationsProfileViewSingle: "{name}さんがあなたのプロフィールを閲覧しました",
    notificationsProfileViewMultiple: "{names}があなたのプロフィールを閲覧しました",
    notificationsMessageReplySingle: "{name}さんがあなたのコメントに返信しました",
    notificationsMessageCommentSingle: "{name}さんがあなたの投稿にコメントしました",
    notificationsMessagePostSingle: "{name}さんがあなたの投稿にコメントしました",
    notificationsMessageDirectSingle: "{name}さんがあなたにメッセージを送りました",
    notificationsMessageReplyMultiple: "{names}があなたのコメントに返信しました",
    notificationsMessageCommentMultiple: "{names}があなたの投稿にコメントしました",
    notificationsMessagePostMultiple: "{names}があなたの投稿にコメントしました",
    notificationsMessageDirectMultiple: "{names}があなたにメッセージを送りました",
    notificationsLiveInvitationSingle: "{name}さんがライブに招待しました",
    notificationsLiveJoinRequestSingle: "{name}さんがあなたのライブ参加をリクエストしました",
    notificationsLiveStartedSingle: "{name}さんがライブを開始しました",
    notificationsGenericSingle: "{name}さんがあなたとやり取りしました",
    notificationsGenericMultiple: "{names}があなたとやり取りしました",
    notificationsCallReactionsTitle: "通話へのリアクション",
    notificationsReactionsCount: "リアクション: {count}",
    notificationsNoReactionYet: "まだリアクションはありません",
    notificationsProfileVisitorsTitle: "プロフィール訪問者",
    notificationsVisitorsCount: "訪問数: {count}",
    notificationsNoVisitorsYet: "まだ訪問者はいません",
    notificationsPeople: "人",
    feedEmptyTitle: "まだ投稿はありません",
    feedEmptySubtitle: "最初に何かを共有しましょう！",
    postStep: "ステップ",
    postWizardStepContent: "内容",
    postWizardStepMedia: "メディア",
    postWizardStepTagsSettings: "タグと設定",
    postWizardStepPreview: "プレビュー",
    postWriteSomething: "何か書いてみよう... #ハッシュタグ を使おう",
    postHashtagTip: "ヒント: #ハッシュタグ を使おう",
    dashboardSwipeHint: "スワイプ ->",
    dashboardSuggestionsForYou: "あなたへのおすすめ",
    friendsTitleMyFriends: "友だち",
    friendsHeaderStats: "{contacts} 件の連絡先{onlinePart}",
    friendsOnlineLabel: "オンライン",
    friendsSubtitleManageContacts: "連絡先を管理",
    friendsNewCall: "新しい通話",
    friendsCallShort: "通話",
    friendsTabFriends: "友だち",
    friendsTabRequests: "リクエスト",
    friendsTabSent: "送信済み",
    friendsNoRequestYet: "保留中のリクエストはありません",
    friendsRequestsDesc: "受け取った友だちリクエストはここに表示されます",
    friendsNoSentYet: "送信済みリクエストはありません",
    friendsSentDesc: "送信した友だちリクエストはここに表示されます",
    friendsSendMessage: "メッセージを送る",
    friendsAccept: "承認",
    friendsReject: "拒否",
    friendsStartCall: "通話を開始",
    chatSearchPlaceholder: "検索...",
    chatNoConversation: "会話はありません",
    chatAllRead: "すべて既読 ✓",
    chatPersonOnline: "オンラインの人はいません",
    chatOffline: "オフライン",
    chatSeenAt: "最終表示",
    chatSeenYesterdayAt: "昨日の最終表示",
    chatSeenOn: "最終表示日",
    chatYourMessage: "あなたのメッセージ",
    chatMedia: "メディア",
    chatEditContent: "内容を編集",
    chatDeleteForEveryone: "全員から削除",
    chatRecording: "録音中...",
    chatFinish: "完了",
    chatVoiceReady: "ボイスメッセージの準備完了",
    chatMicAccessError: "マイクにアクセスできません",
    chatSearchInConversation: "会話内を検索...",
    chatStartConversationTitle: "会話を始めましょう",
    chatSayHello: "{name}さんに挨拶しましょう！",
    chatNewMessages: "新しいメッセージ",
    chatDeletedMessage: "メッセージは削除されました",
    chatEditMessage: "メッセージを編集",
    chatMessagePlaceholder: "メッセージ...",
    chatNoMatch: "\"{search}\" は見つかりません",
    chatNewMessage: "新規メッセージ",
    chatChooseContact: "連絡先を選んですぐに開始",
    chatSearchContact: "連絡先を検索...",
    chatContacts: "連絡先",
    chatNoContactAvailable: "利用可能な連絡先がありません",
    chatNoFriendFound: "友だちが見つかりません",
    chatFriends: "友だち",
    chatRecents: "最近",
    chatStartConversation: "会話を開始",
    chatOpenConversation: "会話を開く",
    chatYou: "あなた",
    reactionLiked: "いいね",
    reactionDisliked: "気に入りません",
    chatUnknown: "不明",
    chatVideo: "動画",
    chatVoiceMessage: "ボイスメッセージ",
    chatPhoto: "写真",
    chatFile: "ファイル",
    chatUnreadFilter: "未読",
    chatOnlineFilter: "オンライン",
    chatUnreadCount: "未読 {count}",
    chatConversationsCount: "{count} 件の会話",
    chatEmptyHint: "+ をタップして最初のメッセージを送信",
    chatYesterday: "昨日",
    backLabel: "戻る",
    discoverTitle: "発見",
    discoverShowAll: "すべて表示",
    discoverForYou: "あなた向け",
    discoverNearby: "近く",
    discoverOnline: "オンライン",
    discoverPopular: "人気",
    discoverViewGrid: "グリッド表示",
    discoverViewMap: "マップ表示",
    discoverFilters: "フィルター",
    discoverResetFilters: "リセット",
    discoverAllCountries: "すべての国",
    discoverAllLanguages: "すべての言語",
    discoverOnlineOnly: "オンラインのみ",
    discoverNearbySection: "近く",
    discoverClearFilters: "フィルターをクリア",
    discoverNoUsers: "ユーザーが見つかりません",
    discoverNoUsersDesc: "フィルターまたは検索条件を変更してみてください",
    discoverNoLocalizedUsers: "近くのユーザーはいません",
    discoverNoLocalizedUsersDesc: "ユーザーが位置情報を共有するとここに表示されます",
    discoverFounder: "創設者",
    discoverPeopleCount: "{count} 人",
    discoverSearchPlaceholder: "名前、ユーザー名、または自己紹介...",
    discoverGPSRequired: "GPS が必要です",
    discoverResultsCount: "{count} 件",
    liveEndedTitle: "ライブ終了",
    randomCallEndedTitle: "通話終了",
    randomCallThanks: "この通話にご参加いただきありがとうございます。",
    randomCallLeave: "通話から退出",
    randomCallNewCall: "新しい通話",
    randomCallCameraDisabled: "カメラが無効です",
    randomCallMicMuted: "マイクがミュートです",
    liveThanks: "Callo をご利用いただきありがとうございます",
    discoverAdd: "追加",
    discoverRequestSent: "リクエスト送信済み",
    discoverViewProfile: "プロフィールを見る",
    discoverSent: "送信済み ✓",
    friendsRemoveFriend: "この友達を削除",
    friendsWaiting: "保留中",
    postAllowComments: "コメントを許可",
    postVisibility: "公開範囲",
    postYourPublication: "あなたの投稿",
    postCommentsEnabled: "コメント有効",
    postCommentsDisabled: "コメント無効",
    postVisibilityPublicDesc: "全員に表示",
    postVisibilityFriendsDesc: "友達のみ",
    postVisibilityPrivateDesc: "自分のみ",
    nextLabel: "次へ",
    postNoTextContent: "テキスト内容なし",
    postTrendingTitle: "トレンド",
    postNoTrendingNow: "現在トレンドはありません",
    feedUpToDate: "すべて最新です！",
    commentReply: "返信",
    commentInReplyTo: "〜への返信",
    commentActions: "アクション",
    commentEmptyTitle: "まだコメントはありません",
    commentEmptySubtitle: "最初にコメントしましょう！",
    postReactAction: "リアクション",
    postCommentAction: "コメント",
    postShareAction: "共有",
    commentEdit: "編集",
    commentDelete: "削除",
    commentCancel: "キャンセル",
    commentReplyLabel: "返信",
    commentReplyWord: "返信",
    commentRepliesWord: "返信",
    commentWritePlaceholder: "コメントを書く...",
    commentLike: "いいね",
    commentDislike: "よくないね",
    profileLikes: "いいね",
    profileDislikes: "よくないね",
  },
  ko: {
    yearsLabel: "세",
    settingsEditProfileHintPrefix: "이름, 나이, 소개 또는 언어를 수정하려면 다음 섹션으로 이동하세요:",
    settingsEditProfileHintSuffix: "위치는 자동으로 업데이트됩니다.",
    authNamePlaceholder: "예: Alex Kim",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "안전한 비밀번호 만들기",
    authConfirmPasswordPlaceholder: "비밀번호 다시 입력",
    authDateOfBirthPlaceholder: "yyyy/mm/dd",
    authDOBDay: "일",
    authDOBMonth: "월",
    authDOBYear: "년",
    authUsernameInvalidShort: "3-30자, 영문/숫자/_",
    settingsFilterCountriesTitle: "국가별 필터",
    settingsFilterCountriesHelp: "등록된 사용자가 있는 국가만 표시됩니다. 한 번의 클릭으로 전체 지역을 선택할 수 있습니다.",
    settingsFilterLanguagesTitle: "언어별 필터",
    settingsFilterLanguagesHelp: "등록된 사용자가 사용하는 언어만 표시됩니다. 전체 그룹을 선택할 수 있습니다.",
    settingsSavePreferences: "환경설정 저장",
    settingsSaving: "저장 중...",
    commentSave: "저장",
    settingsCountriesTitle: "국가",
    settingsCountriesNoFilter: "필터 없음 — 모든 국가",
    settingsLanguagesNoFilter: "필터 없음 — 모든 언어",
    settingsAgeRangeTitle: "연령대",
    settingsAgeRangeHelp: "매칭되고 싶은 사람들의 최소 및 최대 나이를 설정하세요.",
    settingsMinAge: "최소 나이",
    settingsMaxAge: "최대 나이",
    settingsAgeRangeSummary: "{min}세에서 {max}세 사이의 사람들을 보게 됩니다",
    settingsPreferencesDesc: "랜덤 통화를 위한 국가, 언어, 연령 범위",
    settingsPreferencesHelp: "랜덤 통화 필터를 설정하세요. 모두 허용하려면 비워 두세요.",
    settingsAccountDesc: "정보, 보안 및 계정 삭제",
    settingsAccountInfoTitle: "계정 정보",
    settingsLocation: "위치",
    settingsMemberSince: "가입일",
    settingsLanguagesTitle: "언어",
    settingsIrreversibleAction: "되돌릴 수 없는 작업",
    settingsDeleteKeyword: "삭제",
    settingsAccountInfoDesc: "이메일, 위치, 가입일",
    settingsBlockedTitle: "차단한 사용자",
    settingsBlockedDesc: "차단한 사람을 관리합니다",
    settingsBlockedEmpty: "차단한 사용자가 없습니다",
    settingsUnblock: "차단 해제",
    settingsLoading: "로딩 중...",
    settingsDeleteTitle: "계정 삭제",
    settingsDeleteDesc: "계정과 모든 데이터를 영구적으로 삭제",
    settingsGeolocation: "위치 정보",
    settingsAllowed: "허용됨",
    settingsNotAllowed: "허용 안 됨",
    settingsDeleteWarningDesc: "계정을 삭제하면 모든 데이터가 영구적으로 삭제됩니다:",
    settingsDeleteItemProfile: "프로필 및 프로필 사진",
    settingsDeleteItemMessages: "메시지 및 대화",
    settingsDeleteItemFriends: "친구 목록 및 요청",
    settingsDeleteItemPosts: "게시물 및 댓글",
    settingsDeleteItemCalls: "통화 기록",
    settingsDeleteItemReactions: "좋아요, 싫어요 및 반응",
    settingsCurrentPassword: "현재 비밀번호",
    settingsChangePasswordTitle: "비밀번호 변경",
    settingsChangePasswordDesc: "계정 보안을 강화하려면 비밀번호를 업데이트하세요",
    settingsEnterPassword: "비밀번호를 입력하세요",
    settingsType: "입력",
    settingsToConfirm: "하여 확인",
    settingsDeletePasswordRequired: "비밀번호가 필요합니다",
    settingsDeleting: "삭제 중...",
    settingsDeleteForever: "내 계정 영구 삭제",
    notificationsTitle: "알림",
    notificationsSubtitle: "내 상호작용 소식을 확인하세요",
    notificationsSomeone: "누군가",
    notificationsAnd: "그리고",
    notificationsOther: "다른",
    notificationsOthers: "다른 사람",
    notificationsToday: "오늘",
    notificationsYesterday: "어제",
    notificationsThisWeek: "이번 주",
    notificationsOlder: "이전",
    notificationsAll: "전체",
    notificationsUnread: "읽지 않음",
    notificationsNoNotifications: "알림이 없습니다",
    notificationsUpToDate: "모두 최신 상태입니다!",
    notificationsNoUnread: "상호작용 관련 알림이 여기에 표시됩니다",
    notificationsDelete: "삭제",
    notificationsNew: "새로움",
    notificationsCallReactionSingle: "{name}님이 내 통화에 반응했습니다",
    notificationsCallReactionMultiple: "{names}님이 내 통화에 반응했습니다",
    notificationsLikeCommentSingle: "{name}님이 내 댓글에 반응했습니다",
    notificationsLikePostSingle: "{name}님이 내 게시물에 반응했습니다",
    notificationsLikeProfileSingle: "{name}님이 내 프로필을 좋아합니다",
    notificationsLikeCommentMultiple: "{names}님이 내 댓글에 반응했습니다",
    notificationsLikePostMultiple: "{names}님이 내 게시물에 반응했습니다",
    notificationsLikeProfileMultiple: "{names}님이 내 프로필을 좋아합니다",
    notificationsDislikeCommentSingle: "{name}님이 내 댓글에 반응했습니다",
    notificationsDislikePostSingle: "{name}님이 내 게시물에 반응했습니다",
    notificationsDislikeProfileSingle: "{name}님이 내 프로필을 싫어합니다",
    notificationsDislikeCommentMultiple: "{names}님이 내 댓글에 반응했습니다",
    notificationsDislikePostMultiple: "{names}님이 내 게시물에 반응했습니다",
    notificationsDislikeProfileMultiple: "{names}님이 내 프로필을 싫어합니다",
    notificationsFriendRequestSingle: "{name}님이 친구 요청을 보냈습니다",
    notificationsFriendRejectedSingle: "{name}님이 친구 요청을 거절했습니다",
    notificationsFriendAcceptedSingle: "{name}님이 친구 요청을 수락했습니다",
    notificationsProfileViewSingle: "{name}님이 내 프로필을 봤습니다",
    notificationsProfileViewMultiple: "{names}님이 내 프로필을 봤습니다",
    notificationsMessageReplySingle: "{name}님이 내 댓글에 답글을 남겼습니다",
    notificationsMessageCommentSingle: "{name}님이 내 게시물에 댓글을 남겼습니다",
    notificationsMessagePostSingle: "{name}님이 내 게시물에 댓글을 남겼습니다",
    notificationsMessageDirectSingle: "{name}님이 내게 메시지를 보냈습니다",
    notificationsMessageReplyMultiple: "{names}님이 내 댓글에 답글을 남겼습니다",
    notificationsMessageCommentMultiple: "{names}님이 내 게시물에 댓글을 남겼습니다",
    notificationsMessagePostMultiple: "{names}님이 내 게시물에 댓글을 남겼습니다",
    notificationsMessageDirectMultiple: "{names}님이 내게 메시지를 보냈습니다",
    notificationsLiveInvitationSingle: "{name}님이 라이브에 초대했습니다",
    notificationsLiveJoinRequestSingle: "{name}님이 내 라이브 참여를 요청했습니다",
    notificationsLiveStartedSingle: "{name}님이 라이브를 시작했습니다",
    notificationsGenericSingle: "{name}님이 나와 상호작용했습니다",
    notificationsGenericMultiple: "{names}님이 나와 상호작용했습니다",
    notificationsCallReactionsTitle: "내 통화 반응",
    notificationsReactionsCount: "반응 수: {count}",
    notificationsNoReactionYet: "아직 반응이 없습니다",
    notificationsProfileVisitorsTitle: "프로필 방문자",
    notificationsVisitorsCount: "방문 수: {count}",
    notificationsNoVisitorsYet: "아직 방문자가 없습니다",
    notificationsPeople: "명",
    feedEmptyTitle: "아직 게시물이 없습니다",
    feedEmptySubtitle: "첫 번째로 무언가를 공유해 보세요!",
    postStep: "단계",
    postWizardStepContent: "콘텐츠",
    postWizardStepMedia: "미디어",
    postWizardStepTagsSettings: "태그 및 설정",
    postWizardStepPreview: "미리보기",
    postWriteSomething: "무언가 작성해 보세요... #해시태그 사용",
    postHashtagTip: "팁: #해시태그 사용",
    dashboardSwipeHint: "스와이프 ->",
    dashboardSuggestionsForYou: "추천",
    friendsTitleMyFriends: "내 친구",
    friendsHeaderStats: "{contacts} 연락처{onlinePart}",
    friendsOnlineLabel: "온라인",
    friendsSubtitleManageContacts: "연락처 관리",
    friendsNewCall: "새 통화",
    friendsCallShort: "통화",
    friendsTabFriends: "친구",
    friendsTabRequests: "요청",
    friendsTabSent: "보낸 요청",
    friendsNoRequestYet: "대기 중인 요청이 없습니다",
    friendsRequestsDesc: "받은 친구 요청이 여기에 표시됩니다",
    friendsNoSentYet: "보낸 요청이 없습니다",
    friendsSentDesc: "보낸 친구 요청이 여기에 표시됩니다",
    friendsSendMessage: "메시지 보내기",
    friendsAccept: "수락",
    friendsReject: "거절",
    friendsStartCall: "통화 시작",
    chatSearchPlaceholder: "검색...",
    chatNoConversation: "대화가 없습니다",
    chatAllRead: "모두 읽음 ✓",
    chatPersonOnline: "온라인인 사람이 없습니다",
    chatOffline: "오프라인",
    chatSeenAt: "마지막 접속",
    chatSeenYesterdayAt: "어제 마지막 접속",
    chatSeenOn: "마지막 접속일",
    chatYourMessage: "내 메시지",
    chatMedia: "미디어",
    chatEditContent: "내용 수정",
    chatDeleteForEveryone: "모두에게서 삭제",
    chatRecording: "녹음 중...",
    chatFinish: "완료",
    chatVoiceReady: "음성 메시지 준비됨",
    chatMicAccessError: "마이크에 접근할 수 없습니다",
    chatSearchInConversation: "대화에서 검색...",
    chatStartConversationTitle: "대화를 시작하세요",
    chatSayHello: "{name}님에게 인사해 보세요!",
    chatNewMessages: "새 메시지",
    chatDeletedMessage: "메시지가 삭제되었습니다",
    chatEditMessage: "메시지 수정",
    chatMessagePlaceholder: "메시지...",
    chatNoMatch: "\"{search}\" 를 찾을 수 없습니다",
    chatNewMessage: "새 메시지",
    chatChooseContact: "연락처를 선택하고 바로 시작하세요",
    chatSearchContact: "연락처 검색...",
    chatContacts: "연락처",
    chatNoContactAvailable: "사용 가능한 연락처가 없습니다",
    chatNoFriendFound: "친구를 찾을 수 없습니다",
    chatFriends: "친구",
    chatRecents: "최근",
    chatStartConversation: "대화 시작",
    chatOpenConversation: "대화 열기",
    chatYou: "나",
    reactionLiked: "좋아요",
    reactionDisliked: "싫어요",
    chatUnknown: "알 수 없음",
    chatVideo: "비디오",
    chatVoiceMessage: "음성 메시지",
    chatPhoto: "사진",
    chatFile: "파일",
    chatUnreadFilter: "읽지 않음",
    chatOnlineFilter: "온라인",
    chatUnreadCount: "읽지 않음 {count}",
    chatConversationsCount: "{count}개의 대화",
    chatEmptyHint: "+를 눌러 첫 메시지를 보내세요",
    chatYesterday: "어제",
    backLabel: "뒤로",
    discoverTitle: "탐색",
    discoverShowAll: "모두 보기",
    discoverForYou: "추천",
    discoverNearby: "근처",
    discoverOnline: "온라인",
    discoverPopular: "인기",
    discoverViewGrid: "그리드 보기",
    discoverViewMap: "지도 보기",
    discoverFilters: "필터",
    discoverResetFilters: "초기화",
    discoverAllCountries: "모든 국가",
    discoverAllLanguages: "모든 언어",
    discoverOnlineOnly: "온라인만",
    discoverNearbySection: "근처",
    discoverClearFilters: "필터 지우기",
    discoverNoUsers: "사용자를 찾을 수 없습니다",
    discoverNoUsersDesc: "필터 또는 검색어를 변경해 보세요",
    discoverNoLocalizedUsers: "주변 사용자가 없습니다",
    discoverNoLocalizedUsersDesc: "사용자가 위치를 공유하면 여기에 표시됩니다",
    discoverFounder: "창립자",
    discoverPeopleCount: "{count}명",
    discoverSearchPlaceholder: "이름, 사용자명 또는 소개...",
    discoverGPSRequired: "GPS 필요",
    discoverResultsCount: "{count}개 결과",
    liveEndedTitle: "라이브 종료",
    randomCallEndedTitle: "통화 종료",
    randomCallThanks: "이 통화에 참여해 주셔서 감사합니다.",
    randomCallLeave: "통화 나가기",
    randomCallNewCall: "새 통화",
    randomCallCameraDisabled: "카메라 비활성화됨",
    randomCallMicMuted: "마이크 음소거됨",
    liveThanks: "Callo를 이용해 주셔서 감사합니다",
    discoverAdd: "추가",
    discoverRequestSent: "요청 전송됨",
    discoverViewProfile: "프로필 보기",
    discoverSent: "전송됨 ✓",
    friendsRemoveFriend: "이 친구 삭제",
    friendsWaiting: "대기 중",
    postAllowComments: "댓글 허용",
    postVisibility: "공개 범위",
    postYourPublication: "내 게시물",
    postCommentsEnabled: "댓글 활성화됨",
    postCommentsDisabled: "댓글 비활성화됨",
    postVisibilityPublicDesc: "모두에게 표시",
    postVisibilityFriendsDesc: "친구만",
    postVisibilityPrivateDesc: "나만",
    nextLabel: "다음",
    postNoTextContent: "텍스트 내용 없음",
    postTrendingTitle: "트렌드",
    postNoTrendingNow: "현재 트렌드 없음",
    feedUpToDate: "모두 최신 상태입니다!",
    commentReply: "답글",
    commentInReplyTo: "답글",
    commentActions: "작업",
    commentEmptyTitle: "아직 댓글이 없습니다",
    commentEmptySubtitle: "첫 댓글을 남겨보세요!",
    postReactAction: "반응하기",
    postCommentAction: "댓글",
    postShareAction: "공유",
    commentEdit: "수정",
    commentDelete: "삭제",
    commentCancel: "취소",
    commentReplyLabel: "답글",
    commentReplyWord: "답글",
    commentRepliesWord: "답글",
    commentWritePlaceholder: "댓글 작성...",
    commentLike: "좋아요",
    commentDislike: "싫어요",
    profileLikes: "좋아요",
    profileDislikes: "싫어요",
  },
  hi: {
    yearsLabel: "वर्ष",
    settingsEditProfileHintPrefix: "अपना नाम, उम्र, बायो या भाषाएँ संपादित करने के लिए इस सेक्शन में जाएँ",
    settingsEditProfileHintSuffix: "लोकेशन स्वतः अपडेट होती है।",
    authNamePlaceholder: "उदा.: Alex Sharma",
    authUsernamePlaceholder: "alex.martin",
    authPasswordPlaceholder: "मजबूत पासवर्ड बनाएं",
    authConfirmPasswordPlaceholder: "पासवर्ड फिर दर्ज करें",
    authDateOfBirthPlaceholder: "दिन/महीना/वर्ष",
    authDOBDay: "दिन",
    authDOBMonth: "महीना",
    authDOBYear: "वर्ष",
    authUsernameInvalidShort: "3-30 वर्ण, अक्षर/संख्या/_",
    settingsFilterCountriesTitle: "देशों के अनुसार फ़िल्टर करें",
    settingsFilterCountriesHelp: "केवल वे देश दिखाए जाते हैं जहाँ पंजीकृत उपयोगकर्ता हैं। आप एक क्लिक में पूरा क्षेत्र चुन सकते हैं।",
    settingsFilterLanguagesTitle: "भाषाओं के अनुसार फ़िल्टर करें",
    settingsFilterLanguagesHelp: "केवल पंजीकृत उपयोगकर्ताओं द्वारा बोली जाने वाली भाषाएँ दिखाई जाती हैं। आप पूरा समूह चुन सकते हैं।",
    settingsSavePreferences: "प्राथमिकताएँ सहेजें",
    settingsSaving: "सहेजा जा रहा है...",
    commentSave: "सहेजें",
    settingsCountriesTitle: "देश",
    settingsCountriesNoFilter: "कोई फ़िल्टर नहीं — सभी देश",
    settingsLanguagesNoFilter: "कोई फ़िल्टर नहीं — सभी भाषाएँ",
    settingsAgeRangeTitle: "आयु सीमा",
    settingsAgeRangeHelp: "जिन लोगों से आप मैच होना चाहते हैं उनकी न्यूनतम और अधिकतम आयु निर्धारित करें।",
    settingsMinAge: "न्यूनतम आयु",
    settingsMaxAge: "अधिकतम आयु",
    settingsAgeRangeSummary: "आप {min} से {max} {years} के बीच के लोगों को देखेंगे",
    settingsPreferencesDesc: "रैंडम कॉल के लिए देश, भाषाएँ और आयु सीमा",
    settingsPreferencesHelp: "रैंडम कॉल के लिए अपने फ़िल्टर कॉन्फ़िगर करें। सभी को स्वीकार करने के लिए इसे खाली छोड़ दें।",
    settingsAccountDesc: "जानकारी, सुरक्षा और खाता हटाना",
    settingsAccountInfoTitle: "खाता जानकारी",
    settingsLocation: "स्थान",
    settingsMemberSince: "सदस्य बने",
    settingsLanguagesTitle: "भाषाएँ",
    settingsIrreversibleAction: "अपरिवर्तनीय कार्रवाई",
    settingsDeleteKeyword: "हटाएं",
    settingsAccountInfoDesc: "ईमेल, स्थान, पंजीकरण तिथि",
    settingsBlockedTitle: "ब्लॉक किए गए उपयोगकर्ता",
    settingsBlockedDesc: "जिन लोगों को आपने ब्लॉक किया है उन्हें प्रबंधित करें",
    settingsBlockedEmpty: "कोई ब्लॉक किया गया उपयोगकर्ता नहीं",
    settingsUnblock: "ब्लॉक हटाएं",
    settingsLoading: "लोड हो रहा है...",
    settingsDeleteTitle: "खाता हटाएँ",
    settingsDeleteDesc: "अपने खाते और सभी डेटा को स्थायी रूप से हटाएँ",
    settingsGeolocation: "भू-स्थान",
    settingsAllowed: "अनुमत",
    settingsNotAllowed: "अनुमति नहीं",
    settingsDeleteWarningDesc: "खाता हटाने से आपका सारा डेटा स्थायी रूप से मिट जाएगा:",
    settingsDeleteItemProfile: "प्रोफ़ाइल और प्रोफ़ाइल फोटो",
    settingsDeleteItemMessages: "संदेश और वार्तालाप",
    settingsDeleteItemFriends: "दोस्तों की सूची और अनुरोध",
    settingsDeleteItemPosts: "पोस्ट और टिप्पणियाँ",
    settingsDeleteItemCalls: "कॉल इतिहास",
    settingsDeleteItemReactions: "पसंद, नापसंद और प्रतिक्रियाएँ",
    settingsCurrentPassword: "वर्तमान पासवर्ड",
    settingsChangePasswordTitle: "पासवर्ड बदलें",
    settingsChangePasswordDesc: "अपने खाते की सुरक्षा बढ़ाने के लिए अपना पासवर्ड अपडेट करें",
    settingsEnterPassword: "अपना पासवर्ड दर्ज करें",
    settingsType: "टाइप करें",
    settingsToConfirm: "पुष्टि के लिए",
    settingsDeletePasswordRequired: "पासवर्ड आवश्यक है",
    settingsDeleting: "हटाया जा रहा है...",
    settingsDeleteForever: "मेरा खाता स्थायी रूप से हटाएँ",
    notificationsTitle: "सूचनाएं",
    notificationsSubtitle: "अपनी इंटरैक्शन की जानकारी में रहें",
    notificationsSomeone: "कोई",
    notificationsAnd: "और",
    notificationsOther: "अन्य",
    notificationsOthers: "अन्य",
    notificationsToday: "आज",
    notificationsYesterday: "कल",
    notificationsThisWeek: "इस सप्ताह",
    notificationsOlder: "पहले की",
    notificationsAll: "सभी",
    notificationsUnread: "अपठित",
    notificationsNoNotifications: "कोई सूचना नहीं",
    notificationsUpToDate: "आप पूरी तरह अपडेट हैं!",
    notificationsNoUnread: "आपकी इंटरैक्शन से जुड़ी सूचनाएं यहां दिखाई देंगी",
    notificationsDelete: "हटाएं",
    notificationsNew: "नया",
    notificationsCallReactionSingle: "{name} ने आपकी कॉल पर प्रतिक्रिया दी",
    notificationsCallReactionMultiple: "{names} ने आपकी कॉल पर प्रतिक्रिया दी",
    notificationsLikeCommentSingle: "{name} ने आपकी टिप्पणी पर प्रतिक्रिया दी",
    notificationsLikePostSingle: "{name} ने आपकी पोस्ट पर प्रतिक्रिया दी",
    notificationsLikeProfileSingle: "{name} को आपकी प्रोफ़ाइल पसंद आई",
    notificationsLikeCommentMultiple: "{names} ने आपकी टिप्पणी पर प्रतिक्रिया दी",
    notificationsLikePostMultiple: "{names} ने आपकी पोस्ट पर प्रतिक्रिया दी",
    notificationsLikeProfileMultiple: "{names} को आपकी प्रोफ़ाइल पसंद आई",
    notificationsDislikeCommentSingle: "{name} ने आपकी टिप्पणी पर प्रतिक्रिया दी",
    notificationsDislikePostSingle: "{name} ने आपकी पोस्ट पर प्रतिक्रिया दी",
    notificationsDislikeProfileSingle: "{name} को आपकी प्रोफ़ाइल पसंद नहीं आई",
    notificationsDislikeCommentMultiple: "{names} ने आपकी टिप्पणी पर प्रतिक्रिया दी",
    notificationsDislikePostMultiple: "{names} ने आपकी पोस्ट पर प्रतिक्रिया दी",
    notificationsDislikeProfileMultiple: "{names} को आपकी प्रोफ़ाइल पसंद नहीं आई",
    notificationsFriendRequestSingle: "{name} ने आपको मित्र अनुरोध भेजा",
    notificationsFriendRejectedSingle: "{name} ने आपका मित्र अनुरोध अस्वीकार किया",
    notificationsFriendAcceptedSingle: "{name} ने आपका मित्र अनुरोध स्वीकार किया",
    notificationsProfileViewSingle: "{name} ने आपकी प्रोफ़ाइल देखी",
    notificationsProfileViewMultiple: "{names} ने आपकी प्रोफ़ाइल देखी",
    notificationsMessageReplySingle: "{name} ने आपकी टिप्पणी का उत्तर दिया",
    notificationsMessageCommentSingle: "{name} ने आपकी पोस्ट पर टिप्पणी की",
    notificationsMessagePostSingle: "{name} ने आपकी पोस्ट पर टिप्पणी की",
    notificationsMessageDirectSingle: "{name} ने आपको संदेश भेजा",
    notificationsMessageReplyMultiple: "{names} ने आपकी टिप्पणी का उत्तर दिया",
    notificationsMessageCommentMultiple: "{names} ने आपकी पोस्ट पर टिप्पणी की",
    notificationsMessagePostMultiple: "{names} ने आपकी पोस्ट पर टिप्पणी की",
    notificationsMessageDirectMultiple: "{names} ने आपको संदेश भेजे",
    notificationsLiveInvitationSingle: "{name} ने आपको अपनी लाइव में आमंत्रित किया",
    notificationsLiveJoinRequestSingle: "{name} ने आपकी लाइव में शामिल होने का अनुरोध किया",
    notificationsLiveStartedSingle: "{name} लाइव है",
    notificationsGenericSingle: "{name} ने आपके साथ इंटरैक्ट किया",
    notificationsGenericMultiple: "{names} ने आपके साथ इंटरैक्ट किया",
    notificationsCallReactionsTitle: "आपकी कॉल पर प्रतिक्रियाएँ",
    notificationsReactionsCount: "प्रतिक्रियाएँ: {count}",
    notificationsNoReactionYet: "अभी तक कोई प्रतिक्रिया नहीं",
    notificationsProfileVisitorsTitle: "प्रोफ़ाइल विज़िटर",
    notificationsVisitorsCount: "विज़िट: {count}",
    notificationsNoVisitorsYet: "अभी तक कोई विज़िटर नहीं",
    notificationsPeople: "व्यक्ति",
    feedEmptyTitle: "अभी तक कोई पोस्ट नहीं",
    feedEmptySubtitle: "कुछ साझा करने वाले पहले व्यक्ति बनें!",
    postStep: "चरण",
    postWizardStepContent: "सामग्री",
    postWizardStepMedia: "मीडिया",
    postWizardStepTagsSettings: "टैग और सेटिंग्स",
    postWizardStepPreview: "पूर्वावलोकन",
    postWriteSomething: "कुछ लिखें... #हैशटैग का उपयोग करें",
    postHashtagTip: "टिप: #हैशटैग का उपयोग करें",
    dashboardSwipeHint: "स्वाइप ->",
    dashboardSuggestionsForYou: "आपके लिए सुझाव",
    friendsTitleMyFriends: "मेरे दोस्त",
    friendsHeaderStats: "{contacts} संपर्क{onlinePart}",
    friendsOnlineLabel: "ऑनलाइन",
    friendsSubtitleManageContacts: "अपने संपर्क प्रबंधित करें",
    friendsNewCall: "नई कॉल",
    friendsCallShort: "कॉल",
    friendsTabFriends: "दोस्त",
    friendsTabRequests: "अनुरोध",
    friendsTabSent: "भेजे गए",
    friendsNoRequestYet: "कोई लंबित अनुरोध नहीं",
    friendsRequestsDesc: "आपको प्राप्त मित्र अनुरोध यहाँ दिखाई देंगे",
    friendsNoSentYet: "कोई भेजे गए अनुरोध नहीं",
    friendsSentDesc: "आपके भेजे गए मित्र अनुरोध यहाँ दिखाई देंगे",
    friendsSendMessage: "संदेश भेजें",
    friendsAccept: "स्वीकार करें",
    friendsReject: "अस्वीकार करें",
    friendsStartCall: "कॉल शुरू करें",
    chatSearchPlaceholder: "खोजें...",
    chatNoConversation: "कोई बातचीत नहीं",
    chatAllRead: "सब पढ़ लिया ✓",
    chatPersonOnline: "कोई ऑनलाइन नहीं",
    chatOffline: "ऑफलाइन",
    chatSeenAt: "देखा गया",
    chatSeenYesterdayAt: "कल देखा गया",
    chatSeenOn: "देखा गया",
    chatYourMessage: "आपका संदेश",
    chatMedia: "मीडिया",
    chatEditContent: "सामग्री संपादित करें",
    chatDeleteForEveryone: "सभी के लिए हटाएं",
    chatRecording: "रिकॉर्डिंग...",
    chatFinish: "समाप्त करें",
    chatVoiceReady: "वॉइस संदेश तैयार",
    chatMicAccessError: "माइक्रोफोन तक पहुंच नहीं मिली",
    chatSearchInConversation: "बातचीत में खोजें...",
    chatStartConversationTitle: "बातचीत शुरू करें",
    chatSayHello: "{name} को नमस्ते कहें!",
    chatNewMessages: "नए संदेश",
    chatDeletedMessage: "संदेश हटाया गया",
    chatEditMessage: "संदेश संपादित करें",
    chatMessagePlaceholder: "संदेश...",
    chatNoMatch: "\"{search}\" नहीं मिला",
    chatNewMessage: "नया संदेश",
    chatChooseContact: "संपर्क चुनें और तुरंत शुरू करें",
    chatSearchContact: "संपर्क खोजें...",
    chatContacts: "संपर्क",
    chatNoContactAvailable: "कोई संपर्क उपलब्ध नहीं",
    chatNoFriendFound: "कोई दोस्त नहीं मिला",
    chatFriends: "दोस्त",
    chatRecents: "हालिया",
    chatStartConversation: "बातचीत शुरू करें",
    chatOpenConversation: "बातचीत खोलें",
    chatYou: "आप",
    reactionLiked: "पसंद किया",
    reactionDisliked: "पसंद नहीं किया",
    chatUnknown: "अज्ञात",
    chatVideo: "वीडियो",
    chatVoiceMessage: "वॉइस संदेश",
    chatPhoto: "फ़ोटो",
    chatFile: "फ़ाइल",
    chatUnreadFilter: "अपठित",
    chatOnlineFilter: "ऑनलाइन",
    chatUnreadCount: "{count} अपठित",
    chatConversationsCount: "{count} बातचीत",
    chatEmptyHint: "अपना पहला संदेश भेजने के लिए + दबाएँ",
    chatYesterday: "कल",
    backLabel: "वापस",
    discoverTitle: "खोजें",
    discoverShowAll: "सभी दिखाएं",
    discoverForYou: "आपके लिए",
    discoverNearby: "आस-पास",
    discoverOnline: "ऑनलाइन",
    discoverPopular: "लोकप्रिय",
    discoverViewGrid: "ग्रिड दृश्य",
    discoverViewMap: "मैप दृश्य",
    discoverFilters: "फ़िल्टर",
    discoverResetFilters: "रीसेट",
    discoverAllCountries: "सभी देश",
    discoverAllLanguages: "सभी भाषाएँ",
    discoverOnlineOnly: "केवल ऑनलाइन",
    discoverNearbySection: "आस-पास",
    discoverClearFilters: "फ़िल्टर साफ़ करें",
    discoverNoUsers: "कोई उपयोगकर्ता नहीं मिला",
    discoverNoUsersDesc: "अपने फ़िल्टर या खोज बदलकर देखें",
    discoverNoLocalizedUsers: "कोई स्थानीय उपयोगकर्ता नहीं",
    discoverNoLocalizedUsersDesc: "जब उपयोगकर्ता अपना स्थान साझा करेंगे, वे यहाँ दिखाई देंगे",
    discoverFounder: "संस्थापक",
    discoverPeopleCount: "{count} लोग",
    discoverSearchPlaceholder: "नाम, यूज़रनेम या बायो...",
    discoverGPSRequired: "GPS आवश्यक",
    discoverResultsCount: "{count} परिणाम",
    liveEndedTitle: "लाइव समाप्त",
    randomCallEndedTitle: "कॉल समाप्त",
    randomCallThanks: "इस कॉल में भाग लेने के लिए धन्यवाद।",
    randomCallLeave: "कॉल छोड़ें",
    randomCallNewCall: "नई कॉल",
    randomCallCameraDisabled: "कैमरा अक्षम",
    randomCallMicMuted: "माइक्रोफ़ोन म्यूट",
    liveThanks: "Callo उपयोग करने के लिए धन्यवाद",
    discoverAdd: "जोड़ें",
    discoverRequestSent: "अनुरोध भेजा गया",
    discoverViewProfile: "प्रोफ़ाइल देखें",
    discoverSent: "भेजा गया ✓",
    friendsRemoveFriend: "इस दोस्त को हटाएं",
    friendsWaiting: "लंबित",
    postAllowComments: "टिप्पणियों की अनुमति दें",
    postVisibility: "दृश्यता",
    postYourPublication: "आपकी पोस्ट",
    postCommentsEnabled: "टिप्पणियां सक्षम",
    postCommentsDisabled: "टिप्पणियां अक्षम",
    postVisibilityPublicDesc: "सभी को दिखाई दे",
    postVisibilityFriendsDesc: "केवल आपके मित्र",
    postVisibilityPrivateDesc: "केवल आप",
    nextLabel: "अगला",
    postNoTextContent: "कोई पाठ सामग्री नहीं",
    postTrendingTitle: "रुझान",
    postNoTrendingNow: "अभी कोई रुझान नहीं",
    feedUpToDate: "आप पूरी तरह अपडेट हैं!",
    commentReply: "जवाब दें",
    commentInReplyTo: "के जवाब में",
    commentActions: "क्रियाएँ",
    commentEmptyTitle: "अभी तक कोई टिप्पणी नहीं",
    commentEmptySubtitle: "सबसे पहले टिप्पणी करें!",
    postReactAction: "प्रतिक्रिया दें",
    postCommentAction: "टिप्पणी करें",
    postShareAction: "साझा करें",
    commentEdit: "संपादित करें",
    commentDelete: "हटाएं",
    commentCancel: "रद्द करें",
    commentReplyLabel: "जवाब",
    commentReplyWord: "जवाब",
    commentRepliesWord: "जवाब",
    commentWritePlaceholder: "टिप्पणी लिखें...",
    commentLike: "पसंद",
    commentDislike: "नापसंद",
    profileLikes: "पसंद",
    profileDislikes: "नापसंद",
  },
}
const PAGE_TITLE_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  es: {
    dashboardMetaTitle: "Noticias",
    friendsMetaTitle: "Amigos",
    discoverTitle: "Descubrir",
    liveMetaTitle: "Directos",
    messagesMetaTitle: "Mensajes",
    notificationsMetaTitle: "Notificaciones",
    settingsMetaTitle: "Configuración",
    profileMetaTitle: "Mi perfil",
    authLoginMetaTitle: "Iniciar sesión",
    authRegisterMetaTitle: "Crear cuenta gratis",
    authForgotPasswordMetaTitle: "Olvidé mi contraseña",
    authResetCodeMetaTitle: "Verificación del código",
    authResetPasswordMetaTitle: "Nueva contraseña",
    legalTermsPageTitle: "Términos de uso",
    legalMentionsPageTitle: "Aviso legal",
    legalPrivacyPageTitle: "Política de privacidad",
    profileUserNotFoundMetaTitle: "Perfil no encontrado — Callo",
    postNotFoundMetaTitle: "Publicación no encontrada — Callo",
  },
  pt: {
    dashboardMetaTitle: "Feed de notícias",
    friendsMetaTitle: "Amigos",
    discoverTitle: "Descobrir",
    liveMetaTitle: "Lives",
    messagesMetaTitle: "Mensagens",
    notificationsMetaTitle: "Notificações",
    settingsMetaTitle: "Configurações",
    profileMetaTitle: "Meu perfil",
    authLoginMetaTitle: "Entrar",
    authRegisterMetaTitle: "Criar conta grátis",
    authForgotPasswordMetaTitle: "Esqueci minha senha",
    authResetCodeMetaTitle: "Verificação do código",
    authResetPasswordMetaTitle: "Nova senha",
    legalTermsPageTitle: "Termos de uso",
    legalMentionsPageTitle: "Aviso legal",
    legalPrivacyPageTitle: "Política de privacidade",
    profileUserNotFoundMetaTitle: "Perfil não encontrado — Callo",
    postNotFoundMetaTitle: "Publicação não encontrada — Callo",
  },
  de: {
    dashboardMetaTitle: "Neuigkeiten",
    friendsMetaTitle: "Freunde",
    discoverTitle: "Entdecken",
    liveMetaTitle: "Live",
    messagesMetaTitle: "Nachrichten",
    notificationsMetaTitle: "Benachrichtigungen",
    settingsMetaTitle: "Einstellungen",
    profileMetaTitle: "Mein Profil",
    authLoginMetaTitle: "Anmelden",
    authRegisterMetaTitle: "Kostenloses Konto erstellen",
    authForgotPasswordMetaTitle: "Passwort vergessen",
    authResetCodeMetaTitle: "Code-Bestätigung",
    authResetPasswordMetaTitle: "Neues Passwort",
    legalTermsPageTitle: "Nutzungsbedingungen",
    legalMentionsPageTitle: "Impressum",
    legalPrivacyPageTitle: "Datenschutzrichtlinie",
    profileUserNotFoundMetaTitle: "Profil nicht gefunden — Callo",
    postNotFoundMetaTitle: "Beitrag nicht gefunden — Callo",
  },
  it: {
    dashboardMetaTitle: "Notizie",
    friendsMetaTitle: "Amici",
    discoverTitle: "Scopri",
    liveMetaTitle: "Live",
    messagesMetaTitle: "Messaggi",
    notificationsMetaTitle: "Notifiche",
    settingsMetaTitle: "Impostazioni",
    profileMetaTitle: "Il mio profilo",
    authLoginMetaTitle: "Accedi",
    authRegisterMetaTitle: "Crea account gratuito",
    authForgotPasswordMetaTitle: "Password dimenticata",
    authResetCodeMetaTitle: "Verifica del codice",
    authResetPasswordMetaTitle: "Nuova password",
    legalTermsPageTitle: "Termini di utilizzo",
    legalMentionsPageTitle: "Note legali",
    legalPrivacyPageTitle: "Informativa sulla privacy",
    profileUserNotFoundMetaTitle: "Profilo non trovato — Callo",
    postNotFoundMetaTitle: "Pubblicazione non trovata — Callo",
  },
  ar: {
    dashboardMetaTitle: "آخر الأخبار",
    friendsMetaTitle: "الأصدقاء",
    discoverTitle: "اكتشف",
    liveMetaTitle: "البث المباشر",
    messagesMetaTitle: "الرسائل",
    notificationsMetaTitle: "الإشعارات",
    settingsMetaTitle: "الإعدادات",
    profileMetaTitle: "ملفي الشخصي",
    authLoginMetaTitle: "تسجيل الدخول",
    authRegisterMetaTitle: "إنشاء حساب مجاني",
    authForgotPasswordMetaTitle: "نسيت كلمة المرور",
    authResetCodeMetaTitle: "التحقق من الرمز",
    authResetPasswordMetaTitle: "كلمة مرور جديدة",
    legalTermsPageTitle: "شروط الاستخدام",
    legalMentionsPageTitle: "الإشعارات القانونية",
    legalPrivacyPageTitle: "سياسة الخصوصية",
    profileUserNotFoundMetaTitle: "الملف الشخصي غير موجود — Callo",
    postNotFoundMetaTitle: "المنشور غير موجود — Callo",
  },
  tr: {
    dashboardMetaTitle: "Haber akışı",
    friendsMetaTitle: "Arkadaşlar",
    discoverTitle: "Keşfet",
    liveMetaTitle: "Canlı yayınlar",
    messagesMetaTitle: "Mesajlar",
    notificationsMetaTitle: "Bildirimler",
    settingsMetaTitle: "Ayarlar",
    profileMetaTitle: "Profilim",
    authLoginMetaTitle: "Giriş yap",
    authRegisterMetaTitle: "Ücretsiz hesap oluştur",
    authForgotPasswordMetaTitle: "Şifremi unuttum",
    authResetCodeMetaTitle: "Kod doğrulama",
    authResetPasswordMetaTitle: "Yeni şifre",
    legalTermsPageTitle: "Kullanım koşulları",
    legalMentionsPageTitle: "Yasal bildirimler",
    legalPrivacyPageTitle: "Gizlilik politikası",
    profileUserNotFoundMetaTitle: "Profil bulunamadı — Callo",
    postNotFoundMetaTitle: "Gönderi bulunamadı — Callo",
  },
  nl: {
    dashboardMetaTitle: "Nieuwsoverzicht",
    friendsMetaTitle: "Vrienden",
    discoverTitle: "Ontdekken",
    liveMetaTitle: "Live",
    messagesMetaTitle: "Berichten",
    notificationsMetaTitle: "Meldingen",
    settingsMetaTitle: "Instellingen",
    profileMetaTitle: "Mijn profiel",
    authLoginMetaTitle: "Inloggen",
    authRegisterMetaTitle: "Gratis account maken",
    authForgotPasswordMetaTitle: "Wachtwoord vergeten",
    authResetCodeMetaTitle: "Codeverificatie",
    authResetPasswordMetaTitle: "Nieuw wachtwoord",
    legalTermsPageTitle: "Gebruiksvoorwaarden",
    legalMentionsPageTitle: "Juridische vermeldingen",
    legalPrivacyPageTitle: "Privacybeleid",
    profileUserNotFoundMetaTitle: "Profiel niet gevonden — Callo",
    postNotFoundMetaTitle: "Bericht niet gevonden — Callo",
  },
  ru: {
    dashboardMetaTitle: "Лента новостей",
    friendsMetaTitle: "Друзья",
    discoverTitle: "Обзор",
    liveMetaTitle: "Эфиры",
    messagesMetaTitle: "Сообщения",
    notificationsMetaTitle: "Уведомления",
    settingsMetaTitle: "Настройки",
    profileMetaTitle: "Мой профиль",
    authLoginMetaTitle: "Вход",
    authRegisterMetaTitle: "Создать бесплатный аккаунт",
    authForgotPasswordMetaTitle: "Забыли пароль",
    authResetCodeMetaTitle: "Проверка кода",
    authResetPasswordMetaTitle: "Новый пароль",
    legalTermsPageTitle: "Условия использования",
    legalMentionsPageTitle: "Правовая информация",
    legalPrivacyPageTitle: "Политика конфиденциальности",
    profileUserNotFoundMetaTitle: "Профиль не найден — Callo",
    postNotFoundMetaTitle: "Публикация не найдена — Callo",
  },
  zh: {
    dashboardMetaTitle: "动态",
    friendsMetaTitle: "好友",
    discoverTitle: "发现",
    liveMetaTitle: "直播",
    messagesMetaTitle: "消息",
    notificationsMetaTitle: "通知",
    settingsMetaTitle: "设置",
    profileMetaTitle: "我的主页",
    authLoginMetaTitle: "登录",
    authRegisterMetaTitle: "创建免费账号",
    authForgotPasswordMetaTitle: "忘记密码",
    authResetCodeMetaTitle: "验证码验证",
    authResetPasswordMetaTitle: "新密码",
    legalTermsPageTitle: "使用条款",
    legalMentionsPageTitle: "法律声明",
    legalPrivacyPageTitle: "隐私政策",
    profileUserNotFoundMetaTitle: "未找到个人主页 — Callo",
    postNotFoundMetaTitle: "未找到该帖子 — Callo",
  },
  ja: {
    dashboardMetaTitle: "ニュースフィード",
    friendsMetaTitle: "友達",
    discoverTitle: "見つける",
    liveMetaTitle: "ライブ",
    messagesMetaTitle: "メッセージ",
    notificationsMetaTitle: "通知",
    settingsMetaTitle: "設定",
    profileMetaTitle: "マイプロフィール",
    authLoginMetaTitle: "ログイン",
    authRegisterMetaTitle: "無料アカウント作成",
    authForgotPasswordMetaTitle: "パスワードを忘れた",
    authResetCodeMetaTitle: "コード確認",
    authResetPasswordMetaTitle: "新しいパスワード",
    legalTermsPageTitle: "利用規約",
    legalMentionsPageTitle: "法的表示",
    legalPrivacyPageTitle: "プライバシーポリシー",
    profileUserNotFoundMetaTitle: "プロフィールが見つかりません — Callo",
    postNotFoundMetaTitle: "投稿が見つかりません — Callo",
  },
  ko: {
    dashboardMetaTitle: "뉴스 피드",
    friendsMetaTitle: "친구",
    discoverTitle: "탐색",
    liveMetaTitle: "라이브",
    messagesMetaTitle: "메시지",
    notificationsMetaTitle: "알림",
    settingsMetaTitle: "설정",
    profileMetaTitle: "내 프로필",
    authLoginMetaTitle: "로그인",
    authRegisterMetaTitle: "무료 계정 만들기",
    authForgotPasswordMetaTitle: "비밀번호를 잊으셨나요",
    authResetCodeMetaTitle: "코드 확인",
    authResetPasswordMetaTitle: "새 비밀번호",
    legalTermsPageTitle: "이용 약관",
    legalMentionsPageTitle: "법적 고지",
    legalPrivacyPageTitle: "개인정보 처리방침",
    profileUserNotFoundMetaTitle: "프로필을 찾을 수 없습니다 — Callo",
    postNotFoundMetaTitle: "게시물을 찾을 수 없습니다 — Callo",
  },
  hi: {
    dashboardMetaTitle: "न्यूज़ फ़ीड",
    friendsMetaTitle: "दोस्त",
    discoverTitle: "खोजें",
    liveMetaTitle: "लाइव",
    messagesMetaTitle: "संदेश",
    notificationsMetaTitle: "सूचनाएं",
    settingsMetaTitle: "सेटिंग्स",
    profileMetaTitle: "मेरी प्रोफ़ाइल",
    authLoginMetaTitle: "लॉग इन",
    authRegisterMetaTitle: "मुफ़्त खाता बनाएं",
    authForgotPasswordMetaTitle: "पासवर्ड भूल गए",
    authResetCodeMetaTitle: "कोड सत्यापन",
    authResetPasswordMetaTitle: "नया पासवर्ड",
    legalTermsPageTitle: "उपयोग की शर्तें",
    legalMentionsPageTitle: "कानूनी सूचना",
    legalPrivacyPageTitle: "गोपनीयता नीति",
    profileUserNotFoundMetaTitle: "प्रोफ़ाइल नहीं मिली — Callo",
    postNotFoundMetaTitle: "पोस्ट नहीं मिली — Callo",
  },
}

const POST_UI_TRANSLATIONS: Partial<Record<LocaleCode, Partial<Record<TranslationKey, string>>>> = {
  es: {
    postNewPublication: "Nueva publicación",
    postDropMedia: "Suelta tus imágenes/videos o haz clic (máx 9)",
    postVisibilityPublic: "Público",
    postVisibilityFriends: "Amigos",
    postVisibilityPrivate: "Privado",
    postCustomTags: "Etiquetas personalizadas",
    postAddTag: "Añadir etiqueta",
    postAdd: "Añadir",
  },
  pt: {
    postNewPublication: "Nova publicação",
    postDropMedia: "Solte suas imagens/vídeos ou clique (máx 9)",
    postVisibilityPublic: "Público",
    postVisibilityFriends: "Amigos",
    postVisibilityPrivate: "Privado",
    postCustomTags: "Tags personalizadas",
    postAddTag: "Adicionar tag",
    postAdd: "Adicionar",
  },
  de: {
    postNewPublication: "Neuer Beitrag",
    postDropMedia: "Ziehe deine Bilder/Videos hierher oder klicke (max. 9)",
    postVisibilityPublic: "Öffentlich",
    postVisibilityFriends: "Freunde",
    postVisibilityPrivate: "Privat",
    postCustomTags: "Benutzerdefinierte Tags",
    postAddTag: "Tag hinzufügen",
    postAdd: "Hinzufügen",
  },
  it: {
    postNewPublication: "Nuovo post",
    postDropMedia: "Trascina immagini/video o fai clic (max 9)",
    postVisibilityPublic: "Pubblico",
    postVisibilityFriends: "Amici",
    postVisibilityPrivate: "Privato",
    postCustomTags: "Tag personalizzati",
    postAddTag: "Aggiungi un tag",
    postAdd: "Aggiungi",
  },
  ar: {
    postNewPublication: "منشور جديد",
    postDropMedia: "أسقط صورك/فيديوهاتك أو انقر (الحد الأقصى 9)",
    postVisibilityPublic: "عام",
    postVisibilityFriends: "الأصدقاء",
    postVisibilityPrivate: "خاص",
    postCustomTags: "وسوم مخصصة",
    postAddTag: "إضافة وسم",
    postAdd: "إضافة",
  },
  tr: {
    postNewPublication: "Yeni gönderi",
    postDropMedia: "Görsellerini/videolarını sürükle bırak veya tıkla (maks 9)",
    postVisibilityPublic: "Herkese açık",
    postVisibilityFriends: "Arkadaşlar",
    postVisibilityPrivate: "Özel",
    postCustomTags: "Özel etiketler",
    postAddTag: "Etiket ekle",
    postAdd: "Ekle",
  },
  nl: {
    postNewPublication: "Nieuwe post",
    postDropMedia: "Sleep je afbeeldingen/video's of klik (max 9)",
    postVisibilityPublic: "Openbaar",
    postVisibilityFriends: "Vrienden",
    postVisibilityPrivate: "Privé",
    postCustomTags: "Aangepaste tags",
    postAddTag: "Tag toevoegen",
    postAdd: "Toevoegen",
  },
  ru: {
    postNewPublication: "Новая публикация",
    postDropMedia: "Перетащите изображения/видео или нажмите (макс. 9)",
    postVisibilityPublic: "Публично",
    postVisibilityFriends: "Друзья",
    postVisibilityPrivate: "Приватно",
    postCustomTags: "Пользовательские теги",
    postAddTag: "Добавить тег",
    postAdd: "Добавить",
  },
  zh: {
    postNewPublication: "新帖子",
    postDropMedia: "拖放你的图片/视频或点击上传（最多 9 个）",
    postVisibilityPublic: "公开",
    postVisibilityFriends: "好友",
    postVisibilityPrivate: "私密",
    postCustomTags: "自定义标签",
    postAddTag: "添加标签",
    postAdd: "添加",
  },
  ja: {
    postNewPublication: "新しい投稿",
    postDropMedia: "画像/動画をドラッグ&ドロップ、またはクリック（最大9件）",
    postVisibilityPublic: "公開",
    postVisibilityFriends: "友達",
    postVisibilityPrivate: "非公開",
    postCustomTags: "カスタムタグ",
    postAddTag: "タグを追加",
    postAdd: "追加",
  },
  ko: {
    postNewPublication: "새 게시물",
    postDropMedia: "이미지/동영상을 끌어다 놓거나 클릭하세요 (최대 9개)",
    postVisibilityPublic: "전체 공개",
    postVisibilityFriends: "친구",
    postVisibilityPrivate: "비공개",
    postCustomTags: "사용자 태그",
    postAddTag: "태그 추가",
    postAdd: "추가",
  },
  hi: {
    postNewPublication: "नई पोस्ट",
    postDropMedia: "अपनी इमेज/वीडियो ड्रॉप करें या क्लिक करें (अधिकतम 9)",
    postVisibilityPublic: "सार्वजनिक",
    postVisibilityFriends: "दोस्त",
    postVisibilityPrivate: "निजी",
    postCustomTags: "कस्टम टैग",
    postAddTag: "टैग जोड़ें",
    postAdd: "जोड़ें",
  },
}

const REPORT_SHARE_TRANSLATIONS: Record<LocaleCode, Record<string, string>> = {
  "fr": {
    "reportTitle": "Signaler la publication",
    "reportSubtitle": "Pourquoi souhaitez-vous signaler cette publication ? Votre signalement reste confidentiel et aide à protéger la communauté.",
    "reportCategory": "Sélectionnez un motif :",
    "reportDetails": "Détails supplémentaires (facultatif) :",
    "reportDetailsPlaceholder": "Décrivez la situation pour nous aider à comprendre...",
    "reportHide": "Masquer cette publication de mon flux",
    "reportHideDesc": "Vous ne verrez plus cette publication dans votre fil d'actualité.",
    "reportSubmit": "Envoyer le signalement",
    "reportSubmitting": "Envoi en cours...",
    "reportCancel": "Annuler",
    "reportSuccessTitle": "Signalement envoyé !",
    "reportSuccessDesc": "Merci. Notre équipe va examiner cette publication sous 24 heures et prendra les mesures nécessaires.",
    "reportErrorTitle": "Erreur",
    "reportErrorDesc": "Impossible d'envoyer le signalement. Veuillez réessayer.",
    "reportReqCategory": "Veuillez sélectionner un motif de signalement",
    "reportReqDetails": "Veuillez décrire le motif de votre signalement",
    "reportCatSpam": "Spam ou publicité",
    "reportCatHarassment": "Harcèlement",
    "reportCatHate": "Discours de haine",
    "reportCatNudity": "Nudité ou Violence",
    "reportCatFalse": "Fausse information",
    "reportCatOther": "Autre motif...",
    "reshareTitle": "Partager la publication",
    "reshareSubtitle": "Partagez ce contenu avec vos amis",
    "reshareCopyLink": "Copier le lien"
  },
  "en": {
    "reportTitle": "Report Post",
    "reportSubtitle": "Why are you reporting this post? Your report remains confidential and helps keep our community safe.",
    "reportCategory": "Select a reason:",
    "reportDetails": "Additional details (optional):",
    "reportDetailsPlaceholder": "Describe the situation to help us understand...",
    "reportHide": "Hide this post from my feed",
    "reportHideDesc": "You will no longer see this publication in your feed.",
    "reportSubmit": "Submit Report",
    "reportSubmitting": "Submitting...",
    "reportCancel": "Cancel",
    "reportSuccessTitle": "Report Submitted!",
    "reportSuccessDesc": "Thank you. Our team will review this post within 24 hours and take appropriate action.",
    "reportErrorTitle": "Error",
    "reportErrorDesc": "Failed to submit report. Please try again.",
    "reportReqCategory": "Please select a reason for reporting",
    "reportReqDetails": "Please describe the reason for your report",
    "reportCatSpam": "Spam or advertising",
    "reportCatHarassment": "Harassment or bullying",
    "reportCatHate": "Hate speech or bias",
    "reportCatNudity": "Nudity or Violence",
    "reportCatFalse": "False information",
    "reportCatOther": "Other reason...",
    "reshareTitle": "Share Post",
    "reshareSubtitle": "Share this content with your friends",
    "reshareCopyLink": "Copy link"
  },
  "es": {
    "reportTitle": "Reportar Publicación",
    "reportSubtitle": "¿Por qué reportas esta publicación? Tu reporte es confidencial y ayuda a mantener nuestra comunidad segura.",
    "reportCategory": "Selecciona un motivo:",
    "reportDetails": "Detalles adicionales (opcional):",
    "reportDetailsPlaceholder": "Describe la situación para ayudarnos a entender...",
    "reportHide": "Ocultar esta publicación de mi feed",
    "reportHideDesc": "Ya no verás esta publicación en tu feed.",
    "reportSubmit": "Enviar Reporte",
    "reportSubmitting": "Enviando...",
    "reportCancel": "Cancelar",
    "reportSuccessTitle": "¡Reporte Enviado!",
    "reportSuccessDesc": "Gracias. Nuestro equipo revisará esta publicación en 24 horas y tomará las medidas necesarias.",
    "reportErrorTitle": "Error",
    "reportErrorDesc": "No se pudo enviar el reporte. Por favor, inténtalo de nuevo.",
    "reportReqCategory": "Selecciona un motivo para reportar",
    "reportReqDetails": "Describe el motivo de tu reporte",
    "reportCatSpam": "Spam o publicidad",
    "reportCatHarassment": "Acoso o intimidación",
    "reportCatHate": "Discurso de odio",
    "reportCatNudity": "Desnudez o Violencia",
    "reportCatFalse": "Información falsa",
    "reportCatOther": "Otro motivo...",
    "reshareTitle": "Compartir Publicación",
    "reshareSubtitle": "Comparte este contenido con tus amigos",
    "reshareCopyLink": "Copiar enlace"
  },
  "pt": {
    "reportTitle": "Denunciar Publicação",
    "reportSubtitle": "Por que você está denunciando esta publicação? Sua denúncia é confidencial e ajuda a manter nossa comunidade segura.",
    "reportCategory": "Selecione um motivo:",
    "reportDetails": "Detalhes adicionais (opcional):",
    "reportDetailsPlaceholder": "Descreva a situação para nos ajudar a entender...",
    "reportHide": "Ocultar esta publicação do meu feed",
    "reportHideDesc": "Você não verá mais esta publicação em seu feed.",
    "reportSubmit": "Enviar Denúncia",
    "reportSubmitting": "Enviando...",
    "reportCancel": "Cancelar",
    "reportSuccessTitle": "Denúncia Enviada!",
    "reportSuccessDesc": "Obrigado. Nossa equipe analisará esta publicação em 24 horas e tomará as medidas necessárias.",
    "reportErrorTitle": "Erro",
    "reportErrorDesc": "Falha ao enviar denúncia. Tente novamente.",
    "reportReqCategory": "Selecione um motivo para a denúncia",
    "reportReqDetails": "Descreva o motivo da sua denúncia",
    "reportCatSpam": "Spam ou publicidade",
    "reportCatHarassment": "Assédio ou bullying",
    "reportCatHate": "Discurso de ódio",
    "reportCatNudity": "Nudez ou Violência",
    "reportCatFalse": "Informação falsa",
    "reportCatOther": "Outro motivo...",
    "reshareTitle": "Compartilhar Publicação",
    "reshareSubtitle": "Compartilhe este conteúdo com seus amigos",
    "reshareCopyLink": "Copiar link"
  },
  "de": {
    "reportTitle": "Beitrag melden",
    "reportSubtitle": "Warum meldest du diesen Beitrag? Deine Meldung bleibt vertraulich und hilft, unsere Community sicher zu halten.",
    "reportCategory": "Wähle einen Grund:",
    "reportDetails": "Weitere Details (optional):",
    "reportDetailsPlaceholder": "Beschreibe die Situation, um uns zu helfen...",
    "reportHide": "Diesen Beitrag aus meinem Feed ausblenden",
    "reportHideDesc": "Du wirst diesen Beitrag nicht mehr in deinem Feed sehen.",
    "reportSubmit": "Meldung senden",
    "reportSubmitting": "Senden...",
    "reportCancel": "Abbrechen",
    "reportSuccessTitle": "Meldung gesendet!",
    "reportSuccessDesc": "Danke. Unser Team wird diesen Beitrag innerhalb von 24 Stunden überprüfen.",
    "reportErrorTitle": "Fehler",
    "reportErrorDesc": "Fehler beim Senden der Meldung. Bitte versuche es erneut.",
    "reportReqCategory": "Bitte wähle einen Grund für die Meldung",
    "reportReqDetails": "Bitte beschreibe den Grund deiner Meldung",
    "reportCatSpam": "Spam oder Werbung",
    "reportCatHarassment": "Belästigung oder Mobbing",
    "reportCatHate": "Hassrede",
    "reportCatNudity": "Nacktheit oder Gewalt",
    "reportCatFalse": "Falsche Informationen",
    "reportCatOther": "Anderer Grund...",
    "reshareTitle": "Beitrag teilen",
    "reshareSubtitle": "Teile diesen Inhalt mit deinen Freunden",
    "reshareCopyLink": "Link kopieren"
  },
  "it": {
    "reportTitle": "Segnala Post",
    "reportSubtitle": "Perché stai segnalando questo post? La tua segnalazione è riservata e ci aiuta a mantenere sicura la nostra community.",
    "reportCategory": "Seleziona un motivo:",
    "reportDetails": "Dettagli aggiuntivi (opzionale):",
    "reportDetailsPlaceholder": "Descrivi la situazione per aiutarci a capire...",
    "reportHide": "Nascondi questo post dal mio feed",
    "reportHideDesc": "Non vedrai più questo post nel tuo feed.",
    "reportSubmit": "Invia Segnalazione",
    "reportSubmitting": "Invio in corso...",
    "reportCancel": "Annulla",
    "reportSuccessTitle": "Segnalazione Inviata!",
    "reportSuccessDesc": "Grazie. Il nostro team esaminerà questo post entro 24 ore e prenderà i provvedimenti necessari.",
    "reportErrorTitle": "Errore",
    "reportErrorDesc": "Impossibile inviare la segnalazione. Riprova.",
    "reportReqCategory": "Seleziona un motivo per la segnalazione",
    "reportReqDetails": "Descrivi il motivo della tua segnalazione",
    "reportCatSpam": "Spam o pubblicità",
    "reportCatHarassment": "Molestie o bullismo",
    "reportCatHate": "Incitamento all'odio",
    "reportCatNudity": "Nudità o Violenza",
    "reportCatFalse": "Informazioni false",
    "reportCatOther": "Altro motivo...",
    "reshareTitle": "Condividi Post",
    "reshareSubtitle": "Condividi questo contenuto con i tuoi amici",
    "reshareCopyLink": "Copia link"
  },
  "ar": {
    "reportTitle": "الإبلاغ عن المنشور",
    "reportSubtitle": "لماذا تقوم بالإبلاغ عن هذا المنشور؟ يبقى بلاغك سرياً ويساعد في الحفاظ على أمان مجتمعنا.",
    "reportCategory": "اختر سبباً:",
    "reportDetails": "تفاصيل إضافية (اختياري):",
    "reportDetailsPlaceholder": "صف الموقف لمساعدتنا على الفهم...",
    "reportHide": "إخفاء هذا المنشور من يومياتي",
    "reportHideDesc": "لن ترى هذا المنشور في يومياتك بعد الآن.",
    "reportSubmit": "إرسال البلاغ",
    "reportSubmitting": "جاري الإرسال...",
    "reportCancel": "إلغاء",
    "reportSuccessTitle": "تم إرسال البلاغ!",
    "reportSuccessDesc": "شكراً لك. سيقوم فريقنا بمراجعة هذا المنشور خلال 24 ساعة.",
    "reportErrorTitle": "خطأ",
    "reportErrorDesc": "فشل إرسال البلاغ. يرجى المحاولة مرة أخرى.",
    "reportReqCategory": "يرجى تحديد سبب للإبلاغ",
    "reportReqDetails": "يرجى وصف سبب البلاغ",
    "reportCatSpam": "بريد مزعج أو إعلان",
    "reportCatHarassment": "مضايقة أو تنمر",
    "reportCatHate": "خطاب كراهية",
    "reportCatNudity": "عري أو عنف",
    "reportCatFalse": "معلومات خاطئة",
    "reportCatOther": "سبب آخر...",
    "reshareTitle": "مشاركة المنشور",
    "reshareSubtitle": "شارك هذا المحتوى مع أصدقائك",
    "reshareCopyLink": "نسخ الرابط"
  },
  "tr": {
    "reportTitle": "Gönderiyi Şikayet Et",
    "reportSubtitle": "Bu gönderiyi neden şikayet ediyorsunuz? Şikayetiniz gizli tutulur ve topluluğumuzun güvenliğini sağlamaya yardımcı olur.",
    "reportCategory": "Bir neden seçin:",
    "reportDetails": "Ek detaylar (isteğe bağlı):",
    "reportDetailsPlaceholder": "Durumu anlamamıza yardımcı olmak için açıklayın...",
    "reportHide": "Bu gönderiyi akışımdan gizle",
    "reportHideDesc": "Artık bu gönderiyi akışınızda görmeyeceksiniz.",
    "reportSubmit": "Şikayeti Gönder",
    "reportSubmitting": "Gönderiliyor...",
    "reportCancel": "İptal",
    "reportSuccessTitle": "Şikayet Gönderildi!",
    "reportSuccessDesc": "Teşekkürler. Ekibimiz bu gönderiyi 24 saat içinde inceleyecektir.",
    "reportErrorTitle": "Hata",
    "reportErrorDesc": "Şikayet gönderilemedi. Lütfen tekrar deneyin.",
    "reportReqCategory": "Lütfen şikayet için bir neden seçin",
    "reportReqDetails": "Lütfen şikayetinizin nedenini açıklayın",
    "reportCatSpam": "Spam veya reklam",
    "reportCatHarassment": "Taciz veya zorbalık",
    "reportCatHate": "Nefret söylemi",
    "reportCatNudity": "Çıplaklık veya Şiddet",
    "reportCatFalse": "Yanlış bilgi",
    "reportCatOther": "Başka bir neden...",
    "reshareTitle": "Gönderiyi Paylaş",
    "reshareSubtitle": "Bu içeriği arkadaşlarınızla paylaşın",
    "reshareCopyLink": "Bağlantıyı kopyala"
  },
  "nl": {
    "reportTitle": "Bericht Rapporteren",
    "reportSubtitle": "Waarom rapporteer je dit bericht? Je rapport blijft vertrouwelijk en helpt onze community veilig te houden.",
    "reportCategory": "Selecteer een reden:",
    "reportDetails": "Aanvullende details (optioneel):",
    "reportDetailsPlaceholder": "Beschrijf de situatie om ons te helpen begrijpen...",
    "reportHide": "Verberg dit bericht in mijn feed",
    "reportHideDesc": "Je ziet dit bericht niet meer in je feed.",
    "reportSubmit": "Rapport Verzenden",
    "reportSubmitting": "Verzenden...",
    "reportCancel": "Annuleren",
    "reportSuccessTitle": "Rapport Verzonden!",
    "reportSuccessDesc": "Bedankt. Ons team zal dit bericht binnen 24 uur beoordelen.",
    "reportErrorTitle": "Fout",
    "reportErrorDesc": "Rapport verzenden mislukt. Probeer het opnieuw.",
    "reportReqCategory": "Selecteer een reden voor het rapporteren",
    "reportReqDetails": "Beschrijf de reden van je rapport",
    "reportCatSpam": "Spam of reclame",
    "reportCatHarassment": "Intimidatie of pesten",
    "reportCatHate": "Haatzaaien",
    "reportCatNudity": "Naaktheid of Geweld",
    "reportCatFalse": "Onjuiste informatie",
    "reportCatOther": "Andere reden...",
    "reshareTitle": "Bericht Delen",
    "reshareSubtitle": "Deel deze inhoud met je vrienden",
    "reshareCopyLink": "Link kopiëren"
  },
  "ru": {
    "reportTitle": "Пожаловаться на пост",
    "reportSubtitle": "Почему вы жалуетесь на этот пост? Ваша жалоба конфиденциальна и помогает поддерживать безопасность.",
    "reportCategory": "Выберите причину:",
    "reportDetails": "Дополнительные детали (необязательно):",
    "reportDetailsPlaceholder": "Опишите ситуацию, чтобы помочь нам понять...",
    "reportHide": "Скрыть этот пост из моей ленты",
    "reportHideDesc": "Вы больше не увидите этот пост в своей ленте.",
    "reportSubmit": "Отправить жалобу",
    "reportSubmitting": "Отправка...",
    "reportCancel": "Отмена",
    "reportSuccessTitle": "Жалоба отправлена!",
    "reportSuccessDesc": "Спасибо. Наша команда проверит этот пост в течение 24 часов.",
    "reportErrorTitle": "Ошибка",
    "reportErrorDesc": "Не удалось отправить жалобу. Попробуйте еще раз.",
    "reportReqCategory": "Пожалуйста, выберите причину жалобы",
    "reportReqDetails": "Пожалуйста, опишите причину вашей жалобы",
    "reportCatSpam": "Спам или реклама",
    "reportCatHarassment": "Домогательства или травля",
    "reportCatHate": "Язык вражды",
    "reportCatNudity": "Нагота или Насилие",
    "reportCatFalse": "Ложная информация",
    "reportCatOther": "Другая причина...",
    "reshareTitle": "Поделиться постом",
    "reshareSubtitle": "Поделитесь этим контентом с друзьями",
    "reshareCopyLink": "Скопировать ссылку"
  },
  "zh": {
    "reportTitle": "举报帖子",
    "reportSubtitle": "您为什么举报此帖子？您的举报将被保密，并有助于保持我们社区的安全。",
    "reportCategory": "选择一个原因：",
    "reportDetails": "其他详细信息（可选）：",
    "reportDetailsPlaceholder": "描述情况以帮助我们了解...",
    "reportHide": "从我的动态中隐藏此帖子",
    "reportHideDesc": "您将不再在动态中看到此帖子。",
    "reportSubmit": "提交举报",
    "reportSubmitting": "提交中...",
    "reportCancel": "取消",
    "reportSuccessTitle": "举报已提交！",
    "reportSuccessDesc": "谢谢。我们的团队将在 24 小时内审核此帖子。",
    "reportErrorTitle": "错误",
    "reportErrorDesc": "提交举报失败。请重试。",
    "reportReqCategory": "请选择举报原因",
    "reportReqDetails": "请描述您的举报原因",
    "reportCatSpam": "垃圾信息或广告",
    "reportCatHarassment": "骚扰或欺凌",
    "reportCatHate": "仇恨言论",
    "reportCatNudity": "色情或暴力",
    "reportCatFalse": "虚假信息",
    "reportCatOther": "其他原因...",
    "reshareTitle": "分享帖子",
    "reshareSubtitle": "与您的朋友分享此内容",
    "reshareCopyLink": "复制链接"
  },
  "ja": {
    "reportTitle": "投稿を報告",
    "reportSubtitle": "なぜこの投稿を報告しますか？報告は機密として扱われ、コミュニティの安全を守るのに役立ちます。",
    "reportCategory": "理由を選択してください：",
    "reportDetails": "追加の詳細（任意）：",
    "reportDetailsPlaceholder": "状況を理解するために説明してください...",
    "reportHide": "この投稿をフィードから隠す",
    "reportHideDesc": "この投稿はフィードに表示されなくなります。",
    "reportSubmit": "報告を送信",
    "reportSubmitting": "送信中...",
    "reportCancel": "キャンセル",
    "reportSuccessTitle": "報告が送信されました！",
    "reportSuccessDesc": "ありがとうございます。私たちのチームが24時間以内にこの投稿を確認します。",
    "reportErrorTitle": "エラー",
    "reportErrorDesc": "報告の送信に失敗しました。もう一度お試しください。",
    "reportReqCategory": "報告の理由を選択してください",
    "reportReqDetails": "報告の理由を説明してください",
    "reportCatSpam": "スパムまたは広告",
    "reportCatHarassment": "嫌がらせまたはいじめ",
    "reportCatHate": "ヘイトスピーチ",
    "reportCatNudity": "ヌードまたは暴力",
    "reportCatFalse": "誤った情報",
    "reportCatOther": "その他の理由...",
    "reshareTitle": "投稿をシェア",
    "reshareSubtitle": "友達とこのコンテンツを共有する",
    "reshareCopyLink": "リンクをコピー"
  },
  "ko": {
    "reportTitle": "게시물 신고",
    "reportSubtitle": "이 게시물을 신고하는 이유는 무엇인가요? 신고 내용은 기밀로 유지되며 커뮤니티의 안전을 지키는 데 도움이 됩니다.",
    "reportCategory": "이유를 선택하세요:",
    "reportDetails": "추가 세부 정보(선택 사항):",
    "reportDetailsPlaceholder": "상황을 이해하는 데 도움이 되도록 설명해 주세요...",
    "reportHide": "내 피드에서 이 게시물 숨기기",
    "reportHideDesc": "더 이상 피드에서 이 게시물을 보지 않게 됩니다.",
    "reportSubmit": "신고 제출",
    "reportSubmitting": "제출 중...",
    "reportCancel": "취소",
    "reportSuccessTitle": "신고가 제출되었습니다!",
    "reportSuccessDesc": "감사합니다. 24시간 내에 이 게시물을 검토하겠습니다.",
    "reportErrorTitle": "오류",
    "reportErrorDesc": "신고를 제출하지 못했습니다. 다시 시도해 주세요.",
    "reportReqCategory": "신고 이유를 선택해 주세요",
    "reportReqDetails": "신고 이유를 설명해 주세요",
    "reportCatSpam": "스팸 또는 광고",
    "reportCatHarassment": "괴롭힘 또는 따돌림",
    "reportCatHate": "혐오 발언",
    "reportCatNudity": "과도한 노출 또는 폭력",
    "reportCatFalse": "거짓 정보",
    "reportCatOther": "기타 이유...",
    "reshareTitle": "게시물 공유",
    "reshareSubtitle": "이 콘텐츠를 친구들과 공유하세요",
    "reshareCopyLink": "링크 복사"
  },
  "hi": {
    "reportTitle": "पोस्ट की रिपोर्ट करें",
    "reportSubtitle": "आप इस पोस्ट की रिपोर्ट क्यों कर रहे हैं? आपकी रिपोर्ट गोपनीय रहती है और हमारे समुदाय को सुरक्षित रखने में मदद करती है।",
    "reportCategory": "एक कारण चुनें:",
    "reportDetails": "अतिरिक्त विवरण (वैकल्पिक):",
    "reportDetailsPlaceholder": "स्थिति का वर्णन करें ताकि हम समझ सकें...",
    "reportHide": "इस पोस्ट को मेरे फ़ीड से छिपाएँ",
    "reportHideDesc": "अब आप इस पोस्ट को अपने फ़ीड में नहीं देखेंगे।",
    "reportSubmit": "रिपोर्ट जमा करें",
    "reportSubmitting": "जमा कर रहा है...",
    "reportCancel": "रद्द करें",
    "reportSuccessTitle": "रिपोर्ट जमा हो गई!",
    "reportSuccessDesc": "धन्यवाद। हमारी टीम 24 घंटे के भीतर इस पोस्ट की समीक्षा करेगी।",
    "reportErrorTitle": "त्रुटि",
    "reportErrorDesc": "रिपोर्ट जमा करने में विफल। कृपया पुन: प्रयास करें।",
    "reportReqCategory": "कृपया रिपोर्ट करने का एक कारण चुनें",
    "reportReqDetails": "कृपया अपनी रिपोर्ट का कारण बताएं",
    "reportCatSpam": "स्पैम या विज्ञापन",
    "reportCatHarassment": "उत्पीड़न या बदमाशी",
    "reportCatHate": "अभद्र भाषा",
    "reportCatNudity": "नग्नता या हिंसा",
    "reportCatFalse": "गलत जानकारी",
    "reportCatOther": "अन्य कारण...",
    "reshareTitle": "पोस्ट शेयर करें",
    "reshareSubtitle": "इस सामग्री को अपने दोस्तों के साथ शेयर करें",
    "reshareCopyLink": "लिंक कॉपी करें"
  }
}

export function translate(locale: string, key: TranslationKey): string {
  const normalized = resolveLocale(locale)
  const publicPageCompletionOverride = PUBLIC_PAGE_COMPLETION_TRANSLATIONS[normalized]?.[key]
  if (publicPageCompletionOverride) {
    return publicPageCompletionOverride
  }

  const aboutPageOverride = ABOUT_PAGE_TRANSLATIONS[normalized]?.[key]
  if (aboutPageOverride) {
    return aboutPageOverride
  }

  const contactSafetyOverride = CONTACT_SAFETY_TRANSLATIONS[normalized]?.[key]
  if (contactSafetyOverride) {
    return contactSafetyOverride
  }

  const legalPageOverride = LEGAL_PAGE_TRANSLATIONS[normalized]?.[key]
  if (legalPageOverride) {
    return legalPageOverride
  }

  const termsNavOverride = TERMS_NAV_TRANSLATIONS[normalized]?.[key]
  if (termsNavOverride) {
    return termsNavOverride
  }

  const termsPageOverride = TERMS_PAGE_TRANSLATIONS[normalized]?.[key]
  if (termsPageOverride) {
    return termsPageOverride
  }
  const termsEnglishFallback = TERMS_PAGE_TRANSLATIONS.en?.[key]
  if (termsEnglishFallback) {
    return termsEnglishFallback
  }

  const privacyPageOverride = PRIVACY_PAGE_TRANSLATIONS[normalized]?.[key]
  if (privacyPageOverride) {
    return privacyPageOverride
  }

  const privacyRemainingOverride = PRIVACY_REMAINING_TRANSLATIONS[normalized]?.[key]
  if (privacyRemainingOverride) {
    return privacyRemainingOverride
  }

  const privacyEnglishFallback = PRIVACY_PAGE_TRANSLATIONS.en?.[key]
  if (privacyEnglishFallback) {
    return privacyEnglishFallback
  }

  const publicPageOverride = PUBLIC_PAGE_TRANSLATIONS[normalized]?.[key]
  if (publicPageOverride) {
    return publicPageOverride
  }

  const reportShareOverride = REPORT_SHARE_TRANSLATIONS[normalized]?.[key]
  if (reportShareOverride) {
    return reportShareOverride
  }

  const visitorPanelOverride = VISITOR_PANEL_TRANSLATIONS[normalized]?.[key]
  if (visitorPanelOverride) {
    return visitorPanelOverride
  }
  const pageTitleOverride = PAGE_TITLE_TRANSLATIONS[normalized]?.[key]
  if (pageTitleOverride) {
    return pageTitleOverride
  }
  const postUiOverride = POST_UI_TRANSLATIONS[normalized]?.[key]
  if (postUiOverride) {
    return postUiOverride
  }
  const universalOverrides = UNIVERSAL_MISSING_TRANSLATIONS[normalized]
  if (normalized !== "fr" && normalized !== "en" && universalOverrides?.[key]) {
    return universalOverrides[key] as string
  }
  const localized = translations[normalized]?.[key]
  if (localized && (normalized === "fr" || localized !== baseTranslations[key])) {
    return localized
  }
  if (universalOverrides?.[key]) {
    return universalOverrides[key] as string
  }
  const randomCallOverrides = RANDOM_CALL_MISSING_TRANSLATIONS[normalized]
  if (randomCallOverrides?.[key]) {
    return randomCallOverrides[key] as string
  }
  const localeOverrides = LIVE_MISSING_TRANSLATIONS[normalized]
  if (localeOverrides?.[key]) {
    return localeOverrides[key] as string
  }
  return translations.en[key] || baseTranslations[key]
}

type SpokenLanguageEntry = {
  code: "fr" | "en" | "es" | "de" | "it" | "pt" | "ar" | "zh" | "ja" | "ru" | "hi" | "nl"
  stored: string
  flag: string
}

const SPOKEN_LANGUAGE_ENTRIES: SpokenLanguageEntry[] = [
  { code: "fr", stored: "Français", flag: "🇫🇷" },
  { code: "en", stored: "Anglais", flag: "🇬🇧" },
  { code: "es", stored: "Espagnol", flag: "🇪🇸" },
  { code: "de", stored: "Allemand", flag: "🇩🇪" },
  { code: "it", stored: "Italien", flag: "🇮🇹" },
  { code: "pt", stored: "Portugais", flag: "🇧🇷" },
  { code: "ar", stored: "Arabe", flag: "🇸🇦" },
  { code: "zh", stored: "Chinois", flag: "🇨🇳" },
  { code: "ja", stored: "Japonais", flag: "🇯🇵" },
  { code: "ru", stored: "Russe", flag: "🇷🇺" },
  { code: "hi", stored: "Hindi", flag: "🇮🇳" },
  { code: "nl", stored: "Néerlandais", flag: "🇳🇱" },
]

const SPOKEN_LANGUAGE_ALIAS_TO_CODE: Record<string, SpokenLanguageEntry["code"]> = {
  fr: "fr", french: "fr", francais: "fr", français: "fr",
  en: "en", english: "en", anglais: "en",
  es: "es", spanish: "es", espanol: "es", español: "es", espagnol: "es",
  de: "de", german: "de", allemand: "de", deutsch: "de",
  it: "it", italian: "it", italien: "it", italiano: "it",
  pt: "pt", portuguese: "pt", portugues: "pt", português: "pt", portugais: "pt",
  ar: "ar", arabic: "ar", arabe: "ar", arabee: "ar", العربية: "ar",
  zh: "zh", chinese: "zh", chinois: "zh", 中文: "zh",
  ja: "ja", japanese: "ja", japonais: "ja", 日本語: "ja",
  ru: "ru", russian: "ru", russe: "ru", русский: "ru",
  hi: "hi", hindi: "hi", हिन्दी: "hi",
  nl: "nl", dutch: "nl", neerlandais: "nl", néerlandais: "nl", nederlands: "nl",
}

function normalizeLanguageAlias(input: string): string {
  return String(input || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
}

export function resolveSpokenLanguageCode(input?: string | null): SpokenLanguageEntry["code"] | null {
  if (!input) return null
  const raw = String(input).trim().toLowerCase().replace("_", "-")
  if (!raw) return null
  const base = raw.split("-")[0]
  if (SPOKEN_LANGUAGE_ALIAS_TO_CODE[base]) return SPOKEN_LANGUAGE_ALIAS_TO_CODE[base]
  const normalized = normalizeLanguageAlias(input)
  return SPOKEN_LANGUAGE_ALIAS_TO_CODE[normalized] || null
}

export function getSpokenLanguageStoredValue(input?: string | null): string {
  const code = resolveSpokenLanguageCode(input)
  if (!code) return String(input || "")
  return SPOKEN_LANGUAGE_ENTRIES.find((item) => item.code === code)?.stored || String(input || "")
}

export function localizeSpokenLanguage(input: string, locale: string): string {
  const code = resolveSpokenLanguageCode(input)
  if (!code) return input
  try {
    const display = new Intl.DisplayNames([resolveLocale(locale)], { type: "language" }).of(code)
    return display || input
  } catch {
    return input
  }
}

export function localizeSpokenLanguages(values: string[], locale: string): string[] {
  return (values || []).map((value) => localizeSpokenLanguage(value, locale))
}

export function getSpokenLanguageOptions(locale: string): Array<{ code: string; stored: string; label: string; flag: string }> {
  return SPOKEN_LANGUAGE_ENTRIES.map((entry) => ({
    code: entry.code,
    stored: entry.stored,
    label: localizeSpokenLanguage(entry.code, locale),
    flag: entry.flag,
  }))
}

